[
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.6670019,
    "lat": 45.0176181
  },
  {
    "lng": 9.0078954,
    "lat": 50.0819515
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -76.3952429,
    "lat": 40.1637359
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 70.8028377,
    "lat": 22.3053263
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -70.8645872,
    "lat": 43.2625585
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.2585107,
    "lat": 25.7331105
  },
  {
    "lng": 6.1961189,
    "lat": 45.8597877
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 3.0105105,
    "lat": 42.704359
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -83.3771553,
    "lat": 42.4853125
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.1320819,
    "lat": 43.63233
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -119.582876,
    "lat": 49.8585784
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 11.8627403,
    "lat": 45.3951113
  },
  {
    "lng": -4.1433925,
    "lat": 50.3780967
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.4779448,
    "lat": 46.3731303
  },
  {
    "lng": 6.0577244,
    "lat": 46.333849
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 0.1079732,
    "lat": 49.4938975
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.2655785,
    "lat": 39.1713082
  },
  {
    "lng": -83.4571058,
    "lat": 34.203997
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 3.9107676,
    "lat": 43.6611507
  },
  {
    "lng": -82.1811947,
    "lat": 28.2336196
  },
  {
    "lng": -91.580705,
    "lat": 41.6759977
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": 4.5098046,
    "lat": 45.4748298
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -121.8901232,
    "lat": 38.0181745
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": -122.29214,
    "lat": 47.1849009
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": 6.9890508,
    "lat": 50.7627913
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -0.3727503,
    "lat": 49.320622
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.4749347,
    "lat": 48.8490721
  },
  {
    "lng": -71.6885443,
    "lat": 43.7572734
  },
  {
    "lng": -74.9813349,
    "lat": 44.6697996
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -75.9760751,
    "lat": 36.8496579
  },
  {
    "lng": 114.1800713,
    "lat": 22.3159018
  },
  {
    "lng": -86.9080655,
    "lat": 40.4258686
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -1.5695287,
    "lat": 47.1905456
  },
  {
    "lng": -92.1052679,
    "lat": 46.7838287
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.5496148,
    "lat": 33.9528472
  },
  {
    "lng": -74.6004341,
    "lat": 40.3334409
  },
  {
    "lng": -87.682932,
    "lat": 42.0693991
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 4.3338445,
    "lat": 50.8035441
  },
  {
    "lng": 2.6200032,
    "lat": 48.8457347
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 8.6288,
    "lat": 49.6977
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1991229,
    "lat": 51.4989948
  },
  {
    "lng": -71.7614891,
    "lat": 42.5267443
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.3668279,
    "lat": 50.8331141
  },
  {
    "lng": 18.016667,
    "lat": 59.366667
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.2401542,
    "lat": 47.6238204
  },
  {
    "lng": 8.87722,
    "lat": 49.2553
  },
  {
    "lng": 74.6043881,
    "lat": 42.868594
  },
  {
    "lng": -121.9856782,
    "lat": 47.7423219
  },
  {
    "lng": 20.441944,
    "lat": -34.021111
  },
  {
    "lng": -79.8956803,
    "lat": 43.3314156
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -75.9768632,
    "lat": 43.0020107
  },
  {
    "lng": -93.0815678,
    "lat": 37.0011646
  },
  {
    "lng": -76.9274072,
    "lat": 38.6023935
  },
  {
    "lng": 13.0591397,
    "lat": 52.4009309
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -75.7515682,
    "lat": 39.6828358
  },
  {
    "lng": 7.4492808,
    "lat": 48.4088704
  },
  {
    "lng": -109.92006,
    "lat": 22.8938884
  },
  {
    "lng": -75.3499124,
    "lat": 39.9020565
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.4881846,
    "lat": 44.9259011
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.644097,
    "lat": 34.1446643
  },
  {
    "lng": -89.262291,
    "lat": 35.5939671
  },
  {
    "lng": 1.2644847,
    "lat": 45.8354243
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": 0.1967849,
    "lat": 48.0073849
  },
  {
    "lng": 6.6916476,
    "lat": 51.1981778
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 8.5837524,
    "lat": 50.3012792
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.4041725,
    "lat": 39.516644
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -0.5879629,
    "lat": 44.8088438
  },
  {
    "lng": -88.1361888,
    "lat": 42.1539141
  },
  {
    "lng": 2.48291,
    "lat": 48.9031
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 8.550301,
    "lat": 48.7502439
  },
  {
    "lng": -6.6833615,
    "lat": 53.651908
  },
  {
    "lng": 8.5830859,
    "lat": 47.3176276
  },
  {
    "lng": -0.3685668,
    "lat": 43.2957547
  },
  {
    "lng": 3.2876843,
    "lat": 49.8465253
  },
  {
    "lng": -88.1897393,
    "lat": 41.7828751
  },
  {
    "lng": 0.6889268,
    "lat": 47.3900474
  },
  {
    "lng": -74.0120817,
    "lat": 40.2203907
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 76.9628425,
    "lat": 11.0018115
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": -121.99059,
    "lat": 37.050096
  },
  {
    "lng": 2.7015872,
    "lat": 48.4049375
  },
  {
    "lng": -77.1929215,
    "lat": 39.1399187
  },
  {
    "lng": 10.2511001,
    "lat": 53.5098898
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 6.6617476,
    "lat": 46.5098019
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -89.9841627,
    "lat": 38.5135805
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -75.3788141,
    "lat": 37.9331799
  },
  {
    "lng": -73.8587461,
    "lat": 41.0762077
  },
  {
    "lng": 2.5060144,
    "lat": 48.8608712
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -76.3464675,
    "lat": 42.512807
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.450394,
    "lat": 45.5262762
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -117.9859054,
    "lat": 33.7578725
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 7.6824892,
    "lat": 45.0677551
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.3745921,
    "lat": 50.8498357
  },
  {
    "lng": 2.3796245,
    "lat": 48.9960813
  },
  {
    "lng": -1.3741375,
    "lat": 52.7257981
  },
  {
    "lng": -122.232523,
    "lat": 37.4863239
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -88.3021092,
    "lat": 36.6106122
  },
  {
    "lng": 0.6889268,
    "lat": 47.3900474
  },
  {
    "lng": 100.4230508,
    "lat": 13.7803993
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.4880064,
    "lat": 29.8909508
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -3.391696,
    "lat": 51.9472048
  },
  {
    "lng": -1.1236065,
    "lat": 52.6321088
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.7949873,
    "lat": 55.17108
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 12.0832674,
    "lat": 50.8765528
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.399513,
    "lat": 26.1003392
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.4172117,
    "lat": 48.6998552
  },
  {
    "lng": -0.6259875,
    "lat": 48.4944837
  },
  {
    "lng": 9.976727,
    "lat": 56.6488769
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 8.6918153,
    "lat": 47.253174
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -124.1027898,
    "lat": 40.966005
  },
  {
    "lng": 7.5029213,
    "lat": 43.7753495
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.1266886,
    "lat": 48.8035403
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 6.4779448,
    "lat": 46.3731303
  },
  {
    "lng": 2.7015872,
    "lat": 48.4049375
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": 4.7934767,
    "lat": 45.7362255
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": 8.3054682,
    "lat": 47.0505452
  },
  {
    "lng": 37.6742652,
    "lat": -6.8254864
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.3745921,
    "lat": 50.8498357
  },
  {
    "lng": -1.8538889,
    "lat": 46.6286111
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -58.4664257,
    "lat": -34.8192731
  },
  {
    "lng": 2.3019814,
    "lat": 48.8211559
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -157.804184,
    "lat": 21.418555
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 127.0473,
    "lat": 37.5177
  },
  {
    "lng": -61.0055945,
    "lat": 14.5906832
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": 0.2827942,
    "lat": 51.5093771
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.1496735,
    "lat": 43.6306683
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.8723084,
    "lat": 26.640628
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -85.7196893,
    "lat": 34.4442547
  },
  {
    "lng": -84.5740953,
    "lat": 30.8736613
  },
  {
    "lng": 2.134529,
    "lat": 48.7018823
  },
  {
    "lng": 2.1066273,
    "lat": 48.8972505
  },
  {
    "lng": 8.4611036,
    "lat": 47.1823761
  },
  {
    "lng": 26.1009263,
    "lat": 44.4356444
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 10.1857757,
    "lat": 36.8002068
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.7144158,
    "lat": 45.3663548
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -111.634158,
    "lat": 33.2483858
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 2.4818087,
    "lat": 48.6137734
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.4547891,
    "lat": 42.9956397
  },
  {
    "lng": 6.3121658,
    "lat": 46.0672189
  },
  {
    "lng": -93.161159,
    "lat": 44.4582041
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": -70.7939307,
    "lat": 42.1617681
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -79.310989,
    "lat": 45.041508
  },
  {
    "lng": -122.0402399,
    "lat": 37.5296593
  },
  {
    "lng": -80.8100724,
    "lat": 35.5848596
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -80.4927815,
    "lat": 43.451291
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -80.4742261,
    "lat": 35.6709727
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -74.60988,
    "lat": 40.5742696
  },
  {
    "lng": 25.1919784,
    "lat": 37.0651494
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -118.644097,
    "lat": 34.1446643
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.4621381,
    "lat": 53.3783713
  },
  {
    "lng": -88.4069744,
    "lat": 44.2613967
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -99.2662784,
    "lat": 19.416149
  },
  {
    "lng": 6.1301614,
    "lat": 43.1202573
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -1.6171482,
    "lat": 48.088155
  },
  {
    "lng": -1.257412,
    "lat": 51.4024177
  },
  {
    "lng": -71.100082,
    "lat": 43.115019
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -78.1652404,
    "lat": 39.1852184
  },
  {
    "lng": -85.865235,
    "lat": 42.870889
  },
  {
    "lng": -77.4579783,
    "lat": 38.4167265
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7068005,
    "lat": 50.0774496
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.5204498,
    "lat": 45.3188331
  },
  {
    "lng": -88.2430932,
    "lat": 40.1164841
  },
  {
    "lng": -3.5211361,
    "lat": 50.4652392
  },
  {
    "lng": -94.9445572,
    "lat": 32.728803
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -117.1827445,
    "lat": 34.0550328
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -118.4388067,
    "lat": 33.9541453
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -76.3070273,
    "lat": 41.1264315
  },
  {
    "lng": -72.409797,
    "lat": 42.4521519
  },
  {
    "lng": -72.6158096,
    "lat": 40.9733195
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.1266886,
    "lat": 48.8035403
  },
  {
    "lng": -76.7918234,
    "lat": 39.4148436
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -94.2471515,
    "lat": 36.0420248
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -0.3394758,
    "lat": 53.7435722
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.4995234,
    "lat": 37.5980374
  },
  {
    "lng": 6.6548702,
    "lat": 46.2346174
  },
  {
    "lng": 2.2368863,
    "lat": 48.8841522
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": -89.031784,
    "lat": 42.5083272
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -76.7074042,
    "lat": 37.2708788
  },
  {
    "lng": -77.2726393,
    "lat": 39.3827893
  },
  {
    "lng": 5.2828123,
    "lat": 45.5872259
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.7279185,
    "lat": 42.8192943
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -80.2389899,
    "lat": 27.2379528
  },
  {
    "lng": -83.4675021,
    "lat": 42.3712
  },
  {
    "lng": -75.3112095,
    "lat": 40.7423309
  },
  {
    "lng": -92.1476353,
    "lat": 32.5184775
  },
  {
    "lng": -75.2188589,
    "lat": 38.324505
  },
  {
    "lng": -121.8746789,
    "lat": 37.6624312
  },
  {
    "lng": -82.0609557,
    "lat": 39.3575616
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 5.2232175,
    "lat": 46.6291425
  },
  {
    "lng": -122.8718605,
    "lat": 42.3264181
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 98.3891503,
    "lat": 7.8847901
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 2.0030818,
    "lat": 48.980925
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 14.2487679,
    "lat": 40.8358846
  },
  {
    "lng": -88.4069744,
    "lat": 44.2613967
  },
  {
    "lng": -4.4216366,
    "lat": 36.7213028
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -110.3158532,
    "lat": 24.1619948
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.3476583,
    "lat": 46.4976734
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 105.8406959,
    "lat": 21.0242596
  },
  {
    "lng": -100.7654232,
    "lat": 41.1238873
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -122.2270272,
    "lat": 47.3826903
  },
  {
    "lng": -71.1244963,
    "lat": 42.2556543
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.702183,
    "lat": 49.01072
  },
  {
    "lng": -122.643224,
    "lat": 48.2931559
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": -1.5695287,
    "lat": 47.1905456
  },
  {
    "lng": -0.2441765,
    "lat": 44.4701196
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -78.8688833,
    "lat": 38.4493315
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 0.8722566,
    "lat": 51.148555
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -80.7325345,
    "lat": 28.3556635
  },
  {
    "lng": -51.2303767,
    "lat": -30.0324999
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -84.4549262,
    "lat": 33.4487257
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 10.3952118,
    "lat": 63.4304475
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -111.6587085,
    "lat": 40.2337289
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -118.374752,
    "lat": 34.1649502
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 3.9070658,
    "lat": 47.4885365
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -119.702667,
    "lat": 34.4221319
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.3068482,
    "lat": 48.9699732
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -81.4412259,
    "lat": 41.3897764
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -72.5886727,
    "lat": 42.1018764
  },
  {
    "lng": 2.0949768,
    "lat": 48.9938791
  },
  {
    "lng": 2.4530731,
    "lat": 48.7771486
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -88.1836965,
    "lat": 42.3966874
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 39.1742363,
    "lat": 21.5504432
  },
  {
    "lng": -76.2494453,
    "lat": 36.7168315
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": -71.0744952,
    "lat": 42.2973205
  },
  {
    "lng": -93.5885717,
    "lat": 44.0172242
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 5.9304919,
    "lat": 43.1257311
  },
  {
    "lng": 75.8681996,
    "lat": 22.7203616
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 6.9292641,
    "lat": 46.9895828
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": -81.5345547,
    "lat": 28.4944695
  },
  {
    "lng": 2.1266886,
    "lat": 48.8035403
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.1386547,
    "lat": 26.8233946
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": 0.7650348,
    "lat": 45.1724869
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": 73.053721,
    "lat": 33.5915446
  },
  {
    "lng": 6.0812467,
    "lat": 46.1444789
  },
  {
    "lng": -79.697545,
    "lat": 40.4284015
  },
  {
    "lng": -84.1401926,
    "lat": 34.2073196
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -3.2510247,
    "lat": 47.6975924
  },
  {
    "lng": -158.009166,
    "lat": 21.3866667
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 71.4719683,
    "lat": 30.197838
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 6.6349892,
    "lat": 45.4140984
  },
  {
    "lng": -1.5135474,
    "lat": 52.400739
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": 3.6159046,
    "lat": 47.9933948
  },
  {
    "lng": -2.0260409,
    "lat": 48.649518
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 10.7571408,
    "lat": 48.1479335
  },
  {
    "lng": -119.9843482,
    "lat": 38.9332411
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -78.6177611,
    "lat": 42.7689141
  },
  {
    "lng": -0.3635615,
    "lat": 49.1813403
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 10.281931,
    "lat": 47.5135363
  },
  {
    "lng": 2.4516055,
    "lat": 48.8897751
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -2.7599079,
    "lat": 47.6586772
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -86.8919011,
    "lat": 40.4191229
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8059012,
    "lat": 43.9492493
  },
  {
    "lng": 2.4530731,
    "lat": 48.7771486
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -84.7721823,
    "lat": 37.6456488
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.1709524,
    "lat": 45.7768401
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -120.8465941,
    "lat": 37.4946568
  },
  {
    "lng": -105.0811573,
    "lat": 39.8005505
  },
  {
    "lng": 2.3002885,
    "lat": 48.9875044
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.9804153,
    "lat": 46.236193
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 7.2156901,
    "lat": 51.1406481
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 4.3628851,
    "lat": 48.9566218
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 4.3600687,
    "lat": 43.8374249
  },
  {
    "lng": -112.583776,
    "lat": 33.3703197
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": -97.2271249,
    "lat": 32.9299655
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 4.1395124,
    "lat": 51.1646685
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -84.0176904,
    "lat": 33.6676103
  },
  {
    "lng": -72.6311006,
    "lat": 42.3178989
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 11.3525415,
    "lat": 55.4061196
  },
  {
    "lng": -87.0717718,
    "lat": 20.6269889
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -88.207301,
    "lat": 40.1117174
  },
  {
    "lng": -8.4362569,
    "lat": 41.6488247
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -71.3084633,
    "lat": 41.7407661
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 104.9224426,
    "lat": 11.568271
  },
  {
    "lng": -3.1502007,
    "lat": 48.5618483
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -97.371118,
    "lat": 30.3495084
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": 0.4065503,
    "lat": 52.2443103
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -86.3119346,
    "lat": 36.4817111
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -121.4415851,
    "lat": 49.3799779
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -76.6220212,
    "lat": 39.4482981
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.8062224,
    "lat": 47.6980235
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -3.1791934,
    "lat": 51.4816546
  },
  {
    "lng": -74.4660408,
    "lat": 40.5462553
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -84.5597128,
    "lat": 38.2099837
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.9367107,
    "lat": 40.5584882
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -75.9125187,
    "lat": 42.098698
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -117.7197785,
    "lat": 34.0966764
  },
  {
    "lng": -121.176058,
    "lat": 38.6779591
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -86.2483921,
    "lat": 43.2341813
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 0.6176112,
    "lat": 44.2015827
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -15.4349015,
    "lat": 28.1288694
  },
  {
    "lng": 7.2439029,
    "lat": 47.1402077
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": -80.7440174,
    "lat": 34.9248125
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -90.0367512,
    "lat": 32.612602
  },
  {
    "lng": -72.7395401,
    "lat": 41.7162112
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -122.7141049,
    "lat": 38.4404925
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": 2.02135,
    "lat": 47.9019
  },
  {
    "lng": -74.5659848,
    "lat": 40.4138861
  },
  {
    "lng": -118.144155,
    "lat": 34.1476507
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -57.5482079,
    "lat": -37.9976168
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 6.51777,
    "lat": 46.5461677
  },
  {
    "lng": -88.580956,
    "lat": 47.126871
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 75.2763203,
    "lat": 17.8499067
  },
  {
    "lng": -72.6311006,
    "lat": 42.3178989
  },
  {
    "lng": -91.5299106,
    "lat": 41.6612561
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -74.0844894,
    "lat": 41.7464972
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": -95.5377215,
    "lat": 29.6185669
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -119.8276389,
    "lat": 34.4358295
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.8937398,
    "lat": 41.1365122
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -81.3885899,
    "lat": 28.6619154
  },
  {
    "lng": 12.918914,
    "lat": 50.8323531
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -111.6944313,
    "lat": 40.2981599
  },
  {
    "lng": 3.0681174,
    "lat": 45.776018
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -89.216655,
    "lat": 37.7274692
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": 7.4652789,
    "lat": 51.5142273
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 9.7423762,
    "lat": 47.4136351
  },
  {
    "lng": 2.8773541,
    "lat": 48.9582708
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.3227803,
    "lat": 38.7919683
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -0.3033105,
    "lat": 51.3937557
  },
  {
    "lng": -1.0886623,
    "lat": 50.7888796
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": 31.009909,
    "lat": -29.861825
  },
  {
    "lng": -0.6486943,
    "lat": 44.8854667
  },
  {
    "lng": -104.5229518,
    "lat": 33.3943282
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 17.7821882,
    "lat": 48.4791862
  },
  {
    "lng": -84.2946539,
    "lat": 37.7478572
  },
  {
    "lng": -118.7381293,
    "lat": 34.1431615
  },
  {
    "lng": -86.8425761,
    "lat": 21.1527467
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": 15.4382786,
    "lat": 47.0708678
  },
  {
    "lng": -101.8371192,
    "lat": 35.20729
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.4749347,
    "lat": 48.8490721
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -70.8873511,
    "lat": 42.6046209
  },
  {
    "lng": -5.5352463,
    "lat": 50.1194794
  },
  {
    "lng": -0.2157507,
    "lat": 51.5566986
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -96.9442177,
    "lat": 32.8295183
  },
  {
    "lng": -79.05578,
    "lat": 35.9131542
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 1.3549991,
    "lat": 44.0175835
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -71.2804301,
    "lat": 41.9439695
  },
  {
    "lng": 1.9871825,
    "lat": 48.8214478
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -0.0144629,
    "lat": 51.5110713
  },
  {
    "lng": 98.9858802,
    "lat": 18.7882778
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.1561947,
    "lat": 45.6484505
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -117.566444,
    "lat": 33.8752945
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -71.0619957,
    "lat": 42.3778749
  },
  {
    "lng": 2.4309703,
    "lat": 48.8012045
  },
  {
    "lng": 121.4589414,
    "lat": 25.061706
  },
  {
    "lng": -0.4440957,
    "lat": 44.9954151
  },
  {
    "lng": -0.1726236,
    "lat": 51.6482779
  },
  {
    "lng": 5.7086562,
    "lat": 46.8348315
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -95.4560512,
    "lat": 30.3118769
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -119.9036592,
    "lat": 37.570148
  },
  {
    "lng": -89.5119565,
    "lat": 43.0962919
  },
  {
    "lng": -70.2177099,
    "lat": 44.0990717
  },
  {
    "lng": 10.1857757,
    "lat": 36.8002068
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -71.1551119,
    "lat": 42.3473519
  },
  {
    "lng": -97.6736292,
    "lat": 29.8832105
  },
  {
    "lng": 7.1116845,
    "lat": 43.7224167
  },
  {
    "lng": -69.2276,
    "lat": 45.183489
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -116.4139839,
    "lat": 34.1236205
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.5212467,
    "lat": 42.5069391
  },
  {
    "lng": -121.802173,
    "lat": 36.6844029
  },
  {
    "lng": 5.1580574,
    "lat": 45.614003
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -83.9478911,
    "lat": 42.0554875
  },
  {
    "lng": -94.6851702,
    "lat": 38.9742502
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.4396714,
    "lat": 48.8474508
  },
  {
    "lng": -88.5223353,
    "lat": 34.9343599
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.4809129,
    "lat": 48.7489857
  },
  {
    "lng": -78.4457422,
    "lat": 40.9908706
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -88.7774734,
    "lat": 46.8591287
  },
  {
    "lng": -86.2045442,
    "lat": 32.5378668
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -71.6854725,
    "lat": 43.3260376
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -120.6707255,
    "lat": 35.4894169
  },
  {
    "lng": 8.7473608,
    "lat": 50.3681107
  },
  {
    "lng": 2.4252507,
    "lat": 6.3676953
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.30551,
    "lat": 48.9026
  },
  {
    "lng": 2.5358323,
    "lat": 48.8853743
  },
  {
    "lng": 10.5966672,
    "lat": 35.7613215
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": 5.6062495,
    "lat": 43.1758591
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 1.7140683,
    "lat": 48.9891971
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -75.0629531,
    "lat": 42.453492
  },
  {
    "lng": -71.296806,
    "lat": 46.944403
  },
  {
    "lng": 76.2444378,
    "lat": 9.9679032
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -97.4649038,
    "lat": 35.6571367
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -106.1311288,
    "lat": 38.8422178
  },
  {
    "lng": -78.0419281,
    "lat": 42.2446061
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -112.185994,
    "lat": 33.5386858
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -73.7131153,
    "lat": 41.2815783
  },
  {
    "lng": 139.6638239,
    "lat": 35.7077741
  },
  {
    "lng": -74.0410865,
    "lat": 40.8871438
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -111.9866954,
    "lat": 40.6967891
  },
  {
    "lng": 3.0360448,
    "lat": 48.1650409
  },
  {
    "lng": -122.561503,
    "lat": 37.9744323
  },
  {
    "lng": -1.7594444,
    "lat": 46.6986111
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -0.6179871,
    "lat": 48.3044218
  },
  {
    "lng": -82.5508407,
    "lat": 35.595363
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.0018401,
    "lat": 41.093429
  },
  {
    "lng": -70.8092074,
    "lat": 42.0714907
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -82.9295287,
    "lat": 40.126139
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -4.016107,
    "lat": 5.320357
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -79.6411594,
    "lat": 39.6586918
  },
  {
    "lng": -85.8283224,
    "lat": 33.6624824
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -0.5597383,
    "lat": 48.5727431
  },
  {
    "lng": -80.23727,
    "lat": 26.3100794
  },
  {
    "lng": -111.6587085,
    "lat": 40.2337289
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -116.9589086,
    "lat": 33.7839664
  },
  {
    "lng": 28.9758715,
    "lat": 41.006381
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -77.4460583,
    "lat": 37.3562229
  },
  {
    "lng": -121.2810611,
    "lat": 38.7071247
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -1.4992075,
    "lat": 47.2035029
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.3939844,
    "lat": 43.6637121
  },
  {
    "lng": -121.655037,
    "lat": 36.6744117
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -88.9416829,
    "lat": 35.9808073
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -118.374752,
    "lat": 34.1649502
  },
  {
    "lng": -91.5299106,
    "lat": 41.6612561
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.2099992,
    "lat": 44.9754211
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": 121.4511111,
    "lat": 31.2515439
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 19.2691151,
    "lat": 42.4321076
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 2.2105491,
    "lat": 48.9250016
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.9688719,
    "lat": 48.226109
  },
  {
    "lng": -83.1427148,
    "lat": 42.8653073
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": 121.0589931,
    "lat": 14.5637482
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -3.0509812,
    "lat": 53.8179442
  },
  {
    "lng": -122.039966,
    "lat": 38.2493581
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 6.7360182,
    "lat": 43.4330308
  },
  {
    "lng": -71.6097744,
    "lat": 42.4342336
  },
  {
    "lng": -79.625599,
    "lat": 40.4181235
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -74.2390353,
    "lat": 40.7987113
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.0117661,
    "lat": 51.1322179
  },
  {
    "lng": 4.8059012,
    "lat": 43.9492493
  },
  {
    "lng": -123.204785,
    "lat": 44.2191935
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -76.0704906,
    "lat": 42.5842136
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 7.0134418,
    "lat": 43.5515198
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -80.2781057,
    "lat": 25.8575963
  },
  {
    "lng": 2.2411289,
    "lat": 43.6053809
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -120.310349,
    "lat": 47.4234599
  },
  {
    "lng": 2.8709277,
    "lat": 42.7683568
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.5783856,
    "lat": 46.1825453
  },
  {
    "lng": 166.442419,
    "lat": -22.2745264
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -78.1677784,
    "lat": 43.9595998
  },
  {
    "lng": -112.0154991,
    "lat": 41.5110434
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -79.7919754,
    "lat": 36.0726355
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -117.6029341,
    "lat": 33.6408845
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -81.2595731,
    "lat": 40.8375307
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 0.8657641,
    "lat": 46.5666888
  },
  {
    "lng": -71.5517636,
    "lat": -33.0244535
  },
  {
    "lng": 2.1614464,
    "lat": 48.4344621
  },
  {
    "lng": 1.3549991,
    "lat": 44.0175835
  },
  {
    "lng": 5.778361,
    "lat": 45.2097372
  },
  {
    "lng": 4.3338445,
    "lat": 50.8035441
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.0942792,
    "lat": 48.8990413
  },
  {
    "lng": -105.0811573,
    "lat": 39.8005505
  },
  {
    "lng": 5.5910751,
    "lat": 45.3631386
  },
  {
    "lng": 4.0746257,
    "lat": 48.2971626
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": 3.0043728,
    "lat": 42.6176479
  },
  {
    "lng": -117.7197785,
    "lat": 34.0966764
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": 6.1763552,
    "lat": 49.1196964
  },
  {
    "lng": -77.4347283,
    "lat": 38.837613
  },
  {
    "lng": -0.6486943,
    "lat": 44.8854667
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -0.3699697,
    "lat": 50.8115402
  },
  {
    "lng": 121.4710784,
    "lat": 25.0267902
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -81.1655408,
    "lat": 34.9603293
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -81.1802101,
    "lat": 34.0884688
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -1.1609361,
    "lat": 44.3907065
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 0.7184407,
    "lat": 45.1909365
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.6435597,
    "lat": 52.3837058
  },
  {
    "lng": 4.6869716,
    "lat": 45.9264129
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -1.5113138,
    "lat": 46.6858331
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 4.8322266,
    "lat": 46.3036683
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 7.7484488,
    "lat": 48.6047148
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -90.3854141,
    "lat": 43.3355298
  },
  {
    "lng": -75.1162306,
    "lat": 40.1507046
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 6.8827786,
    "lat": 49.287307
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -77.4806603,
    "lat": 37.7594012
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -77.4752667,
    "lat": 38.7509488
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.8738344,
    "lat": 48.1758188
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -87.8709308,
    "lat": 42.9744081
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -116.962526,
    "lat": 32.7947731
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1438863,
    "lat": 39.770683
  },
  {
    "lng": 1.9533495,
    "lat": 43.3192021
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -4.2412484,
    "lat": 50.8309593
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -86.9080655,
    "lat": 40.4258686
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 42.5043596,
    "lat": 18.2164282
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -66.9146008,
    "lat": 10.5060934
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -0.454723,
    "lat": 44.9711192
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.7131153,
    "lat": 41.2815783
  },
  {
    "lng": -82.5508407,
    "lat": 35.595363
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": 5.0135224,
    "lat": 52.1073555
  },
  {
    "lng": 19.1585805,
    "lat": 48.7383895
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 99.9956193,
    "lat": 9.5013944
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.3018662,
    "lat": 51.6201654
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 0.077533,
    "lat": 46.621605
  },
  {
    "lng": -86.2307992,
    "lat": 30.3466423
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.4315213,
    "lat": 43.6403659
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -71.0037374,
    "lat": 42.2509914
  },
  {
    "lng": -80.0666026,
    "lat": 26.5256179
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -77.3465081,
    "lat": 37.5131191
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": -0.2163018,
    "lat": 51.4625314
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.5215973,
    "lat": 42.9751766
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -117.566444,
    "lat": 33.8752945
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -122.036349,
    "lat": 37.3688301
  },
  {
    "lng": -121.387742,
    "lat": 36.2231079
  },
  {
    "lng": 58.5938134,
    "lat": 23.6123628
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 5.3882954,
    "lat": 47.1936509
  },
  {
    "lng": -68.672791,
    "lat": 44.883607
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -78.9636394,
    "lat": 43.0183219
  },
  {
    "lng": -74.2870925,
    "lat": 41.9673148
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -121.955174,
    "lat": 37.3541132
  },
  {
    "lng": 55.4776174,
    "lat": -21.341298
  },
  {
    "lng": -2.6992717,
    "lat": 53.7593363
  },
  {
    "lng": 2.9191579,
    "lat": 42.7452716
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": -83.5135665,
    "lat": 41.9153358
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": -75.4482522,
    "lat": 39.8742784
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.559849,
    "lat": 34.4131941
  },
  {
    "lng": -120.9968892,
    "lat": 37.6393419
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -72.0997804,
    "lat": 41.3556187
  },
  {
    "lng": 6.1983858,
    "lat": 46.1884304
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -4.4154549,
    "lat": 36.7329712
  },
  {
    "lng": -116.962526,
    "lat": 32.7947731
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.2079468,
    "lat": 43.9540167
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.926018,
    "lat": 33.4942189
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 76.214621,
    "lat": 10.5270099
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.988571,
    "lat": 37.5482697
  },
  {
    "lng": 5.8389606,
    "lat": 51.8425749
  },
  {
    "lng": -103.4885462,
    "lat": 38.9208296
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -70.8578253,
    "lat": 42.500096
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": -76.7080456,
    "lat": 39.385227
  },
  {
    "lng": 12.3063909,
    "lat": 55.9285735
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -85.6165976,
    "lat": 44.7606481
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -106.1130821,
    "lat": 37.6000793
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -79.5443274,
    "lat": 40.3024514
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -73.2435218,
    "lat": 40.7276525
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.2470646,
    "lat": 52.2316268
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.510611,
    "lat": 48.8137847
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.810138,
    "lat": 39.9234046
  },
  {
    "lng": -80.4136767,
    "lat": 37.2296566
  },
  {
    "lng": -123.0950506,
    "lat": 44.0505054
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -71.0183787,
    "lat": 42.0834335
  },
  {
    "lng": 7.4817123,
    "lat": 48.4623358
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0072568,
    "lat": 40.8860164
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -91.5299106,
    "lat": 41.6612561
  },
  {
    "lng": 2.2465748,
    "lat": 48.9069349
  },
  {
    "lng": 10.5935183,
    "lat": 35.8749788
  },
  {
    "lng": -90.8683119,
    "lat": 38.8244136
  },
  {
    "lng": -149.894852,
    "lat": 61.2163129
  },
  {
    "lng": -121.2736022,
    "lat": 38.1342805
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -122.3520327,
    "lat": 48.24216
  },
  {
    "lng": -119.9036592,
    "lat": 37.570148
  },
  {
    "lng": -77.859581,
    "lat": 39.2891836
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -84.2809332,
    "lat": 30.4380832
  },
  {
    "lng": -83.1895249,
    "lat": 40.5885271
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -105.07498,
    "lat": 40.3977612
  },
  {
    "lng": -91.8572479,
    "lat": 47.901571
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -2.7599079,
    "lat": 47.6586772
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.47267,
    "lat": 37.6904826
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 19.883611,
    "lat": -33.802222
  },
  {
    "lng": -78.4766781,
    "lat": 38.029306
  },
  {
    "lng": 7.3779933,
    "lat": 51.0186197
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -2.1677298,
    "lat": 47.2473358
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -122.2688522,
    "lat": 37.5600336
  },
  {
    "lng": -87.5675258,
    "lat": 33.2095614
  },
  {
    "lng": -117.2414989,
    "lat": 33.5939372
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 6.1642972,
    "lat": 45.8333544
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -91.2514355,
    "lat": 43.8122836
  },
  {
    "lng": -73.7853915,
    "lat": 43.0821793
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 6.9787389,
    "lat": 45.449556
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.2444145,
    "lat": -3.749365
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -121.2999485,
    "lat": 38.2546373
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1162306,
    "lat": 40.1507046
  },
  {
    "lng": -97.1413417,
    "lat": 33.1838787
  },
  {
    "lng": -78.8336218,
    "lat": 35.6512655
  },
  {
    "lng": -107.0603126,
    "lat": 38.6476702
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -82.0119202,
    "lat": 31.4876934
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 79.8542005,
    "lat": 6.9388614
  },
  {
    "lng": 2.1882897,
    "lat": 48.8086297
  },
  {
    "lng": -123.057938,
    "lat": 49.0846258
  },
  {
    "lng": -0.3635615,
    "lat": 49.1813403
  },
  {
    "lng": -71.0037374,
    "lat": 42.2509914
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -75.2215651,
    "lat": 40.1545535
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.7529071,
    "lat": 36.9092773
  },
  {
    "lng": -76.6932818,
    "lat": 42.8397906
  },
  {
    "lng": -97.1413417,
    "lat": 33.1838787
  },
  {
    "lng": -85.8530544,
    "lat": 41.2381017
  },
  {
    "lng": -2.7599079,
    "lat": 47.6586772
  },
  {
    "lng": -88.4474302,
    "lat": 42.3147529
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.6503982,
    "lat": 41.0413873
  },
  {
    "lng": 0.6889268,
    "lat": 47.3900474
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -95.677556,
    "lat": 39.049011
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": -72.9020069,
    "lat": 41.3836233
  },
  {
    "lng": -84.5930113,
    "lat": 35.4428864
  },
  {
    "lng": -64.8004265,
    "lat": 46.0985679
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -0.7095942,
    "lat": 45.5970869
  },
  {
    "lng": -0.4968888,
    "lat": 44.7846424
  },
  {
    "lng": 4.8111564,
    "lat": 43.6384838
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -95.3489561,
    "lat": 32.2031228
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.7465033,
    "lat": 52.0348915
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": -85.2527381,
    "lat": 37.5697869
  },
  {
    "lng": -117.7075526,
    "lat": 33.5225261
  },
  {
    "lng": 2.30551,
    "lat": 48.9026
  },
  {
    "lng": -85.5872286,
    "lat": 42.291707
  },
  {
    "lng": -122.3774952,
    "lat": 47.8105738
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 6.9129921,
    "lat": 46.4310831
  },
  {
    "lng": -112.468812,
    "lat": 34.539984
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -0.6308396,
    "lat": 44.805615
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -3.1974329,
    "lat": 51.6663189
  },
  {
    "lng": 1.6118771,
    "lat": 50.7259985
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": 1.5190466,
    "lat": 46.5885956
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.8620367,
    "lat": 41.1613168
  },
  {
    "lng": -0.6486943,
    "lat": 44.8854667
  },
  {
    "lng": 2.1779083,
    "lat": 48.9134112
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.4828123,
    "lat": 41.1362729
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -76.5483724,
    "lat": 42.4374175
  },
  {
    "lng": -73.1867391,
    "lat": 41.1779095
  },
  {
    "lng": -0.4881846,
    "lat": 44.9259011
  },
  {
    "lng": 4.8059012,
    "lat": 43.9492493
  },
  {
    "lng": -94.419079,
    "lat": 39.246479
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 1.819207,
    "lat": 48.6452851
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.571382,
    "lat": 40.5992395
  },
  {
    "lng": 13.4795839,
    "lat": 55.4488689
  },
  {
    "lng": -111.8627989,
    "lat": 40.5247777
  },
  {
    "lng": -76.1193678,
    "lat": 43.1756235
  },
  {
    "lng": -93.7465075,
    "lat": 40.740465
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -0.0699321,
    "lat": 51.4734122
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -0.9700664,
    "lat": 51.4564242
  },
  {
    "lng": 7.2113271,
    "lat": 47.9094629
  },
  {
    "lng": 105.8406959,
    "lat": 21.0242596
  },
  {
    "lng": -121.8989248,
    "lat": 37.4332273
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -118.8820414,
    "lat": 34.285558
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -72.8173481,
    "lat": 41.2746962
  },
  {
    "lng": -92.4398402,
    "lat": 35.0891932
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -94.5163876,
    "lat": 46.8202373
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.3337954,
    "lat": 43.6882557
  },
  {
    "lng": 4.3600687,
    "lat": 43.8374249
  },
  {
    "lng": -97.4649038,
    "lat": 35.6571367
  },
  {
    "lng": -118.427027,
    "lat": 34.2625025
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.6082177,
    "lat": 43.1147515
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": 5.4389442,
    "lat": 43.7729328
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -88.8893818,
    "lat": 30.4007626
  },
  {
    "lng": -80.0983887,
    "lat": -2.2895167
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -73.0256609,
    "lat": 41.2784304
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": 16.7792466,
    "lat": 48.0198451
  },
  {
    "lng": -81.1763421,
    "lat": 35.9219402
  },
  {
    "lng": -81.5960705,
    "lat": 31.8477347
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.3145039,
    "lat": 48.9525181
  },
  {
    "lng": -87.900671,
    "lat": 41.8096132
  },
  {
    "lng": -84.5740953,
    "lat": 30.8736613
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -73.3501301,
    "lat": 40.704371
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -79.0614686,
    "lat": 43.08436
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": 3.4228323,
    "lat": 43.4611777
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -76.6042521,
    "lat": 40.153364
  },
  {
    "lng": -72.5688547,
    "lat": 40.8423345
  },
  {
    "lng": -73.1212214,
    "lat": 41.8006523
  },
  {
    "lng": -107.8766,
    "lat": 37.2769484
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": 9.7385532,
    "lat": 52.3744779
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -75.4712794,
    "lat": 40.6022059
  },
  {
    "lng": -106.0465486,
    "lat": 39.4829124
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -118.3692894,
    "lat": 34.0923014
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.2286765,
    "lat": 46.0961011
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -71.6828444,
    "lat": 41.7000996
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -0.6308396,
    "lat": 44.805615
  },
  {
    "lng": -75.5779807,
    "lat": 39.0084464
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.8100724,
    "lat": 35.5848596
  },
  {
    "lng": -2.9778916,
    "lat": 51.3471927
  },
  {
    "lng": -85.843139,
    "lat": 44.723889
  },
  {
    "lng": -82.5338633,
    "lat": 28.483576
  },
  {
    "lng": -71.1470037,
    "lat": 42.8384221
  },
  {
    "lng": 17.9681359,
    "lat": 59.3628802
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -69.274292,
    "lat": 44.211741
  },
  {
    "lng": -74.2734808,
    "lat": 40.7312123
  },
  {
    "lng": -71.4165905,
    "lat": 42.2773177
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 6.876568,
    "lat": 50.8807379
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -97.9030785,
    "lat": 31.124062
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -72.7420399,
    "lat": 41.7620447
  },
  {
    "lng": 118.7788631,
    "lat": 32.0438284
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": 44.507897,
    "lat": 40.1553328
  },
  {
    "lng": -74.0308504,
    "lat": 40.9543943
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -0.6486943,
    "lat": 44.8854667
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.2270272,
    "lat": 47.3826903
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -74.6597376,
    "lat": 40.3496953
  },
  {
    "lng": -75.3015714,
    "lat": 40.0792766
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -84.8561524,
    "lat": 45.0644549
  },
  {
    "lng": -117.929416,
    "lat": 33.8708215
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -96.0940696,
    "lat": 33.1104423
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -76.5483724,
    "lat": 42.4374175
  },
  {
    "lng": -1.1491319,
    "lat": 44.6316943
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -93.2020856,
    "lat": 44.4294359
  },
  {
    "lng": -122.989827,
    "lat": 45.5228939
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.2385432,
    "lat": 48.8126688
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -3.2254545,
    "lat": 57.4707462
  },
  {
    "lng": -95.5100213,
    "lat": 29.7326068
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 9.404651,
    "lat": 45.531574
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.8706239,
    "lat": 47.6846685
  },
  {
    "lng": -93.0372808,
    "lat": 44.8906694
  },
  {
    "lng": -71.1564428,
    "lat": 42.4153739
  },
  {
    "lng": -75.8543591,
    "lat": 42.8484003
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -74.4032354,
    "lat": 40.8623835
  },
  {
    "lng": -82.005019,
    "lat": 39.9401426
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -121.99059,
    "lat": 37.050096
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": -111.8486019,
    "lat": 40.3881114
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -149.894852,
    "lat": 61.2163129
  },
  {
    "lng": 17.6346815,
    "lat": 47.687609
  },
  {
    "lng": 5.2298398,
    "lat": 45.6230017
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 0.9147818,
    "lat": 45.2740403
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -75.9279495,
    "lat": 40.335345
  },
  {
    "lng": -68.7713289,
    "lat": 44.8016255
  },
  {
    "lng": -95.2359403,
    "lat": 38.9719137
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 12.4483489,
    "lat": 55.6898267
  },
  {
    "lng": -76.42977,
    "lat": 36.9775016
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.4916592,
    "lat": 48.8387639
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -84.425589,
    "lat": 42.2416466
  },
  {
    "lng": -73.1867391,
    "lat": 41.1779095
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -2.3596963,
    "lat": 51.3813864
  },
  {
    "lng": -72.9724768,
    "lat": 43.6084792
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -1.3824404,
    "lat": 54.9061115
  },
  {
    "lng": -0.0746149,
    "lat": 47.6968408
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.4034182,
    "lat": 50.8720096
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -72.7420399,
    "lat": 41.7620447
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -73.8755317,
    "lat": 41.9950884
  },
  {
    "lng": -123.3417381,
    "lat": 43.216505
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.2860371,
    "lat": 34.2475493
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.0414701,
    "lat": 47.3215806
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.7771661,
    "lat": 40.4574358
  },
  {
    "lng": -71.1551119,
    "lat": 42.3473519
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -97.8772103,
    "lat": 29.9892928
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -73.362773,
    "lat": 42.1939364
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -96.3455991,
    "lat": 30.6183939
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.5508407,
    "lat": 35.595363
  },
  {
    "lng": 3.6959771,
    "lat": 43.4014434
  },
  {
    "lng": -84.6154897,
    "lat": 34.0234337
  },
  {
    "lng": 2.30551,
    "lat": 48.9026
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": 1.9988356,
    "lat": 48.7760957
  },
  {
    "lng": -95.1291755,
    "lat": 47.5199538
  },
  {
    "lng": 1.1510164,
    "lat": 49.0268903
  },
  {
    "lng": -81.684004,
    "lat": 36.2187873
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -123.194463,
    "lat": 45.2100367
  },
  {
    "lng": -79.2894688,
    "lat": 37.2337555
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -92.4116886,
    "lat": 41.0195659
  },
  {
    "lng": -81.5231597,
    "lat": 40.7965119
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.4164151,
    "lat": 46.2862206
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -122.4737053,
    "lat": 47.4208759
  },
  {
    "lng": -74.0279152,
    "lat": 40.2001133
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -105.0372046,
    "lat": 39.8366528
  },
  {
    "lng": -117.173895,
    "lat": 46.7304268
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 47.9734174,
    "lat": 29.3796532
  },
  {
    "lng": -73.0568716,
    "lat": 43.176909
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -0.3891355,
    "lat": 39.4200749
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -71.8046023,
    "lat": 42.5854371
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -74.4113926,
    "lat": 40.518157
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": -92.1880907,
    "lat": 43.8446296
  },
  {
    "lng": 13.0006423,
    "lat": 48.7814115
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -72.1033194,
    "lat": -36.6066616
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -71.2092214,
    "lat": 42.3370414
  },
  {
    "lng": -0.0215164,
    "lat": 51.4758453
  },
  {
    "lng": -70.082796,
    "lat": 41.7601093
  },
  {
    "lng": -96.5716694,
    "lat": 39.1836082
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -87.2919449,
    "lat": 34.4817816
  },
  {
    "lng": 2.9207275,
    "lat": 42.5428648
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -61.558498,
    "lat": 10.7358489
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": -90.7327362,
    "lat": 29.6494109
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -84.1441046,
    "lat": 34.0028569
  },
  {
    "lng": -79.8725386,
    "lat": 36.6915262
  },
  {
    "lng": 100.567508,
    "lat": 13.8282197
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -72.2505752,
    "lat": 41.8119557
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -72.524362,
    "lat": 40.8695775
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -120.1835765,
    "lat": 39.3279454
  },
  {
    "lng": -0.3234333,
    "lat": 45.01906
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.4718201,
    "lat": 40.5892696
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -96.7077751,
    "lat": 40.8088861
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -77.7145945,
    "lat": 39.1366223
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -70.9754432,
    "lat": 41.9902206
  },
  {
    "lng": -97.6200043,
    "lat": 30.4393696
  },
  {
    "lng": 4.3737121,
    "lat": 50.8676041
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -100.4100445,
    "lat": 20.6004322
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.2810994,
    "lat": 42.03726
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -73.6731749,
    "lat": 42.4134168
  },
  {
    "lng": -111.6944313,
    "lat": 40.2981599
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -88.9843937,
    "lat": 40.5092961
  },
  {
    "lng": 2.2695658,
    "lat": 48.884683
  },
  {
    "lng": -111.651822,
    "lat": 35.1987522
  },
  {
    "lng": 2.4875193,
    "lat": 48.8716626
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": -97.2271249,
    "lat": 32.9299655
  },
  {
    "lng": -74.9746136,
    "lat": 40.0384448
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -82.6359078,
    "lat": 27.7700475
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -95.4560512,
    "lat": 30.3118769
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -72.6311006,
    "lat": 42.3178989
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -86.1095429,
    "lat": 39.6136987
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -77.5205485,
    "lat": 40.0507198
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": -1.7616499,
    "lat": 43.3641518
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -93.9993505,
    "lat": 44.1634663
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -122.2566367,
    "lat": 38.1040864
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -81.4828123,
    "lat": 41.1362729
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -104.7612638,
    "lat": 39.5184514
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": -75.9125187,
    "lat": 42.098698
  },
  {
    "lng": 7.219985,
    "lat": 51.5380394
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -91.2514355,
    "lat": 43.8122836
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -90.1740313,
    "lat": 44.6662287
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.5822632,
    "lat": 33.8188333
  },
  {
    "lng": -85.8590603,
    "lat": 41.6012796
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -4.1927219,
    "lat": 40.7148269
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.659179,
    "lat": 42.451377
  },
  {
    "lng": -73.6652451,
    "lat": 43.3618532
  },
  {
    "lng": -82.1257074,
    "lat": 38.0364535
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.1304176,
    "lat": 40.0687271
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 7.1513834,
    "lat": 43.6612012
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -107.812285,
    "lat": 37.9374939
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -87.6835974,
    "lat": 30.4065868
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -73.7056955,
    "lat": 40.6631362
  },
  {
    "lng": -84.2332718,
    "lat": 39.5522815
  },
  {
    "lng": -157.924442,
    "lat": 21.6438449
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -123.033121,
    "lat": 44.9391565
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -86.8689419,
    "lat": 35.925206
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 0.0689113,
    "lat": 51.5589375
  },
  {
    "lng": -80.9271271,
    "lat": 29.0258132
  },
  {
    "lng": -111.9383931,
    "lat": 41.0349847
  },
  {
    "lng": -3.3660907,
    "lat": 47.7477336
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -87.7521069,
    "lat": 42.0262972
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 113.2592945,
    "lat": 23.1301964
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -118.11711,
    "lat": 34.5793131
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.75596,
    "lat": 51.6317449
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -86.9352842,
    "lat": 34.4434282
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -80.0728201,
    "lat": 26.4614625
  },
  {
    "lng": -75.0629531,
    "lat": 42.453492
  },
  {
    "lng": -79.5656326,
    "lat": 43.6435559
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 2.4516055,
    "lat": 48.8897751
  },
  {
    "lng": -73.7164845,
    "lat": 40.7242205
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -75.2782317,
    "lat": 40.2109404
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 75.851601,
    "lat": 30.9090157
  },
  {
    "lng": -94.5649938,
    "lat": 37.1767058
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -2.7603283,
    "lat": 48.5141134
  },
  {
    "lng": -75.3433705,
    "lat": 40.1148787
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -83.9463359,
    "lat": 42.4567013
  },
  {
    "lng": -117.826166,
    "lat": 33.7458511
  },
  {
    "lng": -84.4721678,
    "lat": 42.7320307
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -92.4453558,
    "lat": 31.3119463
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 105.8406959,
    "lat": 21.0242596
  },
  {
    "lng": -85.9724787,
    "lat": 34.72425
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": 2.2695658,
    "lat": 48.884683
  },
  {
    "lng": -95.6349463,
    "lat": 29.6196787
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -77.2987377,
    "lat": 38.896795
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -8.8932341,
    "lat": 38.5241783
  },
  {
    "lng": 8.4860144,
    "lat": 47.1975084
  },
  {
    "lng": -77.3724593,
    "lat": 35.613224
  },
  {
    "lng": 2.1868998,
    "lat": 48.9229416
  },
  {
    "lng": -92.2896267,
    "lat": 34.7465071
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -73.4945668,
    "lat": 41.146763
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 6.1069469,
    "lat": 46.0338359
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 2.1802832,
    "lat": 48.87778
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": -122.2566367,
    "lat": 38.1040864
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -91.8992837,
    "lat": 30.2735323
  },
  {
    "lng": -118.4720281,
    "lat": 34.4233293
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -2.0260409,
    "lat": 48.649518
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -84.0199108,
    "lat": 33.857328
  },
  {
    "lng": 6.4086189,
    "lat": 46.0775797
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": -96.4058782,
    "lat": 42.4966815
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": -76.2899539,
    "lat": 36.8493695
  },
  {
    "lng": -78.669997,
    "lat": 42.9005956
  },
  {
    "lng": 1.534421,
    "lat": 38.9846117
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.1259014,
    "lat": 48.7739339
  },
  {
    "lng": -77.2651762,
    "lat": 38.9013729
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -1.1491319,
    "lat": 44.6316943
  },
  {
    "lng": -118.2478471,
    "lat": 34.1469416
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -71.0304858,
    "lat": 43.5539309
  },
  {
    "lng": -73.9442812,
    "lat": 41.117785
  },
  {
    "lng": -83.4754913,
    "lat": 42.48059
  },
  {
    "lng": -124.08284,
    "lat": 40.866517
  },
  {
    "lng": 1.8538446,
    "lat": 50.9524769
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": -86.5342881,
    "lat": 39.1670396
  },
  {
    "lng": -95.2864299,
    "lat": 29.5639758
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -58.1624465,
    "lat": 6.8137426
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.6075,
    "lat": 43.291698
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.9293862,
    "lat": 50.9239397
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -79.988494,
    "lat": 40.674863
  },
  {
    "lng": -47.1355473,
    "lat": -23.5304843
  },
  {
    "lng": -83.3771553,
    "lat": 42.4853125
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.7771661,
    "lat": 40.4574358
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -76.053813,
    "lat": 42.0850703
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -95.8937398,
    "lat": 41.1365122
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -76.2494453,
    "lat": 36.7168315
  },
  {
    "lng": 11.3525415,
    "lat": 55.4061196
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -71.1736669,
    "lat": 42.5464828
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 3.4030556,
    "lat": 49.9216667
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -112.185994,
    "lat": 33.5386858
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.7057035,
    "lat": 42.9132581
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": 35.4873214,
    "lat": 38.7219011
  },
  {
    "lng": 9.7062018,
    "lat": 4.0429389
  },
  {
    "lng": -7.6200284,
    "lat": 33.5945144
  },
  {
    "lng": -123.0950506,
    "lat": 44.0505054
  },
  {
    "lng": -86.6722192,
    "lat": 36.0600602
  },
  {
    "lng": -101.296273,
    "lat": 48.23251
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -97.8772103,
    "lat": 29.9892928
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -92.1724265,
    "lat": 38.577359
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 173.9545856,
    "lat": -41.5118691
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -118.3293255,
    "lat": 33.8317716
  },
  {
    "lng": -106.82356,
    "lat": 39.1911128
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 6.2341093,
    "lat": 46.1934005
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.657047,
    "lat": 49.1039289
  },
  {
    "lng": -120.1835765,
    "lat": 39.3279454
  },
  {
    "lng": -73.2435218,
    "lat": 40.7276525
  },
  {
    "lng": -88.7713953,
    "lat": 41.8903447
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -101.8470215,
    "lat": 33.5855677
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -0.2427217,
    "lat": 44.9133742
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.822871,
    "lat": 29.7957633
  },
  {
    "lng": 2.6041207,
    "lat": 44.2902029
  },
  {
    "lng": -76.895924,
    "lat": 37.1118778
  },
  {
    "lng": -121.3153096,
    "lat": 44.0581728
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -48.5496098,
    "lat": -27.5973002
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 2.0381228,
    "lat": 48.7698937
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -0.6450841,
    "lat": 53.5922488
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -79.9414313,
    "lat": 37.270973
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": -92.5310689,
    "lat": 45.1968942
  },
  {
    "lng": -71.9698085,
    "lat": 42.1340806
  },
  {
    "lng": -1.1518287,
    "lat": 51.8988832
  },
  {
    "lng": -73.4078968,
    "lat": 41.1175966
  },
  {
    "lng": -122.1768209,
    "lat": 48.0517429
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -93.7477839,
    "lat": 32.5135356
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0004744,
    "lat": 43.8020626
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -74.1304176,
    "lat": 40.0687271
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -116.4139839,
    "lat": 34.1236205
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -98.5020777,
    "lat": 33.9004572
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.309939,
    "lat": 39.3600586
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 1.8967943,
    "lat": 43.9016766
  },
  {
    "lng": 7.4900618,
    "lat": 48.6217367
  },
  {
    "lng": -73.343167,
    "lat": 40.9009595
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -91.1869659,
    "lat": 30.4494155
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.5116471,
    "lat": 28.6732806
  },
  {
    "lng": -92.4398402,
    "lat": 35.0891932
  },
  {
    "lng": -92.4364298,
    "lat": 39.4201137
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -83.5378173,
    "lat": 41.6529143
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -97.9405828,
    "lat": 29.8826436
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.3002885,
    "lat": 48.9875044
  },
  {
    "lng": -89.2726708,
    "lat": 40.7213015
  },
  {
    "lng": -74.5240422,
    "lat": 39.3898388
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -84.5546295,
    "lat": 42.7338254
  },
  {
    "lng": -79.7919754,
    "lat": 36.0726355
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -90.9562125,
    "lat": 30.4868564
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -112.281933,
    "lat": 33.6290111
  },
  {
    "lng": -83.1876578,
    "lat": 35.9670412
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 6.6836292,
    "lat": 46.5341057
  },
  {
    "lng": -118.4492148,
    "lat": 34.3076252
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -91.0465742,
    "lat": 39.4492151
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -77.466733,
    "lat": 39.308889
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.5236066,
    "lat": 52.2646577
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -1.4246132,
    "lat": 46.1941088
  },
  {
    "lng": -71.1551119,
    "lat": 42.3473519
  },
  {
    "lng": -0.7697191,
    "lat": 44.6063022
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 11.9670171,
    "lat": 57.7072326
  },
  {
    "lng": 4.0493919,
    "lat": 36.7137843
  },
  {
    "lng": -76.9832568,
    "lat": 39.8005316
  },
  {
    "lng": -0.9786725,
    "lat": 51.9983175
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -81.7832912,
    "lat": 32.4490141
  },
  {
    "lng": -1.9254545,
    "lat": 46.692985
  },
  {
    "lng": -92.3801187,
    "lat": 36.3361391
  },
  {
    "lng": -70.6624608,
    "lat": 42.6153595
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -88.3123889,
    "lat": 43.0622536
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": 121.0744942,
    "lat": 14.5270538
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": -74.0093129,
    "lat": 40.7856117
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -71.1843236,
    "lat": 42.3652518
  },
  {
    "lng": 44.0229853,
    "lat": 36.198
  },
  {
    "lng": 115.2191175,
    "lat": -8.6524973
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -72.0759008,
    "lat": 41.5243537
  },
  {
    "lng": -87.9802164,
    "lat": 42.0811563
  },
  {
    "lng": -77.3464516,
    "lat": 38.953282
  },
  {
    "lng": -122.232523,
    "lat": 37.4863239
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -84.408275,
    "lat": 39.3303357
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -75.1721232,
    "lat": 39.7940026
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 2.3340758,
    "lat": 48.7945413
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.3635615,
    "lat": 49.1813403
  },
  {
    "lng": -72.9020069,
    "lat": 41.3836233
  },
  {
    "lng": -58.7950701,
    "lat": -34.3453213
  },
  {
    "lng": -111.6944313,
    "lat": 40.2981599
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -83.0929645,
    "lat": 39.8814519
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": 9.3762397,
    "lat": 47.425618
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -122.32642,
    "lat": 48.4200462
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -88.2430932,
    "lat": 40.1164841
  },
  {
    "lng": -105.101928,
    "lat": 40.1672117
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -84.5930113,
    "lat": 35.4428864
  },
  {
    "lng": -105.6151839,
    "lat": 41.3087527
  },
  {
    "lng": 3.3279296,
    "lat": 48.0056204
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.9450759,
    "lat": 35.0073697
  },
  {
    "lng": -108.49607,
    "lat": 45.7874957
  },
  {
    "lng": -85.9529685,
    "lat": 42.9903205
  },
  {
    "lng": -87.9802164,
    "lat": 42.0811563
  },
  {
    "lng": -97.1413417,
    "lat": 33.1838787
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -120.5785796,
    "lat": 35.1235374
  },
  {
    "lng": -110.111445,
    "lat": 48.179976
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -84.5147454,
    "lat": 33.883887
  },
  {
    "lng": -117.019529,
    "lat": 32.5317397
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -88.7774734,
    "lat": 46.8591287
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": 28.9758715,
    "lat": 41.006381
  },
  {
    "lng": -84.2747329,
    "lat": 34.0709576
  },
  {
    "lng": -87.4139119,
    "lat": 39.4667025
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.7974133,
    "lat": 40.9880495
  },
  {
    "lng": 2.4151151,
    "lat": 48.6538754
  },
  {
    "lng": -122.232523,
    "lat": 37.4863239
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -93.161159,
    "lat": 44.4582041
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.072557,
    "lat": 38.1495947
  },
  {
    "lng": -122.1180201,
    "lat": 37.8857582
  },
  {
    "lng": -74.4032354,
    "lat": 40.8623835
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -96.7077751,
    "lat": 40.8088861
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.3134994,
    "lat": 44.821906
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -74.4113926,
    "lat": 40.518157
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -91.4984941,
    "lat": 44.811349
  },
  {
    "lng": -98.9472344,
    "lat": 40.4906216
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -90.7195348,
    "lat": 29.5957696
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": -80.7093066,
    "lat": 38.6641653
  },
  {
    "lng": -3.4085863,
    "lat": 51.6125883
  },
  {
    "lng": -89.0226793,
    "lat": 42.6829765
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -1.548621,
    "lat": 53.794414
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -80.1060506,
    "lat": 40.7099343
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -117.7517496,
    "lat": 34.0553813
  },
  {
    "lng": -73.4036319,
    "lat": 40.8472369
  },
  {
    "lng": 73.8282141,
    "lat": 15.4989946
  },
  {
    "lng": -42.0189227,
    "lat": -22.8804369
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 75.851601,
    "lat": 30.9090157
  },
  {
    "lng": 2.134529,
    "lat": 48.7018823
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -122.0832101,
    "lat": 37.3893889
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -51.2303767,
    "lat": -30.0324999
  },
  {
    "lng": -122.47267,
    "lat": 37.6904826
  },
  {
    "lng": 6.0243622,
    "lat": 47.2380222
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": -87.7834769,
    "lat": 42.7313756
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -88.1479278,
    "lat": 41.7728699
  },
  {
    "lng": 2.5221284,
    "lat": 48.7711323
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -71.2503157,
    "lat": 41.6024068
  },
  {
    "lng": -73.513589,
    "lat": 40.663289
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -118.11711,
    "lat": 34.5793131
  },
  {
    "lng": -75.2099866,
    "lat": 40.6916081
  },
  {
    "lng": -88.1479278,
    "lat": 41.7728699
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -118.4486675,
    "lat": 34.1866193
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -86.6694413,
    "lat": 35.9522852
  },
  {
    "lng": -76.5932369,
    "lat": 40.3088578
  },
  {
    "lng": 34.7818064,
    "lat": 32.0852997
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": 8.6238228,
    "lat": 47.3324061
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -77.4752667,
    "lat": 38.7509488
  },
  {
    "lng": 0.0504338,
    "lat": 52.4549017
  },
  {
    "lng": -99.1332716,
    "lat": 19.4933046
  },
  {
    "lng": 12.3063909,
    "lat": 55.9285735
  },
  {
    "lng": 6.4813654,
    "lat": 46.5047105
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.5588696,
    "lat": 44.7896878
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -89.7761955,
    "lat": 35.1556451
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.9105031,
    "lat": 48.5515697
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.8919011,
    "lat": 40.4191229
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -80.3819984,
    "lat": 36.0215258
  },
  {
    "lng": -70.2586618,
    "lat": 43.6573605
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -117.575173,
    "lat": 34.1033192
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -48.5496098,
    "lat": -27.5973002
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -73.7676998,
    "lat": 41.157284
  },
  {
    "lng": 15.3122511,
    "lat": -4.32171
  },
  {
    "lng": -96.9442177,
    "lat": 32.8295183
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -121.988571,
    "lat": 37.5482697
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -85.5872286,
    "lat": 42.291707
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.3905714,
    "lat": 45.6134459
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -84.1457505,
    "lat": 33.8062166
  },
  {
    "lng": -89.0078418,
    "lat": 34.4942683
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 2.4516055,
    "lat": 48.8897751
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.6078667,
    "lat": 42.4773097
  },
  {
    "lng": 7.8191185,
    "lat": 51.681281
  },
  {
    "lng": -79.1802994,
    "lat": 35.4798757
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.462609,
    "lat": 44.1858193
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.984579,
    "lat": 28.8759024
  },
  {
    "lng": -86.8647316,
    "lat": 39.6444898
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -93.6648083,
    "lat": 45.210202
  },
  {
    "lng": -91.5195542,
    "lat": 30.4913049
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.227781,
    "lat": 52.0266526
  },
  {
    "lng": -111.841185,
    "lat": 33.3062031
  },
  {
    "lng": -111.789037,
    "lat": 33.3527632
  },
  {
    "lng": -71.2355644,
    "lat": 42.3762385
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -111.926018,
    "lat": 33.4942189
  },
  {
    "lng": 46.7160104,
    "lat": 24.638916
  },
  {
    "lng": -71.6874099,
    "lat": 42.4212463
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -101.2623797,
    "lat": 19.6546004
  },
  {
    "lng": -75.1268413,
    "lat": 40.0770553
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": 1.3018796,
    "lat": 45.1292139
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": -76.3490396,
    "lat": 39.5355063
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.767357,
    "lat": 51.8586611
  },
  {
    "lng": 33.3638783,
    "lat": 35.1746503
  },
  {
    "lng": -77.1516844,
    "lat": 39.0817985
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -124.1707558,
    "lat": 40.8018746
  },
  {
    "lng": -84.5810418,
    "lat": 33.5670562
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.7926335,
    "lat": 41.1328736
  },
  {
    "lng": -75.0307264,
    "lat": 39.9348351
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": -71.1187829,
    "lat": 42.332918
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -89.8614765,
    "lat": 36.8125531
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -77.3469994,
    "lat": 38.0498524
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -82.0041758,
    "lat": 28.9269978
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": -86.1283681,
    "lat": 39.9784186
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -122.391675,
    "lat": 40.5863563
  },
  {
    "lng": -2.7209129,
    "lat": 56.0581178
  },
  {
    "lng": 26.1009263,
    "lat": 44.4356444
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": -0.5097654,
    "lat": 50.9575636
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -73.0438362,
    "lat": 41.5538091
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 76.2444378,
    "lat": 9.9679032
  },
  {
    "lng": 5.1580574,
    "lat": 45.614003
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -4.2412484,
    "lat": 50.8309593
  },
  {
    "lng": -70.8089397,
    "lat": 43.2344819
  },
  {
    "lng": -79.7093339,
    "lat": 40.3301738
  },
  {
    "lng": -73.0438362,
    "lat": 41.5538091
  },
  {
    "lng": 3.3331703,
    "lat": 46.5660526
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -89.1980154,
    "lat": 43.0704473
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 1.874318,
    "lat": 43.0880677
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": -120.375716,
    "lat": 35.3540209
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -77.3063733,
    "lat": 38.8462236
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.4530731,
    "lat": 48.7771486
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 2.48291,
    "lat": 48.9031
  },
  {
    "lng": -87.6305899,
    "lat": 46.4481521
  },
  {
    "lng": -77.6573514,
    "lat": 36.4558016
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -71.2355644,
    "lat": 42.3762385
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": -48.2767837,
    "lat": -18.9188041
  },
  {
    "lng": -84.309939,
    "lat": 39.3600586
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -71.1061639,
    "lat": 42.4184296
  },
  {
    "lng": -95.0877465,
    "lat": 39.109724
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -75.613172,
    "lat": 41.0164681
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -121.290779,
    "lat": 37.9577016
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": 4.6009798,
    "lat": 46.0055024
  },
  {
    "lng": 7.0650378,
    "lat": 46.7207716
  },
  {
    "lng": -87.682932,
    "lat": 42.0693991
  },
  {
    "lng": 121.0486254,
    "lat": 14.6510546
  },
  {
    "lng": -72.8173481,
    "lat": 41.2746962
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.4542915,
    "lat": 44.6960855
  },
  {
    "lng": -2.2138905,
    "lat": 47.2733517
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.599472,
    "lat": 32.7666103
  },
  {
    "lng": -72.7420399,
    "lat": 41.7620447
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -0.5992399,
    "lat": 44.8661755
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -1.4264097,
    "lat": 53.2352134
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 34.7818064,
    "lat": 32.0852997
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.7761489,
    "lat": 44.8405364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -86.9352842,
    "lat": 34.4434282
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -74.1866348,
    "lat": 41.3304767
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 2.4093664,
    "lat": 48.7630238
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": 2.4093664,
    "lat": 48.7630238
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 6.083862,
    "lat": 50.776351
  },
  {
    "lng": -111.8874688,
    "lat": 40.9804423
  },
  {
    "lng": -74.8006895,
    "lat": 40.2688105
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -97.0585717,
    "lat": 36.1156306
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -76.6077213,
    "lat": 36.057938
  },
  {
    "lng": -76.492786,
    "lat": 38.9786401
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.2094566,
    "lat": 42.7135472
  },
  {
    "lng": 7.6072743,
    "lat": 48.6636843
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -59.1932003,
    "lat": -27.6048829
  },
  {
    "lng": -85.3094883,
    "lat": 35.0457219
  },
  {
    "lng": -90.1767012,
    "lat": 30.0018546
  },
  {
    "lng": -118.4720281,
    "lat": 34.4233293
  },
  {
    "lng": 2.2897124,
    "lat": 48.7997756
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -0.3635615,
    "lat": 49.1813403
  },
  {
    "lng": 3.9452194,
    "lat": 50.4431879
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -82.1073583,
    "lat": 41.3673191
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": -77.0722227,
    "lat": 39.1469872
  },
  {
    "lng": -80.7440174,
    "lat": 34.9248125
  },
  {
    "lng": -3.7331808,
    "lat": 40.3070639
  },
  {
    "lng": 5.80266,
    "lat": 45.2264498
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -91.5299106,
    "lat": 41.6612561
  },
  {
    "lng": -78.920589,
    "lat": 42.49645
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -111.044047,
    "lat": 45.6794293
  },
  {
    "lng": -80.0830984,
    "lat": 26.3586885
  },
  {
    "lng": -121.387742,
    "lat": 36.2231079
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": -3.8287012,
    "lat": 53.2811822
  },
  {
    "lng": -0.4450604,
    "lat": 44.6964363
  },
  {
    "lng": -1.5216228,
    "lat": 43.4367292
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -97.4649038,
    "lat": 35.6571367
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.8689419,
    "lat": 35.925206
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -78.7998691,
    "lat": 35.5843849
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.5547038,
    "lat": 33.3496662
  },
  {
    "lng": -122.2054035,
    "lat": 47.7623204
  },
  {
    "lng": -75.387693,
    "lat": 39.9167783
  },
  {
    "lng": -71.0811622,
    "lat": 42.3440285
  },
  {
    "lng": -3.7331808,
    "lat": 40.3070639
  },
  {
    "lng": -86.3921096,
    "lat": 35.8460396
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": 2.3469255,
    "lat": 48.7714153
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -97.9883477,
    "lat": 30.4601975
  },
  {
    "lng": -111.834914,
    "lat": 41.7313063
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 6.2736727,
    "lat": 50.8150263
  },
  {
    "lng": -116.8776005,
    "lat": 33.0472806
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": -122.4168664,
    "lat": 37.6535403
  },
  {
    "lng": -85.0985474,
    "lat": 32.5401394
  },
  {
    "lng": -79.5066895,
    "lat": 36.1029132
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -72.8557306,
    "lat": 41.6653064
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": 80.6160469,
    "lat": 16.5115306
  },
  {
    "lng": -90.7033292,
    "lat": 38.7902503
  },
  {
    "lng": -90.0040817,
    "lat": 32.6308318
  },
  {
    "lng": -117.3505966,
    "lat": 33.1580933
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0437839,
    "lat": 41.1130231
  },
  {
    "lng": -74.892082,
    "lat": 44.928106
  },
  {
    "lng": -1.8752368,
    "lat": 50.8801244
  },
  {
    "lng": 2.3568948,
    "lat": 48.9973824
  },
  {
    "lng": -17.447938,
    "lat": 14.693425
  },
  {
    "lng": 2.433498,
    "lat": 44.2767537
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 8.1957974,
    "lat": 52.5212651
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.3811273,
    "lat": 38.438232
  },
  {
    "lng": -85.0766113,
    "lat": 33.5801103
  },
  {
    "lng": -101.8470215,
    "lat": 33.5855677
  },
  {
    "lng": -86.2483921,
    "lat": 43.2341813
  },
  {
    "lng": 6.876568,
    "lat": 50.8807379
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -122.3455263,
    "lat": 37.9621457
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -79.6644748,
    "lat": 36.3548586
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -111.9741925,
    "lat": 41.0751048
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -77.3005305,
    "lat": 41.7486838
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": -71.7054364,
    "lat": 42.6672938
  },
  {
    "lng": -96.0083018,
    "lat": 32.7092955
  },
  {
    "lng": -71.2925571,
    "lat": 42.2964859
  },
  {
    "lng": 3.8969928,
    "lat": 7.3786064
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -75.082115,
    "lat": 40.2962179
  },
  {
    "lng": 73.8545071,
    "lat": 18.5213738
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -105.220306,
    "lat": 20.6407176
  },
  {
    "lng": -90.8887413,
    "lat": 43.5569174
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -122.1238767,
    "lat": 47.6694141
  },
  {
    "lng": -80.3123023,
    "lat": 43.3600536
  },
  {
    "lng": -86.9080655,
    "lat": 40.4258686
  },
  {
    "lng": -119.9843482,
    "lat": 38.9332411
  },
  {
    "lng": -72.7795419,
    "lat": 41.6612104
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": -117.9463717,
    "lat": 33.7746292
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -87.9822969,
    "lat": 43.2219088
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -73.4856789,
    "lat": 41.4664832
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -120.1381144,
    "lat": 34.5960774
  },
  {
    "lng": -111.926018,
    "lat": 33.4942189
  },
  {
    "lng": -117.826166,
    "lat": 33.7458511
  },
  {
    "lng": -116.875289,
    "lat": 33.9255685
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 9.2719656,
    "lat": 47.6955538
  },
  {
    "lng": -111.6944313,
    "lat": 40.2981599
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -118.8375937,
    "lat": 34.1705609
  },
  {
    "lng": -76.9314571,
    "lat": 40.4691049
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -7.2514438,
    "lat": 52.6506255
  },
  {
    "lng": -113.584131,
    "lat": 37.104153
  },
  {
    "lng": -88.0125794,
    "lat": 44.5126379
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -119.119919,
    "lat": 46.2087066
  },
  {
    "lng": -73.0151084,
    "lat": 40.7656539
  },
  {
    "lng": 4.3737121,
    "lat": 50.8676041
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": -116.392326,
    "lat": 43.6086295
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -114.363662,
    "lat": 43.680741
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -94.626497,
    "lat": 39.1134562
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -81.83511,
    "lat": 41.3144733
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": 39.1742363,
    "lat": 21.5504432
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -73.5293246,
    "lat": 40.7695303
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.3268669,
    "lat": 48.7316381
  },
  {
    "lng": -73.1358091,
    "lat": -40.5736955
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -80.3503283,
    "lat": 27.2939333
  },
  {
    "lng": -83.8843455,
    "lat": 34.227602
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": 1.9009994,
    "lat": 50.4249356
  },
  {
    "lng": 5.0735802,
    "lat": 52.653272
  },
  {
    "lng": -90.5040214,
    "lat": 43.978576
  },
  {
    "lng": 6.8418655,
    "lat": 46.4602978
  },
  {
    "lng": -89.8481652,
    "lat": 40.0117151
  },
  {
    "lng": 2.3633048,
    "lat": 48.7921098
  },
  {
    "lng": -80.4742261,
    "lat": 35.6709727
  },
  {
    "lng": -89.216655,
    "lat": 37.7274692
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 12.6992687,
    "lat": 50.586993
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.9251809,
    "lat": 34.1851017
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -82.4333742,
    "lat": 42.9760854
  },
  {
    "lng": -119.9843482,
    "lat": 38.9332411
  },
  {
    "lng": 20.4568974,
    "lat": 44.8178131
  },
  {
    "lng": -85.0766113,
    "lat": 33.5801103
  },
  {
    "lng": -51.2303767,
    "lat": -30.0324999
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -82.0609557,
    "lat": 39.3575616
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -2.7397217,
    "lat": 51.1267494
  },
  {
    "lng": 2.2792058,
    "lat": 48.9911296
  },
  {
    "lng": -73.343167,
    "lat": 40.9009595
  },
  {
    "lng": -121.99059,
    "lat": 37.050096
  },
  {
    "lng": -74.1242816,
    "lat": 40.8120247
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": 10.135555,
    "lat": 54.3227085
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.4979963,
    "lat": 40.6460921
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -17.447938,
    "lat": 14.693425
  },
  {
    "lng": -4.3965573,
    "lat": 48.4075514
  },
  {
    "lng": -79.0287742,
    "lat": -8.1116778
  },
  {
    "lng": 9.4978479,
    "lat": 51.3157833
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -1.5294444,
    "lat": 46.8244444
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -121.1246966,
    "lat": 37.7394666
  },
  {
    "lng": -0.1872229,
    "lat": 44.8304495
  },
  {
    "lng": 5.8279653,
    "lat": 51.4283287
  },
  {
    "lng": 11.7299205,
    "lat": 48.1475774
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -2.8690655,
    "lat": 47.6554463
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -116.8776005,
    "lat": 33.0472806
  },
  {
    "lng": 4.031926,
    "lat": 49.2577886
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -121.988571,
    "lat": 37.5482697
  },
  {
    "lng": -84.1457505,
    "lat": 33.8062166
  },
  {
    "lng": -58.4026638,
    "lat": -34.7572582
  },
  {
    "lng": -96.6705503,
    "lat": 33.1031744
  },
  {
    "lng": 46.7160104,
    "lat": 24.638916
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -85.8155576,
    "lat": 42.0258779
  },
  {
    "lng": -84.0373054,
    "lat": 41.8975152
  },
  {
    "lng": -87.8569745,
    "lat": 41.900299
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 91.753943,
    "lat": 26.1805978
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 5.4710661,
    "lat": 43.455613
  },
  {
    "lng": -83.7846458,
    "lat": 42.5316918
  },
  {
    "lng": -6.8408929,
    "lat": 34.0218454
  },
  {
    "lng": -81.3578047,
    "lat": 41.1513108
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -74.0643065,
    "lat": 40.3470543
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -101.8470215,
    "lat": 33.5855677
  },
  {
    "lng": -87.8445119,
    "lat": 42.1711365
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -87.8495946,
    "lat": 41.4979467
  },
  {
    "lng": -1.1964165,
    "lat": 53.1443785
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": 2.2765575,
    "lat": 49.1512109
  },
  {
    "lng": -123.0737925,
    "lat": 49.3206294
  },
  {
    "lng": -75.6059638,
    "lat": 39.9597213
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -93.9585295,
    "lat": 44.3238384
  },
  {
    "lng": -77.1929215,
    "lat": 39.1399187
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -91.6704053,
    "lat": 41.9758872
  },
  {
    "lng": -75.5243682,
    "lat": 39.158168
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -73.790959,
    "lat": 42.2528649
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -84.4721678,
    "lat": 42.7320307
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": -0.2427217,
    "lat": 44.9133742
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 0.983698,
    "lat": 47.4110351
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -78.8893999,
    "lat": 38.0686668
  },
  {
    "lng": 2.8319805,
    "lat": 50.4291723
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 7.3625953,
    "lat": 48.7419909
  },
  {
    "lng": -81.345941,
    "lat": 41.239223
  },
  {
    "lng": -82.1518927,
    "lat": 36.9440023
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -122.0660914,
    "lat": 48.0197794
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 7.7523716,
    "lat": 48.6148396
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -92.0178202,
    "lat": 30.2262187
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.9279495,
    "lat": 40.335345
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 5.8008839,
    "lat": 43.1177238
  },
  {
    "lng": -4.400979,
    "lat": 48.4346366
  },
  {
    "lng": -80.6072138,
    "lat": 36.4993877
  },
  {
    "lng": -97.3375448,
    "lat": 37.6922361
  },
  {
    "lng": -74.4118169,
    "lat": 40.3178867
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -88.207301,
    "lat": 40.1117174
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -89.8739753,
    "lat": 35.2045329
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -87.9403418,
    "lat": 41.8994745
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -80.5800049,
    "lat": 35.4094178
  },
  {
    "lng": -100.3917424,
    "lat": 20.5922997
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -97.9405828,
    "lat": 29.8826436
  },
  {
    "lng": -88.7774734,
    "lat": 46.8591287
  },
  {
    "lng": -77.7191081,
    "lat": 39.6430455
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -74.3592296,
    "lat": 40.7182356
  },
  {
    "lng": -123.1342796,
    "lat": 49.7588883
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": 7.4652789,
    "lat": 51.5142273
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -118.6058382,
    "lat": 34.1684364
  },
  {
    "lng": -74.3229264,
    "lat": 40.6517692
  },
  {
    "lng": -89.7045439,
    "lat": 39.676163
  },
  {
    "lng": -75.9015974,
    "lat": 37.4059695
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -117.035864,
    "lat": 32.9628234
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -93.1566107,
    "lat": 45.0060767
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.0324321,
    "lat": 44.6092335
  },
  {
    "lng": -87.3653136,
    "lat": 41.4169806
  },
  {
    "lng": -95.7507897,
    "lat": 30.2095594
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": 12.5178995,
    "lat": 55.6539644
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -84.0199108,
    "lat": 33.857328
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 14.0139733,
    "lat": 51.1825771
  },
  {
    "lng": -122.0660914,
    "lat": 48.0197794
  },
  {
    "lng": -104.969565,
    "lat": 39.5497243
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.8953815,
    "lat": 40.5710454
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -82.7535049,
    "lat": 39.8842304
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 11.479351,
    "lat": 47.8646925
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 3.6959771,
    "lat": 43.4014434
  },
  {
    "lng": -73.7629097,
    "lat": 41.0339862
  },
  {
    "lng": -0.5732063,
    "lat": 51.2356068
  },
  {
    "lng": 6.9477708,
    "lat": 48.2873153
  },
  {
    "lng": -122.2034496,
    "lat": 47.4799078
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -98.3252932,
    "lat": 26.2159066
  },
  {
    "lng": -100.8307739,
    "lat": 20.5222851
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -119.8276389,
    "lat": 34.4358295
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -88.0434304,
    "lat": 42.1105502
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1304588,
    "lat": 40.3100446
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -122.636465,
    "lat": 38.2325829
  },
  {
    "lng": -0.3311238,
    "lat": 51.5714876
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": -71.8225254,
    "lat": 43.1797486
  },
  {
    "lng": -74.0098299,
    "lat": 41.5000767
  },
  {
    "lng": -97.3375448,
    "lat": 37.6922361
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": -122.5246791,
    "lat": 47.6515096
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.2472478,
    "lat": 45.618344
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -114.9822486,
    "lat": 36.0319843
  },
  {
    "lng": -68.7713289,
    "lat": 44.8016255
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -101.8470215,
    "lat": 33.5855677
  },
  {
    "lng": -82.1981764,
    "lat": 33.4504157
  },
  {
    "lng": -93.530214,
    "lat": 47.237166
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 120.6962716,
    "lat": 16.3800747
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -73.6450664,
    "lat": 40.6574186
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 4.668101,
    "lat": 45.8910218
  },
  {
    "lng": -80.3414693,
    "lat": 33.9204354
  },
  {
    "lng": -0.2678212,
    "lat": 51.3326098
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 7.3579641,
    "lat": 48.0777517
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -71.630859,
    "lat": 43.695667
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": -111.9741925,
    "lat": 41.0751048
  },
  {
    "lng": -76.5483724,
    "lat": 42.4374175
  },
  {
    "lng": -73.8645734,
    "lat": 42.2173102
  },
  {
    "lng": -75.5149128,
    "lat": 40.1303822
  },
  {
    "lng": 0.0483875,
    "lat": 50.7945315
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -119.700583,
    "lat": 45.839855
  },
  {
    "lng": 28.9758715,
    "lat": 41.006381
  },
  {
    "lng": -117.2919818,
    "lat": 33.0369867
  },
  {
    "lng": 2.3469255,
    "lat": 48.7714153
  },
  {
    "lng": -77.6460477,
    "lat": 38.975841
  },
  {
    "lng": -93.9585295,
    "lat": 44.3238384
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -72.0807772,
    "lat": 42.1084385
  },
  {
    "lng": -93.3023898,
    "lat": 45.1728923
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.101928,
    "lat": 40.1672117
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 6.9881194,
    "lat": 51.0324743
  },
  {
    "lng": 25.3258422,
    "lat": 60.3001908
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -73.8755317,
    "lat": 41.9950884
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -78.8660527,
    "lat": 43.0407742
  },
  {
    "lng": -95.8243956,
    "lat": 29.7857853
  },
  {
    "lng": -71.6472988,
    "lat": 43.4442432
  },
  {
    "lng": -80.0394977,
    "lat": 40.3275697
  },
  {
    "lng": -95.6971686,
    "lat": 29.9691116
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -87.9751964,
    "lat": 41.7950525
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -108.56448,
    "lat": 39.0672568
  },
  {
    "lng": -89.6272791,
    "lat": 44.9597858
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 5.6039516,
    "lat": 46.9756991
  },
  {
    "lng": -82.7342919,
    "lat": 35.2334472
  },
  {
    "lng": -84.6266111,
    "lat": 38.9989499
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -93.5885717,
    "lat": 44.0172242
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -72.1290542,
    "lat": 41.343025
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -71.0744952,
    "lat": 42.2973205
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -95.8243956,
    "lat": 29.7857853
  },
  {
    "lng": -88.083406,
    "lat": 42.0333608
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.1386015,
    "lat": 41.0799898
  },
  {
    "lng": -77.2676335,
    "lat": 38.636447
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.1040242,
    "lat": 50.9391812
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -95.7607832,
    "lat": 29.5821811
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -82.6418883,
    "lat": 39.7886111
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -76.5528831,
    "lat": 39.155816
  },
  {
    "lng": -111.044047,
    "lat": 45.6794293
  },
  {
    "lng": -111.8486019,
    "lat": 40.3881114
  },
  {
    "lng": 24.8762702,
    "lat": 42.0073633
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -96.9146374,
    "lat": 19.5408338
  },
  {
    "lng": -1.4852861,
    "lat": 51.7838848
  },
  {
    "lng": -121.3153096,
    "lat": 44.0581728
  },
  {
    "lng": -81.8723084,
    "lat": 26.640628
  },
  {
    "lng": -83.1933893,
    "lat": 37.2489635
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": -86.5819394,
    "lat": 36.0156178
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 15.9622315,
    "lat": 45.8426414
  },
  {
    "lng": 5.3242942,
    "lat": 46.1773941
  },
  {
    "lng": -80.9271271,
    "lat": 29.0258132
  },
  {
    "lng": -88.8893818,
    "lat": 30.4007626
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.3627245,
    "lat": 51.9994572
  },
  {
    "lng": -78.3199496,
    "lat": 44.3048009
  },
  {
    "lng": -116.602983,
    "lat": 31.8658887
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": -111.787022,
    "lat": 43.8235163
  },
  {
    "lng": -84.9880449,
    "lat": 32.4610708
  },
  {
    "lng": -121.9357918,
    "lat": 37.7021521
  },
  {
    "lng": -79.2576479,
    "lat": 43.7729744
  },
  {
    "lng": 33.8307062,
    "lat": 27.222556
  },
  {
    "lng": 9.2053999,
    "lat": 45.649723
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 2.8953121,
    "lat": 42.6985304
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 2.4452231,
    "lat": 48.906387
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -74.9226665,
    "lat": 40.1745538
  },
  {
    "lng": -1.2620038,
    "lat": 52.3726682
  },
  {
    "lng": 2.1701573,
    "lat": 48.681708
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -81.3578047,
    "lat": 41.1513108
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.1425781,
    "lat": 39.4850848
  },
  {
    "lng": -87.8536288,
    "lat": 41.630663
  },
  {
    "lng": -84.5496148,
    "lat": 33.9528472
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -117.903317,
    "lat": 33.6633386
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -118.5369316,
    "lat": 34.2345615
  },
  {
    "lng": -122.036349,
    "lat": 37.3688301
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.4516055,
    "lat": 48.8897751
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.7191081,
    "lat": 39.6430455
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.4628135,
    "lat": 36.8414197
  },
  {
    "lng": -122.2034496,
    "lat": 47.4799078
  },
  {
    "lng": -101.8470215,
    "lat": 33.5855677
  },
  {
    "lng": -85.9213796,
    "lat": 39.2014405
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.5342881,
    "lat": 39.1670396
  },
  {
    "lng": -114.0532996,
    "lat": 35.1895921
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -118.5538088,
    "lat": 34.4127963
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.3177933,
    "lat": 41.0461864
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -70.8967226,
    "lat": 42.5195292
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -4.1433925,
    "lat": 50.3780967
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -116.7811531,
    "lat": 47.6742994
  },
  {
    "lng": -2.7005643,
    "lat": 56.2227638
  },
  {
    "lng": 5.6713,
    "lat": 45.6207
  },
  {
    "lng": -123.2620435,
    "lat": 44.5645659
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -117.395582,
    "lat": 34.0701151
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": -120.1835765,
    "lat": 39.3279454
  },
  {
    "lng": -108.75902,
    "lat": 44.752873
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": 9.053596,
    "lat": 48.5203263
  },
  {
    "lng": -85.6802541,
    "lat": 40.1053196
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.9250518,
    "lat": 41.3082138
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -4.88562,
    "lat": 36.508976
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -121.955174,
    "lat": 37.3541132
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -76.8646092,
    "lat": 39.1938429
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -97.4649038,
    "lat": 35.6571367
  },
  {
    "lng": -84.7668495,
    "lat": 43.597646
  },
  {
    "lng": -107.3246941,
    "lat": 39.5466381
  },
  {
    "lng": -88.1450735,
    "lat": 41.9994722
  },
  {
    "lng": -1.5135474,
    "lat": 52.400739
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -84.2946539,
    "lat": 37.7478572
  },
  {
    "lng": -98.3898883,
    "lat": 40.5861322
  },
  {
    "lng": 2.2453842,
    "lat": 48.7144587
  },
  {
    "lng": -117.0430865,
    "lat": 34.033625
  },
  {
    "lng": -48.2767837,
    "lat": -18.9188041
  },
  {
    "lng": -158.009166,
    "lat": 21.3866667
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -106.5173088,
    "lat": 31.7692821
  },
  {
    "lng": -3.6106856,
    "lat": 55.0691831
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -61.4764728,
    "lat": -31.2492442
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.1400923,
    "lat": 29.1871986
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -111.8627989,
    "lat": 40.5247777
  },
  {
    "lng": -93.12611,
    "lat": 44.7391873
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.5011729,
    "lat": 48.4205915
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.0967857,
    "lat": 33.3140311
  },
  {
    "lng": 5.5783856,
    "lat": 46.1825453
  },
  {
    "lng": -58.5264866,
    "lat": -34.4739792
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -121.2117148,
    "lat": 37.7986184
  },
  {
    "lng": -7.9891608,
    "lat": 31.6258257
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -92.9339449,
    "lat": 44.919896
  },
  {
    "lng": -111.3921528,
    "lat": 28.8223775
  },
  {
    "lng": -71.2661597,
    "lat": 41.6770463
  },
  {
    "lng": -122.478836,
    "lat": 48.7544012
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -71.1494972,
    "lat": 42.2792649
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": 6.9459377,
    "lat": 51.1008952
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -81.8020722,
    "lat": 24.5548262
  },
  {
    "lng": -84.5740953,
    "lat": 30.8736613
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -84.4041725,
    "lat": 39.516644
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -71.0994968,
    "lat": 42.3875968
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -116.0833144,
    "lat": 34.8253019
  },
  {
    "lng": -2.0588889,
    "lat": 46.7936111
  },
  {
    "lng": 2.134529,
    "lat": 48.7018823
  },
  {
    "lng": -72.644512,
    "lat": 41.767914
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": -0.4438854,
    "lat": 39.4827253
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": 114.2999353,
    "lat": 30.5951051
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -97.6200043,
    "lat": 30.4393696
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -105.0612448,
    "lat": 39.672564
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": -0.1049747,
    "lat": 50.9999616
  },
  {
    "lng": -70.5587024,
    "lat": 41.5786678
  },
  {
    "lng": 2.2216686,
    "lat": 48.5774044
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": -122.3520327,
    "lat": 48.24216
  },
  {
    "lng": -96.8238183,
    "lat": 33.1505998
  },
  {
    "lng": -84.5546295,
    "lat": 42.7338254
  },
  {
    "lng": -2.8277046,
    "lat": 51.3908826
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -117.579304,
    "lat": 47.4892246
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": 2.3872525,
    "lat": 48.8122302
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -71.3739532,
    "lat": 42.8650869
  },
  {
    "lng": -93.161159,
    "lat": 44.4582041
  },
  {
    "lng": -105.523216,
    "lat": 40.3771926
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 2.4916592,
    "lat": 48.8387639
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.4609528,
    "lat": 35.3187279
  },
  {
    "lng": -80.9450759,
    "lat": 35.0073697
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 21.0714322,
    "lat": 52.2337172
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -77.571382,
    "lat": 40.5992395
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -122.780542,
    "lat": 49.2621643
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -111.9367107,
    "lat": 40.5584882
  },
  {
    "lng": -94.4137923,
    "lat": 39.0924792
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.1138977,
    "lat": 41.5421013
  },
  {
    "lng": -122.0215737,
    "lat": 37.5872576
  },
  {
    "lng": -113.1966394,
    "lat": 40.4062872
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -97.1413417,
    "lat": 33.1838787
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -97.8567339,
    "lat": 30.5736134
  },
  {
    "lng": 4.8090252,
    "lat": 46.0730429
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -63.5720232,
    "lat": 44.6799707
  },
  {
    "lng": -75.7515682,
    "lat": 39.6828358
  },
  {
    "lng": -71.2360624,
    "lat": 42.2802645
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -73.2566332,
    "lat": 40.782634
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": -122.0607963,
    "lat": 37.9479786
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": 4.7449605,
    "lat": 52.4681109
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": 103.733224,
    "lat": 36.474436
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -90.7926324,
    "lat": 40.4264306
  },
  {
    "lng": -114.839607,
    "lat": 31.0269529
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -111.841185,
    "lat": 33.3062031
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -0.4662704,
    "lat": 51.503513
  },
  {
    "lng": -66.0558844,
    "lat": 18.2129421
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 73.8079977,
    "lat": 15.4677228
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.470786,
    "lat": 44.8546856
  },
  {
    "lng": -111.9738429,
    "lat": 41.2230048
  },
  {
    "lng": -73.0839793,
    "lat": 40.867749
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -96.7297206,
    "lat": 32.9481789
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -75.6009964,
    "lat": 38.366027
  },
  {
    "lng": -77.8616386,
    "lat": 40.7944504
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": 5.2676493,
    "lat": 59.4181982
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -93.5268986,
    "lat": 44.7980186
  },
  {
    "lng": -80.4927815,
    "lat": 43.451291
  },
  {
    "lng": -58.7950701,
    "lat": -34.3453213
  },
  {
    "lng": 105.8406959,
    "lat": 21.0242596
  },
  {
    "lng": 5.6758509,
    "lat": 52.0015245
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -92.3328743,
    "lat": 42.498275
  },
  {
    "lng": -0.945556,
    "lat": 45.82
  },
  {
    "lng": -111.8486019,
    "lat": 40.3881114
  },
  {
    "lng": -83.6900211,
    "lat": 43.0161693
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.1374969,
    "lat": 41.4910324
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -87.3811461,
    "lat": 38.687009
  },
  {
    "lng": -93.7460804,
    "lat": 45.3324647
  },
  {
    "lng": 141.3542924,
    "lat": 43.061936
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -119.247053,
    "lat": 35.7688425
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -76.6235105,
    "lat": 39.4837588
  },
  {
    "lng": -76.7301718,
    "lat": 38.9424464
  },
  {
    "lng": -121.2880059,
    "lat": 38.7521235
  },
  {
    "lng": 7.0707659,
    "lat": 52.4359731
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -77.3465081,
    "lat": 37.5131191
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -122.039966,
    "lat": 38.2493581
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -8.6103497,
    "lat": 41.1502195
  },
  {
    "lng": -76.6042521,
    "lat": 40.153364
  },
  {
    "lng": -88.2430932,
    "lat": 40.1164841
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.5848937,
    "lat": 51.0862467
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -120.545122,
    "lat": 46.9970635
  },
  {
    "lng": -107.8766,
    "lat": 37.2769484
  },
  {
    "lng": -74.1242816,
    "lat": 40.8120247
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -74.3483059,
    "lat": 40.651726
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": 3.2131307,
    "lat": 43.3426562
  },
  {
    "lng": -83.9044159,
    "lat": 33.0142344
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 113.2384362,
    "lat": 28.1450774
  },
  {
    "lng": -92.1052679,
    "lat": 46.7838287
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -119.749351,
    "lat": 38.9415062
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.8795408,
    "lat": 40.5827745
  },
  {
    "lng": -118.689423,
    "lat": 34.035591
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -97.9405828,
    "lat": 29.8826436
  },
  {
    "lng": -74.8909988,
    "lat": 39.934002
  },
  {
    "lng": -77.4347283,
    "lat": 38.837613
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -81.4075838,
    "lat": 28.2918995
  },
  {
    "lng": -122.4329883,
    "lat": 45.4978623
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -86.8689419,
    "lat": 35.925206
  },
  {
    "lng": 6.8727506,
    "lat": 45.9246705
  },
  {
    "lng": -118.12706,
    "lat": 34.093042
  },
  {
    "lng": -77.1516844,
    "lat": 39.0817985
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -121.5631723,
    "lat": 37.0065078
  },
  {
    "lng": 4.4886562,
    "lat": 52.2244226
  },
  {
    "lng": -96.7077751,
    "lat": 40.8088861
  },
  {
    "lng": -3.9882568,
    "lat": 55.9477764
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -82.3646068,
    "lat": 41.4219889
  },
  {
    "lng": 10.4919639,
    "lat": 48.8513976
  },
  {
    "lng": -95.8243956,
    "lat": 29.7857853
  },
  {
    "lng": -81.3399769,
    "lat": 41.6664781
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -84.8145115,
    "lat": 9.9221181
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -83.8423061,
    "lat": 42.5733416
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.3821203,
    "lat": 41.8789531
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -88.4040172,
    "lat": 43.0594237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 76.9628425,
    "lat": 11.0018115
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 46.7160104,
    "lat": 24.638916
  },
  {
    "lng": -121.06292,
    "lat": 39.2190607
  },
  {
    "lng": -122.1560768,
    "lat": 37.7249296
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.1574328,
    "lat": 36.0625843
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -75.9760751,
    "lat": 36.8496579
  },
  {
    "lng": 11.3426327,
    "lat": 44.4938203
  },
  {
    "lng": -110.854605,
    "lat": 39.6841305
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": -80.0830984,
    "lat": 26.3586885
  },
  {
    "lng": -111.044047,
    "lat": 45.6794293
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -81.5856742,
    "lat": 28.5656649
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -90.1830408,
    "lat": 32.2998686
  },
  {
    "lng": -81.6182086,
    "lat": 33.5723191
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -83.4754913,
    "lat": 42.48059
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -119.8276389,
    "lat": 34.4358295
  },
  {
    "lng": -81.83511,
    "lat": 41.3144733
  },
  {
    "lng": -81.508732,
    "lat": 41.464498
  },
  {
    "lng": -83.2126517,
    "lat": 34.0378903
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -71.3085329,
    "lat": 42.6414437
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -72.1847598,
    "lat": 40.9633868
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 32.8540497,
    "lat": 39.9207759
  },
  {
    "lng": -80.0973754,
    "lat": 43.9193171
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.2034496,
    "lat": 47.4799078
  },
  {
    "lng": -81.9567716,
    "lat": 35.3692877
  },
  {
    "lng": -74.3483059,
    "lat": 40.651726
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -77.4309829,
    "lat": 34.7509962
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -76.3442846,
    "lat": 37.0264414
  },
  {
    "lng": -75.1340604,
    "lat": 40.2492741
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -82.5486848,
    "lat": 35.8263793
  },
  {
    "lng": -0.591276,
    "lat": 51.512103
  },
  {
    "lng": -97.6200043,
    "lat": 30.4393696
  },
  {
    "lng": 18.016667,
    "lat": 59.366667
  },
  {
    "lng": 2.4452231,
    "lat": 48.906387
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.251587,
    "lat": 43.643032
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.6722192,
    "lat": 36.0600602
  },
  {
    "lng": 6.996379,
    "lat": 49.234362
  },
  {
    "lng": -105.05208,
    "lat": 39.9403995
  },
  {
    "lng": -74.9035159,
    "lat": 39.2401316
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -74.1312504,
    "lat": 40.9397796
  },
  {
    "lng": 39.1742363,
    "lat": 21.5504432
  },
  {
    "lng": -74.533084,
    "lat": 40.3840222
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": -84.1401926,
    "lat": 34.2073196
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 139.766706,
    "lat": 35.6812546
  },
  {
    "lng": 6.0820639,
    "lat": 44.5612032
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -121.530234,
    "lat": 38.5804609
  },
  {
    "lng": -77.2340584,
    "lat": 42.1051571
  },
  {
    "lng": 50.1039991,
    "lat": 26.4367824
  },
  {
    "lng": 2.3019814,
    "lat": 48.8211559
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -4.1024782,
    "lat": 47.9960325
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -80.0532942,
    "lat": 26.715364
  },
  {
    "lng": 0.5513922,
    "lat": 50.8512796
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -74.252537,
    "lat": 44.433981
  },
  {
    "lng": -73.7826363,
    "lat": 40.9115386
  },
  {
    "lng": 2.4159739,
    "lat": 48.8432434
  },
  {
    "lng": -76.5974223,
    "lat": 39.4475075
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 5.8767935,
    "lat": 45.5984113
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -71.3821203,
    "lat": 41.8789531
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -0.1517368,
    "lat": 51.4428954
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -2.047687,
    "lat": 48.4539775
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -119.702667,
    "lat": 34.4221319
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -95.4560512,
    "lat": 30.3118769
  },
  {
    "lng": 2.045018,
    "lat": 45.4065225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -79.5656326,
    "lat": 43.6435559
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -74.1637553,
    "lat": 40.8584328
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -71.2360624,
    "lat": 42.2802645
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -121.7124536,
    "lat": 37.9974219
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -82.5154471,
    "lat": 40.75839
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": -118.4492148,
    "lat": 34.3076252
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -71.1143838,
    "lat": 42.3116046
  },
  {
    "lng": -86.0138729,
    "lat": 39.9555928
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -84.3330301,
    "lat": 46.5126554
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": -88.7774734,
    "lat": 46.8591287
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -122.5246791,
    "lat": 47.6515096
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": -82.6359078,
    "lat": 27.7700475
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -121.955174,
    "lat": 37.3541132
  },
  {
    "lng": -92.4746033,
    "lat": 42.7258451
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.0836549,
    "lat": 41.3203913
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 6.1919276,
    "lat": 49.3615058
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -105.089705,
    "lat": 39.9935959
  },
  {
    "lng": 4.5887889,
    "lat": 51.914403
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.5703031,
    "lat": 43.2924385
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -82.9780962,
    "lat": 40.095494
  },
  {
    "lng": -106.8222688,
    "lat": 44.7947537
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -81.4075838,
    "lat": 28.2918995
  },
  {
    "lng": -112.468812,
    "lat": 34.539984
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -79.0041726,
    "lat": -2.8974072
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -1.4736657,
    "lat": 43.4945144
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 1.9015752,
    "lat": 47.8650984
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.039966,
    "lat": 38.2493581
  },
  {
    "lng": -76.5033406,
    "lat": 40.1098561
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 10.6159077,
    "lat": 54.1364642
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -101.8858689,
    "lat": 36.2452294
  },
  {
    "lng": 1.6118672,
    "lat": 46.2887078
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 5.0487681,
    "lat": 44.0554043
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 126.6168874,
    "lat": 37.4766821
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 6.5772501,
    "lat": 46.5538658
  },
  {
    "lng": -76.7928128,
    "lat": 17.9712148
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 4.6435597,
    "lat": 52.3837058
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": 2.1583033,
    "lat": 44.0496296
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -2.1040102,
    "lat": 47.1152695
  },
  {
    "lng": -3.4914955,
    "lat": 47.7894226
  },
  {
    "lng": -75.5138959,
    "lat": 40.036202
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -1.0815361,
    "lat": 53.9590555
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": -122.7141049,
    "lat": 38.4404925
  },
  {
    "lng": -74.012084,
    "lat": 40.8042674
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.0992246,
    "lat": 43.3290992
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 2.6068064,
    "lat": 48.8009132
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 39.1742363,
    "lat": 21.5504432
  },
  {
    "lng": -78.4766781,
    "lat": 38.029306
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 9.8372796,
    "lat": 48.6218033
  },
  {
    "lng": 24.715431,
    "lat": 43.1349971
  },
  {
    "lng": -0.4804579,
    "lat": 52.6519973
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": -72.0934864,
    "lat": 41.343637
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 0.1826107,
    "lat": 51.5747271
  },
  {
    "lng": -111.933834,
    "lat": 41.6385432
  },
  {
    "lng": -117.1091954,
    "lat": 44.8776081
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": -76.3490396,
    "lat": 39.5355063
  },
  {
    "lng": -103.338396,
    "lat": 20.6720375
  },
  {
    "lng": -76.8646092,
    "lat": 39.1938429
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -121.899142,
    "lat": 37.6090291
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -2.2024324,
    "lat": 51.3161569
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -82.3646068,
    "lat": 41.4219889
  },
  {
    "lng": -82.756907,
    "lat": 28.0856815
  },
  {
    "lng": 2.4749347,
    "lat": 48.8490721
  },
  {
    "lng": -111.9556001,
    "lat": 33.5428006
  },
  {
    "lng": -96.6353488,
    "lat": 30.4764878
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -97.1413417,
    "lat": 33.1838787
  },
  {
    "lng": 114.0545429,
    "lat": 22.5445741
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -0.2244449,
    "lat": 51.5306063
  },
  {
    "lng": -75.0579502,
    "lat": 39.9562238
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -77.4019268,
    "lat": 37.227928
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.6299518,
    "lat": 42.9275277
  },
  {
    "lng": -83.2729081,
    "lat": 42.1961742
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -72.5037167,
    "lat": 41.8251014
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -94.4265011,
    "lat": 35.3880338
  },
  {
    "lng": -122.039966,
    "lat": 38.2493581
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -94.0148021,
    "lat": 30.1313283
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.3588703,
    "lat": 36.5277607
  },
  {
    "lng": -97.4394816,
    "lat": 35.2225717
  },
  {
    "lng": -73.6967338,
    "lat": 40.786702
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.0572272,
    "lat": 37.1176314
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.6017022,
    "lat": 34.2572499
  },
  {
    "lng": -111.6944313,
    "lat": 40.2981599
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -76.8317417,
    "lat": 39.2757359
  },
  {
    "lng": -97.491204,
    "lat": 46.585804
  },
  {
    "lng": -1.0518771,
    "lat": 43.7084065
  },
  {
    "lng": -82.4012643,
    "lat": 40.0581205
  },
  {
    "lng": 23.5719843,
    "lat": 47.6565584
  },
  {
    "lng": -83.6900211,
    "lat": 43.0161693
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -112.185994,
    "lat": 33.5386858
  },
  {
    "lng": -80.6636984,
    "lat": 28.2662775
  },
  {
    "lng": -1.6171001,
    "lat": 54.9751321
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -82.2880508,
    "lat": 27.928464
  },
  {
    "lng": 9.2114144,
    "lat": 48.4919508
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.463028,
    "lat": 44.336864
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -88.0717708,
    "lat": 41.7003302
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.677556,
    "lat": 39.049011
  },
  {
    "lng": -0.1551,
    "lat": 44.53881
  },
  {
    "lng": 5.4088845,
    "lat": 52.1637702
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -80.2493276,
    "lat": 43.5460516
  },
  {
    "lng": 1.1076133,
    "lat": 41.1555564
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -77.4486772,
    "lat": 38.885219
  },
  {
    "lng": -74.0323752,
    "lat": 40.7433066
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.0637708,
    "lat": 47.3586518
  },
  {
    "lng": -86.3921096,
    "lat": 35.8460396
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.5341802,
    "lat": 8.9714493
  },
  {
    "lng": -78.4563914,
    "lat": 35.650711
  },
  {
    "lng": -94.44355,
    "lat": 36.650627
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -72.0759008,
    "lat": 41.5243537
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -64.1834193,
    "lat": -31.4166867
  },
  {
    "lng": 24.3631837,
    "lat": 44.4299971
  },
  {
    "lng": -0.6772991,
    "lat": 48.7285654
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -72.1435861,
    "lat": 43.6446871
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -1.3129164,
    "lat": 54.564094
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -85.8590603,
    "lat": 41.6012796
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 11.8734455,
    "lat": 45.4077172
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -80.9450759,
    "lat": 35.0073697
  },
  {
    "lng": -73.9112103,
    "lat": 41.5965635
  },
  {
    "lng": -94.6851702,
    "lat": 38.9742502
  },
  {
    "lng": -73.6343052,
    "lat": 40.7266477
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -99.1619751,
    "lat": 19.3498606
  },
  {
    "lng": -77.4347283,
    "lat": 38.837613
  },
  {
    "lng": -87.9414608,
    "lat": 42.0087978
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.6856197,
    "lat": 44.4643768
  },
  {
    "lng": 11.8734455,
    "lat": 45.4077172
  },
  {
    "lng": -72.6930522,
    "lat": 41.9810263
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -71.0542002,
    "lat": 42.4085897
  },
  {
    "lng": -79.8030873,
    "lat": 35.8179143
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 27.8879787,
    "lat": 39.6473917
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.8239794,
    "lat": 52.5623089
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -84.99928,
    "lat": 41.634874
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -105.049981,
    "lat": 40.0502623
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.2008288,
    "lat": 46.3580221
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": -84.9030517,
    "lat": 42.8692006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -96.6260468,
    "lat": 41.4523961
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -87.9822969,
    "lat": 43.2219088
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -118.5291917,
    "lat": 34.3798765
  },
  {
    "lng": -75.6496424,
    "lat": 40.2452976
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.2115053,
    "lat": 35.7902384
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -122.391675,
    "lat": 40.5863563
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": -46.5279039,
    "lat": -23.6533509
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 6.1675872,
    "lat": 49.3579272
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.2034496,
    "lat": 47.4799078
  },
  {
    "lng": 1.4284697,
    "lat": 38.9982318
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -89.0078418,
    "lat": 34.4942683
  },
  {
    "lng": -94.0771483,
    "lat": 33.4466745
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": -80.0736533,
    "lat": 36.1198589
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -84.2809332,
    "lat": 30.4380832
  },
  {
    "lng": -1.4621381,
    "lat": 53.3783713
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 10.3733692,
    "lat": 53.8096562
  },
  {
    "lng": -121.99059,
    "lat": 37.050096
  },
  {
    "lng": 0.1561947,
    "lat": 45.6484505
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 1.909928,
    "lat": 48.9931578
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": -1.5342042,
    "lat": 54.9911912
  },
  {
    "lng": -75.9125187,
    "lat": 42.098698
  },
  {
    "lng": -74.4222416,
    "lat": 40.6201412
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -0.3250175,
    "lat": 45.6931647
  },
  {
    "lng": 5.4781463,
    "lat": 52.2148536
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -80.2322706,
    "lat": 25.9873137
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 5.6361825,
    "lat": 45.2928424
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -85.7371604,
    "lat": 38.2770227
  },
  {
    "lng": -73.1307708,
    "lat": 41.1947276
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -74.951279,
    "lat": 40.1045549
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -81.5116471,
    "lat": 28.6732806
  },
  {
    "lng": 11.6400789,
    "lat": 52.1314783
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -80.6424886,
    "lat": 36.44173
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -81.7016346,
    "lat": 30.1654707
  },
  {
    "lng": -82.8071054,
    "lat": 37.8145384
  },
  {
    "lng": -1.8773787,
    "lat": 46.847943
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -91.2563658,
    "lat": 43.9632211
  },
  {
    "lng": -117.929416,
    "lat": 33.8708215
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.814017,
    "lat": 34.044889
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.3861737,
    "lat": 50.8361447
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -99.5069922,
    "lat": 27.5075005
  },
  {
    "lng": -70.8781883,
    "lat": 42.5489744
  },
  {
    "lng": -86.2483921,
    "lat": 43.2341813
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -77.4871236,
    "lat": 37.664879
  },
  {
    "lng": -75.7166345,
    "lat": 39.4497639
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -73.8320784,
    "lat": 40.9381544
  },
  {
    "lng": -90.1767012,
    "lat": 30.0018546
  },
  {
    "lng": -74.0410865,
    "lat": 40.8871438
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -90.5136642,
    "lat": 41.5058344
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 1.534421,
    "lat": 38.9846117
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -73.9283672,
    "lat": 41.7065539
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 4.3338445,
    "lat": 50.8035441
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.3623924,
    "lat": 51.4619551
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.2117148,
    "lat": 37.7986184
  },
  {
    "lng": 24.1228361,
    "lat": 42.219533
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.2865796,
    "lat": 41.6849111
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -71.3137707,
    "lat": 41.4899827
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 106.8838584,
    "lat": 47.9081991
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 1.1528095,
    "lat": 52.0579324
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -0.3944534,
    "lat": 44.8777159
  },
  {
    "lng": -77.4127562,
    "lat": 39.415779
  },
  {
    "lng": -96.9146374,
    "lat": 19.5408338
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 112.4477046,
    "lat": 34.6196539
  },
  {
    "lng": -124.223764,
    "lat": 43.4918372
  },
  {
    "lng": -118.4492148,
    "lat": 34.3076252
  },
  {
    "lng": 1.4628645,
    "lat": 48.4364696
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.4979014,
    "lat": 41.2814842
  },
  {
    "lng": -4.4216366,
    "lat": 36.7213028
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -0.2779124,
    "lat": 51.9486943
  },
  {
    "lng": 2.4093664,
    "lat": 48.7630238
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": 116.3912972,
    "lat": 39.9057136
  },
  {
    "lng": -88.0125794,
    "lat": 44.5126379
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 4.8055118,
    "lat": 45.5597173
  },
  {
    "lng": 2.2557107,
    "lat": 48.5948294
  },
  {
    "lng": -117.8722311,
    "lat": 33.750631
  },
  {
    "lng": 4.8039331,
    "lat": 45.7153254
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.28739,
    "lat": 49.1478922
  },
  {
    "lng": -86.9080655,
    "lat": 40.4258686
  },
  {
    "lng": -121.3153096,
    "lat": 44.0581728
  },
  {
    "lng": -4.033442,
    "lat": 55.7759095
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": -75.5732423,
    "lat": 41.4764699
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -82.9371409,
    "lat": 42.4972583
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 2.2411289,
    "lat": 43.6053809
  },
  {
    "lng": -71.4677032,
    "lat": 42.7656251
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -89.7811745,
    "lat": 30.2751945
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -1.7822482,
    "lat": 53.6466645
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -97.9883477,
    "lat": 30.4601975
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 106.8822289,
    "lat": -6.2628908
  },
  {
    "lng": 2.3340758,
    "lat": 48.7945413
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -3.2510247,
    "lat": 47.6975924
  },
  {
    "lng": -94.1574328,
    "lat": 36.0625843
  },
  {
    "lng": -71.1061639,
    "lat": 42.4184296
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -118.1366153,
    "lat": 34.6981064
  },
  {
    "lng": -117.0314172,
    "lat": 32.7425516
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.2107006,
    "lat": 40.6639916
  },
  {
    "lng": -84.5546295,
    "lat": 42.7338254
  },
  {
    "lng": 0.577077,
    "lat": 44.1688678
  },
  {
    "lng": 2.0388736,
    "lat": 49.0527528
  },
  {
    "lng": 106.8822289,
    "lat": -6.2628908
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -97.4649038,
    "lat": 35.6571367
  },
  {
    "lng": -82.3984882,
    "lat": 34.851354
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -111.747841,
    "lat": 40.2983097
  },
  {
    "lng": 0.0689113,
    "lat": 51.5589375
  },
  {
    "lng": -73.5107732,
    "lat": 42.7091389
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -71.1408776,
    "lat": 42.65717
  },
  {
    "lng": -79.7093339,
    "lat": 40.3301738
  },
  {
    "lng": -122.6246836,
    "lat": 47.5653663
  },
  {
    "lng": -72.5891221,
    "lat": 42.3423259
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -122.768761,
    "lat": 45.4853207
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.7942944,
    "lat": 26.1421976
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -93.5268986,
    "lat": 44.7980186
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -103.3913671,
    "lat": 20.7211203
  },
  {
    "lng": 11.8969383,
    "lat": 48.5162681
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -118.307201,
    "lat": 34.1812089
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 14.4276003,
    "lat": 51.1809132
  },
  {
    "lng": -122.2054035,
    "lat": 47.7623204
  },
  {
    "lng": 2.4197113,
    "lat": 48.8051624
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -82.5338633,
    "lat": 28.483576
  },
  {
    "lng": 4.8059012,
    "lat": 43.9492493
  },
  {
    "lng": -76.3422525,
    "lat": 42.2325723
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.739099,
    "lat": 30.9246276
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -71.3821203,
    "lat": 41.8789531
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": -74.171811,
    "lat": 40.9167654
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": -87.8406031,
    "lat": 42.0112329
  },
  {
    "lng": -75.1515534,
    "lat": 40.103196
  },
  {
    "lng": -84.1051939,
    "lat": 33.7123305
  },
  {
    "lng": -90.4345418,
    "lat": 40.0167925
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -91.0031778,
    "lat": 30.3946729
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -76.0898259,
    "lat": 39.548827
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -80.2872086,
    "lat": 26.0061943
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -104.8769227,
    "lat": 39.579155
  },
  {
    "lng": 14.2487679,
    "lat": 40.8358846
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.4660408,
    "lat": 40.5462553
  },
  {
    "lng": -87.9802164,
    "lat": 42.0811563
  },
  {
    "lng": -97.1413417,
    "lat": 33.1838787
  },
  {
    "lng": 17.6387436,
    "lat": 59.8586126
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -84.0193858,
    "lat": 39.8208998
  },
  {
    "lng": 2.6021145,
    "lat": 48.5624381
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -90.4420411,
    "lat": 41.5152157
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -80.8079545,
    "lat": 28.6126236
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -8.2526339,
    "lat": 37.088241
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -73.0438362,
    "lat": 41.5538091
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -121.971335,
    "lat": 47.8552259
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -0.5879629,
    "lat": 44.8088438
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -76.7928128,
    "lat": 17.9712148
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -82.756367,
    "lat": 28.1470965
  },
  {
    "lng": -71.9329968,
    "lat": -39.273222
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -74.8909988,
    "lat": 39.934002
  },
  {
    "lng": -1.3133333,
    "lat": 46.7141667
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 0.1967849,
    "lat": 48.0073849
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -70.7618592,
    "lat": 41.9426657
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.3458417,
    "lat": 48.6794572
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.0786839,
    "lat": 51.6517156
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -74.0204177,
    "lat": 40.7695457
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 23.7603118,
    "lat": 61.4980214
  },
  {
    "lng": -84.5740953,
    "lat": 30.8736613
  },
  {
    "lng": -91.9630039,
    "lat": 41.0072342
  },
  {
    "lng": 11.7975218,
    "lat": 55.446817
  },
  {
    "lng": -1.5135474,
    "lat": 52.400739
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.4738223,
    "lat": 43.8219222
  },
  {
    "lng": -83.6279321,
    "lat": 41.5571178
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.0811573,
    "lat": 39.8005505
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.5800049,
    "lat": 35.4094178
  },
  {
    "lng": -9.2038448,
    "lat": 39.3443128
  },
  {
    "lng": -120.1835765,
    "lat": 39.3279454
  },
  {
    "lng": -75.9760751,
    "lat": 36.8496579
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -74.0254577,
    "lat": 45.3971509
  },
  {
    "lng": -1.548621,
    "lat": 53.794414
  },
  {
    "lng": 12.703706,
    "lat": 56.0442098
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -76.4796552,
    "lat": 39.4073054
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -91.2343539,
    "lat": 43.8830606
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": -122.478836,
    "lat": 48.7544012
  },
  {
    "lng": -118.6058382,
    "lat": 34.1684364
  },
  {
    "lng": -74.0437839,
    "lat": 41.1130231
  },
  {
    "lng": 2.6068064,
    "lat": 48.8009132
  },
  {
    "lng": -0.1843514,
    "lat": 52.3305093
  },
  {
    "lng": -83.9463359,
    "lat": 42.4567013
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": -8.6394111,
    "lat": 41.0083643
  },
  {
    "lng": -86.4541894,
    "lat": 42.1167065
  },
  {
    "lng": -1.548621,
    "lat": 53.794414
  },
  {
    "lng": -3.7020023,
    "lat": 48.0268097
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 2.2840639,
    "lat": 48.9703664
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -90.4611995,
    "lat": 30.5043583
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.0125794,
    "lat": 44.5126379
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": -43.8470691,
    "lat": -19.9854089
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -121.302728,
    "lat": 38.5890723
  },
  {
    "lng": -92.1176521,
    "lat": 35.8684075
  },
  {
    "lng": -121.8106925,
    "lat": 38.0093296
  },
  {
    "lng": 8.6185666,
    "lat": 47.3969942
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -119.702667,
    "lat": 34.4221319
  },
  {
    "lng": -87.607268,
    "lat": 41.6389236
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -94.0309959,
    "lat": 42.0391745
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -99.2599579,
    "lat": 18.9331321
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": 13.5532976,
    "lat": 68.118191
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.0023825,
    "lat": 41.9287812
  },
  {
    "lng": 120.9803621,
    "lat": 14.5904492
  },
  {
    "lng": 74.8731879,
    "lat": 13.5269784
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": -92.7239637,
    "lat": 41.7430237
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -118.096735,
    "lat": 33.9830688
  },
  {
    "lng": -72.1847598,
    "lat": 40.9633868
  },
  {
    "lng": 0.6889268,
    "lat": 47.3900474
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -92.7098744,
    "lat": 35.9018987
  },
  {
    "lng": -79.008205,
    "lat": 34.6183305
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": -87.848682,
    "lat": 41.1253903
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -105.1319296,
    "lat": 39.977763
  },
  {
    "lng": 102.6470481,
    "lat": 18.0346879
  },
  {
    "lng": -120.375716,
    "lat": 35.3540209
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": -80.3553302,
    "lat": 25.8195424
  },
  {
    "lng": -103.338396,
    "lat": 20.6720375
  },
  {
    "lng": -76.4283781,
    "lat": 44.3054151
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -3.5310879,
    "lat": 40.3536054
  },
  {
    "lng": -96.9442177,
    "lat": 32.8295183
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -1.5695287,
    "lat": 47.1905456
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -70.2586618,
    "lat": 43.6573605
  },
  {
    "lng": 7.90503,
    "lat": 48.8004792
  },
  {
    "lng": 2.289259,
    "lat": 48.8212037
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -0.5473085,
    "lat": 51.4312585
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -119.7029194,
    "lat": 36.8252277
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 6.4086189,
    "lat": 46.0775797
  },
  {
    "lng": -121.8106925,
    "lat": 38.0093296
  },
  {
    "lng": 12.5135924,
    "lat": 55.6637755
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -84.7477136,
    "lat": 33.7514966
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.7880359,
    "lat": 32.7867697
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.752653,
    "lat": 51.7177044
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -90.1830408,
    "lat": 32.2998686
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -105.05208,
    "lat": 39.9403995
  },
  {
    "lng": -0.0123189,
    "lat": 51.5246287
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": -79.7507138,
    "lat": 40.0871147
  },
  {
    "lng": 2.5589558,
    "lat": 48.9802035
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -92.6723254,
    "lat": 38.1259916
  },
  {
    "lng": -70.241993,
    "lat": 43.729525
  },
  {
    "lng": -90.5643258,
    "lat": 38.661953
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": 4.0413095,
    "lat": 48.3185478
  },
  {
    "lng": 1.8487179,
    "lat": 42.9332121
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -155.996933,
    "lat": 19.641941
  },
  {
    "lng": -82.6359078,
    "lat": 27.7700475
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.0426301,
    "lat": 48.9274192
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.270532,
    "lat": 40.224432
  },
  {
    "lng": 0.33179,
    "lat": 48.0168
  },
  {
    "lng": -93.2922715,
    "lat": 37.2081729
  },
  {
    "lng": -70.9478343,
    "lat": 42.981477
  },
  {
    "lng": 2.6500745,
    "lat": 39.5695818
  },
  {
    "lng": 34.8839799,
    "lat": 32.0906241
  },
  {
    "lng": -122.3520327,
    "lat": 48.24216
  },
  {
    "lng": -94.751376,
    "lat": 43.2377381
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": -83.1446485,
    "lat": 42.4894801
  },
  {
    "lng": 6.0525071,
    "lat": 45.8842342
  },
  {
    "lng": 12.7865937,
    "lat": 57.5518736
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -81.4548392,
    "lat": 39.4167742
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.012084,
    "lat": 40.8042674
  },
  {
    "lng": -105.016649,
    "lat": 39.613321
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -84.3635338,
    "lat": 35.5197984
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -91.4984941,
    "lat": 44.811349
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.3731878,
    "lat": 47.5499217
  },
  {
    "lng": 6.0243622,
    "lat": 47.2380222
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -121.290779,
    "lat": 37.9577016
  },
  {
    "lng": 1.2546057,
    "lat": 41.1172364
  },
  {
    "lng": -112.450627,
    "lat": 42.8620287
  },
  {
    "lng": -111.789037,
    "lat": 33.3527632
  },
  {
    "lng": -122.2312383,
    "lat": 47.2061882
  },
  {
    "lng": -73.9897782,
    "lat": 41.1509835
  },
  {
    "lng": 0.1967849,
    "lat": 48.0073849
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.1727546,
    "lat": 45.2926341
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2255727,
    "lat": 48.8709053
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": -77.4127562,
    "lat": 39.415779
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -119.0779359,
    "lat": 34.4458248
  },
  {
    "lng": -4.5122831,
    "lat": 55.836517
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -93.2922715,
    "lat": 37.2081729
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.3878945,
    "lat": 34.2204227
  },
  {
    "lng": 0.6889268,
    "lat": 47.3900474
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -74.1182492,
    "lat": 42.0410578
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 8.071992,
    "lat": 50.141688
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -86.4475898,
    "lat": 36.3883031
  },
  {
    "lng": -75.2326641,
    "lat": 43.1009031
  },
  {
    "lng": -72.6908547,
    "lat": 41.764582
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -78.3199496,
    "lat": 44.3048009
  },
  {
    "lng": -122.0151976,
    "lat": 47.1803702
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -72.5983151,
    "lat": 41.2794282
  },
  {
    "lng": -72.6713448,
    "lat": 41.707785
  },
  {
    "lng": -71.3821203,
    "lat": 41.8789531
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.4535345,
    "lat": 40.8214375
  },
  {
    "lng": -1.32955,
    "lat": 43.75079
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.6077908,
    "lat": 28.0785034
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -78.4298248,
    "lat": 42.0775022
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.8436412,
    "lat": 41.8789942
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -93.1659179,
    "lat": 44.818173
  },
  {
    "lng": -122.5681191,
    "lat": 38.1061979
  },
  {
    "lng": -74.4773916,
    "lat": 39.3405045
  },
  {
    "lng": -72.2147434,
    "lat": 41.7121364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 36.828842,
    "lat": -1.3026148
  },
  {
    "lng": -71.7629658,
    "lat": 42.1499283
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -71.1551119,
    "lat": 42.3473519
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.403984,
    "lat": 44.4794941
  },
  {
    "lng": 151.5511123,
    "lat": -32.7316683
  },
  {
    "lng": -83.257153,
    "lat": 42.3021687
  },
  {
    "lng": 104.6928392,
    "lat": 29.2995746
  },
  {
    "lng": 15.3122511,
    "lat": -4.32171
  },
  {
    "lng": -1.3061227,
    "lat": 45.9437695
  },
  {
    "lng": -1.3824404,
    "lat": 54.9061115
  },
  {
    "lng": -113.903503,
    "lat": 53.545204
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -88.0717708,
    "lat": 41.7003302
  },
  {
    "lng": -72.6908547,
    "lat": 41.764582
  },
  {
    "lng": -118.644097,
    "lat": 34.1446643
  },
  {
    "lng": 5.7055996,
    "lat": 45.2088706
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": -77.3063733,
    "lat": 38.8462236
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -92.2266876,
    "lat": 37.8141419
  },
  {
    "lng": -87.8873916,
    "lat": 42.0415823
  },
  {
    "lng": -84.425589,
    "lat": 42.2416466
  },
  {
    "lng": -118.448647,
    "lat": 33.9776848
  },
  {
    "lng": -83.5960264,
    "lat": 32.5438429
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -81.5464928,
    "lat": 30.7305142
  },
  {
    "lng": -97.0819541,
    "lat": 32.8370727
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -89.7007595,
    "lat": 38.5349571
  },
  {
    "lng": -97.4394816,
    "lat": 35.2225717
  },
  {
    "lng": -1.1236065,
    "lat": 52.6321088
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": 71.4719683,
    "lat": 30.197838
  },
  {
    "lng": -78.6145758,
    "lat": -0.9340311
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.6845895,
    "lat": 49.1049353
  },
  {
    "lng": 7.1513834,
    "lat": 43.6612012
  },
  {
    "lng": -80.5800049,
    "lat": 35.4094178
  },
  {
    "lng": 25.5597482,
    "lat": 47.5297764
  },
  {
    "lng": -75.0579502,
    "lat": 39.9562238
  },
  {
    "lng": 117.1138479,
    "lat": 36.6519754
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 2.289259,
    "lat": 48.8212037
  },
  {
    "lng": 2.3373021,
    "lat": 48.7790514
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -123.2620435,
    "lat": 44.5645659
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.9810407,
    "lat": 45.5705379
  },
  {
    "lng": -76.9199742,
    "lat": 40.2398118
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -90.1767012,
    "lat": 30.0018546
  },
  {
    "lng": -79.1802994,
    "lat": 35.4798757
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 2.4093664,
    "lat": 48.7630238
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -73.2541069,
    "lat": 42.4484778
  },
  {
    "lng": 2.2385432,
    "lat": 48.8126688
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 15.2151181,
    "lat": 59.2747287
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -0.2068872,
    "lat": 51.8031083
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -122.192337,
    "lat": 47.6144219
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": -1.37328,
    "lat": 43.68866
  },
  {
    "lng": -122.192337,
    "lat": 47.6144219
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 4.4811089,
    "lat": 52.1518157
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.9405828,
    "lat": 29.8826436
  },
  {
    "lng": 106.6811524,
    "lat": 10.8237546
  },
  {
    "lng": -118.8375937,
    "lat": 34.1705609
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": -86.3258835,
    "lat": 34.025609
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": 2.6953079,
    "lat": 48.268026
  },
  {
    "lng": -96.3455991,
    "lat": 30.6183939
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.0996306,
    "lat": 26.318342
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.2809332,
    "lat": 30.4380832
  },
  {
    "lng": 7.5952375,
    "lat": 48.3707281
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 101.6454202,
    "lat": 3.0988792
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -0.5879629,
    "lat": 44.8088438
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.7529851,
    "lat": 48.1806379
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -117.7197785,
    "lat": 34.0966764
  },
  {
    "lng": -88.3303618,
    "lat": 42.1816908
  },
  {
    "lng": -96.9442177,
    "lat": 32.8295183
  },
  {
    "lng": -77.8616386,
    "lat": 40.7944504
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.985181,
    "lat": 39.8695516
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.2566367,
    "lat": 38.1040864
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -95.2092076,
    "lat": 29.6910753
  },
  {
    "lng": -74.0072568,
    "lat": 40.8860164
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": -86.2283864,
    "lat": 43.0630734
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -0.5762125,
    "lat": 42.8801011
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8320784,
    "lat": 40.9381544
  },
  {
    "lng": -76.5179991,
    "lat": 41.9572965
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -122.4094051,
    "lat": 48.0399806
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -121.955174,
    "lat": 37.3541132
  },
  {
    "lng": -119.702667,
    "lat": 34.4221319
  },
  {
    "lng": -74.5908483,
    "lat": 41.611556
  },
  {
    "lng": -75.710976,
    "lat": 45.4277659
  },
  {
    "lng": -84.1051939,
    "lat": 33.7123305
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 12.1346523,
    "lat": 50.4950632
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": -79.8625851,
    "lat": 32.7940651
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -111.841185,
    "lat": 33.3062031
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -73.9629154,
    "lat": 40.9253766
  },
  {
    "lng": -5.9953403,
    "lat": 37.3886303
  },
  {
    "lng": -155.1003754,
    "lat": 19.6854458
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 11.7529851,
    "lat": 48.1806379
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.2784264,
    "lat": 42.933597
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -3.3449362,
    "lat": 51.6001047
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -93.0572272,
    "lat": 37.1176314
  },
  {
    "lng": -106.8930799,
    "lat": 34.0572858
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": 4.9884323,
    "lat": 43.5139051
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -77.3063733,
    "lat": 38.8462236
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -88.3334274,
    "lat": 42.8666803
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 9.4978479,
    "lat": 51.3157833
  },
  {
    "lng": -121.290779,
    "lat": 37.9577016
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -88.2578582,
    "lat": 42.1211364
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": 4.1131937,
    "lat": 43.7223794
  },
  {
    "lng": -89.5844457,
    "lat": 44.5234467
  },
  {
    "lng": -70.9494939,
    "lat": 42.466763
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 7.2196635,
    "lat": 51.4818111
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.1374969,
    "lat": 41.4910324
  },
  {
    "lng": 33.3638783,
    "lat": 35.1746503
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -90.1740313,
    "lat": 44.6662287
  },
  {
    "lng": -98.6884208,
    "lat": 29.5635688
  },
  {
    "lng": -80.1353006,
    "lat": 25.7929198
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": -6.8408929,
    "lat": 34.0218454
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -73.2276183,
    "lat": 44.3783486
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 0.3233131,
    "lat": 51.4780898
  },
  {
    "lng": -81.684004,
    "lat": 36.2187873
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.2174603,
    "lat": 41.320856
  },
  {
    "lng": -85.5872286,
    "lat": 42.291707
  },
  {
    "lng": -76.5508618,
    "lat": 39.3868522
  },
  {
    "lng": 152.8424214,
    "lat": -26.756741
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.929416,
    "lat": 33.8708215
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.7001187,
    "lat": 42.7742446
  },
  {
    "lng": -94.1574328,
    "lat": 36.0625843
  },
  {
    "lng": -95.1530516,
    "lat": 43.3955188
  },
  {
    "lng": -97.6775634,
    "lat": 30.6370152
  },
  {
    "lng": -89.6095285,
    "lat": 40.8073044
  },
  {
    "lng": -6.9261131,
    "lat": 52.8408344
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -119.08816,
    "lat": 36.2030064
  },
  {
    "lng": -86.6072054,
    "lat": 33.1781718
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -77.4127562,
    "lat": 39.415779
  },
  {
    "lng": -123.033121,
    "lat": 44.9391565
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": -80.2440518,
    "lat": 36.0998131
  },
  {
    "lng": -0.3685668,
    "lat": 43.2957547
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 6.4360158,
    "lat": 45.7796836
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.7753539,
    "lat": 41.270178
  },
  {
    "lng": -92.1052679,
    "lat": 46.7838287
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -73.11136,
    "lat": 44.4906817
  },
  {
    "lng": -96.8570183,
    "lat": 32.5897831
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -2.0260409,
    "lat": 48.649518
  },
  {
    "lng": -75.1304588,
    "lat": 40.3100446
  },
  {
    "lng": 2.4093664,
    "lat": 48.7630238
  },
  {
    "lng": 8.9746623,
    "lat": 56.1379757
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -94.626497,
    "lat": 39.1134562
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -106.779807,
    "lat": 32.3140354
  },
  {
    "lng": -80.7224386,
    "lat": 35.1159532
  },
  {
    "lng": -80.7009406,
    "lat": 41.1540381
  },
  {
    "lng": -77.2676335,
    "lat": 38.636447
  },
  {
    "lng": 4.438952,
    "lat": 52.1893268
  },
  {
    "lng": -79.9695004,
    "lat": 40.6300671
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 7.1513834,
    "lat": 43.6612012
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": -75.0629531,
    "lat": 42.453492
  },
  {
    "lng": -83.3527097,
    "lat": 42.36837
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 2.4289667,
    "lat": 48.6241665
  },
  {
    "lng": -82.0609557,
    "lat": 39.3575616
  },
  {
    "lng": -88.0895061,
    "lat": 41.6475306
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -1.3030524,
    "lat": 43.7988816
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 0.1967849,
    "lat": 48.0073849
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 9.1605106,
    "lat": 47.7664456
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -76.3056707,
    "lat": 40.0379958
  },
  {
    "lng": 8.8557862,
    "lat": 48.2737512
  },
  {
    "lng": -45.2484314,
    "lat": -18.2051533
  },
  {
    "lng": -81.243372,
    "lat": 42.9832406
  },
  {
    "lng": -82.805646,
    "lat": 39.8428215
  },
  {
    "lng": -72.2505752,
    "lat": 41.8119557
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -9.3282374,
    "lat": 38.9369782
  },
  {
    "lng": -111.789037,
    "lat": 33.3527632
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -81.0352313,
    "lat": 34.000754
  },
  {
    "lng": -77.3464516,
    "lat": 38.953282
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -88.4493796,
    "lat": 43.7533414
  },
  {
    "lng": -74.1537549,
    "lat": 40.9492649
  },
  {
    "lng": -106.82356,
    "lat": 39.1911128
  },
  {
    "lng": -71.5745402,
    "lat": 42.6112242
  },
  {
    "lng": -0.4881708,
    "lat": 38.3436365
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 9.2199647,
    "lat": 48.6664
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 14.4901093,
    "lat": 35.8956788
  },
  {
    "lng": -121.988571,
    "lat": 37.5482697
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -76.4933648,
    "lat": 38.2974855
  },
  {
    "lng": -0.7032713,
    "lat": 52.4877341
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -71.1843236,
    "lat": 42.3652518
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -68.8446177,
    "lat": -32.8894155
  },
  {
    "lng": 2.3212492,
    "lat": 48.8642313
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": -122.989827,
    "lat": 45.5228939
  },
  {
    "lng": -76.217705,
    "lat": 43.106456
  },
  {
    "lng": 1.9988356,
    "lat": 48.7760957
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -72.5976987,
    "lat": 41.9791024
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -75.1515534,
    "lat": 40.103196
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 7.0557352,
    "lat": 48.734239
  },
  {
    "lng": -84.4919524,
    "lat": 39.0889469
  },
  {
    "lng": -99.1517322,
    "lat": 19.4414715
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -4.1433925,
    "lat": 50.3780967
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -71.0994968,
    "lat": 42.3875968
  },
  {
    "lng": -73.9529126,
    "lat": 42.0775906
  },
  {
    "lng": 1.5212467,
    "lat": 42.5069391
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -74.60988,
    "lat": 40.5742696
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": -122.2270272,
    "lat": 47.3826903
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -3.3660907,
    "lat": 47.7477336
  },
  {
    "lng": -81.8431567,
    "lat": 27.8963791
  },
  {
    "lng": -77.4605399,
    "lat": 38.3031837
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -80.4136767,
    "lat": 37.2296566
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.75596,
    "lat": 51.6317449
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -88.822047,
    "lat": 42.3683522
  },
  {
    "lng": -117.9951044,
    "lat": 33.7941024
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -96.9083366,
    "lat": 32.6518004
  },
  {
    "lng": -81.243372,
    "lat": 42.9832406
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -87.7834769,
    "lat": 42.7313756
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -119.495902,
    "lat": 49.8879177
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 6.5398722,
    "lat": 46.0828653
  },
  {
    "lng": -74.186256,
    "lat": 40.935654
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.7755065,
    "lat": 40.20824
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.1810781,
    "lat": 53.0079887
  },
  {
    "lng": -86.2616968,
    "lat": 39.950724
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 5.0414701,
    "lat": 47.3215806
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -97.6775634,
    "lat": 30.6370152
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -76.2899539,
    "lat": 36.8493695
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -70.9494939,
    "lat": 42.466763
  },
  {
    "lng": 73.5301042,
    "lat": 4.1961894
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 12.5135924,
    "lat": 55.6637755
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.929416,
    "lat": 33.8708215
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -88.1850028,
    "lat": 41.9908485
  },
  {
    "lng": -2.6294313,
    "lat": 53.6531915
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.5060144,
    "lat": 48.8608712
  },
  {
    "lng": -71.6129907,
    "lat": 42.2694308
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -119.180381,
    "lat": 34.1976308
  },
  {
    "lng": 8.5980265,
    "lat": 50.2363508
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.3473099,
    "lat": 37.5780965
  },
  {
    "lng": 5.7826657,
    "lat": 43.8338026
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -3.9904173,
    "lat": 55.7893512
  },
  {
    "lng": -105.101928,
    "lat": 40.1672117
  },
  {
    "lng": -71.4677032,
    "lat": 42.7656251
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -2.6318629,
    "lat": 50.9420451
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -0.6308396,
    "lat": 44.805615
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": 11.3278779,
    "lat": 48.2077801
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -79.3314725,
    "lat": 42.4400476
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -121.971335,
    "lat": 47.8552259
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -6.6574093,
    "lat": 53.2214677
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.0579359,
    "lat": 47.6442067
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -122.9543022,
    "lat": 50.1171903
  },
  {
    "lng": -72.1847598,
    "lat": 40.9633868
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.1780374,
    "lat": 51.264018
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -111.9106607,
    "lat": 40.6149174
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": 21.6259782,
    "lat": 47.531399
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -117.147366,
    "lat": 33.4946353
  },
  {
    "lng": -74.4222416,
    "lat": 40.6201412
  },
  {
    "lng": 27.8435878,
    "lat": 37.8483767
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": 36.828842,
    "lat": -1.3026148
  },
  {
    "lng": -77.4309829,
    "lat": 34.7509962
  },
  {
    "lng": -71.5785924,
    "lat": 42.6650324
  },
  {
    "lng": -71.1187829,
    "lat": 42.332918
  },
  {
    "lng": -47.2180677,
    "lat": -23.0908356
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": 25.6321312,
    "lat": 43.0820584
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": -71.2092214,
    "lat": 42.3370414
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 4.3558561,
    "lat": 52.0703201
  },
  {
    "lng": -105.101928,
    "lat": 40.1672117
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.1968257,
    "lat": 39.9526791
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": -2.7603283,
    "lat": 48.5141134
  },
  {
    "lng": -79.1262839,
    "lat": 40.6424116
  },
  {
    "lng": -48.6646323,
    "lat": -27.6447774
  },
  {
    "lng": -0.1880608,
    "lat": 51.4143912
  },
  {
    "lng": -0.0135253,
    "lat": 51.5911967
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 11.3927685,
    "lat": 47.2654296
  },
  {
    "lng": -89.1287636,
    "lat": 41.3272919
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.5174342,
    "lat": 34.2661558
  },
  {
    "lng": -122.4737053,
    "lat": 47.4208759
  },
  {
    "lng": -0.7170764,
    "lat": 44.8958887
  },
  {
    "lng": -70.7746224,
    "lat": 43.4387179
  },
  {
    "lng": -83.3771553,
    "lat": 42.4853125
  },
  {
    "lng": -76.5974223,
    "lat": 39.4475075
  },
  {
    "lng": 6.3681233,
    "lat": 50.801983
  },
  {
    "lng": -71.3606721,
    "lat": 42.3632063
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -99.1517322,
    "lat": 19.4414715
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -114.315321,
    "lat": 48.202158
  },
  {
    "lng": -94.7288558,
    "lat": 31.3386242
  },
  {
    "lng": -46.3286399,
    "lat": -23.9335988
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.0629531,
    "lat": 42.453492
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 2.1836324,
    "lat": 49.0634561
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -2.0597449,
    "lat": 52.3353816
  },
  {
    "lng": 2.4631476,
    "lat": 48.9385489
  },
  {
    "lng": 139.766706,
    "lat": 35.6812546
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.3145039,
    "lat": 48.9525181
  },
  {
    "lng": -122.2070775,
    "lat": 47.6765382
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -70.8578253,
    "lat": 42.500096
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -49.2712724,
    "lat": -25.4295963
  },
  {
    "lng": -83.1499304,
    "lat": 42.6055893
  },
  {
    "lng": -6.4008879,
    "lat": 54.0046033
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -92.4630182,
    "lat": 44.0234387
  },
  {
    "lng": -118.11711,
    "lat": 34.5793131
  },
  {
    "lng": -71.2355644,
    "lat": 42.3762385
  },
  {
    "lng": -79.666672,
    "lat": 43.447436
  },
  {
    "lng": -81.7786972,
    "lat": 26.339806
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -92.3745761,
    "lat": 30.2140928
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.2776468,
    "lat": 40.6081591
  },
  {
    "lng": -89.093966,
    "lat": 42.2713945
  },
  {
    "lng": -76.8646092,
    "lat": 39.1938429
  },
  {
    "lng": -77.9112655,
    "lat": 37.5531622
  },
  {
    "lng": -89.683459,
    "lat": 45.180522
  },
  {
    "lng": -76.2494453,
    "lat": 36.7168315
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -8.6058415,
    "lat": 41.1300103
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.5501874,
    "lat": 39.2085354
  },
  {
    "lng": -7.6200284,
    "lat": 33.5945144
  },
  {
    "lng": -79.1771539,
    "lat": 35.7201229
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -103.228023,
    "lat": 44.0806041
  },
  {
    "lng": -2.0976346,
    "lat": 57.1426487
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -83.2646624,
    "lat": 42.8247524
  },
  {
    "lng": -118.8375937,
    "lat": 34.1705609
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.1173394,
    "lat": 39.9239373
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 30.061507,
    "lat": -1.950851
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 2.0942792,
    "lat": 48.8990413
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -75.9760751,
    "lat": 36.8496579
  },
  {
    "lng": -97.2681939,
    "lat": 36.4129621
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -86.5245906,
    "lat": 35.9670985
  },
  {
    "lng": -123.137414,
    "lat": 49.163168
  },
  {
    "lng": -1.8604874,
    "lat": 53.7229229
  },
  {
    "lng": -101.296273,
    "lat": 48.23251
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -61.5037609,
    "lat": 10.6680972
  },
  {
    "lng": 2.4875193,
    "lat": 48.8716626
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -8.6103497,
    "lat": 41.1502195
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -9.1576301,
    "lat": 38.6831302
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 1.2238259,
    "lat": 45.8055591
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -116.464076,
    "lat": 33.7810031
  },
  {
    "lng": -87.7887615,
    "lat": 41.8878145
  },
  {
    "lng": -82.6995444,
    "lat": 27.8428025
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -71.3322798,
    "lat": 41.9841334
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 12.5135924,
    "lat": 55.6637755
  },
  {
    "lng": -98.3252932,
    "lat": 26.2159066
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 8.6938161,
    "lat": 50.5808795
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -85.9213796,
    "lat": 39.2014405
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -77.4127562,
    "lat": 39.415779
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.4547891,
    "lat": 42.9956397
  },
  {
    "lng": -107.2112407,
    "lat": 39.4005647
  },
  {
    "lng": -0.1991229,
    "lat": 51.4989948
  },
  {
    "lng": -71.2804301,
    "lat": 41.9439695
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 7.1780374,
    "lat": 51.264018
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -87.682932,
    "lat": 42.0693991
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -117.2305791,
    "lat": 33.9375177
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -86.8919011,
    "lat": 40.4191229
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 120.5668992,
    "lat": 15.9759995
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -117.566444,
    "lat": 33.8752945
  },
  {
    "lng": 77.6226,
    "lat": 12.9881567
  },
  {
    "lng": 7.0581152,
    "lat": 46.6190969
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -0.3032767,
    "lat": 51.4613531
  },
  {
    "lng": -73.2584121,
    "lat": 41.1428951
  },
  {
    "lng": -81.345941,
    "lat": 41.239223
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -80.6636984,
    "lat": 28.2662775
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -105.0372046,
    "lat": 39.8366528
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -74.6171489,
    "lat": 39.3820672
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": -87.9803604,
    "lat": 42.2204892
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -88.207301,
    "lat": 40.1117174
  },
  {
    "lng": -71.2084061,
    "lat": 46.8137431
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 4.9639631,
    "lat": 52.0914501
  },
  {
    "lng": 4.8423304,
    "lat": 45.7969952
  },
  {
    "lng": -83.7049498,
    "lat": 42.7978061
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -121.99059,
    "lat": 37.050096
  },
  {
    "lng": 2.3019814,
    "lat": 48.8211559
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 23.8280444,
    "lat": 61.1974827
  },
  {
    "lng": -113.584131,
    "lat": 37.104153
  },
  {
    "lng": -101.8371192,
    "lat": 35.20729
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -75.2590721,
    "lat": 39.9184461
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -75.0729504,
    "lat": 39.8909466
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 2.415796,
    "lat": 48.8795658
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": -107.2112407,
    "lat": 39.4005647
  },
  {
    "lng": -73.1867391,
    "lat": 41.1779095
  },
  {
    "lng": -77.9065508,
    "lat": 34.3548975
  },
  {
    "lng": -1.2309278,
    "lat": 44.2019796
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -85.7279185,
    "lat": 42.8192943
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -88.0895061,
    "lat": 41.6475306
  },
  {
    "lng": 2.1900052,
    "lat": 48.7809496
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -86.7825235,
    "lat": 36.0325687
  },
  {
    "lng": 6.6055827,
    "lat": 46.534566
  },
  {
    "lng": 8.7376029,
    "lat": 41.9263991
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 114.1582784,
    "lat": 22.2818286
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -80.581497,
    "lat": 35.4093143
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -58.5036282,
    "lat": -34.5244484
  },
  {
    "lng": -88.770018,
    "lat": 17.250199
  },
  {
    "lng": 6.0992785,
    "lat": 45.8880398
  },
  {
    "lng": -91.4685617,
    "lat": 43.6624222
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -80.5800049,
    "lat": 35.4094178
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -105.436074,
    "lat": 37.4281735
  },
  {
    "lng": -73.1715669,
    "lat": 44.4671635
  },
  {
    "lng": -79.4607617,
    "lat": 46.3092115
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -83.1499322,
    "lat": 42.6583661
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -96.6925096,
    "lat": 33.0136764
  },
  {
    "lng": -92.4116886,
    "lat": 41.0195659
  },
  {
    "lng": -90.6647985,
    "lat": 42.5006243
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 6.9239103,
    "lat": 43.6589011
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.3034183,
    "lat": 29.0281051
  },
  {
    "lng": -95.9927516,
    "lat": 36.1563122
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 6.083862,
    "lat": 50.776351
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -4.0239568,
    "lat": 39.8560679
  },
  {
    "lng": -121.8903368,
    "lat": 36.9941295
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.2138905,
    "lat": 47.2733517
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.0715658,
    "lat": 37.713606
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8534326,
    "lat": 46.7831001
  },
  {
    "lng": -93.1865659,
    "lat": 36.0081324
  },
  {
    "lng": -121.5881718,
    "lat": 48.1138513
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -114.01062,
    "lat": 51.28597
  },
  {
    "lng": -74.415984,
    "lat": 40.4278841
  },
  {
    "lng": -119.0167679,
    "lat": 36.06523
  },
  {
    "lng": 2.7005289,
    "lat": 48.4881157
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": 6.0641634,
    "lat": 53.0059606
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": -1.7471629,
    "lat": 48.0245814
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -97.2258483,
    "lat": 33.0040126
  },
  {
    "lng": -1.67584,
    "lat": 52.6088967
  },
  {
    "lng": -64.5651667,
    "lat": 45.0682627
  },
  {
    "lng": 9.4697982,
    "lat": 53.9313413
  },
  {
    "lng": -81.9705909,
    "lat": 33.4943487
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.7853915,
    "lat": 43.0821793
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -1.4992075,
    "lat": 47.2035029
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.0044767,
    "lat": 45.7764637
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -7.6200284,
    "lat": 33.5945144
  },
  {
    "lng": -81.7016346,
    "lat": 30.1654707
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -85.4807825,
    "lat": 32.6098566
  },
  {
    "lng": -0.0154152,
    "lat": 51.4781086
  },
  {
    "lng": -81.243372,
    "lat": 42.9832406
  },
  {
    "lng": -87.4046571,
    "lat": 37.9456824
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.219344,
    "lat": 48.8437412
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -77.231012,
    "lat": 39.8308973
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -1.7003017,
    "lat": 43.3624715
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9593041,
    "lat": 40.9414874
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -81.4412259,
    "lat": 41.3897764
  },
  {
    "lng": 12.4483489,
    "lat": 55.6898267
  },
  {
    "lng": 0.9918234,
    "lat": 47.3279746
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -96.8439365,
    "lat": 32.3944908
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 8.3418609,
    "lat": 47.4948072
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -82.3076709,
    "lat": 28.7211775
  },
  {
    "lng": -103.338396,
    "lat": 20.6720375
  },
  {
    "lng": 5.93256,
    "lat": 46.932
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": -83.2732627,
    "lat": 42.3369816
  },
  {
    "lng": 2.2956951,
    "lat": 49.8941708
  },
  {
    "lng": -76.6033433,
    "lat": 39.2340834
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.721834,
    "lat": 45.3990409
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": 2.0942792,
    "lat": 48.8990413
  },
  {
    "lng": 5.5783856,
    "lat": 46.1825453
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -112.185994,
    "lat": 33.5386858
  },
  {
    "lng": -122.29214,
    "lat": 47.1849009
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -89.5473245,
    "lat": 40.3725415
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -71.0767724,
    "lat": 42.7777829
  },
  {
    "lng": -0.7460981,
    "lat": 51.3392845
  },
  {
    "lng": -120.1835765,
    "lat": 39.3279454
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.7540703,
    "lat": 45.6739755
  },
  {
    "lng": 11.4354419,
    "lat": 48.2592477
  },
  {
    "lng": 1.5332389,
    "lat": 45.1584982
  },
  {
    "lng": -118.0539323,
    "lat": 33.8644291
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 2.4159739,
    "lat": 48.8432434
  },
  {
    "lng": -72.6311006,
    "lat": 42.3178989
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -4.5583284,
    "lat": 48.4244717
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": 6.3915748,
    "lat": 46.4952916
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.1266886,
    "lat": 48.8035403
  },
  {
    "lng": -77.8616386,
    "lat": 40.7944504
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.1392227,
    "lat": 48.9614964
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -84.8407732,
    "lat": 33.9237141
  },
  {
    "lng": -72.6908547,
    "lat": 41.764582
  },
  {
    "lng": -96.7077751,
    "lat": 40.8088861
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -90.4070632,
    "lat": 39.3022693
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -76.5528831,
    "lat": 39.155816
  },
  {
    "lng": -117.865339,
    "lat": 34.1361187
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -71.2092214,
    "lat": 42.3370414
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -118.559849,
    "lat": 34.4131941
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -72.644512,
    "lat": 41.767914
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -91.3378987,
    "lat": 34.2928774
  },
  {
    "lng": -0.3623924,
    "lat": 51.4619551
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 1.178352,
    "lat": 49.17231
  },
  {
    "lng": -74.0204177,
    "lat": 40.7695457
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -76.4626118,
    "lat": 40.375713
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 151.885362,
    "lat": -27.7692045
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -84.6768796,
    "lat": 34.0659329
  },
  {
    "lng": -76.7276989,
    "lat": 39.962493
  },
  {
    "lng": -87.8406031,
    "lat": 42.0112329
  },
  {
    "lng": -78.8900409,
    "lat": 33.6956461
  },
  {
    "lng": -0.6308396,
    "lat": 44.805615
  },
  {
    "lng": -83.6117646,
    "lat": 42.241051
  },
  {
    "lng": 139.766706,
    "lat": 35.6812546
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": 10.1857757,
    "lat": 36.8002068
  },
  {
    "lng": 13.2439512,
    "lat": -8.8272699
  },
  {
    "lng": 100.5386136,
    "lat": 13.7784702
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -75.710976,
    "lat": 45.4277659
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": -125.244153,
    "lat": 50.023071
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -1.5149935,
    "lat": 43.4813927
  },
  {
    "lng": -84.5597128,
    "lat": 38.2099837
  },
  {
    "lng": 10.0176952,
    "lat": 53.3965903
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": -2.97019,
    "lat": 56.4605938
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": -93.470786,
    "lat": 44.8546856
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.7832947,
    "lat": 45.0049305
  },
  {
    "lng": -84.7997613,
    "lat": 34.1652304
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -74.5226681,
    "lat": 40.0654375
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -72.9250518,
    "lat": 41.3082138
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -72.6719518,
    "lat": 42.3355692
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": 10.6797912,
    "lat": 43.4714722
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -71.889038,
    "lat": 45.403271
  },
  {
    "lng": -0.2464264,
    "lat": 49.1390059
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 6.1301614,
    "lat": 43.1202573
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -89.7030748,
    "lat": 44.7927669
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -72.6071119,
    "lat": 42.1487691
  },
  {
    "lng": -76.4537302,
    "lat": 41.0044958
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -73.872635,
    "lat": 41.0145418
  },
  {
    "lng": -90.6647985,
    "lat": 42.5006243
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": 6.2455185,
    "lat": 48.6876255
  },
  {
    "lng": -68.2043361,
    "lat": 44.3876378
  },
  {
    "lng": 5.4832687,
    "lat": 43.3351381
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 2.3483549,
    "lat": 48.8153656
  },
  {
    "lng": -121.9877444,
    "lat": 38.3565773
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -89.5119565,
    "lat": 43.0962919
  },
  {
    "lng": -8.4726423,
    "lat": 51.8985136
  },
  {
    "lng": 15.4382786,
    "lat": 47.0708678
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -118.4489739,
    "lat": 35.1321878
  },
  {
    "lng": -91.6392294,
    "lat": 44.0500054
  },
  {
    "lng": -0.0135253,
    "lat": 51.5911967
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -101.2727305,
    "lat": 21.0198147
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": 2.2453842,
    "lat": 48.7144587
  },
  {
    "lng": -117.210656,
    "lat": 33.560832
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -90.1830408,
    "lat": 32.2998686
  },
  {
    "lng": -71.1143838,
    "lat": 42.3116046
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 22.2670522,
    "lat": 60.4517531
  },
  {
    "lng": -95.9927516,
    "lat": 36.1563122
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -3.5995337,
    "lat": 37.1734995
  },
  {
    "lng": -75.7116997,
    "lat": 39.8467414
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -71.3488963,
    "lat": 42.4605189
  },
  {
    "lng": -93.574375,
    "lat": 45.0151361
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 108.4034084,
    "lat": 30.8101669
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.6039516,
    "lat": 46.9756991
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -74.9573908,
    "lat": 40.0323338
  },
  {
    "lng": 1.7537638,
    "lat": 52.4766308
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 9.959178,
    "lat": 63.5842624
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.4503643,
    "lat": 48.1747684
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -82.5187629,
    "lat": 37.4792672
  },
  {
    "lng": -79.4062658,
    "lat": 39.4099097
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -94.81887,
    "lat": 38.8838856
  },
  {
    "lng": -71.1546367,
    "lat": 41.7010642
  },
  {
    "lng": -83.8598742,
    "lat": 33.5966005
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": -84.0373054,
    "lat": 41.8975152
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.938456,
    "lat": 35.6876096
  },
  {
    "lng": -94.419079,
    "lat": 39.246479
  },
  {
    "lng": -74.7333845,
    "lat": 45.0469989
  },
  {
    "lng": -84.6154897,
    "lat": 34.0234337
  },
  {
    "lng": -75.3068878,
    "lat": 39.9483282
  },
  {
    "lng": -117.7517496,
    "lat": 34.0553813
  },
  {
    "lng": -111.044047,
    "lat": 45.6794293
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": -75.546589,
    "lat": 39.7459468
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -81.9081937,
    "lat": 41.375049
  },
  {
    "lng": -75.1946649,
    "lat": 40.9864261
  },
  {
    "lng": -87.6835974,
    "lat": 30.4065868
  },
  {
    "lng": -48.5496098,
    "lat": -27.5973002
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 11.8734455,
    "lat": 45.4077172
  },
  {
    "lng": -97.6200043,
    "lat": 30.4393696
  },
  {
    "lng": 2.2619632,
    "lat": 48.7811049
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -73.4698253,
    "lat": 40.669501
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -76.6232526,
    "lat": 39.3406674
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.6496424,
    "lat": 40.2452976
  },
  {
    "lng": -89.6237402,
    "lat": 20.9670759
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -71.1859782,
    "lat": 44.5736767
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -0.0154152,
    "lat": 51.4781086
  },
  {
    "lng": -58.6671441,
    "lat": -34.6583293
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -122.301411,
    "lat": 37.9154056
  },
  {
    "lng": 6.9703991,
    "lat": 43.6203852
  },
  {
    "lng": 1.9988356,
    "lat": 48.7760957
  },
  {
    "lng": 3.7250121,
    "lat": 51.0538286
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -99.5069922,
    "lat": 27.5075005
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": 5.9304919,
    "lat": 43.1257311
  },
  {
    "lng": 135.0762968,
    "lat": 48.4812568
  },
  {
    "lng": -79.2576479,
    "lat": 43.7729744
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -70.09842,
    "lat": 41.2844408
  },
  {
    "lng": -0.0135253,
    "lat": 51.5911967
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -95.5507771,
    "lat": 30.7235263
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -76.6235105,
    "lat": 39.4837588
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 115.2191175,
    "lat": -8.6524973
  },
  {
    "lng": -84.4310645,
    "lat": 10.3267699
  },
  {
    "lng": -72.5886727,
    "lat": 42.1018764
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -114.668741,
    "lat": 47.6091041
  },
  {
    "lng": -80.5800049,
    "lat": 35.4094178
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.0566735,
    "lat": 40.7899291
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -75.8062341,
    "lat": 39.6010603
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -79.0208814,
    "lat": 43.8505287
  },
  {
    "lng": -76.9274072,
    "lat": 38.6023935
  },
  {
    "lng": 0.0757204,
    "lat": 51.6176444
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -117.3505966,
    "lat": 33.1580933
  },
  {
    "lng": 15.2151181,
    "lat": 59.2747287
  },
  {
    "lng": 0.2781546,
    "lat": 50.7664372
  },
  {
    "lng": 15.409716,
    "lat": 48.1006741
  },
  {
    "lng": -71.2084061,
    "lat": 46.8137431
  },
  {
    "lng": -76.8317417,
    "lat": 39.2757359
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 1.3044842,
    "lat": 51.1296508
  },
  {
    "lng": -73.9897782,
    "lat": 41.1509835
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -97.3404854,
    "lat": 32.9616819
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -77.3464516,
    "lat": 38.953282
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 17.0607599,
    "lat": 61.2998501
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 0.4144984,
    "lat": 46.5089333
  },
  {
    "lng": -122.2054035,
    "lat": 47.7623204
  },
  {
    "lng": -111.651822,
    "lat": 35.1987522
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": -122.3473099,
    "lat": 37.5780965
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -86.4541894,
    "lat": 42.1167065
  },
  {
    "lng": -75.889912,
    "lat": 40.1552219
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -122.768761,
    "lat": 45.4853207
  },
  {
    "lng": -79.8728583,
    "lat": 43.2560802
  },
  {
    "lng": -71.8358095,
    "lat": 42.1945465
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -122.4569315,
    "lat": 48.9466041
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -97.9647269,
    "lat": 29.5688411
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.5420246,
    "lat": 41.0469042
  },
  {
    "lng": -82.3877015,
    "lat": 35.6005795
  },
  {
    "lng": -80.9450759,
    "lat": 35.0073697
  },
  {
    "lng": -83.2341028,
    "lat": 42.6875323
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -104.969565,
    "lat": 39.5497243
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -72.6816365,
    "lat": 41.2827593
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 9.1224313,
    "lat": 47.4299725
  },
  {
    "lng": -71.4586114,
    "lat": 41.6992717
  },
  {
    "lng": -106.325138,
    "lat": 42.8501191
  },
  {
    "lng": -122.2054035,
    "lat": 47.7623204
  },
  {
    "lng": -77.93918,
    "lat": 43.213671
  },
  {
    "lng": -83.8598742,
    "lat": 33.5966005
  },
  {
    "lng": -82.5723193,
    "lat": 27.5214269
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -4.2835502,
    "lat": 47.8411013
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -97.9405828,
    "lat": 29.8826436
  },
  {
    "lng": -88.3123889,
    "lat": 43.0622536
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -121.3153096,
    "lat": 44.0581728
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -89.216655,
    "lat": 37.7274692
  },
  {
    "lng": 6.1724618,
    "lat": 48.6599676
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -121.2462453,
    "lat": 38.642897
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -71.1786655,
    "lat": 42.3959296
  },
  {
    "lng": -80.2493276,
    "lat": 43.5460516
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -95.3024351,
    "lat": 29.9118897
  },
  {
    "lng": -122.5371325,
    "lat": 47.2258172
  },
  {
    "lng": -1.5839895,
    "lat": 47.1231355
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.5133385,
    "lat": 37.0841838
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 0.1079732,
    "lat": 49.4938975
  },
  {
    "lng": -71.9598586,
    "lat": 46.0554948
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -81.6853534,
    "lat": 28.8527675
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.8046023,
    "lat": 42.5854371
  },
  {
    "lng": 6.765164,
    "lat": 43.617944
  },
  {
    "lng": -0.75596,
    "lat": 51.6317449
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.5716694,
    "lat": 39.1836082
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -83.2732627,
    "lat": 42.3369816
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": -81.9705909,
    "lat": 33.4943487
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -73.7048024,
    "lat": 40.7246999
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 9.1364229,
    "lat": 48.9493243
  },
  {
    "lng": -82.5540279,
    "lat": 28.183222
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 2.4197113,
    "lat": 48.8051624
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -117.019529,
    "lat": 32.5317397
  },
  {
    "lng": -94.1288142,
    "lat": 36.1867442
  },
  {
    "lng": -81.3410516,
    "lat": 35.2450607
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -120.4964189,
    "lat": 35.0358216
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -96.4719289,
    "lat": 32.747893
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -80.6009388,
    "lat": 40.4654148
  },
  {
    "lng": -85.4807825,
    "lat": 32.6098566
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -123.033121,
    "lat": 44.9391565
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -87.7887615,
    "lat": 41.8878145
  },
  {
    "lng": -1.67584,
    "lat": 52.6088967
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -80.0830984,
    "lat": 26.3586885
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -7.4919318,
    "lat": 39.8266322
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -104.8769227,
    "lat": 39.579155
  },
  {
    "lng": -96.3455991,
    "lat": 30.6183939
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": -78.4767034,
    "lat": 36.0247769
  },
  {
    "lng": -0.0135253,
    "lat": 51.5911967
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 116.3912972,
    "lat": 39.9057136
  },
  {
    "lng": -78.5103731,
    "lat": 35.9803138
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -86.851123,
    "lat": 33.350293
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 114.0545429,
    "lat": 22.5445741
  },
  {
    "lng": -82.5164242,
    "lat": 35.4661821
  },
  {
    "lng": -79.9559437,
    "lat": 39.6296809
  },
  {
    "lng": 14.4258096,
    "lat": 35.910083
  },
  {
    "lng": -77.3267652,
    "lat": 38.5674096
  },
  {
    "lng": -72.6110645,
    "lat": 42.5896205
  },
  {
    "lng": -120.8471545,
    "lat": 37.7665947
  },
  {
    "lng": -73.9283672,
    "lat": 41.7065539
  },
  {
    "lng": -4.3888761,
    "lat": 55.8775733
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -93.1566107,
    "lat": 45.0060767
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 24.0315921,
    "lat": 49.841952
  },
  {
    "lng": -122.6246836,
    "lat": 47.5653663
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -82.7192671,
    "lat": 28.2441768
  },
  {
    "lng": -93.470786,
    "lat": 44.8546856
  },
  {
    "lng": -111.7386884,
    "lat": 40.3640349
  },
  {
    "lng": 5.7715863,
    "lat": 45.0758358
  },
  {
    "lng": -94.1910044,
    "lat": 42.5044017
  },
  {
    "lng": -111.841185,
    "lat": 33.3062031
  },
  {
    "lng": -71.4235744,
    "lat": 46.8595141
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": -93.1553635,
    "lat": 45.144882
  },
  {
    "lng": -85.3425348,
    "lat": 38.0317303
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -82.3269883,
    "lat": 27.871197
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.0414701,
    "lat": 47.3215806
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -122.29214,
    "lat": 47.1849009
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -74.4115401,
    "lat": 40.5792701
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -119.242889,
    "lat": 34.4480495
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -75.1198911,
    "lat": 39.9448402
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -79.4686558,
    "lat": 44.2396166
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -122.5371325,
    "lat": 47.2258172
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 39.1742363,
    "lat": 21.5504432
  },
  {
    "lng": -104.7008056,
    "lat": 38.682219
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -121.899142,
    "lat": 37.6090291
  },
  {
    "lng": -84.4041725,
    "lat": 39.516644
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -81.0161686,
    "lat": 35.2976298
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -80.5800049,
    "lat": 35.4094178
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 72.5800568,
    "lat": 23.0215374
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -96.6783651,
    "lat": 34.7743383
  },
  {
    "lng": -73.5731712,
    "lat": 45.459099
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -71.1143838,
    "lat": 42.3116046
  },
  {
    "lng": -2.2458192,
    "lat": 51.8653705
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": -88.6867538,
    "lat": 41.9889173
  },
  {
    "lng": -90.4973286,
    "lat": 36.0584021
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -88.9939147,
    "lat": 40.4797828
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -96.6081167,
    "lat": 47.7739988
  },
  {
    "lng": 1.4580047,
    "lat": 48.4489382
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -79.4491057,
    "lat": 43.7543217
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -94.626497,
    "lat": 39.1134562
  },
  {
    "lng": -111.8804817,
    "lat": 40.8894611
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -83.7658369,
    "lat": 42.4243473
  },
  {
    "lng": 24.7453688,
    "lat": 59.4372155
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -74.9829443,
    "lat": 39.8115033
  },
  {
    "lng": 29.3205405,
    "lat": -3.3242483
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.4881708,
    "lat": 38.3436365
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -80.5495112,
    "lat": 34.9854275
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.400941,
    "lat": 37.598958
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.2127083,
    "lat": 48.8247407
  },
  {
    "lng": -2.8458503,
    "lat": 47.5968368
  },
  {
    "lng": 120.6212881,
    "lat": 31.311123
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": -81.0557921,
    "lat": 29.2854132
  },
  {
    "lng": 2.3872525,
    "lat": 48.8122302
  },
  {
    "lng": -5.4108305,
    "lat": 35.5590626
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -122.636465,
    "lat": 38.2325829
  },
  {
    "lng": -121.784889,
    "lat": 47.4957757
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -117.903317,
    "lat": 33.6633386
  },
  {
    "lng": -80.2872086,
    "lat": 26.0061943
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -94.282265,
    "lat": 39.017316
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.7191081,
    "lat": 39.6430455
  },
  {
    "lng": -1.4736657,
    "lat": 43.4945144
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9112103,
    "lat": 41.5965635
  },
  {
    "lng": 105.8406959,
    "lat": 21.0242596
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 67.0207055,
    "lat": 24.8546842
  },
  {
    "lng": -84.3041074,
    "lat": 39.5589474
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -81.3035515,
    "lat": 31.9382381
  },
  {
    "lng": -88.3334274,
    "lat": 42.8666803
  },
  {
    "lng": -77.5645607,
    "lat": 39.1154506
  },
  {
    "lng": 3.094027,
    "lat": 36.7429388
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -121.8374777,
    "lat": 39.7284945
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -87.8947848,
    "lat": 37.9318018
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -2.491841,
    "lat": 52.9045385
  },
  {
    "lng": -77.0011096,
    "lat": 41.2411556
  },
  {
    "lng": -1.5342042,
    "lat": 54.9911912
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.0715658,
    "lat": 37.713606
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -71.4366813,
    "lat": 41.779588
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 4.7540703,
    "lat": 45.6739755
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": 5.6851425,
    "lat": 43.4469081
  },
  {
    "lng": -80.3975399,
    "lat": 27.6387163
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -87.0522661,
    "lat": 41.6107243
  },
  {
    "lng": -71.8623548,
    "lat": 42.3560836
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": 104.063315,
    "lat": 30.659867
  },
  {
    "lng": 5.0414701,
    "lat": 47.3215806
  },
  {
    "lng": -71.346996,
    "lat": 42.2836393
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -0.0154152,
    "lat": 51.4781086
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -97.3404854,
    "lat": 32.9616819
  },
  {
    "lng": 90.3890144,
    "lat": 23.7643863
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 120.0851114,
    "lat": 30.8942995
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -121.290779,
    "lat": 37.9577016
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -0.0927317,
    "lat": 51.3758448
  },
  {
    "lng": 8.6736295,
    "lat": 49.8851869
  },
  {
    "lng": -75.5138959,
    "lat": 40.036202
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -74.1968257,
    "lat": 39.9526791
  },
  {
    "lng": 4.3181187,
    "lat": 50.811795
  },
  {
    "lng": -83.3527097,
    "lat": 42.36837
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.33931,
    "lat": 47.313494
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": -116.5016784,
    "lat": 33.961124
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -87.9822969,
    "lat": 43.2219088
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": 120.9803621,
    "lat": 14.5904492
  },
  {
    "lng": -112.583776,
    "lat": 33.3703197
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -111.634158,
    "lat": 33.2483858
  },
  {
    "lng": -79.5655129,
    "lat": 43.7213619
  },
  {
    "lng": -90.3227803,
    "lat": 38.7919683
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -89.2134359,
    "lat": 43.1834579
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -82.9069508,
    "lat": 42.4435616
  },
  {
    "lng": -83.0335384,
    "lat": 42.6261446
  },
  {
    "lng": -70.9494939,
    "lat": 42.466763
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -83.2396612,
    "lat": 42.7844752
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 7.0557352,
    "lat": 48.734239
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.1177723,
    "lat": 44.0427744
  },
  {
    "lng": -75.2188589,
    "lat": 38.324505
  },
  {
    "lng": -89.0928155,
    "lat": 30.3674198
  },
  {
    "lng": -76.8115168,
    "lat": 40.398036
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -72.6713448,
    "lat": 41.707785
  },
  {
    "lng": -83.9490365,
    "lat": 43.4200387
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 28.9758715,
    "lat": 41.006381
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": -111.29189,
    "lat": 47.5048851
  },
  {
    "lng": -121.176058,
    "lat": 38.6779591
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -117.147366,
    "lat": 33.4946353
  },
  {
    "lng": -80.1098123,
    "lat": 32.9857275
  },
  {
    "lng": -71.9107903,
    "lat": 42.5449024
  },
  {
    "lng": -76.9429182,
    "lat": 39.2065447
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -117.903317,
    "lat": 33.6633386
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 0.0689113,
    "lat": 51.5589375
  },
  {
    "lng": -80.0728201,
    "lat": 26.4614625
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -97.0867203,
    "lat": 33.0283854
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -119.495902,
    "lat": 49.8879177
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -88.852119,
    "lat": 35.6055887
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -75.0437814,
    "lat": 40.1742759
  },
  {
    "lng": 2.7772211,
    "lat": 50.291048
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -82.366121,
    "lat": 28.1866014
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -8.831088,
    "lat": 41.694867
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -90.5136642,
    "lat": 41.5058344
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -79.1802994,
    "lat": 35.4798757
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -0.3018577,
    "lat": 51.4129277
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -0.9700664,
    "lat": 51.4564242
  },
  {
    "lng": -117.9056046,
    "lat": 34.1338751
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -83.6000696,
    "lat": 42.5917805
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": -70.9391625,
    "lat": 42.2212188
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 14.2487679,
    "lat": 40.8358846
  },
  {
    "lng": 2.289259,
    "lat": 48.8212037
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -2.2327511,
    "lat": 53.3261292
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -82.5748194,
    "lat": 27.4989278
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -73.8320784,
    "lat": 40.9381544
  },
  {
    "lng": -72.0934864,
    "lat": 41.343637
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -76.217705,
    "lat": 43.106456
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -6.0414184,
    "lat": 52.9802376
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -75.9279495,
    "lat": 40.335345
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -120.834972,
    "lat": 44.2998261
  },
  {
    "lng": 0.1034297,
    "lat": 51.4340208
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 58.2058419,
    "lat": 23.65478
  },
  {
    "lng": -81.4075838,
    "lat": 28.2918995
  },
  {
    "lng": -72.2268141,
    "lat": 42.594001
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.2289491,
    "lat": 40.7264091
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.3957425,
    "lat": 51.6553875
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.1573695,
    "lat": 48.8897044
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 14.4745958,
    "lat": 50.2471333
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -1.0503893,
    "lat": 45.6938702
  },
  {
    "lng": -111.7386884,
    "lat": 40.3640349
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -122.1702293,
    "lat": 47.1870191
  },
  {
    "lng": -1.4736657,
    "lat": 43.4945144
  },
  {
    "lng": -76.2835569,
    "lat": 40.7914769
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.147899,
    "lat": 43.9277552
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.5387318,
    "lat": 38.5961694
  },
  {
    "lng": -84.5810418,
    "lat": 33.5670562
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -74.2765366,
    "lat": 40.8398218
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -121.955174,
    "lat": 37.3541132
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9395687,
    "lat": 42.8142432
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -86.6497378,
    "lat": 35.741808
  },
  {
    "lng": -74.0326395,
    "lat": 40.9912087
  },
  {
    "lng": -88.9939147,
    "lat": 40.4797828
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": 9.0804584,
    "lat": 52.1873798
  },
  {
    "lng": 7.1612669,
    "lat": 46.8055656
  },
  {
    "lng": -119.951909,
    "lat": 39.2501246
  },
  {
    "lng": -75.7032742,
    "lat": 40.0064958
  },
  {
    "lng": -117.929416,
    "lat": 33.8708215
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 0.4040065,
    "lat": 43.5148029
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -83.1596108,
    "lat": 40.033814
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -116.9739167,
    "lat": 32.8383828
  },
  {
    "lng": 6.1763552,
    "lat": 49.1196964
  },
  {
    "lng": -119.119919,
    "lat": 46.2087066
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -96.9756323,
    "lat": 33.3142085
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -84.1457505,
    "lat": 33.8062166
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -83.6156648,
    "lat": 42.511726
  },
  {
    "lng": 27.6781839,
    "lat": 62.8924601
  },
  {
    "lng": -83.1446485,
    "lat": 42.4894801
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -80.44868,
    "lat": 41.2333897
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -69.7193802,
    "lat": 44.7650773
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -119.8276389,
    "lat": 34.4358295
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -70.8378746,
    "lat": 42.9417199
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.0618702,
    "lat": 37.9020731
  },
  {
    "lng": 0.1481142,
    "lat": 51.5413271
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -96.9442177,
    "lat": 32.8295183
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 4.3668279,
    "lat": 50.8331141
  },
  {
    "lng": -121.9877444,
    "lat": 38.3565773
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": -71.5120096,
    "lat": 42.5375917
  },
  {
    "lng": -118.117191,
    "lat": 33.8503463
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.7050318,
    "lat": 52.6019248
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -80.206436,
    "lat": 26.2445263
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": -86.1807031,
    "lat": 41.6611642
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -0.75596,
    "lat": 51.6317449
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -95.2621553,
    "lat": 29.9988312
  },
  {
    "lng": -72.6908547,
    "lat": 41.764582
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -117.9389526,
    "lat": 34.0686208
  },
  {
    "lng": -9.3745601,
    "lat": 39.1192213
  },
  {
    "lng": 4.8855966,
    "lat": 45.6977109
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -84.0176904,
    "lat": 33.6676103
  },
  {
    "lng": -104.937199,
    "lat": 40.0991506
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -97.6788056,
    "lat": 30.5085915
  },
  {
    "lng": -0.474739,
    "lat": 44.812928
  },
  {
    "lng": -107.2112407,
    "lat": 39.4005647
  },
  {
    "lng": 0.300103,
    "lat": 51.3962097
  },
  {
    "lng": -117.3505966,
    "lat": 33.1580933
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -67.8854173,
    "lat": 45.3283923
  },
  {
    "lng": -87.1250154,
    "lat": 39.523652
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.4127848,
    "lat": 43.4511819
  },
  {
    "lng": 0.7056174,
    "lat": 51.5838691
  },
  {
    "lng": -4.7887547,
    "lat": 55.6332429
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 9.7385532,
    "lat": 52.3744779
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.2779715,
    "lat": 51.6714842
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -78.9284241,
    "lat": 39.6583325
  },
  {
    "lng": -70.2529189,
    "lat": 43.6382443
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": -7.2662964,
    "lat": 40.5378408
  },
  {
    "lng": -71.4586114,
    "lat": 41.6992717
  },
  {
    "lng": -2.7599079,
    "lat": 47.6586772
  },
  {
    "lng": -122.3873133,
    "lat": 45.5392862
  },
  {
    "lng": 2.7932391,
    "lat": 41.6756178
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -0.0927317,
    "lat": 51.3758448
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -106.6329806,
    "lat": 35.2702448
  },
  {
    "lng": 6.4627333,
    "lat": 43.5374662
  },
  {
    "lng": -71.0542002,
    "lat": 42.4085897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -72.9401357,
    "lat": 40.879243
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.7038708,
    "lat": 44.5014007
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -98.2300605,
    "lat": 26.204114
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": -74.6893282,
    "lat": 41.6556465
  },
  {
    "lng": -112.3681428,
    "lat": 33.629247
  },
  {
    "lng": -106.660767,
    "lat": 52.131802
  },
  {
    "lng": -101.8470215,
    "lat": 33.5855677
  },
  {
    "lng": -103.799951,
    "lat": 40.2502582
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": 16.4399659,
    "lat": 43.5116383
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.0812467,
    "lat": 46.1444789
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 130.4699924,
    "lat": 33.5326401
  },
  {
    "lng": -84.5496148,
    "lat": 33.9528472
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": 1.5332389,
    "lat": 45.1584982
  },
  {
    "lng": -96.900362,
    "lat": 46.874967
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -89.953157,
    "lat": 38.8114364
  },
  {
    "lng": -81.8020722,
    "lat": 24.5548262
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.1282572,
    "lat": 44.0537103
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -117.9056046,
    "lat": 34.1338751
  },
  {
    "lng": 2.3019814,
    "lat": 48.8211559
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -1.7271466,
    "lat": 47.2115054
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": -87.7332823,
    "lat": 34.5042652
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -75.6621294,
    "lat": 41.4086874
  },
  {
    "lng": -116.0833144,
    "lat": 34.8253019
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -122.2433113,
    "lat": 49.0699667
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.7767859,
    "lat": 46.4990505
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -1.7937675,
    "lat": 48.1006715
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.9414313,
    "lat": 37.270973
  },
  {
    "lng": -80.4927815,
    "lat": 43.451291
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -118.2478471,
    "lat": 34.1469416
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -120.310349,
    "lat": 47.4234599
  },
  {
    "lng": -118.4492148,
    "lat": 34.3076252
  },
  {
    "lng": -40.4984617,
    "lat": -20.6718755
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -121.838579,
    "lat": 37.2978434
  },
  {
    "lng": 45.4254332,
    "lat": 35.5630567
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -95.1846301,
    "lat": 30.0497077
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -86.2283864,
    "lat": 43.0630734
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -85.9744569,
    "lat": 42.1080979
  },
  {
    "lng": -82.5748194,
    "lat": 27.4989278
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -87.682932,
    "lat": 42.0693991
  },
  {
    "lng": -87.8114044,
    "lat": 42.0700662
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.3510264,
    "lat": 28.5977707
  },
  {
    "lng": -119.702667,
    "lat": 34.4221319
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -118.374752,
    "lat": 34.1649502
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -1.0677602,
    "lat": 50.8221133
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 10.2724617,
    "lat": 36.767891
  },
  {
    "lng": -96.8238183,
    "lat": 33.1505998
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": 115.2191175,
    "lat": -8.6524973
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -73.9395687,
    "lat": 42.8142432
  },
  {
    "lng": -86.9300023,
    "lat": 35.751179
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.3197111,
    "lat": 48.9891693
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -87.0717718,
    "lat": 20.6269889
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 0.1079732,
    "lat": 49.4938975
  },
  {
    "lng": -83.6117646,
    "lat": 42.241051
  },
  {
    "lng": -96.9034244,
    "lat": 32.9515472
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 2.4258354,
    "lat": 48.9351403
  },
  {
    "lng": -88.4493796,
    "lat": 43.7533414
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -71.1425197,
    "lat": 42.8910542
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -111.133224,
    "lat": 39.0935829
  },
  {
    "lng": 4.6435597,
    "lat": 52.3837058
  },
  {
    "lng": -75.8940505,
    "lat": 45.3128048
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.765164,
    "lat": 43.617944
  },
  {
    "lng": -80.1762704,
    "lat": 33.0186699
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -93.9332302,
    "lat": 29.8716577
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.1956331,
    "lat": 39.0180508
  },
  {
    "lng": -80.4677741,
    "lat": 25.091338
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.5879629,
    "lat": 44.8088438
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -96.3455991,
    "lat": 30.6183939
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.83511,
    "lat": 41.3144733
  },
  {
    "lng": -122.1389548,
    "lat": 48.1810957
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -118.1167679,
    "lat": 33.8825705
  },
  {
    "lng": 6.1763552,
    "lat": 49.1196964
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -81.2839038,
    "lat": 28.2498534
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -95.8996261,
    "lat": 29.690292
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -119.0921,
    "lat": 46.2306739
  },
  {
    "lng": -74.2289491,
    "lat": 40.7264091
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": -156.5089398,
    "lat": 20.8894684
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -94.7685084,
    "lat": 36.5898616
  },
  {
    "lng": -84.1401926,
    "lat": 34.2073196
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -124.054331,
    "lat": 46.35232
  },
  {
    "lng": 10.5038864,
    "lat": 60.8721617
  },
  {
    "lng": -87.8871505,
    "lat": 42.9818858
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -77.5645607,
    "lat": 39.1154506
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 114.6280794,
    "lat": 38.6458703
  },
  {
    "lng": 9.053596,
    "lat": 48.5203263
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 2.5096751,
    "lat": 49.0449139
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -118.226624,
    "lat": 33.894927
  },
  {
    "lng": 44.507897,
    "lat": 40.1553328
  },
  {
    "lng": -93.6170448,
    "lat": 42.0267567
  },
  {
    "lng": 118.7788631,
    "lat": 32.0438284
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -117.0814849,
    "lat": 33.1216751
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -86.1283681,
    "lat": 39.9784186
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 7.4652789,
    "lat": 51.5142273
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -2.9163053,
    "lat": 47.7422676
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.1730571,
    "lat": 48.7995951
  },
  {
    "lng": 3.2131307,
    "lat": 43.3426562
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": 2.1868998,
    "lat": 48.9229416
  },
  {
    "lng": -122.5246791,
    "lat": 47.6515096
  },
  {
    "lng": -71.0767724,
    "lat": 42.7777829
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -73.0568716,
    "lat": 43.176909
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": -79.9559437,
    "lat": 39.6296809
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -75.546589,
    "lat": 39.7459468
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -79.7093339,
    "lat": 40.3301738
  },
  {
    "lng": -74.9290536,
    "lat": 39.7912262
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -82.8121191,
    "lat": 39.9547861
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -68.2043361,
    "lat": 44.3876378
  },
  {
    "lng": 7.1186671,
    "lat": 50.5444551
  },
  {
    "lng": -106.6329806,
    "lat": 35.2702448
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": -3.3660907,
    "lat": 47.7477336
  },
  {
    "lng": 2.5076601,
    "lat": 48.8406252
  },
  {
    "lng": -96.789821,
    "lat": 46.877229
  },
  {
    "lng": -71.4547891,
    "lat": 42.9956397
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -85.2559398,
    "lat": 34.0124425
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 100.4230508,
    "lat": 13.7803993
  },
  {
    "lng": -92.3892966,
    "lat": 43.6870098
  },
  {
    "lng": -85.5872286,
    "lat": 42.291707
  },
  {
    "lng": -122.6246836,
    "lat": 47.5653663
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.4875797,
    "lat": 50.9025623
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": -96.9442177,
    "lat": 32.8295183
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": 106.6246178,
    "lat": 26.6499922
  },
  {
    "lng": -95.2864299,
    "lat": 29.5639758
  },
  {
    "lng": -101.5437395,
    "lat": 40.850206
  },
  {
    "lng": -71.3821203,
    "lat": 41.8789531
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -118.4486675,
    "lat": 34.1866193
  },
  {
    "lng": -1.5749324,
    "lat": 49.3015127
  },
  {
    "lng": 36.828842,
    "lat": -1.3026148
  },
  {
    "lng": -97.4033191,
    "lat": 27.7635302
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -74.2295891,
    "lat": 40.41483
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -93.6170448,
    "lat": 42.0267567
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -80.6520161,
    "lat": 41.1035786
  },
  {
    "lng": 5.5518002,
    "lat": 52.0232041
  },
  {
    "lng": -96.9146374,
    "lat": 19.5408338
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 0.0212014,
    "lat": 51.6085806
  },
  {
    "lng": 4.3627245,
    "lat": 51.9994572
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 0.7184407,
    "lat": 45.1909365
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 6.1763552,
    "lat": 49.1196964
  },
  {
    "lng": -75.8936803,
    "lat": 41.1423516
  },
  {
    "lng": 43.0997156,
    "lat": 36.343694
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -80.2440518,
    "lat": 36.0998131
  },
  {
    "lng": -73.0438362,
    "lat": 41.5538091
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 2.1266886,
    "lat": 48.8035403
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 88.3638953,
    "lat": 22.5726459
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": 108.3627211,
    "lat": 22.8193063
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -73.7458456,
    "lat": 42.7436134
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 0.0887195,
    "lat": 51.3736037
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.4818087,
    "lat": 48.6137734
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.2519175,
    "lat": 27.197983
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -97.6960599,
    "lat": 26.1907543
  },
  {
    "lng": -73.6917878,
    "lat": 42.7284117
  },
  {
    "lng": 7.1513834,
    "lat": 43.6612012
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -97.3375448,
    "lat": 37.6922361
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -117.8617337,
    "lat": 33.8714814
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 4.4270852,
    "lat": 50.8171712
  },
  {
    "lng": 6.8727506,
    "lat": 45.9246705
  },
  {
    "lng": -122.989827,
    "lat": 45.5228939
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.7141049,
    "lat": 38.4404925
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 126.9697994,
    "lat": 37.5534363
  },
  {
    "lng": -80.1353006,
    "lat": 25.7929198
  },
  {
    "lng": -88.2430932,
    "lat": 40.1164841
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -89.6953656,
    "lat": 41.788253
  },
  {
    "lng": 110.1956502,
    "lat": 20.0462328
  },
  {
    "lng": -117.9463717,
    "lat": 33.7746292
  },
  {
    "lng": -77.775644,
    "lat": 38.585005
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.5770621,
    "lat": 44.3747245
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": -79.6847703,
    "lat": 40.6739543
  },
  {
    "lng": -0.7761489,
    "lat": 44.8405364
  },
  {
    "lng": -71.1143838,
    "lat": 42.3116046
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 14.4383082,
    "lat": 35.9141259
  },
  {
    "lng": -123.191303,
    "lat": 44.8560029
  },
  {
    "lng": -87.6305899,
    "lat": 46.4481521
  },
  {
    "lng": -72.554088,
    "lat": 41.8430824
  },
  {
    "lng": -71.4378411,
    "lat": 42.5792583
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -9.3136189,
    "lat": 38.8700189
  },
  {
    "lng": -156.3103925,
    "lat": 20.8539162
  },
  {
    "lng": 4.750318,
    "lat": 44.5579391
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.0241621,
    "lat": 42.6289247
  },
  {
    "lng": 2.0100492,
    "lat": 41.5629623
  },
  {
    "lng": -94.6851702,
    "lat": 38.9742502
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 108.9423363,
    "lat": 34.261004
  },
  {
    "lng": -76.4283781,
    "lat": 44.3054151
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.2255727,
    "lat": 48.8709053
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 2.0388736,
    "lat": 49.0527528
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -89.0226793,
    "lat": 42.6829765
  },
  {
    "lng": -82.902901,
    "lat": 42.6741189
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 12.0595795,
    "lat": 47.8556623
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.6414898,
    "lat": 48.1817122
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -70.2177099,
    "lat": 44.0990717
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 103.733224,
    "lat": 36.474436
  },
  {
    "lng": -74.6310081,
    "lat": 41.0401567
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -68.0116807,
    "lat": 46.8606301
  },
  {
    "lng": 6.5143539,
    "lat": 51.1902651
  },
  {
    "lng": -121.420139,
    "lat": 37.7385507
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.611116,
    "lat": 51.7052231
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.147899,
    "lat": 43.9277552
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": -80.0387292,
    "lat": 32.9961038
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -122.0832101,
    "lat": 37.3893889
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.1020957,
    "lat": 47.8101008
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -3.1583936,
    "lat": 47.8340055
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.5368567,
    "lat": 51.8566651
  },
  {
    "lng": -122.8913181,
    "lat": 45.5315957
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -97.2050856,
    "lat": 31.5059105
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -75.1438863,
    "lat": 39.770683
  },
  {
    "lng": -122.808078,
    "lat": 50.3203804
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": -94.626497,
    "lat": 39.1134562
  },
  {
    "lng": 4.6395008,
    "lat": 45.6815791
  },
  {
    "lng": -91.2228203,
    "lat": 44.5772777
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -85.8591285,
    "lat": 37.693952
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 119.0029034,
    "lat": 25.4557366
  },
  {
    "lng": 4.635647,
    "lat": 51.8438893
  },
  {
    "lng": -0.3685668,
    "lat": 43.2957547
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -82.9824019,
    "lat": 39.3331197
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7977048,
    "lat": 33.2371585
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -70.2586618,
    "lat": 43.6573605
  },
  {
    "lng": -94.1885387,
    "lat": 35.9242477
  },
  {
    "lng": -97.2271249,
    "lat": 32.9299655
  },
  {
    "lng": 104.063315,
    "lat": 30.659867
  },
  {
    "lng": -99.3311525,
    "lat": 38.8709984
  },
  {
    "lng": -0.453256,
    "lat": 51.532563
  },
  {
    "lng": 7.3260346,
    "lat": 48.1437763
  },
  {
    "lng": -79.5341802,
    "lat": 8.9714493
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -117.3505966,
    "lat": 33.1580933
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 15.2151181,
    "lat": 59.2747287
  },
  {
    "lng": -77.3859479,
    "lat": 38.9695316
  },
  {
    "lng": 7.05859,
    "lat": 43.5761001
  },
  {
    "lng": -111.9866954,
    "lat": 40.6967891
  },
  {
    "lng": -82.3269883,
    "lat": 27.871197
  },
  {
    "lng": -85.9529685,
    "lat": 42.9903205
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -77.3724593,
    "lat": 35.613224
  },
  {
    "lng": -75.3786521,
    "lat": 40.6178915
  },
  {
    "lng": -123.7080446,
    "lat": 48.7786872
  },
  {
    "lng": -8.4726423,
    "lat": 51.8985136
  },
  {
    "lng": -76.6480219,
    "lat": 39.0595542
  },
  {
    "lng": -88.3053525,
    "lat": 41.8875281
  },
  {
    "lng": 120.6212881,
    "lat": 31.311123
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": 13.1929449,
    "lat": 55.7029296
  },
  {
    "lng": -123.0737925,
    "lat": 49.3206294
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": 1.3336126,
    "lat": 49.1605604
  },
  {
    "lng": -76.3056707,
    "lat": 40.0379958
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 123.4279105,
    "lat": 41.8026095
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -1.7003017,
    "lat": 43.3624715
  },
  {
    "lng": -2.6474422,
    "lat": 47.6350664
  },
  {
    "lng": 10.3952118,
    "lat": 63.4304475
  },
  {
    "lng": -80.2331038,
    "lat": 26.0628665
  },
  {
    "lng": 7.4892974,
    "lat": 9.0643305
  },
  {
    "lng": 6.6448413,
    "lat": 45.8949213
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 115.348216,
    "lat": 25.703866
  },
  {
    "lng": -81.7832912,
    "lat": 32.4490141
  },
  {
    "lng": -73.7826363,
    "lat": 40.9115386
  },
  {
    "lng": 11.005345,
    "lat": 43.3412507
  },
  {
    "lng": 4.4304463,
    "lat": 46.8078372
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.0785177,
    "lat": 47.2596224
  },
  {
    "lng": -119.180381,
    "lat": 34.1976308
  },
  {
    "lng": -77.50741,
    "lat": 18.0431254
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -79.6901302,
    "lat": 44.3893208
  },
  {
    "lng": -71.1908924,
    "lat": 42.7262016
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -0.8138335,
    "lat": 49.0982623
  },
  {
    "lng": -94.282265,
    "lat": 39.017316
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -1.0990407,
    "lat": 53.785097
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -92.4056858,
    "lat": 34.856613
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -106.0465486,
    "lat": 39.4829124
  },
  {
    "lng": 112.5666191,
    "lat": 26.8971308
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -81.0161686,
    "lat": 35.2976298
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -94.6332768,
    "lat": 38.9914109
  },
  {
    "lng": -82.8364111,
    "lat": 34.6850749
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 114.051111,
    "lat": 35.308611
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.1319296,
    "lat": 39.977763
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8201338,
    "lat": 41.0550969
  },
  {
    "lng": 35.3252861,
    "lat": 36.9863599
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -70.187578,
    "lat": 43.8009132
  },
  {
    "lng": -82.9651045,
    "lat": 40.2317686
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 121.4511111,
    "lat": 31.2515439
  },
  {
    "lng": -0.5435655,
    "lat": 43.8668219
  },
  {
    "lng": -96.0422378,
    "lat": 41.1544433
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": 2.6389115,
    "lat": 50.5309351
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -117.3703235,
    "lat": 34.1064001
  },
  {
    "lng": -79.5656326,
    "lat": 43.6435559
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 113.8951222,
    "lat": 29.72817
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -118.5174342,
    "lat": 34.2661558
  },
  {
    "lng": -88.3525714,
    "lat": 41.6834778
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 113.619321,
    "lat": 34.7472531
  },
  {
    "lng": 7.8169251,
    "lat": 52.2217481
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 3.620686,
    "lat": 49.564665
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 7.6875628,
    "lat": 49.6035639
  },
  {
    "lng": -118.3963062,
    "lat": 34.0696501
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": -118.4486675,
    "lat": 34.1866193
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 9.8913283,
    "lat": 56.8383525
  },
  {
    "lng": -84.2032767,
    "lat": 40.0394982
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -81.243372,
    "lat": 42.9832406
  },
  {
    "lng": -80.7440174,
    "lat": 34.9248125
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": 9.5495141,
    "lat": 56.169453
  },
  {
    "lng": -72.6713448,
    "lat": 41.707785
  },
  {
    "lng": -73.7826363,
    "lat": 40.9115386
  },
  {
    "lng": -88.083406,
    "lat": 42.0333608
  },
  {
    "lng": 135.5014539,
    "lat": 34.6937569
  },
  {
    "lng": -117.953097,
    "lat": 34.0280619
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -71.1061639,
    "lat": 42.4184296
  },
  {
    "lng": -122.403277,
    "lat": 45.5863014
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 117.1913008,
    "lat": 39.1175488
  },
  {
    "lng": -1.9483083,
    "lat": 52.0940158
  },
  {
    "lng": 2.3275141,
    "lat": 48.9756423
  },
  {
    "lng": -71.3495035,
    "lat": 42.5292605
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -84.5546295,
    "lat": 42.7338254
  },
  {
    "lng": -83.1446485,
    "lat": 42.4894801
  },
  {
    "lng": 0.6176112,
    "lat": 44.2015827
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 23.7603118,
    "lat": 61.4980214
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -82.6359078,
    "lat": 27.7700475
  },
  {
    "lng": -0.3394758,
    "lat": 53.7435722
  },
  {
    "lng": -79.2576479,
    "lat": 43.7729744
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -1.37342,
    "lat": 43.65801
  },
  {
    "lng": 2.2144942,
    "lat": 43.3105303
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.1320819,
    "lat": 43.63233
  },
  {
    "lng": -86.8689419,
    "lat": 35.925206
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -74.2905713,
    "lat": 41.0053413
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 166.442419,
    "lat": -22.2745264
  },
  {
    "lng": -0.3635615,
    "lat": 49.1813403
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.4749347,
    "lat": 48.8490721
  },
  {
    "lng": 123.4279105,
    "lat": 41.8026095
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -72.859545,
    "lat": 41.3909305
  },
  {
    "lng": -0.2427217,
    "lat": 44.9133742
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": 113.2592945,
    "lat": 23.1301964
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -93.21772,
    "lat": 44.7319094
  },
  {
    "lng": 6.9478263,
    "lat": 46.252844
  },
  {
    "lng": -87.8873916,
    "lat": 42.0415823
  },
  {
    "lng": -82.6995444,
    "lat": 27.8428025
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -79.3079337,
    "lat": 34.4987347
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -0.6300671,
    "lat": 45.7460663
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": -79.8625851,
    "lat": 32.7940651
  },
  {
    "lng": -75.0688604,
    "lat": 39.841417
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -84.1556809,
    "lat": 31.5782062
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -83.3763219,
    "lat": 42.4644795
  },
  {
    "lng": -122.636465,
    "lat": 38.2325829
  },
  {
    "lng": -118.1374663,
    "lat": 34.1928193
  },
  {
    "lng": 7.0191865,
    "lat": 43.5761076
  },
  {
    "lng": 12.3652209,
    "lat": 55.7303911
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": -9.0701572,
    "lat": 39.6029108
  },
  {
    "lng": -5.3893743,
    "lat": 37.7807467
  },
  {
    "lng": -71.3137707,
    "lat": 41.4899827
  },
  {
    "lng": 113.2592945,
    "lat": 23.1301964
  },
  {
    "lng": -85.9491298,
    "lat": 37.8403456
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.665452,
    "lat": 40.904011
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": 0.6889268,
    "lat": 47.3900474
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -74.6809503,
    "lat": 40.6741476
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 2.2766735,
    "lat": 48.730158
  },
  {
    "lng": -8.6058415,
    "lat": 41.1300103
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -76.5483724,
    "lat": 42.4374175
  },
  {
    "lng": -88.0670118,
    "lat": 41.8775293
  },
  {
    "lng": -71.1061639,
    "lat": 42.4184296
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 2.4093664,
    "lat": 48.7630238
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -82.2327525,
    "lat": 27.9378338
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -72.6786035,
    "lat": 42.0671708
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -81.0228331,
    "lat": 29.2108147
  },
  {
    "lng": 15.0947756,
    "lat": 47.3805128
  },
  {
    "lng": -117.8659441,
    "lat": 34.0203253
  },
  {
    "lng": -71.9785356,
    "lat": -13.5170887
  },
  {
    "lng": 1.4196476,
    "lat": 51.3334726
  },
  {
    "lng": -87.668889,
    "lat": 20.596667
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -75.546589,
    "lat": 39.7459468
  },
  {
    "lng": -94.6332768,
    "lat": 38.9914109
  },
  {
    "lng": 6.1301614,
    "lat": 43.1202573
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -70.9494939,
    "lat": 42.466763
  },
  {
    "lng": -87.9517842,
    "lat": 43.3195224
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -122.972545,
    "lat": 49.2433804
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -80.5495112,
    "lat": 34.9854275
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -92.4630182,
    "lat": 44.0234387
  },
  {
    "lng": 2.1386946,
    "lat": 47.9272265
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -80.0721599,
    "lat": -0.3828099
  },
  {
    "lng": -82.6715845,
    "lat": 42.7525317
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.3053525,
    "lat": 41.8875281
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 2.1266886,
    "lat": 48.8035403
  },
  {
    "lng": -90.5643258,
    "lat": 38.661953
  },
  {
    "lng": -1.1626569,
    "lat": 52.2578681
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": 0.0930414,
    "lat": 50.9705836
  },
  {
    "lng": -84.2809332,
    "lat": 30.4380832
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -82.3534728,
    "lat": 36.3134398
  },
  {
    "lng": -2.7856762,
    "lat": 51.3142922
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -91.1869659,
    "lat": 30.4494155
  },
  {
    "lng": -73.1062025,
    "lat": 43.9733602
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 5.6969882,
    "lat": 50.8579855
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 2.3633048,
    "lat": 48.7921098
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -69.790649,
    "lat": 44.713074
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": 4.8096049,
    "lat": 45.7292173
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -77.4083096,
    "lat": 39.003685
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -82.0609557,
    "lat": 39.3575616
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.1641314,
    "lat": 48.7119046
  },
  {
    "lng": 0.1481142,
    "lat": 51.5413271
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -88.2430932,
    "lat": 40.1164841
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -79.7919754,
    "lat": 36.0726355
  },
  {
    "lng": -3.3793614,
    "lat": 52.2405222
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 6.4779448,
    "lat": 46.3731303
  },
  {
    "lng": 121.0486254,
    "lat": 14.6510546
  },
  {
    "lng": 2.1347291,
    "lat": 48.894254
  },
  {
    "lng": -0.941684,
    "lat": 48.9963184
  },
  {
    "lng": -71.5785924,
    "lat": 42.6650324
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -61.4096021,
    "lat": 10.51591
  },
  {
    "lng": -35.2080905,
    "lat": -5.805398
  },
  {
    "lng": -73.993889,
    "lat": 40.7652778
  },
  {
    "lng": -0.34118,
    "lat": 45.10735
  },
  {
    "lng": -74.3673748,
    "lat": 41.1312069
  },
  {
    "lng": -97.1474628,
    "lat": 31.5491899
  },
  {
    "lng": 0.0949036,
    "lat": 51.7685568
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 14.5929127,
    "lat": 53.4296809
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 39.1742363,
    "lat": 21.5504432
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -88.7033859,
    "lat": 34.2576067
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -90.0750949,
    "lat": 36.4933927
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -104.9092844,
    "lat": 40.3350303
  },
  {
    "lng": -80.1494901,
    "lat": 26.0112014
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -71.0931485,
    "lat": 41.9019257
  },
  {
    "lng": -92.9339449,
    "lat": 44.919896
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -85.8902547,
    "lat": 38.9592201
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -92.9339449,
    "lat": 44.919896
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 2.7015872,
    "lat": 48.4049375
  },
  {
    "lng": -122.1238767,
    "lat": 47.6694141
  },
  {
    "lng": -92.2896267,
    "lat": 34.7465071
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.9724787,
    "lat": 34.72425
  },
  {
    "lng": -123.2077861,
    "lat": 39.1501662
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.1929215,
    "lat": 39.1399187
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.2084941,
    "lat": 28.6702526
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -118.0014517,
    "lat": 34.1483499
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -0.500972,
    "lat": 43.8911318
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.2781057,
    "lat": 25.8575963
  },
  {
    "lng": 8.1044149,
    "lat": 50.0220051
  },
  {
    "lng": -0.6300671,
    "lat": 45.7460663
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -77.4083096,
    "lat": 39.003685
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -121.8746789,
    "lat": 37.6624312
  },
  {
    "lng": -79.8728583,
    "lat": 43.2560802
  },
  {
    "lng": -88.8893818,
    "lat": 30.4007626
  },
  {
    "lng": -105.938456,
    "lat": 35.6876096
  },
  {
    "lng": -86.4691677,
    "lat": 40.0483744
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -78.762383,
    "lat": 39.6526498
  },
  {
    "lng": 7.6251879,
    "lat": 51.9625101
  },
  {
    "lng": -71.71351,
    "lat": 42.2960187
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": 0.2450626,
    "lat": 46.6852065
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.289259,
    "lat": 48.8212037
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -117.9463717,
    "lat": 33.7746292
  },
  {
    "lng": 0.493541,
    "lat": 46.5545812
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 55.4776174,
    "lat": -21.341298
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": 4.10473,
    "lat": 45.5125
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -121.3153096,
    "lat": 44.0581728
  },
  {
    "lng": -71.4378411,
    "lat": 42.5792583
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.1464895,
    "lat": 45.5366795
  },
  {
    "lng": 2.9580234,
    "lat": 48.8239829
  },
  {
    "lng": -104.8769227,
    "lat": 39.579155
  },
  {
    "lng": 34.7818064,
    "lat": 32.0852997
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -83.2320991,
    "lat": 33.0801429
  },
  {
    "lng": 115.2191175,
    "lat": -8.6524973
  },
  {
    "lng": -84.5930113,
    "lat": 35.4428864
  },
  {
    "lng": -77.1516844,
    "lat": 39.0817985
  },
  {
    "lng": -78.7812081,
    "lat": 35.7882893
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -90.1997949,
    "lat": 38.4428078
  },
  {
    "lng": -74.5746001,
    "lat": 39.2776156
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -0.3685668,
    "lat": 43.2957547
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -74.9619779,
    "lat": 39.8512162
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 1.8320589,
    "lat": 46.7422328
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -77.0584474,
    "lat": 39.1803067
  },
  {
    "lng": -96.8238183,
    "lat": 33.1505998
  },
  {
    "lng": -81.345941,
    "lat": 41.239223
  },
  {
    "lng": 2.4455201,
    "lat": 48.9229803
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.8590006,
    "lat": 35.481705
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": -2.3596963,
    "lat": 51.3813864
  },
  {
    "lng": -3.000425,
    "lat": 51.5887675
  },
  {
    "lng": -87.8892189,
    "lat": 41.5261437
  },
  {
    "lng": -122.989827,
    "lat": 45.5228939
  },
  {
    "lng": -71.0994968,
    "lat": 42.3875968
  },
  {
    "lng": -112.120834,
    "lat": 46.236595
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.3480592,
    "lat": 36.1459327
  },
  {
    "lng": -71.1551119,
    "lat": 42.3473519
  },
  {
    "lng": -111.9395211,
    "lat": 40.6061337
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 5.7711166,
    "lat": 50.9503183
  },
  {
    "lng": -84.8491126,
    "lat": 36.8297937
  },
  {
    "lng": -84.0193858,
    "lat": 39.8208998
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -77.1549078,
    "lat": 39.3765918
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -86.190272,
    "lat": 40.5789277
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -71.3352393,
    "lat": 41.7424526
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -86.1095429,
    "lat": 39.6136987
  },
  {
    "lng": -77.0952516,
    "lat": 43.0467301
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -70.4429592,
    "lat": 43.6797334
  },
  {
    "lng": -116.559631,
    "lat": 43.5737361
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -79.072557,
    "lat": 38.1495947
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -88.1479278,
    "lat": 41.7728699
  },
  {
    "lng": -71.9698085,
    "lat": 42.1340806
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -75.7263008,
    "lat": 40.2578714
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -81.3510264,
    "lat": 28.5977707
  },
  {
    "lng": -85.9529685,
    "lat": 42.9903205
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -105.220306,
    "lat": 20.6407176
  },
  {
    "lng": -115.3481135,
    "lat": 51.0866897
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -91.4984941,
    "lat": 44.811349
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -121.768053,
    "lat": 37.6820583
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -121.8746789,
    "lat": 37.6624312
  },
  {
    "lng": -81.0726108,
    "lat": 32.2802665
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -75.0254256,
    "lat": 39.4862777
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.3275141,
    "lat": 48.9756423
  },
  {
    "lng": -86.2910945,
    "lat": 36.2079779
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": -106.660767,
    "lat": 52.131802
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -111.9866954,
    "lat": 40.6967891
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": -147.716675,
    "lat": 64.837845
  },
  {
    "lng": -85.8590603,
    "lat": 41.6012796
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.3821295,
    "lat": 38.9107156
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -1.7888095,
    "lat": 43.3383176
  },
  {
    "lng": -118.374752,
    "lat": 34.1649502
  },
  {
    "lng": 3.2501874,
    "lat": 45.5432962
  },
  {
    "lng": -88.3303618,
    "lat": 42.1816908
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.0011096,
    "lat": 41.2411556
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -86.5342881,
    "lat": 39.1670396
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 1.2611389,
    "lat": 44.6806047
  },
  {
    "lng": -89.7811745,
    "lat": 30.2751945
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -77.2676335,
    "lat": 38.636447
  },
  {
    "lng": -87.8839693,
    "lat": 41.1639309
  },
  {
    "lng": -88.2430932,
    "lat": 40.1164841
  },
  {
    "lng": -78.4766781,
    "lat": 38.029306
  },
  {
    "lng": -108.56448,
    "lat": 39.0672568
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.618842,
    "lat": 30.4057552
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -83.606568,
    "lat": 32.6200973
  },
  {
    "lng": -121.420139,
    "lat": 37.7385507
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -93.8512052,
    "lat": 41.6322562
  },
  {
    "lng": -86.9080655,
    "lat": 40.4258686
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 4.6435597,
    "lat": 52.3837058
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": 54.3774014,
    "lat": 24.4538352
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -73.5898872,
    "lat": 40.7157545
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": -95.4366206,
    "lat": 42.7125676
  },
  {
    "lng": -84.6266111,
    "lat": 38.9989499
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -71.5159565,
    "lat": -32.9220036
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": 2.3570028,
    "lat": 48.8125893
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -88.5408574,
    "lat": 44.0206919
  },
  {
    "lng": -121.4016604,
    "lat": 38.3780978
  },
  {
    "lng": -87.9138911,
    "lat": 33.9675458
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -73.7826363,
    "lat": 40.9115386
  },
  {
    "lng": -104.7091322,
    "lat": 40.4233142
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 8.2416556,
    "lat": 50.0820384
  },
  {
    "lng": -0.2427217,
    "lat": 44.9133742
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -83.7319658,
    "lat": 32.4586695
  },
  {
    "lng": 0.0581,
    "lat": 43.1973846
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -94.992736,
    "lat": 29.3872254
  },
  {
    "lng": 39.1742363,
    "lat": 21.5504432
  },
  {
    "lng": -123.0737925,
    "lat": 49.3206294
  },
  {
    "lng": -83.1933893,
    "lat": 37.2489635
  },
  {
    "lng": 2.1802832,
    "lat": 48.87778
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -122.47267,
    "lat": 37.6904826
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 120.9803621,
    "lat": 14.5904492
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 57.4800061,
    "lat": -20.2643015
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -79.6443879,
    "lat": 43.5896231
  },
  {
    "lng": -73.6788272,
    "lat": 41.4266361
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": 17.6486876,
    "lat": 47.7529429
  },
  {
    "lng": -57.6190998,
    "lat": -25.3172629
  },
  {
    "lng": -116.4139839,
    "lat": 34.1236205
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -74.9869191,
    "lat": 39.688691
  },
  {
    "lng": -84.7668495,
    "lat": 43.597646
  },
  {
    "lng": -122.1703055,
    "lat": 37.4265407
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -83.2732627,
    "lat": 42.3369816
  },
  {
    "lng": -117.8984565,
    "lat": 34.0142641
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -104.297186,
    "lat": 39.0355459
  },
  {
    "lng": -73.2987663,
    "lat": 40.7064515
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -70.7618592,
    "lat": 41.9426657
  },
  {
    "lng": -89.5844457,
    "lat": 44.5234467
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -149.894852,
    "lat": 61.2163129
  },
  {
    "lng": 101.6454202,
    "lat": 3.0988792
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -71.3085329,
    "lat": 42.6414437
  },
  {
    "lng": -83.5363637,
    "lat": 42.5246873
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -119.8276389,
    "lat": 34.4358295
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -92.4630182,
    "lat": 44.0234387
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -93.8399077,
    "lat": 30.0294356
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": -96.9458791,
    "lat": 43.6225937
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -1.7503658,
    "lat": 54.9220987
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -0.3311238,
    "lat": 51.5714876
  },
  {
    "lng": -71.3517602,
    "lat": 42.5968617
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -74.2737573,
    "lat": 40.2601096
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.1894241,
    "lat": 48.8279362
  },
  {
    "lng": -122.670649,
    "lat": 45.4206749
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": -101.0425231,
    "lat": 42.0429412
  },
  {
    "lng": -123.1059324,
    "lat": 44.6365071
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -0.9700664,
    "lat": 51.4564242
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -87.8715185,
    "lat": 41.9348693
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": 2.510611,
    "lat": 48.8137847
  },
  {
    "lng": -81.243372,
    "lat": 42.9832406
  },
  {
    "lng": -69.6178847,
    "lat": 44.0800341
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -118.0338664,
    "lat": 33.9749136
  },
  {
    "lng": -75.7515682,
    "lat": 39.6828358
  },
  {
    "lng": 2.0817809,
    "lat": 41.4728432
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -118.0107092,
    "lat": 33.9060971
  },
  {
    "lng": -120.7678602,
    "lat": 37.1641544
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 106.8838584,
    "lat": 47.9081991
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -86.6702816,
    "lat": 39.6878242
  },
  {
    "lng": -79.7881025,
    "lat": 40.4211798
  },
  {
    "lng": -73.2858994,
    "lat": 40.8393515
  },
  {
    "lng": -81.440667,
    "lat": 41.240056
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -69.790649,
    "lat": 44.713074
  },
  {
    "lng": 6.2364886,
    "lat": 52.2694896
  },
  {
    "lng": -122.478836,
    "lat": 48.7544012
  },
  {
    "lng": 73.8545071,
    "lat": 18.5213738
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -79.7567616,
    "lat": 43.2167526
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.9939147,
    "lat": 40.4797828
  },
  {
    "lng": -82.5164242,
    "lat": 35.4661821
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -59.6184184,
    "lat": 13.0977832
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -76.3056707,
    "lat": 40.0379958
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -72.6908547,
    "lat": 41.764582
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -84.7477136,
    "lat": 33.7514966
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -81.3442915,
    "lat": 35.7333312
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 50.1039991,
    "lat": 26.4367824
  },
  {
    "lng": -108.56448,
    "lat": 39.0672568
  },
  {
    "lng": -83.241357,
    "lat": 42.5226219
  },
  {
    "lng": 0.1967849,
    "lat": 48.0073849
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": 7.0134418,
    "lat": 43.5515198
  },
  {
    "lng": -118.307201,
    "lat": 34.1812089
  },
  {
    "lng": -76.2899539,
    "lat": 36.8493695
  },
  {
    "lng": -99.157701,
    "lat": 19.3718796
  },
  {
    "lng": 27.4962548,
    "lat": 38.4549686
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.3269883,
    "lat": 27.871197
  },
  {
    "lng": 12.2999286,
    "lat": 55.5833746
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -97.9907362,
    "lat": 26.1594305
  },
  {
    "lng": -117.566444,
    "lat": 33.8752945
  },
  {
    "lng": -122.2301808,
    "lat": 47.3075369
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -82.2773629,
    "lat": 37.6742682
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -123.2620435,
    "lat": 44.5645659
  },
  {
    "lng": -94.3821295,
    "lat": 38.9107156
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -87.9414608,
    "lat": 42.0087978
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -68.7621574,
    "lat": 44.7967947
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -96.900362,
    "lat": 46.874967
  },
  {
    "lng": -80.2781057,
    "lat": 25.8575963
  },
  {
    "lng": -81.3442915,
    "lat": 35.7333312
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.0532942,
    "lat": 26.715364
  },
  {
    "lng": -117.1827445,
    "lat": 34.0550328
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -74.9999754,
    "lat": 40.0166151
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.1450735,
    "lat": 41.9994722
  },
  {
    "lng": -79.3314725,
    "lat": 42.4400476
  },
  {
    "lng": 19.9971534,
    "lat": 50.0469432
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -78.8505516,
    "lat": 35.7325352
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -97.0585717,
    "lat": 36.1156306
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -0.2427217,
    "lat": 44.9133742
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.4832339,
    "lat": 42.4310816
  },
  {
    "lng": -84.6433146,
    "lat": 42.7269261
  },
  {
    "lng": -77.1890783,
    "lat": 40.201499
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": -70.0758508,
    "lat": 41.6862224
  },
  {
    "lng": -80.6070391,
    "lat": 34.2464886
  },
  {
    "lng": -0.3379675,
    "lat": 51.753051
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -71.3821203,
    "lat": 41.8789531
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -72.9771002,
    "lat": 43.4717502
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": -117.3008784,
    "lat": 34.4263886
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": -122.768761,
    "lat": 45.4853207
  },
  {
    "lng": -80.2440518,
    "lat": 36.0998131
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": 2.2176533,
    "lat": 43.0538068
  },
  {
    "lng": -96.6388833,
    "lat": 32.912624
  },
  {
    "lng": -76.6148148,
    "lat": 39.3964591
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -89.004141,
    "lat": 42.2467221
  },
  {
    "lng": -95.8243956,
    "lat": 29.7857853
  },
  {
    "lng": -84.4721678,
    "lat": 42.7320307
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -88.1479278,
    "lat": 41.7728699
  },
  {
    "lng": -84.5501874,
    "lat": 39.2085354
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -72.9401357,
    "lat": 40.879243
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -70.545273,
    "lat": 43.384092
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": -78.696697,
    "lat": 43.0183913
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -94.6557914,
    "lat": 39.0277832
  },
  {
    "lng": -122.2070775,
    "lat": 47.6765382
  },
  {
    "lng": -117.8617337,
    "lat": 33.8714814
  },
  {
    "lng": -70.7055941,
    "lat": 42.091769
  },
  {
    "lng": -99.1906167,
    "lat": 19.4071156
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": -97.5861393,
    "lat": 33.2342834
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -90.3227803,
    "lat": 38.7919683
  },
  {
    "lng": 9.9884451,
    "lat": 54.0703296
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -84.6332986,
    "lat": 40.1023909
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -121.3153096,
    "lat": 44.0581728
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.3465081,
    "lat": 37.5131191
  },
  {
    "lng": -118.2478471,
    "lat": 34.1469416
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.0388736,
    "lat": 49.0527528
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -83.7788283,
    "lat": 41.888936
  },
  {
    "lng": -82.0394286,
    "lat": 28.865286
  },
  {
    "lng": -74.4439254,
    "lat": 40.4951365
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -88.1170784,
    "lat": 43.1790768
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": -159.3191601,
    "lat": 22.0747334
  },
  {
    "lng": -104.7612638,
    "lat": 39.5184514
  },
  {
    "lng": -122.5449763,
    "lat": 37.9060368
  },
  {
    "lng": 4.3338445,
    "lat": 50.8035441
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -71.0767724,
    "lat": 42.7777829
  },
  {
    "lng": -90.2417806,
    "lat": 29.9942265
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -83.8979573,
    "lat": 33.9887165
  },
  {
    "lng": -49.0658025,
    "lat": -26.9195567
  },
  {
    "lng": 3.97492,
    "lat": 44.3041
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -70.2586618,
    "lat": 43.6573605
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -72.7553916,
    "lat": 40.809848
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.5420246,
    "lat": 41.0469042
  },
  {
    "lng": -97.4033191,
    "lat": 27.7635302
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -66.05344,
    "lat": 18.384239
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -115.121584,
    "lat": 36.2005843
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 4.3965975,
    "lat": 52.2048978
  },
  {
    "lng": -71.0744952,
    "lat": 42.2973205
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -70.4429592,
    "lat": 43.6797334
  },
  {
    "lng": -116.9814167,
    "lat": 33.3033679
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": 46.7160104,
    "lat": 24.638916
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": -149.3863924,
    "lat": 61.2700284
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -87.9414608,
    "lat": 42.0087978
  },
  {
    "lng": -117.3272615,
    "lat": 33.6680772
  },
  {
    "lng": -92.447758,
    "lat": 42.5361805
  },
  {
    "lng": -85.4191482,
    "lat": 41.799217
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -3.9459248,
    "lat": 51.6195955
  },
  {
    "lng": -0.8868896,
    "lat": 52.7645663
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -3.5269209,
    "lat": 50.7256138
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": 50.1039991,
    "lat": 26.4367824
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -103.338396,
    "lat": 20.6720375
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -94.1288142,
    "lat": 36.1867442
  },
  {
    "lng": -66.9146008,
    "lat": 10.5060934
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": 100.4869513,
    "lat": 5.6435195
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -105.1319296,
    "lat": 39.977763
  },
  {
    "lng": 17.7959288,
    "lat": 59.1653304
  },
  {
    "lng": -104.6158764,
    "lat": 50.4479733
  },
  {
    "lng": -77.7928574,
    "lat": 43.2881104
  },
  {
    "lng": -86.3921096,
    "lat": 35.8460396
  },
  {
    "lng": -92.116219,
    "lat": 32.5025471
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -83.9293952,
    "lat": 42.6072552
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -95.6349463,
    "lat": 29.6196787
  },
  {
    "lng": -74.1979277,
    "lat": 40.7934789
  },
  {
    "lng": -85.7057035,
    "lat": 42.9132581
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.2006687,
    "lat": 40.8559314
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -121.2880059,
    "lat": 38.7521235
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.9580234,
    "lat": 48.8239829
  },
  {
    "lng": -1.0714014,
    "lat": 44.6360982
  },
  {
    "lng": -122.1598465,
    "lat": 37.4443293
  },
  {
    "lng": 5.862294,
    "lat": 43.4522053
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -88.0934108,
    "lat": 42.1969689
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -4.4239646,
    "lat": 55.8455828
  },
  {
    "lng": -95.6349463,
    "lat": 29.6196787
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 2.5034999,
    "lat": 48.9082988
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -70.2529189,
    "lat": 43.6382443
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -111.834914,
    "lat": 41.7313063
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -81.4075838,
    "lat": 28.2918995
  },
  {
    "lng": -81.4023356,
    "lat": 40.875891
  },
  {
    "lng": 2.2453842,
    "lat": 48.7144587
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -77.0928401,
    "lat": 42.6137794
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -71.407013,
    "lat": 43.54805
  },
  {
    "lng": -90.3971021,
    "lat": 45.6900818
  },
  {
    "lng": -97.0585717,
    "lat": 36.1156306
  },
  {
    "lng": -86.5427551,
    "lat": 33.5439212
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -82.2272119,
    "lat": 34.9381361
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.3734547,
    "lat": 40.6867667
  },
  {
    "lng": -57.6190998,
    "lat": -25.3172629
  },
  {
    "lng": -81.6851271,
    "lat": 41.3139426
  },
  {
    "lng": 5.8816763,
    "lat": 51.626921
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -82.5817053,
    "lat": 34.8269276
  },
  {
    "lng": 9.0150026,
    "lat": 48.8012983
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -3.2568304,
    "lat": 54.0977012
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -81.4075838,
    "lat": 28.2918995
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -111.111309,
    "lat": 43.6025939
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -118.5978087,
    "lat": 34.2011078
  },
  {
    "lng": -93.3356204,
    "lat": 44.7779041
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -75.4712794,
    "lat": 40.6022059
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 37.3792617,
    "lat": 37.0628317
  },
  {
    "lng": -89.5150764,
    "lat": 35.228976
  },
  {
    "lng": 7.570077,
    "lat": 47.53656
  },
  {
    "lng": 12.3425797,
    "lat": 45.5035386
  },
  {
    "lng": -76.7074042,
    "lat": 37.2708788
  },
  {
    "lng": -120.375716,
    "lat": 35.3540209
  },
  {
    "lng": -71.2661597,
    "lat": 41.6770463
  },
  {
    "lng": -1.0815361,
    "lat": 53.9590555
  },
  {
    "lng": -83.0302033,
    "lat": 42.5803122
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -71.1143838,
    "lat": 42.3116046
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -71.1956111,
    "lat": 42.5048167
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -97.4033191,
    "lat": 27.7635302
  },
  {
    "lng": -0.4440957,
    "lat": 44.9954151
  },
  {
    "lng": -81.3578047,
    "lat": 41.1513108
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -85.9529685,
    "lat": 42.9903205
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -111.841185,
    "lat": 33.3062031
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -93.2349489,
    "lat": 45.1607987
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -0.5879629,
    "lat": 44.8088438
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 104.063315,
    "lat": 30.659867
  },
  {
    "lng": -81.5231597,
    "lat": 40.7965119
  },
  {
    "lng": 5.303116,
    "lat": 51.6889387
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -95.6010143,
    "lat": 33.1384886
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 1.1528095,
    "lat": 52.0579324
  },
  {
    "lng": -76.9274072,
    "lat": 38.6023935
  },
  {
    "lng": -86.621443,
    "lat": 36.3049177
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -81.6853534,
    "lat": 28.8527675
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -79.6443879,
    "lat": 43.5896231
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 1.09163,
    "lat": 49.3831
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8423304,
    "lat": 45.7969952
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -81.2680223,
    "lat": 28.8117345
  },
  {
    "lng": 46.7160104,
    "lat": 24.638916
  },
  {
    "lng": -84.263826,
    "lat": 39.2689476
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.6115586,
    "lat": 43.1922408
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -70.4533844,
    "lat": 43.4925843
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": -77.2651762,
    "lat": 38.9013729
  },
  {
    "lng": -121.955174,
    "lat": 37.3541132
  },
  {
    "lng": -81.3035515,
    "lat": 31.9382381
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": 5.278244,
    "lat": 45.111331
  },
  {
    "lng": 0.487531,
    "lat": 44.8534568
  },
  {
    "lng": -78.7997616,
    "lat": 42.9783924
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -71.1755732,
    "lat": 42.2489143
  },
  {
    "lng": -71.2360624,
    "lat": 42.2802645
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": -71.0744952,
    "lat": 42.2973205
  },
  {
    "lng": -70.2529189,
    "lat": 43.6382443
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": 12.5135924,
    "lat": 55.6637755
  },
  {
    "lng": 6.3676062,
    "lat": 49.5442267
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -122.2270272,
    "lat": 47.3826903
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": -94.8907869,
    "lat": 47.4785418
  },
  {
    "lng": -93.5663455,
    "lat": 44.9032963
  },
  {
    "lng": -83.0302033,
    "lat": 42.5803122
  },
  {
    "lng": -94.208787,
    "lat": 36.3728608
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 9.3257408,
    "lat": 54.7674684
  },
  {
    "lng": -77.5358049,
    "lat": 35.8968236
  },
  {
    "lng": 10.8523018,
    "lat": 48.5455295
  },
  {
    "lng": -79.895197,
    "lat": 40.86108
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -85.8590603,
    "lat": 41.6012796
  },
  {
    "lng": -73.5876273,
    "lat": 40.7556561
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": -105.089705,
    "lat": 39.9935959
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": 6.1096409,
    "lat": 46.2567057
  },
  {
    "lng": 10.7604024,
    "lat": 34.7394361
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -92.5659635,
    "lat": 38.628683
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.6132377,
    "lat": -33.5808615
  },
  {
    "lng": -80.9450759,
    "lat": 35.0073697
  },
  {
    "lng": 41.1277565,
    "lat": 37.8835738
  },
  {
    "lng": 2.1266886,
    "lat": 48.8035403
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.546589,
    "lat": 39.7459468
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -78.7812081,
    "lat": 35.7882893
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -75.6114584,
    "lat": 38.6413452
  },
  {
    "lng": 6.9459377,
    "lat": 51.1008952
  },
  {
    "lng": -83.3601542,
    "lat": 35.4350977
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -92.4364298,
    "lat": 39.4201137
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 2.4093697,
    "lat": 48.9379976
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -73.2435218,
    "lat": 40.7276525
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -98.7075744,
    "lat": 35.5261633
  },
  {
    "lng": -97.2085844,
    "lat": 26.0734119
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": 4.8059012,
    "lat": 43.9492493
  },
  {
    "lng": 2.4283244,
    "lat": 44.5206925
  },
  {
    "lng": -111.044047,
    "lat": 45.6794293
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -1.5149935,
    "lat": 43.4813927
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.1244966,
    "lat": 42.2912093
  },
  {
    "lng": -100.783739,
    "lat": 46.808327
  },
  {
    "lng": -97.0585717,
    "lat": 36.1156306
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -96.6925096,
    "lat": 33.0136764
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -98.581341,
    "lat": 33.1020053
  },
  {
    "lng": -54.6162947,
    "lat": -20.4640173
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -79.9047583,
    "lat": 36.2087468
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -116.4139839,
    "lat": 34.1236205
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -83.8240663,
    "lat": 34.2978794
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": -88.9939147,
    "lat": 40.4797828
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -75.1946649,
    "lat": 40.9864261
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -0.1049747,
    "lat": 50.9999616
  },
  {
    "lng": -114.0532996,
    "lat": 35.1895921
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -122.3520327,
    "lat": 48.24216
  },
  {
    "lng": -68.8446177,
    "lat": -32.8894155
  },
  {
    "lng": -95.5377215,
    "lat": 29.6185669
  },
  {
    "lng": -80.0736533,
    "lat": 36.1198589
  },
  {
    "lng": -121.290779,
    "lat": 37.9577016
  },
  {
    "lng": -71.1408776,
    "lat": 42.65717
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -64.8004265,
    "lat": 46.0985679
  },
  {
    "lng": 3.0041906,
    "lat": 43.1837757
  },
  {
    "lng": -122.6065092,
    "lat": 37.9526801
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 0.5824703,
    "lat": 50.8553888
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -88.1834277,
    "lat": 43.4252776
  },
  {
    "lng": -121.816926,
    "lat": 36.62593
  },
  {
    "lng": -1.1305431,
    "lat": 37.9923795
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": -74.6930393,
    "lat": 41.133372
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": -0.942439,
    "lat": 48.6474693
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 0.5545405,
    "lat": 51.5507054
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -3.1791934,
    "lat": 51.4816546
  },
  {
    "lng": -111.044047,
    "lat": 45.6794293
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": 43.0997156,
    "lat": 36.343694
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -77.2651762,
    "lat": 38.9013729
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -90.435999,
    "lat": 38.7150511
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -111.044047,
    "lat": 45.6794293
  },
  {
    "lng": 7.2909824,
    "lat": 52.6947452
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.2713568,
    "lat": 48.7247641
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -80.0481488,
    "lat": 32.7024009
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -77.2688875,
    "lat": 38.7812445
  },
  {
    "lng": -88.0599986,
    "lat": 44.4493584
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.5164242,
    "lat": 35.4661821
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -77.4019268,
    "lat": 37.227928
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.8408929,
    "lat": 34.0218454
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -86.8647316,
    "lat": 39.6444898
  },
  {
    "lng": -83.2646624,
    "lat": 42.8247524
  },
  {
    "lng": -73.7826363,
    "lat": 40.9115386
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -81.5116471,
    "lat": 28.6732806
  },
  {
    "lng": 147.3281233,
    "lat": -42.8825088
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -76.7870991,
    "lat": 41.20484
  },
  {
    "lng": -81.9748429,
    "lat": 33.4709714
  },
  {
    "lng": -90.1767012,
    "lat": 30.0018546
  },
  {
    "lng": 3.3941795,
    "lat": 6.4550575
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.865235,
    "lat": 42.870889
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -84.2747329,
    "lat": 34.0709576
  },
  {
    "lng": -9.4204495,
    "lat": 38.6968919
  },
  {
    "lng": -1.4852861,
    "lat": 51.7838848
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.7753539,
    "lat": 41.270178
  },
  {
    "lng": -2.8062224,
    "lat": 47.6980235
  },
  {
    "lng": -88.3147539,
    "lat": 41.7571701
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -95.0949303,
    "lat": 29.5074538
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -120.339415,
    "lat": 50.6758269
  },
  {
    "lng": 0.340196,
    "lat": 46.5802596
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -95.9927516,
    "lat": 36.1563122
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.334267,
    "lat": 48.911729
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -75.7515682,
    "lat": 39.6828358
  },
  {
    "lng": 8.626979,
    "lat": 48.1678244
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -82.9651045,
    "lat": 40.2317686
  },
  {
    "lng": -88.1784085,
    "lat": 42.0255827
  },
  {
    "lng": -85.2099992,
    "lat": 44.9754211
  },
  {
    "lng": -4.0000308,
    "lat": 43.4306997
  },
  {
    "lng": 0.262039,
    "lat": 52.3990199
  },
  {
    "lng": -0.3379675,
    "lat": 51.753051
  },
  {
    "lng": -95.677556,
    "lat": 39.049011
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -84.6433146,
    "lat": 42.7269261
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -96.9553675,
    "lat": 32.5888072
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": 6.5510623,
    "lat": 43.6191015
  },
  {
    "lng": 44.3872213,
    "lat": 33.3061701
  },
  {
    "lng": -73.7812103,
    "lat": 42.8631868
  },
  {
    "lng": -81.4190808,
    "lat": 33.2641009
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.9760751,
    "lat": 36.8496579
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -70.7719426,
    "lat": 43.0120186
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.0830984,
    "lat": 26.3586885
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.8628942,
    "lat": 47.6379599
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -96.5388038,
    "lat": 33.0151561
  },
  {
    "lng": -79.3916713,
    "lat": 36.5879877
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 21.2636504,
    "lat": 40.5216577
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -83.1763145,
    "lat": 42.3222599
  },
  {
    "lng": -3.8287012,
    "lat": 53.2811822
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.7204155,
    "lat": 12.5375979
  },
  {
    "lng": -85.3865271,
    "lat": 40.1936892
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -73.1715669,
    "lat": 44.4671635
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -122.4614566,
    "lat": 37.8770247
  },
  {
    "lng": 6.6946573,
    "lat": 45.5685467
  },
  {
    "lng": -70.927048,
    "lat": 43.134564
  },
  {
    "lng": -122.2648674,
    "lat": 48.0713855
  },
  {
    "lng": 135.5014539,
    "lat": 34.6937569
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -122.4788813,
    "lat": 48.15336
  },
  {
    "lng": -91.5511429,
    "lat": 35.9469741
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -122.6384056,
    "lat": 47.5315625
  },
  {
    "lng": 138.5710441,
    "lat": 35.6652481
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 98.3891503,
    "lat": 7.8847901
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.8544568,
    "lat": 42.5269718
  },
  {
    "lng": -84.7477136,
    "lat": 33.7514966
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -97.9883477,
    "lat": 30.4601975
  },
  {
    "lng": -122.9146292,
    "lat": 49.2041754
  },
  {
    "lng": 0.3954774,
    "lat": 52.7538673
  },
  {
    "lng": -82.9376919,
    "lat": 41.5119954
  },
  {
    "lng": 2.1868998,
    "lat": 48.9229416
  },
  {
    "lng": -99.2382245,
    "lat": 19.3607174
  },
  {
    "lng": 10.3952118,
    "lat": 63.4304475
  },
  {
    "lng": 2.4093664,
    "lat": 48.7630238
  },
  {
    "lng": -119.700583,
    "lat": 45.839855
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -82.0350598,
    "lat": 41.4516512
  },
  {
    "lng": -82.756907,
    "lat": 28.0856815
  },
  {
    "lng": -100.3917424,
    "lat": 20.5922997
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -91.1869659,
    "lat": 30.4494155
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -99.0233759,
    "lat": 19.1916095
  },
  {
    "lng": 5.9304919,
    "lat": 43.1257311
  },
  {
    "lng": 17.1314203,
    "lat": 48.1557669
  },
  {
    "lng": -74.9869191,
    "lat": 39.688691
  },
  {
    "lng": 4.2974524,
    "lat": 45.793226
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -117.3505966,
    "lat": 33.1580933
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": 8.2416556,
    "lat": 50.0820384
  },
  {
    "lng": -79.1226768,
    "lat": 44.1088502
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -121.3153096,
    "lat": 44.0581728
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": 2.0426301,
    "lat": 48.9274192
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -81.3885899,
    "lat": 28.6619154
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -82.3984882,
    "lat": 34.851354
  },
  {
    "lng": -86.2483921,
    "lat": 43.2341813
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 120.9817861,
    "lat": 14.4809012
  },
  {
    "lng": -0.3302184,
    "lat": 50.8902203
  },
  {
    "lng": 114.8782861,
    "lat": 40.8171433
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 2.5798953,
    "lat": 48.5958681
  },
  {
    "lng": -120.9968892,
    "lat": 37.6393419
  },
  {
    "lng": -2.7599079,
    "lat": 47.6586772
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.7928827,
    "lat": 45.6950021
  },
  {
    "lng": -71.4547891,
    "lat": 42.9956397
  },
  {
    "lng": -118.2005236,
    "lat": 34.1998302
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 79.8542005,
    "lat": 6.9388614
  },
  {
    "lng": -2.5429139,
    "lat": 47.614847
  },
  {
    "lng": -75.3405529,
    "lat": 40.5794426
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -121.3716178,
    "lat": 38.4087993
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -84.0199108,
    "lat": 33.857328
  },
  {
    "lng": -122.1560768,
    "lat": 37.7249296
  },
  {
    "lng": -76.0732254,
    "lat": 39.5594191
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 4.9036535,
    "lat": 36.6439022
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 4.44653,
    "lat": 47.15274
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.1494901,
    "lat": 26.0112014
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 73.0651511,
    "lat": 33.6938118
  },
  {
    "lng": 12.4573112,
    "lat": 55.7583936
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -71.1631137,
    "lat": 42.7070354
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -120.308938,
    "lat": 46.3775015
  },
  {
    "lng": -71.0683741,
    "lat": 42.4268484
  },
  {
    "lng": 44.0332586,
    "lat": 32.595759
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": 3.4203712,
    "lat": 46.1239268
  },
  {
    "lng": 69.2877212,
    "lat": 41.2932886
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -91.1869659,
    "lat": 30.4494155
  },
  {
    "lng": -96.6353488,
    "lat": 30.4764878
  },
  {
    "lng": 7.8970717,
    "lat": 50.4941653
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.0823355,
    "lat": 49.4300997
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -117.5153511,
    "lat": 33.9820864
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -99.1324941,
    "lat": 19.2953782
  },
  {
    "lng": -84.5192192,
    "lat": 34.1014112
  },
  {
    "lng": -81.4828123,
    "lat": 41.1362729
  },
  {
    "lng": 0.6176112,
    "lat": 44.2015827
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -122.1768209,
    "lat": 48.0517429
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -75.9760751,
    "lat": 36.8496579
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": -122.0402399,
    "lat": 37.5296593
  },
  {
    "lng": -1.1226397,
    "lat": 46.8263148
  },
  {
    "lng": -83.711604,
    "lat": 41.621718
  },
  {
    "lng": 10.5593214,
    "lat": 47.1405865
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 6.8592928,
    "lat": 47.4616568
  },
  {
    "lng": -0.078521,
    "lat": 51.7957409
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -60.7336808,
    "lat": -34.1977548
  },
  {
    "lng": 13.8201171,
    "lat": 55.4295203
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -41.8875267,
    "lat": -22.7597805
  },
  {
    "lng": -88.1050853,
    "lat": 42.5775187
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 120.9724002,
    "lat": 14.651348
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -80.3975399,
    "lat": 27.6387163
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -65.7528911,
    "lat": 44.6762173
  },
  {
    "lng": -76.492786,
    "lat": 38.9786401
  },
  {
    "lng": -88.3303618,
    "lat": 42.1816908
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.9927516,
    "lat": 36.1563122
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": 8.5253985,
    "lat": 47.1951976
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -1.5135474,
    "lat": 52.400739
  },
  {
    "lng": -117.084195,
    "lat": 32.6400541
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -70.9494939,
    "lat": 42.466763
  },
  {
    "lng": -100.315258,
    "lat": 25.6802019
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.4549262,
    "lat": 33.4487257
  },
  {
    "lng": 2.1900052,
    "lat": 48.7809496
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -112.8331033,
    "lat": 49.6945782
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -87.8715185,
    "lat": 41.9348693
  },
  {
    "lng": -109.546214,
    "lat": 38.5738096
  },
  {
    "lng": 5.1623805,
    "lat": 48.7712673
  },
  {
    "lng": -122.7459664,
    "lat": 45.9018496
  },
  {
    "lng": -6.9261131,
    "lat": 52.8408344
  },
  {
    "lng": -82.4333742,
    "lat": 42.9760854
  },
  {
    "lng": 6.5680077,
    "lat": 53.2190652
  },
  {
    "lng": -60.6617024,
    "lat": -32.9593609
  },
  {
    "lng": -95.3024351,
    "lat": 29.9118897
  },
  {
    "lng": -7.9807002,
    "lat": 40.2202451
  },
  {
    "lng": 3.862452,
    "lat": 43.6978777
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -95.4105347,
    "lat": 39.8166687
  },
  {
    "lng": -0.1110147,
    "lat": 47.222937
  },
  {
    "lng": -73.1118997,
    "lat": 42.6990349
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.655037,
    "lat": 36.6744117
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 11.8734455,
    "lat": 45.4077172
  },
  {
    "lng": 2.8722456,
    "lat": 48.7100369
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 153.4145987,
    "lat": -28.0023731
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -88.0717708,
    "lat": 41.7003302
  },
  {
    "lng": -1.6044065,
    "lat": 54.9617219
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -1.0150646,
    "lat": 46.871379
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -74.3457623,
    "lat": 43.0505021
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -70.7803543,
    "lat": 42.6326501
  },
  {
    "lng": -85.8590603,
    "lat": 41.6012796
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.3660907,
    "lat": 47.7477336
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": -90.1670585,
    "lat": 38.657181
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -4.1024782,
    "lat": 47.9960325
  },
  {
    "lng": -103.85937,
    "lat": 44.490817
  },
  {
    "lng": -1.57027,
    "lat": 55.1832364
  },
  {
    "lng": -9.2365233,
    "lat": 38.758959
  },
  {
    "lng": -94.9774274,
    "lat": 29.7355047
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 0.7538866,
    "lat": 49.6179384
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -74.2107006,
    "lat": 40.6639916
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -87.2011806,
    "lat": 20.9317633
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -122.3473099,
    "lat": 37.5780965
  },
  {
    "lng": -0.865783,
    "lat": 44.5626798
  },
  {
    "lng": 8.7376029,
    "lat": 41.9263991
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": 3.0105105,
    "lat": 42.704359
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -91.733423,
    "lat": 45.5027926
  },
  {
    "lng": -84.1357453,
    "lat": 35.7603575
  },
  {
    "lng": -2.2087993,
    "lat": 56.9640234
  },
  {
    "lng": 5.7679082,
    "lat": 49.5145564
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -63.5720232,
    "lat": 44.6799707
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 4.8534326,
    "lat": 46.7831001
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -73.4698253,
    "lat": 40.669501
  },
  {
    "lng": -72.8227503,
    "lat": 41.461612
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -89.3350888,
    "lat": 37.7644952
  },
  {
    "lng": -95.6349463,
    "lat": 29.6196787
  },
  {
    "lng": -122.0215737,
    "lat": 37.5872576
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -114.1130367,
    "lat": 51.7923735
  },
  {
    "lng": 5.0414701,
    "lat": 47.3215806
  },
  {
    "lng": 5.5703031,
    "lat": 43.2924385
  },
  {
    "lng": -80.6770111,
    "lat": 35.7331953
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 8.7291498,
    "lat": 47.4991723
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.4093664,
    "lat": 48.7630238
  },
  {
    "lng": -111.9738429,
    "lat": 41.2230048
  },
  {
    "lng": -118.4486675,
    "lat": 34.1866193
  },
  {
    "lng": -96.9553675,
    "lat": 32.5888072
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -86.4436018,
    "lat": 36.9903199
  },
  {
    "lng": -73.2006687,
    "lat": 40.8559314
  },
  {
    "lng": 1.9371554,
    "lat": 47.8835088
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -58.68455,
    "lat": -34.409311
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 0.9918234,
    "lat": 47.3279746
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 1.9017347,
    "lat": 50.055774
  },
  {
    "lng": -0.902805,
    "lat": 52.2343297
  },
  {
    "lng": 136.5836516,
    "lat": 34.8817102
  },
  {
    "lng": -122.1560768,
    "lat": 37.7249296
  },
  {
    "lng": -95.4560512,
    "lat": 30.3118769
  },
  {
    "lng": -5.0293161,
    "lat": 51.7117492
  },
  {
    "lng": -80.151449,
    "lat": 41.641445
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -0.1511977,
    "lat": 47.9965376
  },
  {
    "lng": -79.5656326,
    "lat": 43.6435559
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 1.3337639,
    "lat": 47.5876861
  },
  {
    "lng": 9.2794469,
    "lat": 41.5911382
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -8.1022591,
    "lat": 37.0712719
  },
  {
    "lng": -93.3501222,
    "lat": 44.8897027
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -75.7774177,
    "lat": 40.5173165
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.4455201,
    "lat": 48.9229803
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -122.3053932,
    "lat": 47.8278656
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -76.3442846,
    "lat": 37.0264414
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": 9.9215263,
    "lat": 57.0462626
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -96.7077751,
    "lat": 40.8088861
  },
  {
    "lng": -1.3131692,
    "lat": 51.0612766
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 4.3668279,
    "lat": 50.8331141
  },
  {
    "lng": 5.2298559,
    "lat": 49.7705329
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -5.9336562,
    "lat": 54.5842881
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 6.1763552,
    "lat": 49.1196964
  },
  {
    "lng": -5.9953403,
    "lat": 37.3886303
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 7.8653814,
    "lat": 48.1224978
  },
  {
    "lng": -1.2620038,
    "lat": 52.3726682
  },
  {
    "lng": -2.7535644,
    "lat": 48.1762534
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -97.4033191,
    "lat": 27.7635302
  },
  {
    "lng": -84.2946539,
    "lat": 37.7478572
  },
  {
    "lng": 2.2276489,
    "lat": 48.7000046
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 9.5960536,
    "lat": 54.5035476
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": 6.1675872,
    "lat": 49.3579272
  },
  {
    "lng": 5.6969882,
    "lat": 50.8579855
  },
  {
    "lng": 7.1906969,
    "lat": 43.6690101
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.836241,
    "lat": 38.3856488
  },
  {
    "lng": 10.2835977,
    "lat": 53.6635561
  },
  {
    "lng": 6.1675872,
    "lat": 49.3579272
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -84.1335644,
    "lat": 34.235309
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -117.7517496,
    "lat": 34.0553813
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -122.4168664,
    "lat": 37.6535403
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.6976609,
    "lat": 44.3778474
  },
  {
    "lng": -88.207301,
    "lat": 40.1117174
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 7.3389937,
    "lat": 47.7467233
  },
  {
    "lng": -1.2077985,
    "lat": 52.7723859
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.4172117,
    "lat": 48.6998552
  },
  {
    "lng": -71.1187829,
    "lat": 42.332918
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": 2.2695658,
    "lat": 48.884683
  },
  {
    "lng": -12.8260215,
    "lat": 10.0368
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": 19.2361111,
    "lat": -34.4175
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": -73.55793,
    "lat": 44.62884
  },
  {
    "lng": -93.2922715,
    "lat": 37.2081729
  },
  {
    "lng": -73.343167,
    "lat": 40.9009595
  },
  {
    "lng": -97.1341783,
    "lat": 32.9412363
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 6.0910097,
    "lat": 43.3040144
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.1767012,
    "lat": 30.0018546
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -0.3032767,
    "lat": 51.4613531
  },
  {
    "lng": -0.0154152,
    "lat": 51.4781086
  },
  {
    "lng": -122.1702293,
    "lat": 47.1870191
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 5.0715646,
    "lat": 49.6063089
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -1.9154621,
    "lat": 52.6791667
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.7435,
    "lat": 49.5929
  },
  {
    "lng": -85.5356726,
    "lat": 41.9031963
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -1.0209685,
    "lat": 44.0630824
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -77.4752667,
    "lat": 38.7509488
  },
  {
    "lng": -2.4514219,
    "lat": 52.6780532
  },
  {
    "lng": -2.2024324,
    "lat": 51.3161569
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.4979963,
    "lat": 40.6460921
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -80.4136767,
    "lat": 37.2296566
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 5.1925264,
    "lat": 45.90363
  },
  {
    "lng": 5.4127848,
    "lat": 43.4511819
  },
  {
    "lng": -122.5316686,
    "lat": 37.9747795
  },
  {
    "lng": 2.5732616,
    "lat": 48.8091528
  },
  {
    "lng": 21.2692121,
    "lat": 48.7220196
  },
  {
    "lng": 28.8322923,
    "lat": 47.0245117
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -119.9843482,
    "lat": 38.9332411
  },
  {
    "lng": -121.3716178,
    "lat": 38.4087993
  },
  {
    "lng": 79.8542005,
    "lat": 6.9388614
  },
  {
    "lng": -92.0178202,
    "lat": 30.2262187
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -1.2885317,
    "lat": 51.823462
  },
  {
    "lng": -10.0994464,
    "lat": 51.7696536
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": -1.4269698,
    "lat": 46.6705431
  },
  {
    "lng": -86.8254383,
    "lat": 21.1855431
  },
  {
    "lng": -77.3859479,
    "lat": 38.9695316
  },
  {
    "lng": -74.333495,
    "lat": 40.2852895
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -121.542726,
    "lat": 37.7832614
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.012084,
    "lat": 40.8042674
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 8.52491,
    "lat": 47.3117624
  },
  {
    "lng": -86.6722192,
    "lat": 36.0600602
  },
  {
    "lng": -99.1906167,
    "lat": 19.4071156
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -2.2024324,
    "lat": 51.3161569
  },
  {
    "lng": -121.95255,
    "lat": 49.1709788
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": 2.4890211,
    "lat": 42.1822177
  },
  {
    "lng": -109.546214,
    "lat": 38.5738096
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -121.95255,
    "lat": 49.1709788
  },
  {
    "lng": 6.5623343,
    "lat": 51.3331205
  },
  {
    "lng": -71.4539683,
    "lat": 42.4321064
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.0335624,
    "lat": 37.9768525
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -121.9877444,
    "lat": 38.3565773
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -16.5627509,
    "lat": 13.4410165
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -88.8177418,
    "lat": 35.6144446
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -81.3578047,
    "lat": 41.1513108
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 17.9681359,
    "lat": 59.3628802
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -79.666672,
    "lat": 43.447436
  },
  {
    "lng": 5.0735802,
    "lat": 52.653272
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": -99.1906167,
    "lat": 19.4071156
  },
  {
    "lng": 91.8344348,
    "lat": 22.333778
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": -97.3375448,
    "lat": 37.6922361
  },
  {
    "lng": 5.2298559,
    "lat": 49.7705329
  },
  {
    "lng": -100.315258,
    "lat": 25.6802019
  },
  {
    "lng": -3.784376,
    "lat": 55.9991959
  },
  {
    "lng": -79.6765713,
    "lat": 44.6502303
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 16.5463679,
    "lat": 59.6110992
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 4.2662071,
    "lat": 39.8894922
  },
  {
    "lng": 1.9485841,
    "lat": 44.5811875
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -82.5508407,
    "lat": 35.595363
  },
  {
    "lng": 2.4000602,
    "lat": 50.6395937
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.1778792,
    "lat": 46.8033114
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -72.2762084,
    "lat": 41.491269
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -76.515226,
    "lat": 40.3295901
  },
  {
    "lng": 8.694724,
    "lat": 49.4093582
  },
  {
    "lng": -72.5751341,
    "lat": 42.2591392
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -73.9442812,
    "lat": 41.117785
  },
  {
    "lng": -8.4150492,
    "lat": 39.6036596
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": 1.4353783,
    "lat": 38.9072784
  },
  {
    "lng": -86.5342881,
    "lat": 39.1670396
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -112.5285237,
    "lat": 37.0481715
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -74.0731738,
    "lat": 45.6452452
  },
  {
    "lng": -88.6352595,
    "lat": 36.7413624
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -1.4194401,
    "lat": 53.6991226
  },
  {
    "lng": 7.0341973,
    "lat": 5.489736
  },
  {
    "lng": -117.566444,
    "lat": 33.8752945
  },
  {
    "lng": 2.2368863,
    "lat": 48.8841522
  },
  {
    "lng": -0.1908861,
    "lat": 51.3596769
  },
  {
    "lng": -44.246944,
    "lat": -19.466111
  },
  {
    "lng": 1.6053807,
    "lat": 42.9638998
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -0.6620551,
    "lat": 51.9165794
  },
  {
    "lng": 5.0715646,
    "lat": 49.6063089
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.2765575,
    "lat": 49.1512109
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -122.6874469,
    "lat": 48.0559402
  },
  {
    "lng": -94.0984277,
    "lat": 30.0829344
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.3330573,
    "lat": 37.496904
  },
  {
    "lng": -1.3757282,
    "lat": 47.7194057
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": 3.4113639,
    "lat": 44.5037957
  },
  {
    "lng": -97.6114237,
    "lat": 38.8402805
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 85.3205817,
    "lat": 27.708317
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": -97.8772103,
    "lat": 29.9892928
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -122.561503,
    "lat": 37.9744323
  },
  {
    "lng": -80.0830984,
    "lat": 26.3586885
  },
  {
    "lng": -74.1454214,
    "lat": 40.7684342
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 11.0566523,
    "lat": 49.1952934
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -79.6847703,
    "lat": 40.6739543
  },
  {
    "lng": -121.955174,
    "lat": 37.3541132
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 73.5301042,
    "lat": 4.1961894
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -121.8989248,
    "lat": 37.4332273
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": -72.9632651,
    "lat": 41.2709645
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -122.561503,
    "lat": 37.9744323
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -99.1906167,
    "lat": 19.4071156
  },
  {
    "lng": -0.1049747,
    "lat": 50.9999616
  },
  {
    "lng": -81.5032364,
    "lat": 30.0295303
  },
  {
    "lng": 127.0473,
    "lat": 37.5177
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -121.176058,
    "lat": 38.6779591
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -95.4187924,
    "lat": 30.0795707
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -80.9856069,
    "lat": 35.1478727
  },
  {
    "lng": -122.9543022,
    "lat": 50.1171903
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -98.1981486,
    "lat": 19.0437196
  },
  {
    "lng": 34.8760954,
    "lat": 32.0604256
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -1.1236065,
    "lat": 52.6321088
  },
  {
    "lng": -122.036349,
    "lat": 37.3688301
  },
  {
    "lng": -91.6392294,
    "lat": 44.0500054
  },
  {
    "lng": -72.4613331,
    "lat": 41.4528584
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.206436,
    "lat": 26.2445263
  },
  {
    "lng": -80.2781057,
    "lat": 25.8575963
  },
  {
    "lng": -80.2493276,
    "lat": 43.5460516
  },
  {
    "lng": -86.2541768,
    "lat": 41.8297694
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -120.435857,
    "lat": 34.9531295
  },
  {
    "lng": 8.5828944,
    "lat": 52.2004727
  },
  {
    "lng": -74.2176435,
    "lat": 40.0978929
  },
  {
    "lng": -0.6438974,
    "lat": 52.913192
  },
  {
    "lng": -93.0219376,
    "lat": 37.6832712
  },
  {
    "lng": 10.9461479,
    "lat": 50.8349097
  },
  {
    "lng": 10.407855,
    "lat": 53.248706
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 12.5329678,
    "lat": 57.9299658
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 11.8609561,
    "lat": 45.4115847
  },
  {
    "lng": -117.1827445,
    "lat": 34.0550328
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -74.215011,
    "lat": 40.7642404
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -88.0840212,
    "lat": 41.5263603
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 120.9545903,
    "lat": 14.4070149
  },
  {
    "lng": 6.3121658,
    "lat": 46.0672189
  },
  {
    "lng": -159.3191601,
    "lat": 22.0747334
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -80.0656106,
    "lat": 40.4656244
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -79.6059188,
    "lat": 40.6271073
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": -123.2290777,
    "lat": 44.8486414
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -0.902805,
    "lat": 52.2343297
  },
  {
    "lng": 2.4916592,
    "lat": 48.8387639
  },
  {
    "lng": -3.8758396,
    "lat": 40.4933095
  },
  {
    "lng": -122.7141049,
    "lat": 38.4404925
  },
  {
    "lng": -74.1637553,
    "lat": 40.8584328
  },
  {
    "lng": -1.1448708,
    "lat": 43.8066637
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -70.8781883,
    "lat": 42.5489744
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -117.566444,
    "lat": 33.8752945
  },
  {
    "lng": -85.3782795,
    "lat": 32.6454116
  },
  {
    "lng": 10.8337852,
    "lat": 48.2687941
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 6.5680077,
    "lat": 53.2190652
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -95.8243956,
    "lat": 29.7857853
  },
  {
    "lng": -0.0659685,
    "lat": 51.5174861
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -0.1991229,
    "lat": 51.4989948
  },
  {
    "lng": -112.036277,
    "lat": 46.5927425
  },
  {
    "lng": -87.8735662,
    "lat": 41.81483
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -58.5622869,
    "lat": -34.6481661
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 13.1624096,
    "lat": 46.2313099
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 8.3640342,
    "lat": 47.4182444
  },
  {
    "lng": -1.8604874,
    "lat": 53.7229229
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": 121.4589414,
    "lat": 25.061706
  },
  {
    "lng": -70.2823287,
    "lat": 41.6535345
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 16.6131116,
    "lat": 49.1911221
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 6.5623343,
    "lat": 51.3331205
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": -0.2749555,
    "lat": 51.6136623
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 3.5665965,
    "lat": 51.1844827
  },
  {
    "lng": -8.3959425,
    "lat": 43.3709703
  },
  {
    "lng": 2.2695658,
    "lat": 48.884683
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 10.1857757,
    "lat": 36.8002068
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -75.4583956,
    "lat": 43.2102196
  },
  {
    "lng": 4.2176541,
    "lat": 43.8266904
  },
  {
    "lng": -93.161159,
    "lat": 44.4582041
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 11.98632,
    "lat": 48.3136408
  },
  {
    "lng": -87.6305899,
    "lat": 46.4481521
  },
  {
    "lng": 13.7772781,
    "lat": 45.6496485
  },
  {
    "lng": 7.5674652,
    "lat": 51.445525
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.1810781,
    "lat": 53.0079887
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -74.6487018,
    "lat": 42.1487726
  },
  {
    "lng": 15.9622315,
    "lat": 45.8426414
  },
  {
    "lng": 0.983698,
    "lat": 47.4110351
  },
  {
    "lng": -117.2919818,
    "lat": 33.0369867
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.2146275,
    "lat": 43.4162729
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 4.2360263,
    "lat": 45.2424978
  },
  {
    "lng": -97.3865494,
    "lat": 32.3474463
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 6.759562,
    "lat": 51.434999
  },
  {
    "lng": 3.9452194,
    "lat": 50.4431879
  },
  {
    "lng": 106.6811524,
    "lat": 10.8237546
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -77.1956331,
    "lat": 39.0180508
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": -0.7630148,
    "lat": 51.2494169
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": -72.9250518,
    "lat": 41.3082138
  },
  {
    "lng": -75.0354347,
    "lat": 43.0150703
  },
  {
    "lng": -8.6103497,
    "lat": 41.1502195
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -94.969956,
    "lat": 35.91537
  },
  {
    "lng": -79.8387175,
    "lat": -6.7716146
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -1.5695287,
    "lat": 47.1905456
  },
  {
    "lng": -96.7077751,
    "lat": 40.8088861
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -71.0994968,
    "lat": 42.3875968
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": 6.4946806,
    "lat": 47.6863376
  },
  {
    "lng": 32.8554966,
    "lat": 39.8853321
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 150.5134227,
    "lat": -23.3782137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 17.6387436,
    "lat": 59.8586126
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -111.8627989,
    "lat": 40.5247777
  },
  {
    "lng": -118.5978087,
    "lat": 34.2011078
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.1981764,
    "lat": 33.4504157
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -52.7066964,
    "lat": 47.5646794
  },
  {
    "lng": 2.1868998,
    "lat": 48.9229416
  },
  {
    "lng": 6.9881194,
    "lat": 51.0324743
  },
  {
    "lng": -87.2011806,
    "lat": 20.9317633
  },
  {
    "lng": 6.62843,
    "lat": 51.451283
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.787022,
    "lat": 43.8235163
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": 11.8734455,
    "lat": 45.4077172
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.8152074,
    "lat": 33.4638745
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": 2.4916592,
    "lat": 48.8387639
  },
  {
    "lng": -0.2796034,
    "lat": 51.5560695
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.6775634,
    "lat": 30.6370152
  },
  {
    "lng": -74.5857218,
    "lat": 40.844265
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -1.6676238,
    "lat": 43.3844003
  },
  {
    "lng": -84.778628,
    "lat": 42.9892847
  },
  {
    "lng": 72.5800568,
    "lat": 23.0215374
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -73.872635,
    "lat": 41.0145418
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -86.7825235,
    "lat": 36.0325687
  },
  {
    "lng": -121.29318,
    "lat": 38.8915741
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.1783134,
    "lat": 50.8526637
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -92.447758,
    "lat": 42.5361805
  },
  {
    "lng": -76.6042521,
    "lat": 40.153364
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": 8.4034195,
    "lat": 49.0068705
  },
  {
    "lng": -81.9320157,
    "lat": 34.9498007
  },
  {
    "lng": -0.9943593,
    "lat": 41.7140829
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -0.4095586,
    "lat": 52.99965
  },
  {
    "lng": -71.3821203,
    "lat": 41.8789531
  },
  {
    "lng": -2.8452562,
    "lat": 47.7584409
  },
  {
    "lng": 17.0326689,
    "lat": 51.1089776
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -79.05578,
    "lat": 35.9131542
  },
  {
    "lng": 0.6383746,
    "lat": 51.8019608
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -81.7016346,
    "lat": 30.1654707
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -79.05578,
    "lat": 35.9131542
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": 7.290923,
    "lat": 51.9773625
  },
  {
    "lng": -111.9866584,
    "lat": 46.4649011
  },
  {
    "lng": -119.495902,
    "lat": 49.8879177
  },
  {
    "lng": -73.0438362,
    "lat": 41.5538091
  },
  {
    "lng": 8.4034195,
    "lat": 49.0068705
  },
  {
    "lng": 12.0819247,
    "lat": 55.6433478
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -0.5639812,
    "lat": 45.9085506
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -83.1499304,
    "lat": 42.6055893
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -117.2740777,
    "lat": 32.8401623
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": 10.2758153,
    "lat": 50.1847547
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -89.5278045,
    "lat": 31.6143213
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.7909452,
    "lat": 37.831272
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.5804218,
    "lat": 46.0603171
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": 2.2824663,
    "lat": 48.9064207
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -79.0639039,
    "lat": 43.1065603
  },
  {
    "lng": -2.2198605,
    "lat": 51.745424
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -3.000425,
    "lat": 51.5887675
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -110.1618548,
    "lat": 38.9961201
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -122.3053932,
    "lat": 47.8278656
  },
  {
    "lng": -90.1570232,
    "lat": 30.4043607
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -0.3699697,
    "lat": 50.8115402
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": 6.4867321,
    "lat": 43.5039337
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -97.8417144,
    "lat": 30.082475
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 1.6995213,
    "lat": 41.3463825
  },
  {
    "lng": -125.904708,
    "lat": 49.1529643
  },
  {
    "lng": 11.4250395,
    "lat": 48.7630165
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.6294321,
    "lat": 43.3708943
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 2.0388736,
    "lat": 49.0527528
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.8526969,
    "lat": 42.9300668
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -97.6788056,
    "lat": 30.5085915
  },
  {
    "lng": -90.1843091,
    "lat": 38.8908583
  },
  {
    "lng": -2.779317,
    "lat": 55.9556144
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 0.6267842,
    "lat": 41.6147605
  },
  {
    "lng": -71.5525188,
    "lat": 42.3468589
  },
  {
    "lng": 7.6824892,
    "lat": 45.0677551
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 3.2131307,
    "lat": 43.3426562
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 145.582931,
    "lat": -36.773286
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": 25.4701983,
    "lat": 65.0117869
  },
  {
    "lng": -76.0372354,
    "lat": 45.6402189
  },
  {
    "lng": 2.3491069,
    "lat": 43.2130358
  },
  {
    "lng": -2.3596963,
    "lat": 51.3813864
  },
  {
    "lng": -90.0657477,
    "lat": 30.3582305
  },
  {
    "lng": -122.793281,
    "lat": 49.2842958
  },
  {
    "lng": -80.1762704,
    "lat": 33.0186699
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 0.164274,
    "lat": 44.5007939
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -159.3463523,
    "lat": 22.0833399
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": 89.8401059,
    "lat": 23.03408
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.5937073,
    "lat": 48.6272298
  },
  {
    "lng": -5.273032,
    "lat": 50.1016731
  },
  {
    "lng": 0.2673446,
    "lat": 51.1371483
  },
  {
    "lng": 0.1438299,
    "lat": 38.7324708
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -111.5908473,
    "lat": 33.1941699
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.4394816,
    "lat": 35.2225717
  },
  {
    "lng": 4.8855966,
    "lat": 45.6977109
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.4455201,
    "lat": 48.9229803
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 2.0324321,
    "lat": 44.6092335
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -77.1233587,
    "lat": 38.9812725
  },
  {
    "lng": -81.2839038,
    "lat": 28.2498534
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -107.9779962,
    "lat": 36.7520109
  },
  {
    "lng": 3.8969928,
    "lat": 7.3786064
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -85.1386015,
    "lat": 41.0799898
  },
  {
    "lng": 4.8934402,
    "lat": 44.8363656
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": -2.1208614,
    "lat": 53.5435569
  },
  {
    "lng": -117.379483,
    "lat": 33.1958696
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": 6.6617476,
    "lat": 46.5098019
  },
  {
    "lng": -112.8331033,
    "lat": 49.6945782
  },
  {
    "lng": 12.0974869,
    "lat": 49.0195333
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 9.6556042,
    "lat": 47.3859513
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.0715646,
    "lat": 49.6063089
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -116.9763092,
    "lat": 33.9299925
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": 6.0910097,
    "lat": 43.3040144
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 3.7250121,
    "lat": 51.0538286
  },
  {
    "lng": 6.46667,
    "lat": 50.8833
  },
  {
    "lng": 2.2674892,
    "lat": 48.9148269
  },
  {
    "lng": -86.2874232,
    "lat": 32.4149235
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -87.682932,
    "lat": 42.0693991
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -2.6183238,
    "lat": 51.7938786
  },
  {
    "lng": -83.1848781,
    "lat": 34.4870458
  },
  {
    "lng": -118.374752,
    "lat": 34.1649502
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 101.5234848,
    "lat": 3.6900079
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 7.444639,
    "lat": 51.7717757
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -75.7515682,
    "lat": 39.6828358
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 4.8078783,
    "lat": 44.1371311
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -71.71351,
    "lat": 42.2960187
  },
  {
    "lng": -1.0677602,
    "lat": 50.8221133
  },
  {
    "lng": -122.3330573,
    "lat": 37.496904
  },
  {
    "lng": -106.6308524,
    "lat": 39.624457
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.0475937,
    "lat": 59.9738693
  },
  {
    "lng": 2.334267,
    "lat": 48.911729
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": 10.1056465,
    "lat": 56.1565872
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -1.6363856,
    "lat": 53.716564
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -86.8919011,
    "lat": 40.4191229
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.5495112,
    "lat": 34.9854275
  },
  {
    "lng": -89.9841627,
    "lat": 38.5135805
  },
  {
    "lng": -0.1835802,
    "lat": 50.8452678
  },
  {
    "lng": 0.3018662,
    "lat": 51.6201654
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": 10.3952118,
    "lat": 63.4304475
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.272863,
    "lat": 37.8708393
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -122.657047,
    "lat": 49.1039289
  },
  {
    "lng": -111.926018,
    "lat": 33.4942189
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 0.6383746,
    "lat": 51.8019608
  },
  {
    "lng": -74.5348749,
    "lat": 39.8176178
  },
  {
    "lng": 83.2921297,
    "lat": 17.6935526
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -88.1479278,
    "lat": 41.7728699
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -74.249663,
    "lat": 45.9024084
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -1.8991667,
    "lat": 46.7202778
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 11.1430287,
    "lat": 47.8452213
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -117.379483,
    "lat": 33.1958696
  },
  {
    "lng": -111.789037,
    "lat": 33.3527632
  },
  {
    "lng": 4.4811089,
    "lat": 52.1518157
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -54.9582718,
    "lat": -34.9087162
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -1.0677602,
    "lat": 50.8221133
  },
  {
    "lng": -2.2458192,
    "lat": 51.8653705
  },
  {
    "lng": 6.9684353,
    "lat": 53.0786257
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.6141867,
    "lat": 38.263995
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": 4.3600687,
    "lat": 43.8374249
  },
  {
    "lng": -83.1779537,
    "lat": 41.114485
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": -1.5756205,
    "lat": 54.7770139
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 18.016667,
    "lat": 59.366667
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -87.8606367,
    "lat": 42.9105722
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.5441944,
    "lat": 28.5694468
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.7603283,
    "lat": 48.5141134
  },
  {
    "lng": -1.1964165,
    "lat": 53.1443785
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 7.8431299,
    "lat": 47.560991
  },
  {
    "lng": 7.1294088,
    "lat": 49.3704071
  },
  {
    "lng": -0.8809428,
    "lat": 41.6521342
  },
  {
    "lng": -86.4436018,
    "lat": 36.9903199
  },
  {
    "lng": -0.6308396,
    "lat": 44.805615
  },
  {
    "lng": 6.8940537,
    "lat": 52.2209855
  },
  {
    "lng": 7.1943544,
    "lat": 51.1798706
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -76.9199742,
    "lat": 40.2398118
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 33.3638783,
    "lat": 35.1746503
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -76.2494453,
    "lat": 36.7168315
  },
  {
    "lng": 7.2994054,
    "lat": 47.9569146
  },
  {
    "lng": -86.2307992,
    "lat": 30.3466423
  },
  {
    "lng": 7.0134418,
    "lat": 43.5515198
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -4.1433925,
    "lat": 50.3780967
  },
  {
    "lng": -1.4761491,
    "lat": 52.9212617
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -79.8728583,
    "lat": 43.2560802
  },
  {
    "lng": -70.8739761,
    "lat": 43.1981117
  },
  {
    "lng": -76.053813,
    "lat": 42.0850703
  },
  {
    "lng": -124.2174647,
    "lat": 43.3678937
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -83.376398,
    "lat": 33.9597677
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -49.3695627,
    "lat": -28.6789941
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -105.0372046,
    "lat": 39.8366528
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 6.1041352,
    "lat": 49.3043497
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -118.4486675,
    "lat": 34.1866193
  },
  {
    "lng": -122.3455263,
    "lat": 37.9621457
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": -1.1305431,
    "lat": 37.9923795
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -156.3237119,
    "lat": 20.792026
  },
  {
    "lng": -8.0232598,
    "lat": 37.1395485
  },
  {
    "lng": 4.7760237,
    "lat": 51.5887845
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -118.2350733,
    "lat": 34.230429
  },
  {
    "lng": -79.9559437,
    "lat": 39.6296809
  },
  {
    "lng": -47.8828,
    "lat": -15.7939869
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 44.3872213,
    "lat": 33.3061701
  },
  {
    "lng": 2.2552381,
    "lat": 46.9921896
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -1.7594444,
    "lat": 46.6986111
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5595029,
    "lat": 44.7737872
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": 2.0678397,
    "lat": 43.4539616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.5252267,
    "lat": 43.929489
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -121.944881,
    "lat": 37.2870626
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 151.3120675,
    "lat": -33.3117096
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -58.7662564,
    "lat": -27.5246619
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -75.3741691,
    "lat": 6.1536166
  },
  {
    "lng": -0.2796034,
    "lat": 51.5560695
  },
  {
    "lng": 9.1750718,
    "lat": 47.659216
  },
  {
    "lng": 12.0495271,
    "lat": 57.7970147
  },
  {
    "lng": -114.9822486,
    "lat": 36.0319843
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -72.7395401,
    "lat": 41.7162112
  },
  {
    "lng": 5.8100016,
    "lat": 47.1811265
  },
  {
    "lng": -71.065573,
    "lat": 42.2501425
  },
  {
    "lng": -9.2365233,
    "lat": 38.758959
  },
  {
    "lng": -2.3926783,
    "lat": 53.8717465
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -72.4423102,
    "lat": 42.9620253
  },
  {
    "lng": -111.6587085,
    "lat": 40.2337289
  },
  {
    "lng": 7.0960124,
    "lat": 51.5110321
  },
  {
    "lng": -77.3063733,
    "lat": 38.8462236
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -118.0539323,
    "lat": 33.8644291
  },
  {
    "lng": -6.0414184,
    "lat": 52.9802376
  },
  {
    "lng": 18.798327,
    "lat": 54.4288032
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -95.4560512,
    "lat": 30.3118769
  },
  {
    "lng": -157.9129733,
    "lat": 21.34045
  },
  {
    "lng": 100.9872185,
    "lat": 13.3662087
  },
  {
    "lng": 74.7870308,
    "lat": 13.3519723
  },
  {
    "lng": -1.5149935,
    "lat": 43.4813927
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.7056955,
    "lat": 40.6631362
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 100.5386136,
    "lat": 13.7784702
  },
  {
    "lng": -99.2327986,
    "lat": 19.4788356
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -117.0814849,
    "lat": 33.1216751
  },
  {
    "lng": -2.2138905,
    "lat": 47.2733517
  },
  {
    "lng": -1.4968,
    "lat": 53.6830458
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -95.4187924,
    "lat": 30.0795707
  },
  {
    "lng": -72.5198761,
    "lat": 42.3731948
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 3.17459,
    "lat": 45.7067
  },
  {
    "lng": -70.927048,
    "lat": 43.134564
  },
  {
    "lng": -3.7659722,
    "lat": 40.6587726
  },
  {
    "lng": -88.0717708,
    "lat": 41.7003302
  },
  {
    "lng": -9.2365233,
    "lat": 38.758959
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -74.154352,
    "lat": 41.8448455
  },
  {
    "lng": 2.8953121,
    "lat": 42.6985304
  },
  {
    "lng": -121.96947,
    "lat": 48.0817561
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -74.4809868,
    "lat": 40.7970382
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 9.7703927,
    "lat": 53.7889203
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -84.4721678,
    "lat": 42.7320307
  },
  {
    "lng": -81.684004,
    "lat": 36.2187873
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -54.9582718,
    "lat": -34.9087162
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -75.1256812,
    "lat": 40.0959385
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -74.0984769,
    "lat": 41.0585352
  },
  {
    "lng": -77.443014,
    "lat": 43.0993
  },
  {
    "lng": -93.6170448,
    "lat": 42.0267567
  },
  {
    "lng": 2.30551,
    "lat": 48.9026
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 0.7652218,
    "lat": 45.8520668
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 4.338636,
    "lat": 50.8545959
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -75.2882893,
    "lat": 40.004128
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 23.7603118,
    "lat": 61.4980214
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 9.7385532,
    "lat": 52.3744779
  },
  {
    "lng": 8.6736295,
    "lat": 49.8851869
  },
  {
    "lng": -76.0493684,
    "lat": 42.098408
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -86.2094342,
    "lat": 35.3620235
  },
  {
    "lng": -78.219615,
    "lat": 0.3316022
  },
  {
    "lng": 9.0078266,
    "lat": 50.0818411
  },
  {
    "lng": -7.6991779,
    "lat": 52.3611009
  },
  {
    "lng": -78.3990378,
    "lat": 35.5882559
  },
  {
    "lng": -119.2790529,
    "lat": 50.7005059
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.8121191,
    "lat": 39.9547861
  },
  {
    "lng": -74.4113926,
    "lat": 40.518157
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -73.2006687,
    "lat": 40.8559314
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -91.6704053,
    "lat": 41.9758872
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": -3.0509812,
    "lat": 53.8179442
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -117.290039,
    "lat": 49.494891
  },
  {
    "lng": -84.6102213,
    "lat": 38.8756194
  },
  {
    "lng": 153.1490383,
    "lat": -27.4392673
  },
  {
    "lng": 34.7818064,
    "lat": 32.0852997
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": 4.09203,
    "lat": 46.0205
  },
  {
    "lng": -77.2651762,
    "lat": 38.9013729
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.6292018,
    "lat": 38.7927405
  },
  {
    "lng": -80.9818016,
    "lat": 43.3700899
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.6124179,
    "lat": 33.4270275
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -103.228023,
    "lat": 44.0806041
  },
  {
    "lng": -73.0454164,
    "lat": 40.871241
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -70.6154965,
    "lat": 41.7452589
  },
  {
    "lng": 1.3549991,
    "lat": 44.0175835
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 77.3272147,
    "lat": 28.5706333
  },
  {
    "lng": -71.5517636,
    "lat": -33.0244535
  },
  {
    "lng": 5.2828123,
    "lat": 45.5872259
  },
  {
    "lng": 6.929204,
    "lat": 51.521581
  },
  {
    "lng": -74.3148279,
    "lat": 40.6233995
  },
  {
    "lng": 4.0565359,
    "lat": 48.2931517
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -71.2661597,
    "lat": 41.6770463
  },
  {
    "lng": 7.8191185,
    "lat": 51.681281
  },
  {
    "lng": -86.8689419,
    "lat": 35.925206
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -72.0337376,
    "lat": 42.0750465
  },
  {
    "lng": -121.173921,
    "lat": 44.2726203
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -77.443014,
    "lat": 43.0993
  },
  {
    "lng": -122.2433113,
    "lat": 49.0699667
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -0.3775015,
    "lat": 51.5060205
  },
  {
    "lng": -81.9498042,
    "lat": 28.0394654
  },
  {
    "lng": 6.8514435,
    "lat": 51.4696137
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": 6.996379,
    "lat": 49.234362
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -4.2660965,
    "lat": 55.4540605
  },
  {
    "lng": -0.5038294,
    "lat": 51.392296
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -77.5626132,
    "lat": 39.913338
  },
  {
    "lng": -122.5316686,
    "lat": 37.9747795
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -73.9897782,
    "lat": 41.1509835
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 8.5980265,
    "lat": 50.2363508
  },
  {
    "lng": -156.4549898,
    "lat": 20.7476261
  },
  {
    "lng": -2.0822333,
    "lat": 52.5700229
  },
  {
    "lng": -117.2233069,
    "lat": 33.3663105
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -76.6148148,
    "lat": 39.3964591
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -123.1110551,
    "lat": 45.5190404
  },
  {
    "lng": 30.7208911,
    "lat": 36.8888637
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": 28.9758715,
    "lat": 41.006381
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -87.0604487,
    "lat": 41.4672552
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.951183,
    "lat": 39.0022605
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": -92.081509,
    "lat": 30.5335302
  },
  {
    "lng": -3.1029086,
    "lat": 51.0147895
  },
  {
    "lng": -70.5587024,
    "lat": 41.5786678
  },
  {
    "lng": -73.7853915,
    "lat": 43.0821793
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -119.119919,
    "lat": 46.2087066
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -1.5135474,
    "lat": 52.400739
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -90.2417806,
    "lat": 29.9942265
  },
  {
    "lng": -78.4297365,
    "lat": 40.3575744
  },
  {
    "lng": -97.827833,
    "lat": 30.5217116
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 57.36914,
    "lat": -20.2789702
  },
  {
    "lng": 2.2695658,
    "lat": 48.884683
  },
  {
    "lng": -95.8833235,
    "lat": 35.9420431
  },
  {
    "lng": -89.0442238,
    "lat": 43.3873717
  },
  {
    "lng": 5.4768915,
    "lat": 52.5150949
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -72.5976987,
    "lat": 41.9791024
  },
  {
    "lng": -85.2559398,
    "lat": 34.0124425
  },
  {
    "lng": -1.0935837,
    "lat": 45.9883689
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": -89.953157,
    "lat": 38.8114364
  },
  {
    "lng": -5.1468484,
    "lat": 36.4268068
  },
  {
    "lng": 3.3941795,
    "lat": 6.4550575
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -121.3716178,
    "lat": 38.4087993
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": 2.3872525,
    "lat": 48.8122302
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": 24.7453688,
    "lat": 59.4372155
  },
  {
    "lng": -110.2997756,
    "lat": 31.5545973
  },
  {
    "lng": -119.702667,
    "lat": 34.4221319
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.8940505,
    "lat": 45.3128048
  },
  {
    "lng": -84.7996573,
    "lat": 33.3806716
  },
  {
    "lng": -1.4652044,
    "lat": 47.2155058
  },
  {
    "lng": -0.4804579,
    "lat": 52.6519973
  },
  {
    "lng": -121.2357828,
    "lat": 38.7907339
  },
  {
    "lng": 5.1925264,
    "lat": 45.90363
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -122.4929452,
    "lat": 47.2419677
  },
  {
    "lng": 12.9990874,
    "lat": 55.882914
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": -120.339415,
    "lat": 50.6758269
  },
  {
    "lng": 8.9520281,
    "lat": 46.0050102
  },
  {
    "lng": 104.9224426,
    "lat": 11.568271
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 50.0490975,
    "lat": 40.4728104
  },
  {
    "lng": 110.4229104,
    "lat": -6.9903988
  },
  {
    "lng": -72.8992932,
    "lat": 41.3943921
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -5.8408396,
    "lat": 37.3397709
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -105.0811573,
    "lat": 39.8005505
  },
  {
    "lng": -82.5594293,
    "lat": 36.550238
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": -87.7521069,
    "lat": 42.0262972
  },
  {
    "lng": 147.3281233,
    "lat": -42.8825088
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -1.5592776,
    "lat": 43.4832523
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -82.6359078,
    "lat": 27.7700475
  },
  {
    "lng": 7.0960124,
    "lat": 51.5110321
  },
  {
    "lng": 2.334267,
    "lat": 48.911729
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -83.9478911,
    "lat": 42.0554875
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -4.2412484,
    "lat": 50.8309593
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -0.1991229,
    "lat": 51.4989948
  },
  {
    "lng": -106.4244938,
    "lat": 36.1780125
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 6.6055827,
    "lat": 46.534566
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -1.1472098,
    "lat": 44.7951052
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -80.399513,
    "lat": 26.1003392
  },
  {
    "lng": 6.3676062,
    "lat": 49.5442267
  },
  {
    "lng": -86.8024491,
    "lat": 33.6054626
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -3.5211361,
    "lat": 50.4652392
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 9.7385532,
    "lat": 52.3744779
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -93.9993505,
    "lat": 44.1634663
  },
  {
    "lng": 6.8081935,
    "lat": 50.9096219
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -75.546589,
    "lat": 39.7459468
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 4.4196718,
    "lat": 44.0121279
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -8.6058415,
    "lat": 41.1300103
  },
  {
    "lng": 19.428333,
    "lat": -34.23
  },
  {
    "lng": -122.2566367,
    "lat": 38.1040864
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": -97.9405828,
    "lat": 29.8826436
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.2057067,
    "lat": 51.2376557
  },
  {
    "lng": -72.1578243,
    "lat": 41.6993535
  },
  {
    "lng": 8.7376029,
    "lat": 41.9263991
  },
  {
    "lng": -2.4476231,
    "lat": 51.2919489
  },
  {
    "lng": -73.7826363,
    "lat": 40.9115386
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -89.0936778,
    "lat": 38.960601
  },
  {
    "lng": -83.5657167,
    "lat": 35.8672932
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -2.0160287,
    "lat": 53.9618497
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": 25.2829111,
    "lat": 54.6870458
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -1.0287636,
    "lat": 45.6245332
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": 0.0249248,
    "lat": 51.5495236
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -117.826166,
    "lat": 33.7458511
  },
  {
    "lng": -78.1652404,
    "lat": 39.1852184
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 8.7397624,
    "lat": 48.7142691
  },
  {
    "lng": -80.0666026,
    "lat": 26.5256179
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": -82.7192671,
    "lat": 28.2441768
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -1.4722242,
    "lat": 47.1685211
  },
  {
    "lng": 3.3995767,
    "lat": 47.9812486
  },
  {
    "lng": -73.9701382,
    "lat": 40.8509333
  },
  {
    "lng": -87.5715641,
    "lat": 37.970495
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -80.1762704,
    "lat": 33.0186699
  },
  {
    "lng": -8.08053,
    "lat": 40.51642
  },
  {
    "lng": -70.7939307,
    "lat": 42.1617681
  },
  {
    "lng": -58.6351056,
    "lat": -34.4537215
  },
  {
    "lng": -74.3177933,
    "lat": 41.0461864
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -2.9184744,
    "lat": 47.6199988
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 2.2674892,
    "lat": 48.9148269
  },
  {
    "lng": 9.2794469,
    "lat": 41.5911382
  },
  {
    "lng": 4.8855966,
    "lat": 45.6977109
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.9367107,
    "lat": 40.5584882
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -0.0154152,
    "lat": 51.4781086
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -85.1386015,
    "lat": 41.0799898
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 1.2644847,
    "lat": 45.8354243
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -73.8162354,
    "lat": 42.4684148
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -103.799951,
    "lat": 40.2502582
  },
  {
    "lng": 7.4652789,
    "lat": 51.5142273
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": -77.3464516,
    "lat": 38.953282
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -72.6077753,
    "lat": 41.7148499
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -76.8485094,
    "lat": 39.0984317
  },
  {
    "lng": 8.9520281,
    "lat": 46.0050102
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": 12.7626208,
    "lat": 48.4031909
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": 0.0949036,
    "lat": 51.7685568
  },
  {
    "lng": -2.7603283,
    "lat": 48.5141134
  },
  {
    "lng": -0.0154152,
    "lat": 51.4781086
  },
  {
    "lng": -0.3281887,
    "lat": 51.4467444
  },
  {
    "lng": -76.5483724,
    "lat": 42.4374175
  },
  {
    "lng": -75.2995777,
    "lat": 40.2796371
  },
  {
    "lng": -85.3094883,
    "lat": 35.0457219
  },
  {
    "lng": 2.9667,
    "lat": 42.7838039
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -84.0712997,
    "lat": 34.0514898
  },
  {
    "lng": -95.4560512,
    "lat": 30.3118769
  },
  {
    "lng": -87.848085,
    "lat": 41.8228378
  },
  {
    "lng": -81.0557921,
    "lat": 29.2854132
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 6.0812467,
    "lat": 46.1444789
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -92.116219,
    "lat": 32.5025471
  },
  {
    "lng": -1.2620038,
    "lat": 52.3726682
  },
  {
    "lng": -80.2331038,
    "lat": 26.0628665
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -101.6829766,
    "lat": 21.121965
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": 8.446357,
    "lat": 49.9819502
  },
  {
    "lng": 88.3638953,
    "lat": 22.5726459
  },
  {
    "lng": -78.8505516,
    "lat": 35.7325352
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 3.0000288,
    "lat": 49.5805561
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.7659,
    "lat": 40.2203074
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -4.2793767,
    "lat": 36.7162109
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -155.1003754,
    "lat": 19.6854458
  },
  {
    "lng": 9.5294671,
    "lat": 48.8849825
  },
  {
    "lng": -95.9927516,
    "lat": 36.1563122
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -0.3004067,
    "lat": 51.5149803
  },
  {
    "lng": 31.009909,
    "lat": -29.861825
  },
  {
    "lng": -86.075836,
    "lat": 41.6650487
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -94.1574328,
    "lat": 36.0625843
  },
  {
    "lng": -72.6719518,
    "lat": 42.3355692
  },
  {
    "lng": 2.4433101,
    "lat": 44.9285441
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 8.2416556,
    "lat": 50.0820384
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 7.1503312,
    "lat": 43.7228225
  },
  {
    "lng": 28.9758715,
    "lat": 41.006381
  },
  {
    "lng": -112.8331033,
    "lat": 49.6945782
  },
  {
    "lng": 9.4294425,
    "lat": 52.4257979
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -89.5230357,
    "lat": 37.3034933
  },
  {
    "lng": 9.9571081,
    "lat": 49.8565075
  },
  {
    "lng": 0.5537161,
    "lat": 51.8780637
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": -80.1137701,
    "lat": 43.477503
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 0.2781546,
    "lat": 50.7664372
  },
  {
    "lng": -84.9373276,
    "lat": 41.0788904
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -158.016672,
    "lat": 21.5006241
  },
  {
    "lng": 2.4809129,
    "lat": 48.7489857
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.2341028,
    "lat": 42.6875323
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -122.0335624,
    "lat": 37.9768525
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.2493276,
    "lat": 43.5460516
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -6.0410762,
    "lat": 53.1068619
  },
  {
    "lng": -71.6422408,
    "lat": 42.3196015
  },
  {
    "lng": -0.0927317,
    "lat": 51.3758448
  },
  {
    "lng": -111.8627989,
    "lat": 40.5247777
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -82.0609557,
    "lat": 39.3575616
  },
  {
    "lng": 10.1601492,
    "lat": 48.3044877
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -79.4607617,
    "lat": 46.3092115
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 0.3772655,
    "lat": 52.6025943
  },
  {
    "lng": -1.4621381,
    "lat": 53.3783713
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 23.7603118,
    "lat": 61.4980214
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.2440518,
    "lat": 36.0998131
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 5.36109,
    "lat": 61.3187823
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 10.0471189,
    "lat": 48.3251884
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 121.0486254,
    "lat": 14.6510546
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.5244419,
    "lat": 51.6113905
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 5.681781,
    "lat": 45.2325079
  },
  {
    "lng": -2.5221184,
    "lat": 53.0671376
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -77.0047276,
    "lat": 40.2101972
  },
  {
    "lng": -74.4660408,
    "lat": 40.5462553
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 27.9166653,
    "lat": 43.2073873
  },
  {
    "lng": -4.1433925,
    "lat": 50.3780967
  },
  {
    "lng": 4.8920811,
    "lat": 44.9332277
  },
  {
    "lng": -97.6788056,
    "lat": 30.5085915
  },
  {
    "lng": 13.0591397,
    "lat": 52.4009309
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 7.0534664,
    "lat": 47.7551188
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -82.005019,
    "lat": 39.9401426
  },
  {
    "lng": -84.5898256,
    "lat": 33.3975472
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -122.470042,
    "lat": 38.5052288
  },
  {
    "lng": -106.0433023,
    "lat": 39.6302657
  },
  {
    "lng": -70.082796,
    "lat": 41.7601093
  },
  {
    "lng": 25.2829111,
    "lat": 54.6870458
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 11.5129742,
    "lat": 51.0227878
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -106.660767,
    "lat": 52.131802
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 8.4381568,
    "lat": 49.4704113
  },
  {
    "lng": 0.6889268,
    "lat": 47.3900474
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -121.7529071,
    "lat": 36.9092773
  },
  {
    "lng": 2.3226987,
    "lat": 48.8658525
  },
  {
    "lng": 1.3009485,
    "lat": 38.9830568
  },
  {
    "lng": 4.8380426,
    "lat": 47.0239064
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -80.5222961,
    "lat": 43.4652699
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -82.5603625,
    "lat": 35.6967238
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 120.9817861,
    "lat": 14.4809012
  },
  {
    "lng": 5.5703031,
    "lat": 43.2924385
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -105.016649,
    "lat": 39.613321
  },
  {
    "lng": -106.82356,
    "lat": 39.1911128
  },
  {
    "lng": -72.6311006,
    "lat": 42.3178989
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": -0.3394758,
    "lat": 53.7435722
  },
  {
    "lng": 2.4343549,
    "lat": 48.9409151
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": -77.2651762,
    "lat": 38.9013729
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.3699697,
    "lat": 50.8115402
  },
  {
    "lng": 3.4302412,
    "lat": 43.6263176
  },
  {
    "lng": -81.5345547,
    "lat": 28.4944695
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -79.5923855,
    "lat": 43.7848982
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 110.3646857,
    "lat": -7.8012646
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -80.1494901,
    "lat": 26.0112014
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.2127011,
    "lat": 47.9793437
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -81.1881557,
    "lat": 37.7781702
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 10.327678,
    "lat": 36.8790882
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -83.1596108,
    "lat": 40.033814
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 1.1239654,
    "lat": 49.4222278
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -99.5069922,
    "lat": 27.5075005
  },
  {
    "lng": 10.7861682,
    "lat": 52.4205588
  },
  {
    "lng": -81.7942944,
    "lat": 26.1421976
  },
  {
    "lng": -122.0322895,
    "lat": 37.3228934
  },
  {
    "lng": -73.8987469,
    "lat": 40.9312099
  },
  {
    "lng": -77.1956331,
    "lat": 39.0180508
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 33.3638783,
    "lat": 35.1746503
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -1.4315213,
    "lat": 43.6403659
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -118.3935254,
    "lat": 33.8897798
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 6.0820639,
    "lat": 44.5612032
  },
  {
    "lng": -78.6891675,
    "lat": 43.9122995
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 12.138218,
    "lat": 55.5101491
  },
  {
    "lng": 36.828842,
    "lat": -1.3026148
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 7.6120793,
    "lat": 47.6056484
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.1332853,
    "lat": 50.9575365
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -105.089705,
    "lat": 39.9935959
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -0.8324037,
    "lat": 51.4120318
  },
  {
    "lng": 4.8855966,
    "lat": 45.6977109
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -122.2034496,
    "lat": 47.4799078
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 7.6483815,
    "lat": 48.0439812
  },
  {
    "lng": 32.5826451,
    "lat": -25.906355
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": 8.7704695,
    "lat": 50.8090106
  },
  {
    "lng": -83.2910468,
    "lat": 42.6389216
  },
  {
    "lng": -74.7659,
    "lat": 40.2203074
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -89.1618188,
    "lat": 54.0245941
  },
  {
    "lng": 4.6111981,
    "lat": 52.4574236
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": -96.6227714,
    "lat": 32.7287413
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -0.3394758,
    "lat": 53.7435722
  },
  {
    "lng": -4.2412484,
    "lat": 50.8309593
  },
  {
    "lng": -113.584131,
    "lat": 37.104153
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -71.1522766,
    "lat": 42.4792618
  },
  {
    "lng": -92.0095079,
    "lat": 41.6612394
  },
  {
    "lng": 28.37,
    "lat": -26.235278
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -86.5705084,
    "lat": 30.7621326
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -86.9080655,
    "lat": 40.4258686
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -112.3842224,
    "lat": 33.4674695
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 12.4483489,
    "lat": 55.6898267
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 73.5301042,
    "lat": 4.1961894
  },
  {
    "lng": -81.5856742,
    "lat": 28.5656649
  },
  {
    "lng": -59.1555837,
    "lat": -37.297371
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -96.4066987,
    "lat": 32.8923464
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -80.1494901,
    "lat": 26.0112014
  },
  {
    "lng": 6.5928442,
    "lat": 46.5349093
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 6.840984,
    "lat": 46.8978306
  },
  {
    "lng": -0.5023006,
    "lat": 45.0496567
  },
  {
    "lng": 25.2829111,
    "lat": 54.6870458
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -75.4712794,
    "lat": 40.6022059
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -78.4766781,
    "lat": 38.029306
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": 0.739923,
    "lat": 47.3577
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 11.3426327,
    "lat": 44.4938203
  },
  {
    "lng": 9.0035455,
    "lat": 48.7084162
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -118.3878945,
    "lat": 34.2204227
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -77.4347283,
    "lat": 38.837613
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -89.0226793,
    "lat": 42.6829765
  },
  {
    "lng": -105.016649,
    "lat": 39.613321
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": 17.766667,
    "lat": 59.416667
  },
  {
    "lng": 7.335124,
    "lat": 51.4370171
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -74.8023882,
    "lat": 41.322316
  },
  {
    "lng": 18.798327,
    "lat": 54.4288032
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.985181,
    "lat": 39.8695516
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 11.2655684,
    "lat": 47.4429543
  },
  {
    "lng": -82.2880508,
    "lat": 27.928464
  },
  {
    "lng": -93.2169807,
    "lat": 30.2305095
  },
  {
    "lng": -87.8735662,
    "lat": 41.81483
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -117.566444,
    "lat": 33.8752945
  },
  {
    "lng": -74.5143232,
    "lat": 40.9012101
  },
  {
    "lng": -76.42977,
    "lat": 36.9775016
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.4439254,
    "lat": 40.4951365
  },
  {
    "lng": -75.1515534,
    "lat": 40.103196
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -51.0261927,
    "lat": -30.0819338
  },
  {
    "lng": -71.4165905,
    "lat": 42.2773177
  },
  {
    "lng": 4.490519,
    "lat": 52.2629093
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -71.6422408,
    "lat": 42.3196015
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.6267842,
    "lat": 41.6147605
  },
  {
    "lng": 20.4568974,
    "lat": 44.8178131
  },
  {
    "lng": 78.4740613,
    "lat": 17.360589
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -122.2270272,
    "lat": 47.3826903
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 7.089351,
    "lat": 49.4305056
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -59.1152598,
    "lat": -34.5661734
  },
  {
    "lng": -74.171811,
    "lat": 40.9167654
  },
  {
    "lng": 10.0228291,
    "lat": 57.1095604
  },
  {
    "lng": -98.8082745,
    "lat": 19.32929
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 17.1314203,
    "lat": 48.1557669
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 4.8138874,
    "lat": 44.4225104
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 36.828842,
    "lat": -1.3026148
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -98.1561192,
    "lat": 29.1335781
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -71.1843236,
    "lat": 42.3652518
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -117.6483876,
    "lat": 34.09751
  },
  {
    "lng": -1.9417444,
    "lat": 52.3057655
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": 8.6124721,
    "lat": 47.2905574
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": 32.8540497,
    "lat": 39.9207759
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -114.6179954,
    "lat": 32.723268
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 91.8344348,
    "lat": 22.333778
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 6.996379,
    "lat": 49.234362
  },
  {
    "lng": 13.2807255,
    "lat": 52.6732755
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.3085329,
    "lat": 42.6414437
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 55.4135962,
    "lat": -21.2840124
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.4164807,
    "lat": 41.45011
  },
  {
    "lng": -4.4216366,
    "lat": 36.7213028
  },
  {
    "lng": -74.417097,
    "lat": 40.7598227
  },
  {
    "lng": 5.36109,
    "lat": 61.3187823
  },
  {
    "lng": -87.8212263,
    "lat": 42.5846773
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -77.4347283,
    "lat": 38.837613
  },
  {
    "lng": -3.2570517,
    "lat": 54.0979084
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -3.5995337,
    "lat": 37.1734995
  },
  {
    "lng": -68.7713289,
    "lat": 44.8016255
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 127.8573107,
    "lat": 26.3791496
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -118.852583,
    "lat": 36.2516475
  },
  {
    "lng": -117.3136547,
    "lat": 34.0739016
  },
  {
    "lng": -75.5463673,
    "lat": 44.8433048
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": 8.5828944,
    "lat": 52.2004727
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -119.0779359,
    "lat": 34.4458248
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -97.8417144,
    "lat": 30.082475
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -73.2584121,
    "lat": 41.1428951
  },
  {
    "lng": 10.8768728,
    "lat": 48.0497474
  },
  {
    "lng": -123.137414,
    "lat": 49.163168
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": -79.6142224,
    "lat": 37.188635
  },
  {
    "lng": -5.273032,
    "lat": 50.1016731
  },
  {
    "lng": 7.9492262,
    "lat": 47.9770172
  },
  {
    "lng": 7.444639,
    "lat": 51.7717757
  },
  {
    "lng": -79.5341802,
    "lat": 8.9714493
  },
  {
    "lng": -79.666672,
    "lat": 43.447436
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -86.8254383,
    "lat": 21.1855431
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -75.644567,
    "lat": 45.0154164
  },
  {
    "lng": -1.6171001,
    "lat": 54.9751321
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -96.6536701,
    "lat": 49.6711222
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -118.3845942,
    "lat": 33.8398289
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -82.7896471,
    "lat": 40.733795
  },
  {
    "lng": 101.0244136,
    "lat": 13.1416329
  },
  {
    "lng": -90.1830408,
    "lat": 32.2998686
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -68.6161357,
    "lat": 44.3036899
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": 4.031926,
    "lat": 49.2577886
  },
  {
    "lng": 2.2956951,
    "lat": 49.8941708
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -117.3703235,
    "lat": 34.1064001
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 77.401989,
    "lat": 23.2584857
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -105.101928,
    "lat": 40.1672117
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": 11.8627403,
    "lat": 45.3951113
  },
  {
    "lng": 4.6111981,
    "lat": 52.4574236
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.844117,
    "lat": 42.6870896
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": 147.3281233,
    "lat": -42.8825088
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -86.3921096,
    "lat": 35.8460396
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -70.5587024,
    "lat": 41.5786678
  },
  {
    "lng": -75.7652424,
    "lat": 39.9829308
  },
  {
    "lng": 6.4053868,
    "lat": 46.2087237
  },
  {
    "lng": -2.3596963,
    "lat": 51.3813864
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -76.9429182,
    "lat": 39.2065447
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -70.2586618,
    "lat": 43.6573605
  },
  {
    "lng": -71.0683741,
    "lat": 42.4268484
  },
  {
    "lng": -74.7659,
    "lat": 40.2203074
  },
  {
    "lng": -119.2790529,
    "lat": 50.7005059
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 5.4804956,
    "lat": 43.6003084
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -80.2493276,
    "lat": 43.5460516
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -111.4979963,
    "lat": 40.6460921
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": -74.1337508,
    "lat": 42.1956438
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 8.9668368,
    "lat": 52.3756616
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -1.4264097,
    "lat": 53.2352134
  },
  {
    "lng": -93.3204872,
    "lat": 44.8322405
  },
  {
    "lng": -71.0119948,
    "lat": 42.4084302
  },
  {
    "lng": -77.795367,
    "lat": 38.7135498
  },
  {
    "lng": -2.9184744,
    "lat": 47.6199988
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": -80.2533838,
    "lat": 35.8240265
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 16.5720327,
    "lat": 48.5694535
  },
  {
    "lng": 1.9988356,
    "lat": 48.7760957
  },
  {
    "lng": -117.8722311,
    "lat": 33.750631
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -72.1934184,
    "lat": 41.3212481
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -77.443014,
    "lat": 43.0993
  },
  {
    "lng": -83.396897,
    "lat": 43.491132
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 8.4673098,
    "lat": 49.4892913
  },
  {
    "lng": -77.4309829,
    "lat": 34.7509962
  },
  {
    "lng": 4.3731644,
    "lat": 50.6872135
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -16.9086783,
    "lat": 32.6496497
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.5135474,
    "lat": 52.400739
  },
  {
    "lng": -82.9295287,
    "lat": 40.126139
  },
  {
    "lng": -71.1551119,
    "lat": 42.3473519
  },
  {
    "lng": -3.2299102,
    "lat": 51.6489468
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": 2.2958034,
    "lat": 48.753613
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -119.7487235,
    "lat": 39.5404679
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -8.4726423,
    "lat": 51.8985136
  },
  {
    "lng": 3.3331703,
    "lat": 46.5660526
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -112.3842224,
    "lat": 33.4674695
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -67.4752615,
    "lat": -45.8632024
  },
  {
    "lng": -122.5681191,
    "lat": 38.1061979
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -58.5559691,
    "lat": -34.5509077
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -86.0085955,
    "lat": 40.0455918
  },
  {
    "lng": -123.033121,
    "lat": 44.9391565
  },
  {
    "lng": -118.396466,
    "lat": 34.0211224
  },
  {
    "lng": -84.5084835,
    "lat": 41.3203058
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -88.4474302,
    "lat": 42.3147529
  },
  {
    "lng": 11.5049302,
    "lat": 48.5003308
  },
  {
    "lng": 17.9500556,
    "lat": 59.4293164
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": -88.3147539,
    "lat": 41.7571701
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": 4.5999778,
    "lat": 51.8714812
  },
  {
    "lng": 16.3572556,
    "lat": 48.3096359
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -119.702667,
    "lat": 34.4221319
  },
  {
    "lng": 7.749254,
    "lat": 46.0212076
  },
  {
    "lng": -73.0438362,
    "lat": 41.5538091
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -16.2507843,
    "lat": 28.467178
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -8.6103497,
    "lat": 41.1502195
  },
  {
    "lng": -81.7355692,
    "lat": 41.3822398
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -118.0879763,
    "lat": 34.0676169
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": -73.9283672,
    "lat": 41.7065539
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 0.487531,
    "lat": 44.8534568
  },
  {
    "lng": -120.832348,
    "lat": 35.3107214
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -89.1528176,
    "lat": 30.3504751
  },
  {
    "lng": -117.3008784,
    "lat": 34.4263886
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 4.3600687,
    "lat": 43.8374249
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": -117.9294401,
    "lat": 33.6170092
  },
  {
    "lng": -75.1256812,
    "lat": 40.0959385
  },
  {
    "lng": -94.626497,
    "lat": 39.1134562
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 4.3600687,
    "lat": 43.8374249
  },
  {
    "lng": -122.989827,
    "lat": 45.5228939
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -87.2169149,
    "lat": 30.421309
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -111.841185,
    "lat": 33.3062031
  },
  {
    "lng": -118.2918113,
    "lat": 33.8815702
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": 30.7030242,
    "lat": 36.8865728
  },
  {
    "lng": 73.0923253,
    "lat": 31.4220558
  },
  {
    "lng": -4.728605,
    "lat": 41.6521807
  },
  {
    "lng": -79.2380322,
    "lat": 42.0965167
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": 107.0867363,
    "lat": 10.3535221
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -77.7105332,
    "lat": 34.3676686
  },
  {
    "lng": 10.8815262,
    "lat": 49.5710376
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 144.3598241,
    "lat": -38.1493248
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -83.6117646,
    "lat": 42.241051
  },
  {
    "lng": -120.339415,
    "lat": 50.6758269
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 121.0486254,
    "lat": 14.6510546
  },
  {
    "lng": -4.1433925,
    "lat": 50.3780967
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -123.3272489,
    "lat": 42.4393707
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 104.9224426,
    "lat": 11.568271
  },
  {
    "lng": 0.714368,
    "lat": 47.3390872
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 151.3120675,
    "lat": -33.3117096
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": 10.1596948,
    "lat": 56.1220185
  },
  {
    "lng": 11.3927685,
    "lat": 47.2654296
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -121.9856782,
    "lat": 47.7423219
  },
  {
    "lng": -85.784453,
    "lat": 42.2094839
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -73.5512469,
    "lat": 40.6523325
  },
  {
    "lng": 3.7250121,
    "lat": 51.0538286
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": -0.4011868,
    "lat": 54.2820009
  },
  {
    "lng": -49.2532691,
    "lat": -16.680882
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -75.9206345,
    "lat": 45.2584759
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": 6.9239103,
    "lat": 43.6589011
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -78.3199496,
    "lat": 44.3048009
  },
  {
    "lng": 5.0297213,
    "lat": 43.695131
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -73.8645734,
    "lat": 42.2173102
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.43736,
    "lat": 44.85028
  },
  {
    "lng": 44.3953896,
    "lat": 35.4719308
  },
  {
    "lng": -71.1244966,
    "lat": 42.2912093
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -118.1085554,
    "lat": 34.0990995
  },
  {
    "lng": -1.5518632,
    "lat": 47.2996846
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.8409057,
    "lat": 41.2736163
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -122.2070775,
    "lat": 47.6765382
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -1.4315213,
    "lat": 43.6403659
  },
  {
    "lng": -97.4394816,
    "lat": 35.2225717
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": -78.1677784,
    "lat": 43.9595998
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": -99.3698995,
    "lat": 40.4379956
  },
  {
    "lng": -84.2809332,
    "lat": 30.4380832
  },
  {
    "lng": -74.1143091,
    "lat": 40.6687141
  },
  {
    "lng": -97.9647269,
    "lat": 29.5688411
  },
  {
    "lng": -0.7734022,
    "lat": 48.0706687
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": -75.9279495,
    "lat": 40.335345
  },
  {
    "lng": 87.6380633,
    "lat": 26.6637932
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": 12.5051413,
    "lat": 55.7718649
  },
  {
    "lng": -89.2897646,
    "lat": 43.0123487
  },
  {
    "lng": -122.9146292,
    "lat": 49.2041754
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -5.2276468,
    "lat": 50.233989
  },
  {
    "lng": -81.275054,
    "lat": 33.8986841
  },
  {
    "lng": -120.7678602,
    "lat": 37.1641544
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -3.028878,
    "lat": 52.2029156
  },
  {
    "lng": -112.185994,
    "lat": 33.5386858
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.748344,
    "lat": 48.8741286
  },
  {
    "lng": -77.7191081,
    "lat": 39.6430455
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": -69.942111,
    "lat": 18.4801972
  },
  {
    "lng": -90.3215983,
    "lat": 32.3410552
  },
  {
    "lng": -93.161159,
    "lat": 44.4582041
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -3.1791934,
    "lat": 51.4816546
  },
  {
    "lng": -74.4113926,
    "lat": 40.518157
  },
  {
    "lng": -82.3269883,
    "lat": 27.871197
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 9.4616921,
    "lat": 52.5045772
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 33.8307062,
    "lat": 27.222556
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -2.7599079,
    "lat": 47.6586772
  },
  {
    "lng": -84.4310645,
    "lat": 10.3267699
  },
  {
    "lng": 10.7807299,
    "lat": 48.7180364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.677556,
    "lat": 39.049011
  },
  {
    "lng": -80.9450759,
    "lat": 35.0073697
  },
  {
    "lng": -0.4675041,
    "lat": 52.1363806
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 21.0714322,
    "lat": 52.2337172
  },
  {
    "lng": 4.0328094,
    "lat": 45.204168
  },
  {
    "lng": 12.4985492,
    "lat": 55.704111
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 146.9135265,
    "lat": -36.0737734
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -2.2138905,
    "lat": 47.2733517
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -117.147366,
    "lat": 33.4946353
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -0.3004067,
    "lat": 51.5149803
  },
  {
    "lng": -76.7074042,
    "lat": 37.2708788
  },
  {
    "lng": -111.8953815,
    "lat": 40.5710454
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -122.3455263,
    "lat": 37.9621457
  },
  {
    "lng": 12.9569266,
    "lat": 52.2288191
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 4.3628851,
    "lat": 48.9566218
  },
  {
    "lng": 123.0250585,
    "lat": 10.6163458
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.4381568,
    "lat": 49.4704113
  },
  {
    "lng": -0.0472059,
    "lat": 38.6028245
  },
  {
    "lng": 101.6454202,
    "lat": 3.0988792
  },
  {
    "lng": 17.965219,
    "lat": 40.335126
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -74.4113926,
    "lat": 40.518157
  },
  {
    "lng": -73.1867391,
    "lat": 41.1779095
  },
  {
    "lng": -4.0816846,
    "lat": 52.4143113
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -84.2747329,
    "lat": 34.0709576
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -113.584131,
    "lat": 37.104153
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 14.2487679,
    "lat": 40.8358846
  },
  {
    "lng": -2.7990345,
    "lat": 54.0484068
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 23.6470593,
    "lat": 37.9431594
  },
  {
    "lng": -156.3103925,
    "lat": 20.8539162
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -90.3567669,
    "lat": 37.4914691
  },
  {
    "lng": 6.7871219,
    "lat": 50.6612623
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 11.3927685,
    "lat": 47.2654296
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 50.1039991,
    "lat": 26.4367824
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 7.6580337,
    "lat": 47.8736185
  },
  {
    "lng": 10.3678235,
    "lat": 53.4374683
  },
  {
    "lng": -86.1090828,
    "lat": 42.7876022
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -83.4675021,
    "lat": 42.3712
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -80.6923169,
    "lat": 32.3850708
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -0.3623924,
    "lat": 51.4619551
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -119.593249,
    "lat": 49.5003268
  },
  {
    "lng": 150.89385,
    "lat": -34.4243941
  },
  {
    "lng": 0.0930414,
    "lat": 50.9705836
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -111.789037,
    "lat": 33.3527632
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": -1.5149935,
    "lat": 43.4813927
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -109.92006,
    "lat": 22.8938884
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -1.607077,
    "lat": 48.2630217
  },
  {
    "lng": -76.4537302,
    "lat": 41.0044958
  },
  {
    "lng": -120.339415,
    "lat": 50.6758269
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.0415528,
    "lat": 39.9980022
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 8.531245,
    "lat": 50.570561
  },
  {
    "lng": -83.9890066,
    "lat": 33.9566391
  },
  {
    "lng": 11.8734455,
    "lat": 45.4077172
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 8.4259004,
    "lat": 47.384708
  },
  {
    "lng": -86.1283681,
    "lat": 39.9784186
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -79.756817,
    "lat": 34.1280501
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -122.0335624,
    "lat": 37.9768525
  },
  {
    "lng": 9.7037748,
    "lat": 48.6967865
  },
  {
    "lng": -117.9294401,
    "lat": 33.6170092
  },
  {
    "lng": -0.2427217,
    "lat": 44.9133742
  },
  {
    "lng": -70.8967226,
    "lat": 42.5195292
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -77.6473195,
    "lat": 37.486806
  },
  {
    "lng": -155.66391,
    "lat": 20.020452
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -89.0226793,
    "lat": 42.6829765
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 0.2207441,
    "lat": 51.5617734
  },
  {
    "lng": -99.7414869,
    "lat": 40.7788486
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -97.8772103,
    "lat": 29.9892928
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -87.0717718,
    "lat": 20.6269889
  },
  {
    "lng": -123.1059324,
    "lat": 44.6365071
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -0.4440957,
    "lat": 44.9954151
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -93.2349489,
    "lat": 45.1607987
  },
  {
    "lng": -106.660767,
    "lat": 52.131802
  },
  {
    "lng": 8.849423,
    "lat": 53.0684356
  },
  {
    "lng": 121.0589931,
    "lat": 14.5637482
  },
  {
    "lng": -86.621443,
    "lat": 36.3049177
  },
  {
    "lng": -102.5722706,
    "lat": 22.7753891
  },
  {
    "lng": 0.2255168,
    "lat": 49.1460831
  },
  {
    "lng": -0.7449925,
    "lat": 51.4143513
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -78.8900409,
    "lat": 33.6956461
  },
  {
    "lng": -0.23054,
    "lat": 51.408966
  },
  {
    "lng": 8.554163,
    "lat": 50.8417001
  },
  {
    "lng": -70.2177099,
    "lat": 44.0990717
  },
  {
    "lng": 11.6038619,
    "lat": 52.1885647
  },
  {
    "lng": -74.1979277,
    "lat": 40.7934789
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 8.079534,
    "lat": 47.373166
  },
  {
    "lng": -0.3557651,
    "lat": 44.6508185
  },
  {
    "lng": -94.8907869,
    "lat": 47.4785418
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -117.929416,
    "lat": 33.8708215
  },
  {
    "lng": -91.5299106,
    "lat": 41.6612561
  },
  {
    "lng": 9.6541116,
    "lat": 48.7031377
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -83.2965971,
    "lat": 42.3833698
  },
  {
    "lng": -8.3959425,
    "lat": 43.3709703
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 9.4236655,
    "lat": 50.6656227
  },
  {
    "lng": 12.1818964,
    "lat": 55.4565009
  },
  {
    "lng": 115.7393915,
    "lat": -32.3006647
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.2250324,
    "lat": 46.2051192
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -123.0737925,
    "lat": 49.3206294
  },
  {
    "lng": -2.8908955,
    "lat": 53.1908873
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -3.5505644,
    "lat": 47.8692882
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -117.64843,
    "lat": 34.065846
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.7785644,
    "lat": 45.7754498
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": -118.3935254,
    "lat": 33.8897798
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": 6.1226129,
    "lat": 46.1758901
  },
  {
    "lng": -9.0490601,
    "lat": 53.2744122
  },
  {
    "lng": -94.1574328,
    "lat": 36.0625843
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -75.4179623,
    "lat": 41.1770316
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.1296075,
    "lat": 48.8063265
  },
  {
    "lng": 2.510611,
    "lat": 48.8137847
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.6279321,
    "lat": 41.5571178
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 7.4652789,
    "lat": 51.5142273
  },
  {
    "lng": -73.9695409,
    "lat": 41.5048402
  },
  {
    "lng": -81.243372,
    "lat": 42.9832406
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.32931,
    "lat": 51.2955044
  },
  {
    "lng": -117.690075,
    "lat": 34.0133561
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -92.0490096,
    "lat": 30.317144
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.789037,
    "lat": 33.3527632
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -79.9414313,
    "lat": 37.270973
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -83.810138,
    "lat": 39.9234046
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 3.2899107,
    "lat": 46.3074423
  },
  {
    "lng": 0.9386329,
    "lat": 52.6802052
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 7.9429235,
    "lat": 48.4695984
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": -75.1438863,
    "lat": 39.770683
  },
  {
    "lng": -70.654259,
    "lat": -33.4626422
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -116.9739167,
    "lat": 32.8383828
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -88.0599986,
    "lat": 44.4493584
  },
  {
    "lng": -82.5508407,
    "lat": 35.595363
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": -71.2084061,
    "lat": 46.8137431
  },
  {
    "lng": 9.6431145,
    "lat": 47.8075299
  },
  {
    "lng": -111.6944313,
    "lat": 40.2981599
  },
  {
    "lng": 6.5928442,
    "lat": 46.5349093
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -93.530214,
    "lat": 47.237166
  },
  {
    "lng": 4.8423304,
    "lat": 45.7969952
  },
  {
    "lng": -98.9736172,
    "lat": 18.8150158
  },
  {
    "lng": -82.8121191,
    "lat": 39.9547861
  },
  {
    "lng": -0.4646064,
    "lat": 46.3239233
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -13.8599051,
    "lat": 28.4993424
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 8.2416556,
    "lat": 50.0820384
  },
  {
    "lng": -1.1246168,
    "lat": 53.3042362
  },
  {
    "lng": 4.3660765,
    "lat": 45.4037177
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -96.8863922,
    "lat": 33.0890094
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -81.6499356,
    "lat": 31.1407032
  },
  {
    "lng": 0.1113306,
    "lat": 43.1607605
  },
  {
    "lng": -2.8277046,
    "lat": 51.3908826
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5424424,
    "lat": 50.8095801
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 31.009909,
    "lat": -29.861825
  },
  {
    "lng": -123.2077861,
    "lat": 39.1501662
  },
  {
    "lng": 8.4673098,
    "lat": 49.4892913
  },
  {
    "lng": -97.1413417,
    "lat": 33.1838787
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.5872286,
    "lat": 42.291707
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -78.9361468,
    "lat": 42.7111701
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -117.760056,
    "lat": 33.9926803
  },
  {
    "lng": -90.1830408,
    "lat": 32.2998686
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -58.7965583,
    "lat": -34.4534551
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -74.0323752,
    "lat": 40.7433066
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.4775114,
    "lat": 51.546655
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -71.2092214,
    "lat": 42.3370414
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.6433146,
    "lat": 42.7269261
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": 6.4779448,
    "lat": 46.3731303
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -2.4251259,
    "lat": 53.5735158
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": 6.0207779,
    "lat": 46.243244
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -81.9468057,
    "lat": 41.3131066
  },
  {
    "lng": -95.7908195,
    "lat": 36.0525993
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -79.05578,
    "lat": 35.9131542
  },
  {
    "lng": 7.5943951,
    "lat": 50.3533278
  },
  {
    "lng": -123.3417381,
    "lat": 43.216505
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 103.8500437,
    "lat": 1.296168
  },
  {
    "lng": -78.1677784,
    "lat": 43.9595998
  },
  {
    "lng": -95.555513,
    "lat": 33.6617962
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.5707519,
    "lat": 43.4046491
  },
  {
    "lng": -1.1420694,
    "lat": 45.7687967
  },
  {
    "lng": -116.0833144,
    "lat": 34.8253019
  },
  {
    "lng": -122.5681191,
    "lat": 38.1061979
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -118.0879763,
    "lat": 34.0676169
  },
  {
    "lng": 0.1079732,
    "lat": 49.4938975
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -82.3984882,
    "lat": 34.851354
  },
  {
    "lng": 9.1895147,
    "lat": 48.8953937
  },
  {
    "lng": 28.2009844,
    "lat": 47.8392391
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 5.6221058,
    "lat": 6.3330586
  },
  {
    "lng": -0.7465033,
    "lat": 52.0348915
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -120.375716,
    "lat": 35.3540209
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -77.1951755,
    "lat": 38.838703
  },
  {
    "lng": -118.4486675,
    "lat": 34.1866193
  },
  {
    "lng": -80.5607951,
    "lat": 28.0684067
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 43.9837257,
    "lat": 36.1672128
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": 78.4740613,
    "lat": 17.360589
  },
  {
    "lng": 0.8722566,
    "lat": 51.148555
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 6.1042772,
    "lat": 52.2356369
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -123.763124,
    "lat": 49.4721147
  },
  {
    "lng": 5.7455106,
    "lat": 52.0716825
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.1494901,
    "lat": 26.0112014
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 0.5321089,
    "lat": 51.0965459
  },
  {
    "lng": 5.3503555,
    "lat": 60.5110194
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 5.6662814,
    "lat": 51.9663016
  },
  {
    "lng": -71.1631137,
    "lat": 42.7070354
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": 2.1138977,
    "lat": 41.5421013
  },
  {
    "lng": -117.9463717,
    "lat": 33.7746292
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 3.3848084,
    "lat": 39.6046865
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -2.8908955,
    "lat": 53.1908873
  },
  {
    "lng": 2.9469339,
    "lat": 50.4191721
  },
  {
    "lng": 100.4974327,
    "lat": 13.9120701
  },
  {
    "lng": -91.5299106,
    "lat": 41.6612561
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -71.4558911,
    "lat": 41.6603788
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -3.2568304,
    "lat": 54.0977012
  },
  {
    "lng": -77.0849245,
    "lat": 38.9813699
  },
  {
    "lng": -99.157701,
    "lat": 19.3718796
  },
  {
    "lng": -79.7966835,
    "lat": 43.3248924
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -81.6182086,
    "lat": 33.5723191
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -1.1857007,
    "lat": 43.6569623
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -0.0144629,
    "lat": 51.5110713
  },
  {
    "lng": 4.2334587,
    "lat": 48.5161872
  },
  {
    "lng": -2.3742854,
    "lat": 57.2839493
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 8.5461079,
    "lat": 50.2062948
  },
  {
    "lng": -79.5341802,
    "lat": 8.9714493
  },
  {
    "lng": -94.70496,
    "lat": 37.4108841
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -1.548621,
    "lat": 53.794414
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -21.8852649,
    "lat": 64.0975595
  },
  {
    "lng": -110.3158532,
    "lat": 24.1619948
  },
  {
    "lng": -121.9746797,
    "lat": 37.226611
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -122.0215737,
    "lat": 37.5872576
  },
  {
    "lng": -3.5269209,
    "lat": 50.7256138
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.9688855,
    "lat": 54.2485576
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 115.2191175,
    "lat": -8.6524973
  },
  {
    "lng": -82.9780695,
    "lat": 42.2858536
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -111.9395211,
    "lat": 40.6061337
  },
  {
    "lng": -71.5412101,
    "lat": 41.8310404
  },
  {
    "lng": -122.657047,
    "lat": 49.1039289
  },
  {
    "lng": -0.9786725,
    "lat": 51.9983175
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -97.1420308,
    "lat": 32.563487
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.5313816,
    "lat": 38.8898478
  },
  {
    "lng": -77.2651762,
    "lat": 38.9013729
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 132.4758818,
    "lat": 34.3971315
  },
  {
    "lng": 6.3024961,
    "lat": 46.3059806
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 13.08824,
    "lat": 52.5606426
  },
  {
    "lng": -85.5800022,
    "lat": 42.2011538
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 10.0929593,
    "lat": 48.8375607
  },
  {
    "lng": -8.2955712,
    "lat": 41.4417677
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 6.9239103,
    "lat": 43.6589011
  },
  {
    "lng": 11.4738309,
    "lat": 47.29282
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.7087667,
    "lat": 45.9751893
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.0093129,
    "lat": 40.7856117
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.684294,
    "lat": 40.9808209
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": 3.5021158,
    "lat": 43.6499836
  },
  {
    "lng": -121.99059,
    "lat": 37.050096
  },
  {
    "lng": -73.3734547,
    "lat": 40.6867667
  },
  {
    "lng": -76.8861122,
    "lat": 40.2663107
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": 6.8031625,
    "lat": 50.8027168
  },
  {
    "lng": 5.36109,
    "lat": 61.3187823
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": -122.1598465,
    "lat": 37.4443293
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 8.8371266,
    "lat": 50.1438711
  },
  {
    "lng": -2.4791931,
    "lat": 47.2771383
  },
  {
    "lng": 1.6272972,
    "lat": 43.0424295
  },
  {
    "lng": -122.8284874,
    "lat": 47.6395373
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 10.135555,
    "lat": 54.3227085
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -121.899142,
    "lat": 37.6090291
  },
  {
    "lng": 8.4673098,
    "lat": 49.4892913
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -84.5546295,
    "lat": 42.7338254
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.3373021,
    "lat": 48.7790514
  },
  {
    "lng": -87.6651467,
    "lat": 41.5574046
  },
  {
    "lng": -117.3703235,
    "lat": 34.1064001
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -106.660767,
    "lat": 52.131802
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.9194212,
    "lat": 43.839826
  },
  {
    "lng": -77.7485516,
    "lat": 39.9259345
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -79.6443879,
    "lat": 43.5896231
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -122.972545,
    "lat": 49.2433804
  },
  {
    "lng": -81.2084941,
    "lat": 28.6702526
  },
  {
    "lng": -1.7822482,
    "lat": 53.6466645
  },
  {
    "lng": 1.2644847,
    "lat": 45.8354243
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 15.9622315,
    "lat": 45.8426414
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -73.0918715,
    "lat": 41.8580338
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -117.019529,
    "lat": 32.5317397
  },
  {
    "lng": -99.1332716,
    "lat": 19.4933046
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -86.0085955,
    "lat": 40.0455918
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -84.7477136,
    "lat": 33.7514966
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -80.0351117,
    "lat": 43.6340679
  },
  {
    "lng": 2.2465748,
    "lat": 48.9069349
  },
  {
    "lng": -122.1702445,
    "lat": 37.427467
  },
  {
    "lng": -81.330414,
    "lat": 48.477473
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": 6.8444162,
    "lat": 46.753921
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -157.7960716,
    "lat": 21.4055
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 10.1808016,
    "lat": 47.9863099
  },
  {
    "lng": -104.858682,
    "lat": 39.3722552
  },
  {
    "lng": 13.8456344,
    "lat": 58.3896329
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.4659275,
    "lat": 43.6307863
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -121.3153096,
    "lat": 44.0581728
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -3.8492688,
    "lat": 40.1248436
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -0.0786839,
    "lat": 51.6517156
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": 5.0924352,
    "lat": 51.8937356
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -73.7629097,
    "lat": 41.0339862
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -16.9086783,
    "lat": 32.6496497
  },
  {
    "lng": 2.1266886,
    "lat": 48.8035403
  },
  {
    "lng": -99.1955083,
    "lat": 19.5370001
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 6.3702817,
    "lat": 46.264918
  },
  {
    "lng": -2.3655434,
    "lat": 53.7541156
  },
  {
    "lng": -122.33931,
    "lat": 47.313494
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 106.8838584,
    "lat": 47.9081991
  },
  {
    "lng": -71.1040018,
    "lat": 42.3656347
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": 31.009909,
    "lat": -29.861825
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -111.841185,
    "lat": 33.3062031
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -116.9629378,
    "lat": 44.0265525
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -76.8485094,
    "lat": 39.0984317
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.92926,
    "lat": 45.639968
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -70.2586618,
    "lat": 43.6573605
  },
  {
    "lng": -1.4761491,
    "lat": 52.9212617
  },
  {
    "lng": -80.4927815,
    "lat": 43.451291
  },
  {
    "lng": 7.1612669,
    "lat": 46.8055656
  },
  {
    "lng": -122.039966,
    "lat": 38.2493581
  },
  {
    "lng": 2.3872525,
    "lat": 48.8122302
  },
  {
    "lng": -52.7066964,
    "lat": 47.5646794
  },
  {
    "lng": -75.3851334,
    "lat": 40.0947624
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": -71.889038,
    "lat": 45.403271
  },
  {
    "lng": -99.1517322,
    "lat": 19.4414715
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 13.5027631,
    "lat": 59.3809146
  },
  {
    "lng": -58.3016167,
    "lat": -34.7476798
  },
  {
    "lng": 1.3044842,
    "lat": 51.1296508
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -73.9395687,
    "lat": 42.8142432
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.1765814,
    "lat": 35.3137739
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": -0.549372,
    "lat": 42.5692515
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.71573,
    "lat": 25.9372513
  },
  {
    "lng": -113.2857941,
    "lat": 54.7214539
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -93.0552437,
    "lat": 34.5038393
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -122.7141049,
    "lat": 38.4404925
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -72.3102794,
    "lat": 43.6482811
  },
  {
    "lng": -80.2497707,
    "lat": 26.2128609
  },
  {
    "lng": 7.4652789,
    "lat": 51.5142273
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -75.7774177,
    "lat": 40.5173165
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -71.1994976,
    "lat": 42.194543
  },
  {
    "lng": -83.3527097,
    "lat": 42.36837
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -93.2432791,
    "lat": 44.650051
  },
  {
    "lng": -74.2107006,
    "lat": 40.6639916
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 2.3194375,
    "lat": 48.8188544
  },
  {
    "lng": -95.9927516,
    "lat": 36.1563122
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -71.3495035,
    "lat": 42.5292605
  },
  {
    "lng": -69.942111,
    "lat": 18.4801972
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": 31.009909,
    "lat": -29.861825
  },
  {
    "lng": -1.3939844,
    "lat": 43.6637121
  },
  {
    "lng": -90.3715909,
    "lat": 38.7761446
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.2630238,
    "lat": 48.8003835
  },
  {
    "lng": -113.366399,
    "lat": 43.735735
  },
  {
    "lng": -80.9968286,
    "lat": 29.1386874
  },
  {
    "lng": -72.0584234,
    "lat": 44.0792316
  },
  {
    "lng": -3.9459248,
    "lat": 51.6195955
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -0.0123189,
    "lat": 51.5246287
  },
  {
    "lng": -82.1811947,
    "lat": 28.2336196
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -87.9403418,
    "lat": 41.8994745
  },
  {
    "lng": -122.780542,
    "lat": 49.2621643
  },
  {
    "lng": -0.5732063,
    "lat": 51.2356068
  },
  {
    "lng": 13.0085489,
    "lat": 50.7405217
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -94.992736,
    "lat": 29.3872254
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -123.1342796,
    "lat": 49.7588883
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -70.7693304,
    "lat": 41.8894422
  },
  {
    "lng": -86.6722192,
    "lat": 36.0600602
  },
  {
    "lng": -108.56448,
    "lat": 39.0672568
  },
  {
    "lng": -83.1668713,
    "lat": 42.4805913
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -123.8057607,
    "lat": 39.4436579
  },
  {
    "lng": 1.4353783,
    "lat": 38.9072784
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -84.5697965,
    "lat": 42.8424784
  },
  {
    "lng": -71.889038,
    "lat": 45.403271
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": 2.2453842,
    "lat": 48.7144587
  },
  {
    "lng": 6.8569063,
    "lat": 46.4537524
  },
  {
    "lng": -78.9421751,
    "lat": 43.87982
  },
  {
    "lng": -84.7668495,
    "lat": 43.597646
  },
  {
    "lng": -71.1061639,
    "lat": 42.4184296
  },
  {
    "lng": -96.9442177,
    "lat": 32.8295183
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 0.2433695,
    "lat": 52.2416427
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -0.3033105,
    "lat": 51.3937557
  },
  {
    "lng": -86.37416,
    "lat": 39.6128243
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -2.8908955,
    "lat": 53.1908873
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.3019814,
    "lat": 48.8211559
  },
  {
    "lng": -88.1170784,
    "lat": 43.1790768
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -76.8317417,
    "lat": 39.2757359
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -85.3094883,
    "lat": 35.0457219
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 6.122827,
    "lat": 49.3278069
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 24.0168024,
    "lat": 35.5158141
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -74.333495,
    "lat": 40.2852895
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -64.3723708,
    "lat": 45.9079431
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 5.0660616,
    "lat": 51.5856184
  },
  {
    "lng": -89.9559348,
    "lat": 38.7236594
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.2779124,
    "lat": 51.9486943
  },
  {
    "lng": -71.0931485,
    "lat": 41.9019257
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -117.2424787,
    "lat": 33.2021284
  },
  {
    "lng": -88.3123889,
    "lat": 43.0622536
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -118.39524,
    "lat": 37.363679
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -72.6071119,
    "lat": 42.1487691
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -77.4486772,
    "lat": 38.885219
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.7689951,
    "lat": 49.4432174
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": 5.1740496,
    "lat": 45.7500102
  },
  {
    "lng": 120.695345,
    "lat": 27.9963899
  },
  {
    "lng": 12.0595795,
    "lat": 47.8556623
  },
  {
    "lng": 7.6251879,
    "lat": 51.9625101
  },
  {
    "lng": 9.4978479,
    "lat": 51.3157833
  },
  {
    "lng": 2.6500745,
    "lat": 39.5695818
  },
  {
    "lng": -85.9213796,
    "lat": 39.2014405
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 10.1857757,
    "lat": 36.8002068
  },
  {
    "lng": -81.9284776,
    "lat": 37.8024603
  },
  {
    "lng": -84.1468616,
    "lat": 33.4473361
  },
  {
    "lng": -2.5313108,
    "lat": 53.1920711
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.2385432,
    "lat": 48.8126688
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": -122.824222,
    "lat": 38.4021038
  },
  {
    "lng": -82.9069508,
    "lat": 42.4435616
  },
  {
    "lng": -98.2363318,
    "lat": 29.8867349
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -123.1342796,
    "lat": 49.7588883
  },
  {
    "lng": -119.275205,
    "lat": 46.2804298
  },
  {
    "lng": 8.7123912,
    "lat": 50.011974
  },
  {
    "lng": 9.7385532,
    "lat": 52.3744779
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -75.3068878,
    "lat": 39.9483282
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -83.4430002,
    "lat": 42.8522506
  },
  {
    "lng": -124.0159522,
    "lat": 44.9617922
  },
  {
    "lng": -71.2472913,
    "lat": 43.6542439
  },
  {
    "lng": 5.6221058,
    "lat": 6.3330586
  },
  {
    "lng": 4.3338445,
    "lat": 50.8035441
  },
  {
    "lng": -116.559631,
    "lat": 43.5737361
  },
  {
    "lng": -106.0465486,
    "lat": 39.4829124
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": -86.8254383,
    "lat": 21.1855431
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 9.242431,
    "lat": 50.4411156
  },
  {
    "lng": -3.4270534,
    "lat": 47.7354591
  },
  {
    "lng": 8.1061259,
    "lat": 51.5725501
  },
  {
    "lng": -75.2718507,
    "lat": 39.9381682
  },
  {
    "lng": -90.485784,
    "lat": 30.0771675
  },
  {
    "lng": -83.8881711,
    "lat": 43.5962107
  },
  {
    "lng": 2.48291,
    "lat": 48.9031
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -73.8381351,
    "lat": 42.6251239
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 2.2897124,
    "lat": 48.7997756
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -118.0879763,
    "lat": 34.0676169
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": 17.1314203,
    "lat": 48.1557669
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -122.972545,
    "lat": 49.2433804
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 4.7169554,
    "lat": 49.7804687
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -71.2092214,
    "lat": 42.3370414
  },
  {
    "lng": -74.4118169,
    "lat": 40.3178867
  },
  {
    "lng": -98.1257348,
    "lat": 29.7028266
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -74.9829443,
    "lat": 39.8115033
  },
  {
    "lng": 4.8078783,
    "lat": 44.1371311
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -80.0942087,
    "lat": 26.9342246
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -116.392326,
    "lat": 43.6086295
  },
  {
    "lng": 9.3509475,
    "lat": 45.5761735
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.44074,
    "lat": 43.2877
  },
  {
    "lng": 27.4962548,
    "lat": 38.4549686
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -122.1560768,
    "lat": 37.7249296
  },
  {
    "lng": -82.652893,
    "lat": 46.373464
  },
  {
    "lng": -0.1726236,
    "lat": 51.6482779
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 6.553745,
    "lat": 46.5512503
  },
  {
    "lng": -59.0978393,
    "lat": -35.1856322
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": 4.4811089,
    "lat": 52.1518157
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -0.9700664,
    "lat": 51.4564242
  },
  {
    "lng": -103.338396,
    "lat": 20.6720375
  },
  {
    "lng": -84.180897,
    "lat": 39.4203978
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.7630148,
    "lat": 51.2494169
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 2.4159739,
    "lat": 48.8432434
  },
  {
    "lng": -100.384479,
    "lat": 21.0012598
  },
  {
    "lng": -91.3932118,
    "lat": 44.9371325
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": 11.0960722,
    "lat": 53.0989099
  },
  {
    "lng": 147.3281233,
    "lat": -42.8825088
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 12.4985492,
    "lat": 55.704111
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -123.8319802,
    "lat": 46.1882007
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": -80.9239671,
    "lat": 36.6612387
  },
  {
    "lng": -0.4865787,
    "lat": 51.1407587
  },
  {
    "lng": -158.0211735,
    "lat": 21.5010609
  },
  {
    "lng": -0.0117661,
    "lat": 51.1322179
  },
  {
    "lng": -106.0465486,
    "lat": 39.4829124
  },
  {
    "lng": -1.6414898,
    "lat": 48.1817122
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": 11.9593734,
    "lat": 49.0250012
  },
  {
    "lng": -72.5976987,
    "lat": 41.9791024
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -74.2301459,
    "lat": 40.701213
  },
  {
    "lng": -76.0372354,
    "lat": 45.6402189
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 10.5236066,
    "lat": 52.2646577
  },
  {
    "lng": -72.0759008,
    "lat": 41.5243537
  },
  {
    "lng": 7.219985,
    "lat": 51.5380394
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.1024635,
    "lat": 50.7352621
  },
  {
    "lng": -79.9546341,
    "lat": 43.2661904
  },
  {
    "lng": -80.9818016,
    "lat": 43.3700899
  },
  {
    "lng": -88.9843937,
    "lat": 40.5092961
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.701098,
    "lat": 38.3396367
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": 3.3941795,
    "lat": 6.4550575
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.2368863,
    "lat": 48.8841522
  },
  {
    "lng": -121.2810611,
    "lat": 38.7071247
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -74.8623849,
    "lat": 39.7765048
  },
  {
    "lng": -43.9450948,
    "lat": -19.9227318
  },
  {
    "lng": 4.3212622,
    "lat": 45.4348987
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 3.1212505,
    "lat": 39.8532473
  },
  {
    "lng": -0.6149074,
    "lat": 51.1857892
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 1.2161321,
    "lat": 44.8879431
  },
  {
    "lng": -75.9042674,
    "lat": 41.2432536
  },
  {
    "lng": -82.8001026,
    "lat": 27.9658533
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -73.9373912,
    "lat": 41.7841956
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -122.0832101,
    "lat": 37.3893889
  },
  {
    "lng": -13.8693225,
    "lat": 28.7400646
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.3195789,
    "lat": 48.8647637
  },
  {
    "lng": -83.4754913,
    "lat": 42.48059
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -84.2193334,
    "lat": 39.0274538
  },
  {
    "lng": 11.9382855,
    "lat": 58.3490555
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -1.5813204,
    "lat": 48.8488845
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 1.7537638,
    "lat": 52.4766308
  },
  {
    "lng": 1.8967943,
    "lat": 43.9016766
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -1.4315213,
    "lat": 43.6403659
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": 3.2492577,
    "lat": 45.7971315
  },
  {
    "lng": 2.4749347,
    "lat": 48.8490721
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 10.8979522,
    "lat": 48.3690341
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 6.2351431,
    "lat": 44.0918144
  },
  {
    "lng": 0.0689113,
    "lat": 51.5589375
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -83.810138,
    "lat": 39.9234046
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.4718299,
    "lat": 48.8046989
  },
  {
    "lng": 3.0041906,
    "lat": 43.1837757
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -70.151825,
    "lat": 44.671094
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -73.6292667,
    "lat": 45.4325141
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.4222416,
    "lat": 40.6201412
  },
  {
    "lng": -1.7854322,
    "lat": 51.5615327
  },
  {
    "lng": 6.1915748,
    "lat": 45.951157
  },
  {
    "lng": 2.1779083,
    "lat": 48.9134112
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -82.8890965,
    "lat": 42.4969652
  },
  {
    "lng": 4.9441635,
    "lat": 45.6965347
  },
  {
    "lng": -1.4149834,
    "lat": 43.4694806
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -73.1867391,
    "lat": 41.1779095
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -3.3660907,
    "lat": 47.7477336
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -85.0030617,
    "lat": 41.941091
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": 0.6425012,
    "lat": 51.9453005
  },
  {
    "lng": -71.065573,
    "lat": 42.2501425
  },
  {
    "lng": -121.78167,
    "lat": 42.224867
  },
  {
    "lng": 0.2255168,
    "lat": 49.1460831
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": -74.0243916,
    "lat": 41.503557
  },
  {
    "lng": -113.491241,
    "lat": 53.5462055
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 2.334267,
    "lat": 48.911729
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.5243682,
    "lat": 39.158168
  },
  {
    "lng": -47.8828,
    "lat": -15.7939869
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 14.4901093,
    "lat": 35.8956788
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": -57.5482079,
    "lat": -37.9976168
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 8.0599414,
    "lat": 47.5671976
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 8.5976831,
    "lat": 47.260692
  },
  {
    "lng": -73.7926335,
    "lat": 41.1328736
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -75.5274568,
    "lat": 45.4068372
  },
  {
    "lng": -78.8635324,
    "lat": 43.8975558
  },
  {
    "lng": -114.1493997,
    "lat": 46.4148155
  },
  {
    "lng": -95.6971686,
    "lat": 29.9691116
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 9.0205888,
    "lat": 46.1920538
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.3503555,
    "lat": 60.5110194
  },
  {
    "lng": -118.0577568,
    "lat": 34.1082994
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": -80.8100724,
    "lat": 35.5848596
  },
  {
    "lng": -0.6294321,
    "lat": 43.3708943
  },
  {
    "lng": -76.7455478,
    "lat": 39.2609921
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -59.1488389,
    "lat": -37.2919426
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": 9.2794469,
    "lat": 41.5911382
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -99.6569007,
    "lat": 19.292545
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 7.0581152,
    "lat": 46.6190969
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 5.4389442,
    "lat": 43.7729328
  },
  {
    "lng": 9.218655,
    "lat": 49.142291
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -73.9726508,
    "lat": 40.8929329
  },
  {
    "lng": 38.7524127,
    "lat": 9.0358287
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -118.12706,
    "lat": 34.093042
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 6.0243622,
    "lat": 47.2380222
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -99.1517322,
    "lat": 19.4414715
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": -76.5136495,
    "lat": 37.2356655
  },
  {
    "lng": 17.0326689,
    "lat": 51.1089776
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": -147.716675,
    "lat": 64.837845
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -118.7619719,
    "lat": 34.1792025
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -93.2922715,
    "lat": 37.2081729
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -74.4439254,
    "lat": 40.4951365
  },
  {
    "lng": 0.3135215,
    "lat": 48.2522145
  },
  {
    "lng": -48.6643444,
    "lat": -28.241827
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.9304919,
    "lat": 43.1257311
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -73.5293246,
    "lat": 40.7695303
  },
  {
    "lng": -88.7713953,
    "lat": 41.8903447
  },
  {
    "lng": 9.9614889,
    "lat": 53.8371714
  },
  {
    "lng": -80.0983887,
    "lat": -2.2895167
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": -85.6165976,
    "lat": 44.7606481
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -73.5107732,
    "lat": 42.7091389
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": -97.3404854,
    "lat": 32.9616819
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 9.1282868,
    "lat": 55.9445468
  },
  {
    "lng": -96.5722411,
    "lat": 33.2862455
  },
  {
    "lng": -122.6246836,
    "lat": 47.5653663
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -80.5222961,
    "lat": 43.4652699
  },
  {
    "lng": -6.8408929,
    "lat": 34.0218454
  },
  {
    "lng": -80.4706078,
    "lat": 27.816415
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -73.7517983,
    "lat": 40.9278769
  },
  {
    "lng": 7.7689368,
    "lat": 48.1918267
  },
  {
    "lng": 8.7473608,
    "lat": 50.3681107
  },
  {
    "lng": -72.7364844,
    "lat": 41.7117668
  },
  {
    "lng": -95.1846301,
    "lat": 30.0497077
  },
  {
    "lng": -3.1474212,
    "lat": 52.6600742
  },
  {
    "lng": -73.4856789,
    "lat": 41.4664832
  },
  {
    "lng": -122.2988587,
    "lat": 38.0043667
  },
  {
    "lng": 5.0548176,
    "lat": 43.4057279
  },
  {
    "lng": 2.2105491,
    "lat": 48.9250016
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.4136767,
    "lat": 37.2296566
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -81.5267403,
    "lat": 29.4044186
  },
  {
    "lng": 2.0997927,
    "lat": 41.3598601
  },
  {
    "lng": -122.5449763,
    "lat": 37.9060368
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -65.2038133,
    "lat": -26.8303703
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 17.9500556,
    "lat": 59.4293164
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -5.9226718,
    "lat": 37.283689
  },
  {
    "lng": -87.1761455,
    "lat": 41.5758708
  },
  {
    "lng": 4.2074197,
    "lat": 51.9930016
  },
  {
    "lng": 6.1763552,
    "lat": 49.1196964
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 1.4442469,
    "lat": 43.6044622
  },
  {
    "lng": -123.033121,
    "lat": 44.9391565
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": -83.1763145,
    "lat": 42.3222599
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -149.894852,
    "lat": 61.2163129
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": 13.08824,
    "lat": 52.5606426
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.8064922,
    "lat": 45.8640034
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -71.8272911,
    "lat": 41.3775996
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 17.752136,
    "lat": 59.4777776
  },
  {
    "lng": -3.2869398,
    "lat": 58.8520573
  },
  {
    "lng": -83.0062746,
    "lat": 42.4932575
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -99.157701,
    "lat": 19.3718796
  },
  {
    "lng": 0.1826107,
    "lat": 51.5747271
  },
  {
    "lng": -7.4155628,
    "lat": 37.1946052
  },
  {
    "lng": -76.8861122,
    "lat": 40.2663107
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -7.9138664,
    "lat": 40.6574713
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -117.9294401,
    "lat": 33.6170092
  },
  {
    "lng": 8.0257947,
    "lat": 47.8518286
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -84.2958988,
    "lat": 39.174625
  },
  {
    "lng": -81.275054,
    "lat": 33.8986841
  },
  {
    "lng": -75.602387,
    "lat": 41.4688301
  },
  {
    "lng": -111.651822,
    "lat": 35.1987522
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.1374969,
    "lat": 41.4910324
  },
  {
    "lng": 2.3226786,
    "lat": 48.8661905
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -77.2651762,
    "lat": 38.9013729
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -81.3800824,
    "lat": 30.2274645
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -87.5088712,
    "lat": 38.6911371
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -70.6624608,
    "lat": 42.6153595
  },
  {
    "lng": -116.5016784,
    "lat": 33.961124
  },
  {
    "lng": 8.2902,
    "lat": 50.2147
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -84.5822632,
    "lat": 33.8188333
  },
  {
    "lng": 8.6736295,
    "lat": 49.8851869
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -86.1649421,
    "lat": 34.1983281
  },
  {
    "lng": -90.481677,
    "lat": 38.783855
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 0.4757363,
    "lat": 51.5754602
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 2.7310072,
    "lat": 47.9978628
  },
  {
    "lng": -104.985181,
    "lat": 39.8695516
  },
  {
    "lng": -89.0226793,
    "lat": 42.6829765
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -4.0855906,
    "lat": 52.5861123
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 5.0286859,
    "lat": 52.0262053
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 7.6251879,
    "lat": 51.9625101
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 1.3044842,
    "lat": 51.1296508
  },
  {
    "lng": -3.000425,
    "lat": 51.5887675
  },
  {
    "lng": -80.0728201,
    "lat": 26.4614625
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -91.1869659,
    "lat": 30.4494155
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 13.7381437,
    "lat": 51.0493286
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -0.9392027,
    "lat": 51.0024945
  },
  {
    "lng": 7.7861959,
    "lat": 47.5605924
  },
  {
    "lng": -73.87619,
    "lat": 45.67932
  },
  {
    "lng": -1.548621,
    "lat": 53.794414
  },
  {
    "lng": 31.009909,
    "lat": -29.861825
  },
  {
    "lng": 7.6251879,
    "lat": 51.9625101
  },
  {
    "lng": 75.8681996,
    "lat": 22.7203616
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8534326,
    "lat": 46.7831001
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -40.2460053,
    "lat": -15.2454478
  },
  {
    "lng": -90.6106819,
    "lat": 39.6272694
  },
  {
    "lng": 2.2545943,
    "lat": 41.9302021
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 5.36109,
    "lat": 61.3187823
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -121.290779,
    "lat": 37.9577016
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 11.9670171,
    "lat": 57.7072326
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -105.0372046,
    "lat": 39.8366528
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -122.7141049,
    "lat": 38.4404925
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": 7.815973,
    "lat": 47.3069637
  },
  {
    "lng": -81.684004,
    "lat": 36.2187873
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -79.5341802,
    "lat": 8.9714493
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": -74.0323752,
    "lat": 40.7433066
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -79.05578,
    "lat": 35.9131542
  },
  {
    "lng": -70.9753978,
    "lat": 43.3050758
  },
  {
    "lng": -77.0011096,
    "lat": 41.2411556
  },
  {
    "lng": -71.889038,
    "lat": 45.403271
  },
  {
    "lng": -2.0163917,
    "lat": 52.5039074
  },
  {
    "lng": -99.2599579,
    "lat": 18.9331321
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -89.5230357,
    "lat": 37.3034933
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -4.4216366,
    "lat": 36.7213028
  },
  {
    "lng": -75.662956,
    "lat": 39.6159851
  },
  {
    "lng": 10.8979522,
    "lat": 48.3690341
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -84.853838,
    "lat": 38.9495047
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 9.6979598,
    "lat": 53.7278939
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -87.7834769,
    "lat": 42.7313756
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -70.4533844,
    "lat": 43.4925843
  },
  {
    "lng": 18.6540233,
    "lat": 54.3482907
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -106.660767,
    "lat": 52.131802
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 2.6500745,
    "lat": 39.5695818
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": 6.5506458,
    "lat": 52.997225
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -79.684768,
    "lat": 34.6173516
  },
  {
    "lng": -1.1236065,
    "lat": 52.6321088
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.6251879,
    "lat": 51.9625101
  },
  {
    "lng": 6.7537317,
    "lat": 46.5730628
  },
  {
    "lng": -84.0479643,
    "lat": 35.8217479
  },
  {
    "lng": -4.6867447,
    "lat": 36.6421248
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -122.47267,
    "lat": 37.6904826
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 8.6938161,
    "lat": 50.5808795
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -1.6683537,
    "lat": 47.2632611
  },
  {
    "lng": 1.0802533,
    "lat": 51.2800275
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -68.183899,
    "lat": 48.583875
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -3.1791934,
    "lat": 51.4816546
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -123.3272489,
    "lat": 42.4393707
  },
  {
    "lng": -2.2206585,
    "lat": 52.1911849
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.59393,
    "lat": 43.65506
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -3.8243251,
    "lat": 53.322475
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -6.2036691,
    "lat": 36.6141547
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.9852679,
    "lat": 52.5841365
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -122.2054035,
    "lat": 47.7623204
  },
  {
    "lng": -71.0542002,
    "lat": 42.4085897
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -78.3199496,
    "lat": 44.3048009
  },
  {
    "lng": -74.5143232,
    "lat": 40.9012101
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -95.3010624,
    "lat": 32.3512601
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 1.2644847,
    "lat": 45.8354243
  },
  {
    "lng": -8.5122705,
    "lat": 38.3729735
  },
  {
    "lng": -3.032721,
    "lat": 48.800878
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -122.12883,
    "lat": 37.834897
  },
  {
    "lng": -116.0775155,
    "lat": 44.7325107
  },
  {
    "lng": 8.7291498,
    "lat": 47.4991723
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": -73.0454164,
    "lat": 40.871241
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -118.129807,
    "lat": 34.051522
  },
  {
    "lng": 2.7015872,
    "lat": 48.4049375
  },
  {
    "lng": -76.307162,
    "lat": 40.1571324
  },
  {
    "lng": -81.2353683,
    "lat": 28.7225829
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.2270272,
    "lat": 47.3826903
  },
  {
    "lng": 1.0181293,
    "lat": 49.0452346
  },
  {
    "lng": 6.9963543,
    "lat": 43.6008898
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -84.105006,
    "lat": 40.7399785
  },
  {
    "lng": -80.1353006,
    "lat": 25.7929198
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -5.9336562,
    "lat": 54.5842881
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 5.2176582,
    "lat": 52.3722582
  },
  {
    "lng": -6.1513647,
    "lat": 53.4862405
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -83.2646624,
    "lat": 42.8247524
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 5.2002043,
    "lat": 43.9110641
  },
  {
    "lng": -88.0437509,
    "lat": 30.6913462
  },
  {
    "lng": -116.2958789,
    "lat": 33.677474
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.2424787,
    "lat": 33.2021284
  },
  {
    "lng": 2.6500745,
    "lat": 39.5695818
  },
  {
    "lng": 24.7499297,
    "lat": 42.1418541
  },
  {
    "lng": -73.9701382,
    "lat": 40.8509333
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 145.4863217,
    "lat": -38.0806283
  },
  {
    "lng": -107.7447813,
    "lat": 38.1833236
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -71.346996,
    "lat": 42.2836393
  },
  {
    "lng": 0.8994651,
    "lat": 51.8896903
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": -123.1059324,
    "lat": 44.6365071
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.2092214,
    "lat": 42.3370414
  },
  {
    "lng": -76.8317417,
    "lat": 39.2757359
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -86.8425761,
    "lat": 21.1527467
  },
  {
    "lng": -93.1010141,
    "lat": 41.3144108
  },
  {
    "lng": 148.9372222,
    "lat": -33.2933333
  },
  {
    "lng": -0.0786839,
    "lat": 51.6517156
  },
  {
    "lng": -118.12706,
    "lat": 34.093042
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": 121.0616503,
    "lat": 14.5578167
  },
  {
    "lng": -118.12706,
    "lat": 34.093042
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -83.4675021,
    "lat": 42.3712
  },
  {
    "lng": -77.515298,
    "lat": 43.090959
  },
  {
    "lng": -1.4471035,
    "lat": 55.0087655
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -117.2424787,
    "lat": 33.2021284
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 9.573777,
    "lat": 49.9947528
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -90.7195348,
    "lat": 29.5957696
  },
  {
    "lng": -0.0135253,
    "lat": 51.5911967
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 30.061507,
    "lat": -1.950851
  },
  {
    "lng": -74.665452,
    "lat": 40.904011
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 11.3763014,
    "lat": 47.7518502
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 7.9020696,
    "lat": 53.5736426
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 7.6824892,
    "lat": 45.0677551
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -74.8291638,
    "lat": 40.8538944
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -98.2300605,
    "lat": 26.204114
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -85.969951,
    "lat": 31.8087678
  },
  {
    "lng": -68.330514,
    "lat": -34.6126025
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -2.4251259,
    "lat": 53.5735158
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 1.3337639,
    "lat": 47.5876861
  },
  {
    "lng": -79.1262839,
    "lat": 40.6424116
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -106.831735,
    "lat": 40.4848003
  },
  {
    "lng": -122.2127011,
    "lat": 47.9793437
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -83.7596557,
    "lat": 40.3611643
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -74.4659275,
    "lat": 43.6307863
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -81.4410425,
    "lat": 27.4957453
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 9.9966023,
    "lat": 48.3904657
  },
  {
    "lng": 1.3044842,
    "lat": 51.1296508
  },
  {
    "lng": -73.1968205,
    "lat": 42.8788667
  },
  {
    "lng": -122.33931,
    "lat": 47.313494
  },
  {
    "lng": -122.6246836,
    "lat": 47.5653663
  },
  {
    "lng": 4.3181187,
    "lat": 50.811795
  },
  {
    "lng": 9.9215263,
    "lat": 57.0462626
  },
  {
    "lng": -85.4807825,
    "lat": 32.6098566
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -70.2586618,
    "lat": 43.6573605
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -97.6788056,
    "lat": 30.5085915
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 139.766706,
    "lat": 35.6812546
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -99.2327986,
    "lat": 19.4788356
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 121.4589414,
    "lat": 25.061706
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -99.1906167,
    "lat": 19.4071156
  },
  {
    "lng": 6.0525071,
    "lat": 45.8842342
  },
  {
    "lng": -71.2355644,
    "lat": 42.3762385
  },
  {
    "lng": 7.0134418,
    "lat": 43.5515198
  },
  {
    "lng": 8.2146017,
    "lat": 53.1389753
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 12.0974869,
    "lat": 49.0195333
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -82.9780695,
    "lat": 42.2858536
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 150.86499,
    "lat": -33.7822832
  },
  {
    "lng": -71.2355644,
    "lat": 42.3762385
  },
  {
    "lng": 2.3212492,
    "lat": 48.8642313
  },
  {
    "lng": -60.6617024,
    "lat": -32.9593609
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -97.4981698,
    "lat": 25.9024289
  },
  {
    "lng": -122.0607963,
    "lat": 37.9479786
  },
  {
    "lng": -122.301411,
    "lat": 37.9154056
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 4.4285918,
    "lat": 52.1809225
  },
  {
    "lng": -74.1496048,
    "lat": 40.5834557
  },
  {
    "lng": -74.3483059,
    "lat": 40.651726
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.8944,
    "lat": 49.9675456
  },
  {
    "lng": -3.5995337,
    "lat": 37.1734995
  },
  {
    "lng": -84.1170163,
    "lat": 9.9981515
  },
  {
    "lng": -84.5822632,
    "lat": 33.8188333
  },
  {
    "lng": -0.4652452,
    "lat": 47.4460674
  },
  {
    "lng": 7.5878261,
    "lat": 47.5581077
  },
  {
    "lng": -16.9086783,
    "lat": 32.6496497
  },
  {
    "lng": -78.7391813,
    "lat": 35.5071045
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 30.2368381,
    "lat": 1.5642298
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 4.7449605,
    "lat": 52.4681109
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 7.4472685,
    "lat": 48.6373266
  },
  {
    "lng": -99.1906167,
    "lat": 19.4071156
  },
  {
    "lng": 9.1895147,
    "lat": 48.8953937
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -78.8893999,
    "lat": 38.0686668
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": -2.4194132,
    "lat": 52.5345626
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 8.9520281,
    "lat": 46.0050102
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -100.1850769,
    "lat": 25.7871006
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -1.2885317,
    "lat": 51.823462
  },
  {
    "lng": -0.5435655,
    "lat": 43.8668219
  },
  {
    "lng": -3.1582296,
    "lat": 56.1110218
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -83.3771553,
    "lat": 42.4853125
  },
  {
    "lng": -38.4812772,
    "lat": -12.9822499
  },
  {
    "lng": 7.0557352,
    "lat": 48.734239
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 11.3927685,
    "lat": 47.2654296
  },
  {
    "lng": -80.0942087,
    "lat": 26.9342246
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -106.779807,
    "lat": 32.3140354
  },
  {
    "lng": -82.4168055,
    "lat": 36.1451082
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -88.3525714,
    "lat": 41.6834778
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -86.37416,
    "lat": 39.6128243
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -92.9438218,
    "lat": 44.8277446
  },
  {
    "lng": 127.0853183,
    "lat": 36.9908233
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": 13.39272,
    "lat": 51.5158115
  },
  {
    "lng": -85.1824269,
    "lat": 42.3192548
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": -73.5669583,
    "lat": 45.4981853
  },
  {
    "lng": -81.3410516,
    "lat": 35.2450607
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -99.0925404,
    "lat": 19.3588629
  },
  {
    "lng": -79.6901302,
    "lat": 44.3893208
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -74.2210643,
    "lat": 40.8164458
  },
  {
    "lng": -73.3734547,
    "lat": 40.6867667
  },
  {
    "lng": -75.1198911,
    "lat": 39.9448402
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -4.7882104,
    "lat": 50.338466
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 4.3338445,
    "lat": 50.8035441
  },
  {
    "lng": -95.8937398,
    "lat": 41.1365122
  },
  {
    "lng": 5.4372681,
    "lat": 51.8874333
  },
  {
    "lng": -73.059912,
    "lat": 41.2223781
  },
  {
    "lng": -122.8072257,
    "lat": 47.0263876
  },
  {
    "lng": -79.6443879,
    "lat": 43.5896231
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -118.7538071,
    "lat": 34.2677404
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -77.3063733,
    "lat": 38.8462236
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -104.500541,
    "lat": 37.169397
  },
  {
    "lng": -1.3402795,
    "lat": 52.0601807
  },
  {
    "lng": -116.602983,
    "lat": 31.8658887
  },
  {
    "lng": -75.071284,
    "lat": 39.9181686
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.4660408,
    "lat": 40.5462553
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 121.4589414,
    "lat": 25.061706
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -88.3053525,
    "lat": 41.8875281
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -75.8817316,
    "lat": 41.2464824
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": 2.1138977,
    "lat": 41.5421013
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -122.2054035,
    "lat": 47.7623204
  },
  {
    "lng": -97.827833,
    "lat": 30.5217116
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -104.858682,
    "lat": 39.3722552
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -81.5856742,
    "lat": 28.5656649
  },
  {
    "lng": 8.1350021,
    "lat": 49.3539802
  },
  {
    "lng": 4.6408412,
    "lat": 52.1131403
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -122.989827,
    "lat": 45.5228939
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 6.2980123,
    "lat": 43.3855592
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -1.1518287,
    "lat": 51.8988832
  },
  {
    "lng": -0.3685668,
    "lat": 43.2957547
  },
  {
    "lng": -1.4761491,
    "lat": 52.9212617
  },
  {
    "lng": -0.472528,
    "lat": 51.7511784
  },
  {
    "lng": -124.1707558,
    "lat": 40.8018746
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -8.4726423,
    "lat": 51.8985136
  },
  {
    "lng": -118.3845942,
    "lat": 33.8398289
  },
  {
    "lng": 7.0086255,
    "lat": 43.641141
  },
  {
    "lng": -80.9271271,
    "lat": 29.0258132
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -0.2012376,
    "lat": 5.5571096
  },
  {
    "lng": -90.2214858,
    "lat": 38.5955375
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -55.1347737,
    "lat": -27.8738956
  },
  {
    "lng": -117.6124179,
    "lat": 33.4270275
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": 13.1796853,
    "lat": 48.7556753
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -123.0737925,
    "lat": 49.3206294
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -72.9020069,
    "lat": 41.3836233
  },
  {
    "lng": -111.834914,
    "lat": 41.7313063
  },
  {
    "lng": -118.3845942,
    "lat": 33.8398289
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -82.3519192,
    "lat": 27.7123035
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.882817,
    "lat": 43.513671
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -80.2493276,
    "lat": 43.5460516
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -72.6908547,
    "lat": 41.764582
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -75.7774177,
    "lat": 40.5173165
  },
  {
    "lng": -48.6339782,
    "lat": -26.9924395
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -74.1454214,
    "lat": 40.7684342
  },
  {
    "lng": -0.3004067,
    "lat": 51.5149803
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -110.3158532,
    "lat": 24.1619948
  },
  {
    "lng": -71.1187829,
    "lat": 42.332918
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 104.063315,
    "lat": 30.659867
  },
  {
    "lng": -73.2541069,
    "lat": 42.4484778
  },
  {
    "lng": 100.0639917,
    "lat": 13.8190071
  },
  {
    "lng": -118.3845942,
    "lat": 33.8398289
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": -112.0244841,
    "lat": 41.1135837
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": -73.5017966,
    "lat": 40.814858
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -82.9069508,
    "lat": 42.4435616
  },
  {
    "lng": -80.2493276,
    "lat": 43.5460516
  },
  {
    "lng": -117.58938,
    "lat": 33.6626232
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -86.6694413,
    "lat": 35.9522852
  },
  {
    "lng": -74.1182492,
    "lat": 42.0410578
  },
  {
    "lng": 8.7376029,
    "lat": 41.9263991
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 0.1079732,
    "lat": 49.4938975
  },
  {
    "lng": -76.42977,
    "lat": 36.9775016
  },
  {
    "lng": -77.3507698,
    "lat": 39.4817659
  },
  {
    "lng": 10.596884,
    "lat": 49.6389632
  },
  {
    "lng": -97.2271249,
    "lat": 32.9299655
  },
  {
    "lng": -74.8231794,
    "lat": 11.0101922
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -121.988571,
    "lat": 37.5482697
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -123.508918,
    "lat": 49.4006197
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 5.7727504,
    "lat": 46.9032246
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 4.3315503,
    "lat": 50.8606042
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": 7.7885978,
    "lat": 48.8172236
  },
  {
    "lng": -85.5163391,
    "lat": 42.7891193
  },
  {
    "lng": -70.1895554,
    "lat": 44.4724293
  },
  {
    "lng": 11.3426327,
    "lat": 44.4938203
  },
  {
    "lng": -78.4766781,
    "lat": 38.029306
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -95.1169366,
    "lat": 43.8663464
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -113.214894,
    "lat": 53.7128571
  },
  {
    "lng": 7.1024635,
    "lat": 50.7352621
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 2.4019804,
    "lat": 48.8965023
  },
  {
    "lng": 0.5595871,
    "lat": 47.7440445
  },
  {
    "lng": 21.2692121,
    "lat": 48.7220196
  },
  {
    "lng": -89.5108818,
    "lat": 44.4604931
  },
  {
    "lng": -70.9753978,
    "lat": 43.3050758
  },
  {
    "lng": -81.3055188,
    "lat": 28.6987317
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": -3.5175773,
    "lat": 55.8829582
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": 18.0894593,
    "lat": 48.31295
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -1.954579,
    "lat": 48.363601
  },
  {
    "lng": 1.3549991,
    "lat": 44.0175835
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 11.9670171,
    "lat": 57.7072326
  },
  {
    "lng": 0.7046455,
    "lat": 44.4056615
  },
  {
    "lng": -1.5815742,
    "lat": 52.2814519
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 102.6133707,
    "lat": 17.9640988
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 6.9239103,
    "lat": 43.6589011
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 11.9670171,
    "lat": 57.7072326
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -75.1812913,
    "lat": 40.9995386
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 9.9748557,
    "lat": 52.3749334
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -116.602983,
    "lat": 31.8658887
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -78.8688833,
    "lat": 38.4493315
  },
  {
    "lng": -95.0949303,
    "lat": 29.5074538
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": 0.6153054,
    "lat": 44.8373323
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": -122.0215737,
    "lat": 37.5872576
  },
  {
    "lng": 8.6394715,
    "lat": 52.1530879
  },
  {
    "lng": -118.1956709,
    "lat": 50.998045
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": -77.3063733,
    "lat": 38.8462236
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -0.7465033,
    "lat": 52.0348915
  },
  {
    "lng": -1.6117595,
    "lat": 54.9751136
  },
  {
    "lng": 6.1675872,
    "lat": 49.3579272
  },
  {
    "lng": 4.8059012,
    "lat": 43.9492493
  },
  {
    "lng": -121.8106925,
    "lat": 38.0093296
  },
  {
    "lng": 8.3054682,
    "lat": 47.0505452
  },
  {
    "lng": -119.292058,
    "lat": 36.3302284
  },
  {
    "lng": 8.5752736,
    "lat": 48.9430357
  },
  {
    "lng": -83.6513229,
    "lat": 41.3747744
  },
  {
    "lng": -105.22058,
    "lat": 39.7546349
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": 73.1942567,
    "lat": 22.2973142
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -80.6672631,
    "lat": 32.9021377
  },
  {
    "lng": -82.5508407,
    "lat": 35.595363
  },
  {
    "lng": 73.0923253,
    "lat": 31.4220558
  },
  {
    "lng": -73.5835826,
    "lat": 40.6576071
  },
  {
    "lng": -72.2108428,
    "lat": 41.3659278
  },
  {
    "lng": -73.1212214,
    "lat": 41.8006523
  },
  {
    "lng": 6.0161687,
    "lat": 46.5270731
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": 2.3194375,
    "lat": 48.8188544
  },
  {
    "lng": -85.0215983,
    "lat": 32.341536
  },
  {
    "lng": -80.0983887,
    "lat": -2.2895167
  },
  {
    "lng": -70.2823287,
    "lat": 41.6535345
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -76.7918234,
    "lat": 39.4148436
  },
  {
    "lng": -71.0119948,
    "lat": 42.4084302
  },
  {
    "lng": 17.8127308,
    "lat": 59.2439038
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 3.570579,
    "lat": 47.7961287
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -84.7668495,
    "lat": 43.597646
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": 6.553745,
    "lat": 46.5512503
  },
  {
    "lng": -77.4347283,
    "lat": 38.837613
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -82.2327525,
    "lat": 27.9378338
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -118.307201,
    "lat": 34.1812089
  },
  {
    "lng": 1.8505364,
    "lat": 48.9079595
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -82.2272119,
    "lat": 34.9381361
  },
  {
    "lng": 75.8681996,
    "lat": 22.7203616
  },
  {
    "lng": -75.26046,
    "lat": 40.0084456
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -122.2276378,
    "lat": 47.5766324
  },
  {
    "lng": 1.7140683,
    "lat": 48.9891971
  },
  {
    "lng": 3.3331703,
    "lat": 46.5660526
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -122.1560768,
    "lat": 37.7249296
  },
  {
    "lng": 2.4151151,
    "lat": 48.6538754
  },
  {
    "lng": -79.4491057,
    "lat": 43.7543217
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -119.495902,
    "lat": 49.8879177
  },
  {
    "lng": 115.2191175,
    "lat": -8.6524973
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -104.820246,
    "lat": 41.139981
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -104.6158764,
    "lat": 50.4479733
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -105.938456,
    "lat": 35.6876096
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -87.9531303,
    "lat": 42.2830786
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": -0.3004067,
    "lat": 51.5149803
  },
  {
    "lng": -59.1488389,
    "lat": -37.2919426
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -82.9371409,
    "lat": 42.4972583
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": -8.1989013,
    "lat": 41.3648572
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -2.3198467,
    "lat": 51.2294852
  },
  {
    "lng": 18.0399308,
    "lat": 59.2759647
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": -71.3264492,
    "lat": 42.8808677
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 23.7603118,
    "lat": 61.4980214
  },
  {
    "lng": -97.3375448,
    "lat": 37.6922361
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": -71.0037374,
    "lat": 42.2509914
  },
  {
    "lng": -88.0039653,
    "lat": 42.263079
  },
  {
    "lng": 88.3638953,
    "lat": 22.5726459
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": 4.8526493,
    "lat": 52.2862177
  },
  {
    "lng": -1.7822482,
    "lat": 53.6466645
  },
  {
    "lng": -89.3614407,
    "lat": 40.7907409
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": -1.5149935,
    "lat": 43.4813927
  },
  {
    "lng": -94.208787,
    "lat": 36.3728608
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 2.4197113,
    "lat": 48.8051624
  },
  {
    "lng": 121.4511111,
    "lat": 31.2515439
  },
  {
    "lng": 2.1374969,
    "lat": 41.4910324
  },
  {
    "lng": -77.1516844,
    "lat": 39.0817985
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -123.3272489,
    "lat": 42.4393707
  },
  {
    "lng": -71.0744952,
    "lat": 42.2973205
  },
  {
    "lng": -117.173895,
    "lat": 46.7304268
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 7.2333295,
    "lat": 49.2833031
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -82.5338633,
    "lat": 28.483576
  },
  {
    "lng": 18.1820897,
    "lat": 59.3669445
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -80.1494901,
    "lat": 26.0112014
  },
  {
    "lng": 5.7357595,
    "lat": 49.2932974
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -1.67584,
    "lat": 52.6088967
  },
  {
    "lng": -87.7686078,
    "lat": 41.741406
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": -1.3776342,
    "lat": 53.9259798
  },
  {
    "lng": -80.1353006,
    "lat": 25.7929198
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 121.0486254,
    "lat": 14.6510546
  },
  {
    "lng": -125.244153,
    "lat": 50.023071
  },
  {
    "lng": 13.0591397,
    "lat": 52.4009309
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.478836,
    "lat": 48.7544012
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": 103.7649059,
    "lat": 1.4581986
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": -120.4579009,
    "lat": 34.6391501
  },
  {
    "lng": -112.3842224,
    "lat": 33.4674695
  },
  {
    "lng": 6.7556852,
    "lat": 53.1638192
  },
  {
    "lng": -73.6113502,
    "lat": 40.6534835
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -122.478836,
    "lat": 48.7544012
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -97.8772103,
    "lat": 29.9892928
  },
  {
    "lng": -73.7126064,
    "lat": 41.132973
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.036349,
    "lat": 37.3688301
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 9.5581577,
    "lat": 52.2099318
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -104.8658084,
    "lat": 39.9205405
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -73.4078968,
    "lat": 41.1175966
  },
  {
    "lng": -82.902901,
    "lat": 42.6741189
  },
  {
    "lng": -79.2576479,
    "lat": 43.7729744
  },
  {
    "lng": -122.657047,
    "lat": 49.1039289
  },
  {
    "lng": 120.1852496,
    "lat": 22.9921256
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": -81.9081937,
    "lat": 41.375049
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.3338445,
    "lat": 50.8035441
  },
  {
    "lng": -73.5748483,
    "lat": 41.2087066
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -74.012084,
    "lat": 40.8042674
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -84.1170163,
    "lat": 9.9981515
  },
  {
    "lng": -2.0580178,
    "lat": 48.6320379
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -97.937622,
    "lat": 49.187089
  },
  {
    "lng": -112.281933,
    "lat": 33.6290111
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": 9.7473511,
    "lat": 56.5034534
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.6154897,
    "lat": 34.0234337
  },
  {
    "lng": 0.7126205,
    "lat": 51.5349879
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -0.7170764,
    "lat": 44.8958887
  },
  {
    "lng": 19.2691151,
    "lat": 42.4321076
  },
  {
    "lng": 78.1358153,
    "lat": 27.8761073
  },
  {
    "lng": -74.4262011,
    "lat": 40.4997407
  },
  {
    "lng": -82.7192671,
    "lat": 28.2441768
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -87.0338464,
    "lat": 35.6148165
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -84.5546295,
    "lat": 42.7338254
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -68.4662317,
    "lat": -33.1959388
  },
  {
    "lng": 91.753943,
    "lat": 26.1805978
  },
  {
    "lng": -86.5342881,
    "lat": 39.1670396
  },
  {
    "lng": 13.0820846,
    "lat": 54.3096314
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -77.1154448,
    "lat": 37.5327893
  },
  {
    "lng": -2.9350039,
    "lat": 43.2630018
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": 5.5271394,
    "lat": 45.126906
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -91.4984941,
    "lat": 44.811349
  },
  {
    "lng": 2.3507289,
    "lat": 48.861352
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 101.7055684,
    "lat": 3.0340649
  },
  {
    "lng": -97.3404854,
    "lat": 32.9616819
  },
  {
    "lng": 30.061507,
    "lat": -1.950851
  },
  {
    "lng": -75.0946183,
    "lat": 39.8676134
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 5.4127848,
    "lat": 43.4511819
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.760056,
    "lat": 33.9926803
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 26.1772794,
    "lat": 44.4902779
  },
  {
    "lng": -75.1526774,
    "lat": 39.8381691
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 2.2465748,
    "lat": 48.9069349
  },
  {
    "lng": 5.5910751,
    "lat": 45.3631386
  },
  {
    "lng": -73.9283672,
    "lat": 41.7065539
  },
  {
    "lng": 2.334267,
    "lat": 48.911729
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -78.8688833,
    "lat": 38.4493315
  },
  {
    "lng": 0.7299495,
    "lat": 52.0401524
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 17.9681359,
    "lat": 59.3628802
  },
  {
    "lng": 115.1609766,
    "lat": -8.6434167
  },
  {
    "lng": -95.4187924,
    "lat": 30.0795707
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -93.7211623,
    "lat": 36.9724863
  },
  {
    "lng": -75.1162306,
    "lat": 40.1507046
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -75.292676,
    "lat": 40.372048
  },
  {
    "lng": 80.270186,
    "lat": 13.0836939
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -68.836982,
    "lat": 44.7445159
  },
  {
    "lng": 1.089746,
    "lat": 49.4151549
  },
  {
    "lng": -123.2620435,
    "lat": 44.5645659
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -90.9806954,
    "lat": 38.9794923
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 9.0150026,
    "lat": 48.8012983
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 121.0573969,
    "lat": 14.3134763
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 5.7455106,
    "lat": 52.0716825
  },
  {
    "lng": -74.9077919,
    "lat": 39.7836223
  },
  {
    "lng": 12.0974869,
    "lat": 49.0195333
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 4.3188215,
    "lat": 52.0446265
  },
  {
    "lng": 4.7493384,
    "lat": 52.2669442
  },
  {
    "lng": -75.1438863,
    "lat": 39.770683
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7253575,
    "lat": 17.0604663
  },
  {
    "lng": -2.9350039,
    "lat": 43.2630018
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": 88.3638953,
    "lat": 22.5726459
  },
  {
    "lng": -74.3045277,
    "lat": 40.6652251
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 79.8542005,
    "lat": 6.9388614
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": -111.9866954,
    "lat": 40.6967891
  },
  {
    "lng": -0.3691409,
    "lat": 51.4150272
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": -70.650549,
    "lat": -33.4625225
  },
  {
    "lng": -1.8604874,
    "lat": 53.7229229
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 12.6757914,
    "lat": 48.2268085
  },
  {
    "lng": -51.2303767,
    "lat": -30.0324999
  },
  {
    "lng": 9.1364229,
    "lat": 48.9493243
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -121.8903368,
    "lat": 36.9941295
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -96.4980424,
    "lat": 33.1801161
  },
  {
    "lng": -92.5601884,
    "lat": 39.7969772
  },
  {
    "lng": -89.216655,
    "lat": 37.7274692
  },
  {
    "lng": 5.5783856,
    "lat": 46.1825453
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -76.1789242,
    "lat": 40.1799111
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.2440518,
    "lat": 36.0998131
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 6.8514435,
    "lat": 51.4696137
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -82.6359078,
    "lat": 27.7700475
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 12.3747329,
    "lat": 51.3406321
  },
  {
    "lng": -2.9770012,
    "lat": 53.4105292
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -86.1283681,
    "lat": 39.9784186
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -0.2427217,
    "lat": 44.9133742
  },
  {
    "lng": 10.6159077,
    "lat": 54.1364642
  },
  {
    "lng": -1.37328,
    "lat": 43.68866
  },
  {
    "lng": 9.4978479,
    "lat": 51.3157833
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -75.1340604,
    "lat": 40.2492741
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -86.1597137,
    "lat": 33.3967079
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -77.0398762,
    "lat": 35.1068428
  },
  {
    "lng": -1.4269698,
    "lat": 46.6705431
  },
  {
    "lng": -2.2206585,
    "lat": 52.1911849
  },
  {
    "lng": 10.9718974,
    "lat": 49.0305748
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 9.4800858,
    "lat": 47.6500279
  },
  {
    "lng": -3.8758396,
    "lat": 40.4933095
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -77.0398762,
    "lat": 35.1068428
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -96.3050064,
    "lat": 35.4325854
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": -79.8728583,
    "lat": 43.2560802
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 11.9670171,
    "lat": 57.7072326
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 5.5302024,
    "lat": 46.6769747
  },
  {
    "lng": 0.8994651,
    "lat": 51.8896903
  },
  {
    "lng": -100.9763993,
    "lat": 22.1516472
  },
  {
    "lng": 3.3396173,
    "lat": 47.9917465
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 9.9434769,
    "lat": 49.7780356
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 135.5014539,
    "lat": 34.6937569
  },
  {
    "lng": -114.363662,
    "lat": 43.680741
  },
  {
    "lng": -0.5216683,
    "lat": 44.8791708
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": 8.4673098,
    "lat": 49.4892913
  },
  {
    "lng": -0.8324037,
    "lat": 51.4120318
  },
  {
    "lng": 8.6711118,
    "lat": 52.1152245
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -82.2359254,
    "lat": 27.044224
  },
  {
    "lng": -68.7713289,
    "lat": 44.8016255
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 4.9570975,
    "lat": 45.6638963
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 8.0256131,
    "lat": 50.8751175
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 3.5107999,
    "lat": 47.9035931
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 0.4757177,
    "lat": 50.9265004
  },
  {
    "lng": 2.2411289,
    "lat": 43.6053809
  },
  {
    "lng": -122.2070775,
    "lat": 47.6765382
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -0.5404819,
    "lat": 53.2293545
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -100.315258,
    "lat": 25.6802019
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 6.1069469,
    "lat": 46.0338359
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.3277854,
    "lat": 48.8482145
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -86.0085955,
    "lat": 40.0455918
  },
  {
    "lng": -79.461708,
    "lat": 44.056258
  },
  {
    "lng": -0.283934,
    "lat": 49.1823826
  },
  {
    "lng": 27.4721276,
    "lat": 42.4936616
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -76.9271851,
    "lat": 39.0397735
  },
  {
    "lng": 174.9057626,
    "lat": -41.2125751
  },
  {
    "lng": -1.4562207,
    "lat": 43.39876
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -95.4187924,
    "lat": 30.0795707
  },
  {
    "lng": -113.770256,
    "lat": 50.3481989
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -122.2127011,
    "lat": 47.9793437
  },
  {
    "lng": -90.3770869,
    "lat": 38.3652768
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 78.4740613,
    "lat": 17.360589
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.3749508,
    "lat": 40.7985464
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 10.8979522,
    "lat": 48.3690341
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 125.4515852,
    "lat": 6.878324
  },
  {
    "lng": -2.0976346,
    "lat": 57.1426487
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -78.3968299,
    "lat": 40.5193586
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -85.1824269,
    "lat": 42.3192548
  },
  {
    "lng": -84.5546295,
    "lat": 42.7338254
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -88.4069744,
    "lat": 44.2613967
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -110.3158532,
    "lat": 24.1619948
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 8.0605908,
    "lat": 51.4002384
  },
  {
    "lng": -84.5496148,
    "lat": 33.9528472
  },
  {
    "lng": -70.650549,
    "lat": -33.4625225
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 11.3297921,
    "lat": 50.9793301
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 6.0791195,
    "lat": 49.1237163
  },
  {
    "lng": 18.0894593,
    "lat": 48.31295
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.4381568,
    "lat": 49.4704113
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -73.6917878,
    "lat": 42.7284117
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -64.0681408,
    "lat": -30.70466
  },
  {
    "lng": 4.4147041,
    "lat": 52.0475517
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -109.2194544,
    "lat": 41.5860557
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.4036319,
    "lat": 40.8472369
  },
  {
    "lng": 6.9881194,
    "lat": 51.0324743
  },
  {
    "lng": -73.7629097,
    "lat": 41.0339862
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -121.176058,
    "lat": 38.6779591
  },
  {
    "lng": 7.1780374,
    "lat": 51.264018
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.9338911,
    "lat": 39.9005585
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 36.8172449,
    "lat": -1.2832533
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -16.7787271,
    "lat": 28.2101368
  },
  {
    "lng": 17.7959288,
    "lat": 59.1653304
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 0.2781546,
    "lat": 50.7664372
  },
  {
    "lng": -95.5230691,
    "lat": 35.4700917
  },
  {
    "lng": 2.4749347,
    "lat": 48.8490721
  },
  {
    "lng": 3.0335243,
    "lat": 42.7946794
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 5.0660616,
    "lat": 51.5856184
  },
  {
    "lng": 11.6400789,
    "lat": 52.1314783
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": 7.6824892,
    "lat": 45.0677551
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 26.1009263,
    "lat": 44.4356444
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 6.759562,
    "lat": 51.434999
  },
  {
    "lng": -118.4453745,
    "lat": 34.2242902
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.3633048,
    "lat": 48.7921098
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -88.9125723,
    "lat": 43.0798032
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -114.9822486,
    "lat": 36.0319843
  },
  {
    "lng": -71.4128343,
    "lat": 41.8239891
  },
  {
    "lng": 0.6889268,
    "lat": 47.3900474
  },
  {
    "lng": -77.4118027,
    "lat": 35.5942045
  },
  {
    "lng": -78.7998691,
    "lat": 35.5843849
  },
  {
    "lng": -68.672791,
    "lat": 44.883607
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -117.9611761,
    "lat": 34.0854739
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.478836,
    "lat": 48.7544012
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -75.3490769,
    "lat": 40.0373323
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": -76.8485094,
    "lat": 39.0984317
  },
  {
    "lng": 9.7454815,
    "lat": 52.3212183
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": 18.2073591,
    "lat": 59.3120997
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": 7.9625883,
    "lat": 52.2414052
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -90.0517638,
    "lat": 35.1460249
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 5.0286859,
    "lat": 52.0262053
  },
  {
    "lng": 9.4333264,
    "lat": 54.7833021
  },
  {
    "lng": -8.378194,
    "lat": 41.290118
  },
  {
    "lng": -96.6388833,
    "lat": 32.912624
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -80.2440518,
    "lat": 36.0998131
  },
  {
    "lng": -89.0078418,
    "lat": 34.4942683
  },
  {
    "lng": -2.8650938,
    "lat": 54.0721085
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -84.5501874,
    "lat": 39.2085354
  },
  {
    "lng": 2.3896123,
    "lat": 48.9267236
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 9.9351811,
    "lat": 51.5328328
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -4.7760138,
    "lat": 37.8845813
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -73.7240106,
    "lat": 40.636793
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -120.4579009,
    "lat": 34.6391501
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": -71.1061639,
    "lat": 42.4184296
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -2.4543424,
    "lat": 50.6096257
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.7106094,
    "lat": 52.0114922
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -91.4984941,
    "lat": 44.811349
  },
  {
    "lng": 0.5961846,
    "lat": 47.4036631
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -4.1433925,
    "lat": 50.3780967
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 1.3009485,
    "lat": 38.9830568
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -85.7833563,
    "lat": 40.8065352
  },
  {
    "lng": 2.2695658,
    "lat": 48.884683
  },
  {
    "lng": -73.6837987,
    "lat": 45.435114
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -122.2301808,
    "lat": 47.3075369
  },
  {
    "lng": -3.5269209,
    "lat": 50.7256138
  },
  {
    "lng": -122.4094051,
    "lat": 48.0399806
  },
  {
    "lng": 8.32494,
    "lat": 49.7053458
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -123.0950506,
    "lat": 44.0505054
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -121.988571,
    "lat": 37.5482697
  },
  {
    "lng": 10.684738,
    "lat": 53.866444
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -3.1716324,
    "lat": 56.1961905
  },
  {
    "lng": -83.4754913,
    "lat": 42.48059
  },
  {
    "lng": 5.9146362,
    "lat": 45.6886292
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -118.559849,
    "lat": 34.4131941
  },
  {
    "lng": 1.3044842,
    "lat": 51.1296508
  },
  {
    "lng": -86.9838165,
    "lat": 34.6060203
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -121.99059,
    "lat": 37.050096
  },
  {
    "lng": -121.2810611,
    "lat": 38.7071247
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 2.3872525,
    "lat": 48.8122302
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 11.9712985,
    "lat": 51.4824354
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -81.3498212,
    "lat": 34.1659795
  },
  {
    "lng": -123.0220289,
    "lat": 44.0462362
  },
  {
    "lng": 11.3526351,
    "lat": 48.1704908
  },
  {
    "lng": -89.4350519,
    "lat": 30.4090829
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 4.6931244,
    "lat": 45.9561547
  },
  {
    "lng": 2.5524906,
    "lat": 48.8492238
  },
  {
    "lng": 0.526559,
    "lat": 51.3819167
  },
  {
    "lng": -76.2494453,
    "lat": 36.7168315
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.3945384,
    "lat": 40.9784354
  },
  {
    "lng": -0.2012376,
    "lat": 5.5571096
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": -116.464076,
    "lat": 33.7810031
  },
  {
    "lng": -75.0940625,
    "lat": 40.0609445
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -93.605092,
    "lat": 41.7320796
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -0.2589013,
    "lat": 52.0882012
  },
  {
    "lng": -75.0946183,
    "lat": 39.8676134
  },
  {
    "lng": -79.05578,
    "lat": 35.9131542
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -78.878292,
    "lat": 35.0525759
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 3.8855537,
    "lat": 45.0459739
  },
  {
    "lng": 34.7818064,
    "lat": 32.0852997
  },
  {
    "lng": 0.1631961,
    "lat": 51.8676279
  },
  {
    "lng": -0.902805,
    "lat": 52.2343297
  },
  {
    "lng": 7.1978546,
    "lat": 51.6143815
  },
  {
    "lng": -122.192337,
    "lat": 47.6144219
  },
  {
    "lng": -99.097453,
    "lat": 19.3957447
  },
  {
    "lng": -82.3269883,
    "lat": 27.871197
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -86.5342881,
    "lat": 39.1670396
  },
  {
    "lng": -117.3703235,
    "lat": 34.1064001
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -74.4015405,
    "lat": 40.6984348
  },
  {
    "lng": -94.1166283,
    "lat": 36.3330154
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -99.1952423,
    "lat": 19.3906515
  },
  {
    "lng": -122.972545,
    "lat": 49.2433804
  },
  {
    "lng": 12.0595795,
    "lat": 47.8556623
  },
  {
    "lng": 139.766706,
    "lat": 35.6812546
  },
  {
    "lng": -81.8020722,
    "lat": 24.5548262
  },
  {
    "lng": -93.7594059,
    "lat": 41.5644476
  },
  {
    "lng": -94.81887,
    "lat": 38.8838856
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": -92.6255048,
    "lat": 44.8596498
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -118.0879763,
    "lat": 34.0676169
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 10.386436,
    "lat": 52.3254911
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 10.9700482,
    "lat": 49.8439391
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -92.1801925,
    "lat": 30.2378751
  },
  {
    "lng": 0.5231646,
    "lat": 51.2748258
  },
  {
    "lng": 78.0098161,
    "lat": 27.1752554
  },
  {
    "lng": -1.7854322,
    "lat": 51.5615327
  },
  {
    "lng": -94.6851702,
    "lat": 38.9742502
  },
  {
    "lng": 6.2495954,
    "lat": 46.2025309
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": 2.2630238,
    "lat": 48.8003835
  },
  {
    "lng": 2.9437526,
    "lat": 46.5524374
  },
  {
    "lng": 6.8514435,
    "lat": 51.4696137
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -81.3461738,
    "lat": 28.7012172
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -1.67584,
    "lat": 52.6088967
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": 73.8545071,
    "lat": 18.5213738
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -97.5468898,
    "lat": 30.5427638
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 144.3598241,
    "lat": -38.1493248
  },
  {
    "lng": -99.3311525,
    "lat": 38.8709984
  },
  {
    "lng": -54.558258,
    "lat": -29.2004769
  },
  {
    "lng": -0.3018577,
    "lat": 51.4129277
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -111.4979963,
    "lat": 40.6460921
  },
  {
    "lng": -63.7892386,
    "lat": 46.394259
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -83.3771553,
    "lat": 42.4853125
  },
  {
    "lng": -76.8861122,
    "lat": 40.2663107
  },
  {
    "lng": -82.6379387,
    "lat": 38.4784144
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -118.129807,
    "lat": 34.051522
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -94.1288142,
    "lat": 36.1867442
  },
  {
    "lng": -72.8246139,
    "lat": 40.9446394
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -118.0879763,
    "lat": 34.0676169
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 2.136145,
    "lat": 48.8478753
  },
  {
    "lng": 7.1024635,
    "lat": 50.7352621
  },
  {
    "lng": -90.5228976,
    "lat": 37.8517986
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": 10.8979522,
    "lat": 48.3690341
  },
  {
    "lng": 18.4126147,
    "lat": 43.8570713
  },
  {
    "lng": -98.1981486,
    "lat": 19.0437196
  },
  {
    "lng": 7.1780374,
    "lat": 51.264018
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -75.1119434,
    "lat": 39.7027677
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -4.2412484,
    "lat": 50.8309593
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -3.0756369,
    "lat": 47.7483013
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -106.5594391,
    "lat": 35.0879638
  },
  {
    "lng": -82.692005,
    "lat": 28.3581405
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -114.0532996,
    "lat": 35.1895921
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -2.2198605,
    "lat": 51.745424
  },
  {
    "lng": 7.5000007,
    "lat": 6.4499833
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": -85.4807825,
    "lat": 32.6098566
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -74.9693329,
    "lat": 39.7173375
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -79.0935648,
    "lat": 37.4463105
  },
  {
    "lng": -71.2360624,
    "lat": 42.2802645
  },
  {
    "lng": 9.3762397,
    "lat": 47.425618
  },
  {
    "lng": -116.5016784,
    "lat": 33.961124
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 0.8477322,
    "lat": 52.829919
  },
  {
    "lng": -2.9778916,
    "lat": 51.3471927
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -71.2355644,
    "lat": 42.3762385
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": 126.9518,
    "lat": 37.4782
  },
  {
    "lng": 9.6599406,
    "lat": 47.4276538
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -1.7767859,
    "lat": 46.4990505
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -76.2461259,
    "lat": 41.0602024
  },
  {
    "lng": -88.2364775,
    "lat": 42.4436308
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": 7.8993599,
    "lat": 47.3206417
  },
  {
    "lng": -77.4605399,
    "lat": 38.3031837
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": 5.0414701,
    "lat": 47.3215806
  },
  {
    "lng": -57.9537638,
    "lat": -34.9206797
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 10.9587203,
    "lat": 49.4885711
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.0338765,
    "lat": 34.6731323
  },
  {
    "lng": 5.3072813,
    "lat": 45.3481942
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 7.1262071,
    "lat": 43.5812868
  },
  {
    "lng": -74.012084,
    "lat": 40.8042674
  },
  {
    "lng": -71.537476,
    "lat": 43.207178
  },
  {
    "lng": 10.1808016,
    "lat": 47.9863099
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -80.0387292,
    "lat": 32.9961038
  },
  {
    "lng": -97.3887764,
    "lat": 30.0541116
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": 4.80986,
    "lat": 45.6467
  },
  {
    "lng": -88.3123889,
    "lat": 43.0622536
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 14.2487679,
    "lat": 40.8358846
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -70.551453,
    "lat": 43.735879
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -73.1062025,
    "lat": 43.9733602
  },
  {
    "lng": 1.1306951,
    "lat": 51.3719507
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.3825154,
    "lat": 48.9565669
  },
  {
    "lng": -91.9479586,
    "lat": 38.8467082
  },
  {
    "lng": 10.135555,
    "lat": 54.3227085
  },
  {
    "lng": -93.5521411,
    "lat": 37.0675544
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 121.0764343,
    "lat": 14.5605166
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -9.4204495,
    "lat": 38.6968919
  },
  {
    "lng": -2.2439196,
    "lat": 53.7907262
  },
  {
    "lng": 115.2191175,
    "lat": -8.6524973
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -87.6305899,
    "lat": 46.4481521
  },
  {
    "lng": 14.4258096,
    "lat": 35.910083
  },
  {
    "lng": -0.1740904,
    "lat": 45.6791182
  },
  {
    "lng": 2.3764363,
    "lat": 43.4902317
  },
  {
    "lng": -1.67584,
    "lat": 52.6088967
  },
  {
    "lng": 2.510611,
    "lat": 48.8137847
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 8.634513,
    "lat": 47.6960491
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -2.2663682,
    "lat": 53.7816338
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 5.6062495,
    "lat": 43.1758591
  },
  {
    "lng": -118.1634075,
    "lat": 34.8641446
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": -74.8142502,
    "lat": 38.9841969
  },
  {
    "lng": 1.3044842,
    "lat": 51.1296508
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 31.045686,
    "lat": -17.831773
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": -94.1166283,
    "lat": 36.3330154
  },
  {
    "lng": 2.30551,
    "lat": 48.9026
  },
  {
    "lng": -4.1281427,
    "lat": 40.5836411
  },
  {
    "lng": 153.4145987,
    "lat": -28.0023731
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -74.8231794,
    "lat": 11.0101922
  },
  {
    "lng": -87.1916834,
    "lat": 34.639258
  },
  {
    "lng": 12.4985492,
    "lat": 55.704111
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": -2.2138905,
    "lat": 47.2733517
  },
  {
    "lng": -96.3455991,
    "lat": 30.6183939
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": -74.9794987,
    "lat": 40.7584793
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -123.0737925,
    "lat": 49.3206294
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -3.4146801,
    "lat": 50.6190962
  },
  {
    "lng": -85.4879523,
    "lat": 42.9547136
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 17.9681359,
    "lat": 59.3628802
  },
  {
    "lng": 7.1825445,
    "lat": 50.8963758
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -75.9696186,
    "lat": 40.7974296
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.4078968,
    "lat": 41.1175966
  },
  {
    "lng": -88.2578582,
    "lat": 42.1211364
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -88.1361888,
    "lat": 42.1539141
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 8.6930633,
    "lat": 47.3895597
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -116.559631,
    "lat": 43.5737361
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -0.1726236,
    "lat": 51.6482779
  },
  {
    "lng": -95.4187924,
    "lat": 30.0795707
  },
  {
    "lng": 13.0630004,
    "lat": 53.3617163
  },
  {
    "lng": -75.710976,
    "lat": 45.4277659
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": -96.9083366,
    "lat": 32.6518004
  },
  {
    "lng": -87.7834769,
    "lat": 42.7313756
  },
  {
    "lng": 6.5621137,
    "lat": 46.5258
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 0.0689113,
    "lat": 51.5589375
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -81.2680223,
    "lat": 28.8117345
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -122.2070775,
    "lat": 47.6765382
  },
  {
    "lng": -95.2214564,
    "lat": 33.1890841
  },
  {
    "lng": 121.0486254,
    "lat": 14.6510546
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.6118771,
    "lat": 50.7259985
  },
  {
    "lng": 8.2416556,
    "lat": 50.0820384
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -111.926018,
    "lat": 33.4942189
  },
  {
    "lng": -81.6332812,
    "lat": 38.3505995
  },
  {
    "lng": -3.2208487,
    "lat": 51.5745432
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -71.5785924,
    "lat": 42.6650324
  },
  {
    "lng": -111.4748846,
    "lat": 40.5125438
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -93.2922715,
    "lat": 37.2081729
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 121.0486254,
    "lat": 14.6510546
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -77.0722227,
    "lat": 39.1469872
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 6.5213004,
    "lat": 52.3080276
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.2674029,
    "lat": 48.6155573
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 37.6742652,
    "lat": -6.8254864
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -78.762383,
    "lat": 39.6526498
  },
  {
    "lng": -117.7197785,
    "lat": 34.0966764
  },
  {
    "lng": -1.548621,
    "lat": 53.794414
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -71.3084633,
    "lat": 41.7407661
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -5.3868293,
    "lat": 36.2100586
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": -73.7629097,
    "lat": 41.0339862
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -95.9927516,
    "lat": 36.1563122
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": 10.7545933,
    "lat": 49.1147095
  },
  {
    "lng": 0.0429787,
    "lat": 45.5547638
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -94.3621376,
    "lat": 39.3731886
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 33.0332657,
    "lat": 34.6852901
  },
  {
    "lng": -122.2941914,
    "lat": 37.5164926
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -69.8140298,
    "lat": 43.9133661
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -105.05208,
    "lat": 39.9403995
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -155.1003754,
    "lat": 19.6854458
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -121.9856782,
    "lat": 47.7423219
  },
  {
    "lng": 4.87477,
    "lat": 45.52524
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": 11.0993619,
    "lat": 55.6833793
  },
  {
    "lng": 5.3737893,
    "lat": 43.7346782
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": -74.228185,
    "lat": 40.8813513
  },
  {
    "lng": 25.1332843,
    "lat": 35.33908
  },
  {
    "lng": -89.031784,
    "lat": 42.5083272
  },
  {
    "lng": 13.8201171,
    "lat": 55.4295203
  },
  {
    "lng": 6.759562,
    "lat": 51.434999
  },
  {
    "lng": 8.63306,
    "lat": 49.4025
  },
  {
    "lng": 2.166162,
    "lat": 48.9898588
  },
  {
    "lng": 11.3426327,
    "lat": 44.4938203
  },
  {
    "lng": 8.0072645,
    "lat": 51.329832
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -0.5762125,
    "lat": 42.8801011
  },
  {
    "lng": 4.19978,
    "lat": 44.2600172
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": -59.1488389,
    "lat": -37.2919426
  },
  {
    "lng": -118.3692894,
    "lat": 34.0923014
  },
  {
    "lng": 4.7876566,
    "lat": 52.4952218
  },
  {
    "lng": 10.0832982,
    "lat": 48.2833039
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 153.0933668,
    "lat": -26.6544338
  },
  {
    "lng": -89.6272791,
    "lat": 44.9597858
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 80.270186,
    "lat": 13.0836939
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -80.0852695,
    "lat": 42.1294712
  },
  {
    "lng": -82.5338633,
    "lat": 28.483576
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -84.7027575,
    "lat": 39.065813
  },
  {
    "lng": -72.9467908,
    "lat": 42.7718433
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -90.0973694,
    "lat": 30.4408827
  },
  {
    "lng": -111.9367107,
    "lat": 40.5584882
  },
  {
    "lng": -0.0927317,
    "lat": 51.3758448
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 0.0285581,
    "lat": 45.4722149
  },
  {
    "lng": -70.2177099,
    "lat": 44.0990717
  },
  {
    "lng": -74.2765366,
    "lat": 40.8398218
  },
  {
    "lng": -83.1596108,
    "lat": 40.033814
  },
  {
    "lng": 10.8979522,
    "lat": 48.3690341
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -71.3517602,
    "lat": 42.5968617
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.399125,
    "lat": 47.0811658
  },
  {
    "lng": -106.82356,
    "lat": 39.1911128
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -0.7097768,
    "lat": 51.0876062
  },
  {
    "lng": -76.6826661,
    "lat": 39.3486919
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -80.0532942,
    "lat": 26.715364
  },
  {
    "lng": 4.8216902,
    "lat": 45.6733141
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -87.2169149,
    "lat": 30.421309
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": 4.8423304,
    "lat": 45.7969952
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 31.009909,
    "lat": -29.861825
  },
  {
    "lng": -86.1090828,
    "lat": 42.7876022
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -87.0717718,
    "lat": 20.6269889
  },
  {
    "lng": 14.2487679,
    "lat": 40.8358846
  },
  {
    "lng": -112.03628,
    "lat": 43.4887907
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -72.9250518,
    "lat": 41.3082138
  },
  {
    "lng": 78.4740613,
    "lat": 17.360589
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": -5.5352463,
    "lat": 50.1194794
  },
  {
    "lng": -73.4526144,
    "lat": 45.6050197
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.0729178,
    "lat": 46.0345572
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 2.4530731,
    "lat": 48.7771486
  },
  {
    "lng": 7.7769882,
    "lat": 48.2198805
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 36.8172449,
    "lat": -1.2832533
  },
  {
    "lng": 76.1391283,
    "lat": 28.7931703
  },
  {
    "lng": -71.2925571,
    "lat": 42.2964859
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.902805,
    "lat": 52.2343297
  },
  {
    "lng": -80.1386547,
    "lat": 26.8233946
  },
  {
    "lng": -1.2344047,
    "lat": 54.5760419
  },
  {
    "lng": -74.8909988,
    "lat": 39.934002
  },
  {
    "lng": -122.397126,
    "lat": 37.7586927
  },
  {
    "lng": -86.5859011,
    "lat": 34.729847
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -91.6704053,
    "lat": 41.9758872
  },
  {
    "lng": 10.7578121,
    "lat": 48.1805562
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -86.1336351,
    "lat": 40.4864444
  },
  {
    "lng": -0.3944534,
    "lat": 44.8777159
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": -0.9050287,
    "lat": 51.5375786
  },
  {
    "lng": -62.6483547,
    "lat": 45.5869474
  },
  {
    "lng": 4.7785644,
    "lat": 45.7754498
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -96.9771177,
    "lat": 37.6809165
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -1.1515951,
    "lat": 46.159732
  },
  {
    "lng": -74.1194403,
    "lat": 40.9796683
  },
  {
    "lng": -2.0976346,
    "lat": 57.1426487
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 14.7631229,
    "lat": 50.8700733
  },
  {
    "lng": -118.0879763,
    "lat": 34.0676169
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -111.9944938,
    "lat": 40.5252569
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -93.4638936,
    "lat": 44.9405086
  },
  {
    "lng": -1.1305431,
    "lat": 37.9923795
  },
  {
    "lng": -74.7226665,
    "lat": 39.9325409
  },
  {
    "lng": -84.5546295,
    "lat": 42.7338254
  },
  {
    "lng": 13.2457591,
    "lat": 52.7529379
  },
  {
    "lng": -46.5096698,
    "lat": -18.6041453
  },
  {
    "lng": -72.5982955,
    "lat": 44.5615499
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -87.5715641,
    "lat": 37.970495
  },
  {
    "lng": 15.4382786,
    "lat": 47.0708678
  },
  {
    "lng": -85.805386,
    "lat": 30.1765914
  },
  {
    "lng": 145.1177321,
    "lat": -37.5121301
  },
  {
    "lng": -76.9959168,
    "lat": 39.5751717
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -99.2599579,
    "lat": 18.9331321
  },
  {
    "lng": 22.1459535,
    "lat": 65.5831187
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -99.1517322,
    "lat": 19.4414715
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 4.87477,
    "lat": 45.52524
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 17.1314203,
    "lat": 48.1557669
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -91.5812739,
    "lat": 41.4797157
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -85.865235,
    "lat": 42.870889
  },
  {
    "lng": -95.2359403,
    "lat": 38.9719137
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 7.4652789,
    "lat": 51.5142273
  },
  {
    "lng": -0.4775114,
    "lat": 51.546655
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.9768632,
    "lat": 43.0020107
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 6.5340061,
    "lat": 45.4849883
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -118.4486675,
    "lat": 34.1866193
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -92.9339449,
    "lat": 44.919896
  },
  {
    "lng": -122.989827,
    "lat": 45.5228939
  },
  {
    "lng": -76.9369189,
    "lat": 38.980666
  },
  {
    "lng": -0.5515588,
    "lat": 47.4739884
  },
  {
    "lng": -118.307201,
    "lat": 34.1812089
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": -95.6349463,
    "lat": 29.6196787
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -83.5378173,
    "lat": 41.6529143
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.6621294,
    "lat": 41.4086874
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.4414627,
    "lat": 53.0996153
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 2.2255727,
    "lat": 48.8709053
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -82.7893788,
    "lat": 28.0116627
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -121.1841587,
    "lat": 45.6015056
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -81.4959267,
    "lat": 35.8484645
  },
  {
    "lng": -76.2899539,
    "lat": 36.8493695
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -83.376398,
    "lat": 33.9597677
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": -81.243372,
    "lat": 42.9832406
  },
  {
    "lng": 150.89385,
    "lat": -34.4243941
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": 6.3121658,
    "lat": 46.0672189
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -75.9279495,
    "lat": 40.335345
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -86.8425761,
    "lat": 21.1527467
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 16.5463679,
    "lat": 59.6110992
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": -122.4995234,
    "lat": 37.5980374
  },
  {
    "lng": -107.9779962,
    "lat": 36.7520109
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -75.3085201,
    "lat": 39.9809452
  },
  {
    "lng": -74.4222416,
    "lat": 40.6201412
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 7.4892974,
    "lat": 9.0643305
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 8.7548,
    "lat": 49.8152
  },
  {
    "lng": -83.1035688,
    "lat": 42.4620142
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 1.2644847,
    "lat": 45.8354243
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.5222961,
    "lat": 43.4652699
  },
  {
    "lng": -122.1238767,
    "lat": 47.6694141
  },
  {
    "lng": -75.0437814,
    "lat": 40.1742759
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -118.12706,
    "lat": 34.093042
  },
  {
    "lng": -80.148379,
    "lat": 25.9812025
  },
  {
    "lng": 1.144961,
    "lat": 41.1109268
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -72.9250518,
    "lat": 41.3082138
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": 127.0365,
    "lat": 37.5635
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -116.7811531,
    "lat": 47.6742994
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 2.3570028,
    "lat": 48.8125893
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 127.0466,
    "lat": 37.6686
  },
  {
    "lng": -118.12706,
    "lat": 34.093042
  },
  {
    "lng": -87.8003438,
    "lat": 42.1816919
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -74.0120817,
    "lat": 40.2203907
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 1.94063,
    "lat": 44.0664
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": 6.6916476,
    "lat": 51.1981778
  },
  {
    "lng": -120.5785796,
    "lat": 35.1235374
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.2301808,
    "lat": 47.3075369
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -119.0167679,
    "lat": 36.06523
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 20.1178282,
    "lat": -33.7869944
  },
  {
    "lng": 2.3194375,
    "lat": 48.8188544
  },
  {
    "lng": -71.5164618,
    "lat": 42.1428913
  },
  {
    "lng": 11.5879359,
    "lat": 50.9281717
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -82.6829406,
    "lat": 38.5367471
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.7808584,
    "lat": 45.8570477
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -122.261823,
    "lat": 37.504936
  },
  {
    "lng": -117.1827445,
    "lat": 34.0550328
  },
  {
    "lng": -83.9040944,
    "lat": 38.8645138
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 6.2402791,
    "lat": 46.3820585
  },
  {
    "lng": -122.9072329,
    "lat": 44.5363364
  },
  {
    "lng": 2.48291,
    "lat": 48.9031
  },
  {
    "lng": -94.2008288,
    "lat": 46.3580221
  },
  {
    "lng": -114.377385,
    "lat": 62.4540807
  },
  {
    "lng": -76.8317417,
    "lat": 39.2757359
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 4.8395051,
    "lat": 45.8765557
  },
  {
    "lng": -87.7844944,
    "lat": 41.5733669
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -73.6113502,
    "lat": 40.6534835
  },
  {
    "lng": 8.4444861,
    "lat": 47.3965147
  },
  {
    "lng": -1.2268602,
    "lat": 46.4604008
  },
  {
    "lng": -1.5167069,
    "lat": 51.4126079
  },
  {
    "lng": -73.0521981,
    "lat": 41.4928044
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -74.4113926,
    "lat": 40.518157
  },
  {
    "lng": -117.888855,
    "lat": 33.9170444
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -121.739005,
    "lat": 38.5435526
  },
  {
    "lng": 7.1161892,
    "lat": 46.791321
  },
  {
    "lng": -80.0728201,
    "lat": 26.4614625
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -84.5084835,
    "lat": 41.3203058
  },
  {
    "lng": -124.7911479,
    "lat": 49.2632931
  },
  {
    "lng": 5.2092152,
    "lat": 51.9493315
  },
  {
    "lng": -86.8926239,
    "lat": 41.3120186
  },
  {
    "lng": -74.228185,
    "lat": 40.8813513
  },
  {
    "lng": -81.0352313,
    "lat": 34.000754
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 7.1024635,
    "lat": 50.7352621
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": 12.3691588,
    "lat": 50.4773298
  },
  {
    "lng": 11.5879359,
    "lat": 50.9281717
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -79.05578,
    "lat": 35.9131542
  },
  {
    "lng": 7.9429235,
    "lat": 48.4695984
  },
  {
    "lng": 39.6111216,
    "lat": 24.471153
  },
  {
    "lng": 6.2364886,
    "lat": 52.2694896
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 11.5213344,
    "lat": 3.8689867
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -120.9968892,
    "lat": 37.6393419
  },
  {
    "lng": -0.4264364,
    "lat": 51.8850696
  },
  {
    "lng": -96.7297206,
    "lat": 32.9481789
  },
  {
    "lng": -69.0571014,
    "lat": 44.0823473
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.7078294,
    "lat": 40.7053335
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -7.9891608,
    "lat": 31.6258257
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -87.3653136,
    "lat": 41.4169806
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -121.3721745,
    "lat": 38.6857362
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -63.908282,
    "lat": 44.6401885
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 10.3952118,
    "lat": 63.4304475
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 15.4382786,
    "lat": 47.0708678
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 11.7135474,
    "lat": 55.7186117
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -72.5805642,
    "lat": 42.4636924
  },
  {
    "lng": -91.9901206,
    "lat": 30.0996471
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -118.5356869,
    "lat": 34.200768
  },
  {
    "lng": 13.48839,
    "lat": 48.2085868
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.9962165,
    "lat": 33.870413
  },
  {
    "lng": 8.90677,
    "lat": 53.1414124
  },
  {
    "lng": 11.8734455,
    "lat": 45.4077172
  },
  {
    "lng": -1.0198263,
    "lat": 44.6883648
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -3.000425,
    "lat": 51.5887675
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 12.7573679,
    "lat": 47.2713898
  },
  {
    "lng": 3.2917502,
    "lat": 49.5425466
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 67.0207055,
    "lat": 24.8546842
  },
  {
    "lng": 9.7385532,
    "lat": 52.3744779
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -80.1100556,
    "lat": 40.3561805
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -0.1991229,
    "lat": 51.4989948
  },
  {
    "lng": 12.5135924,
    "lat": 55.6637755
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": -76.7455478,
    "lat": 39.2609921
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -95.480941,
    "lat": 40.7192038
  },
  {
    "lng": 10.6613448,
    "lat": 52.5780612
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.0335624,
    "lat": 37.9768525
  },
  {
    "lng": 17.1467019,
    "lat": 60.6750132
  },
  {
    "lng": -73.8987469,
    "lat": 40.9312099
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": 6.5804218,
    "lat": 46.0603171
  },
  {
    "lng": -85.5356726,
    "lat": 41.9031963
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.3896123,
    "lat": 48.9267236
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -76.7083033,
    "lat": 40.2653681
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": -149.894852,
    "lat": 61.2163129
  },
  {
    "lng": -122.701098,
    "lat": 38.3396367
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": 2.8199439,
    "lat": 41.9793006
  },
  {
    "lng": 13.5960911,
    "lat": 52.3643159
  },
  {
    "lng": -117.000165,
    "lat": 46.7323875
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": -77.4463445,
    "lat": 38.9646244
  },
  {
    "lng": -79.7879575,
    "lat": 34.2069786
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.518485,
    "lat": 41.083064
  },
  {
    "lng": -81.684004,
    "lat": 36.2187873
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -1.7954134,
    "lat": 51.0690613
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": -75.3646997,
    "lat": 41.1220987
  },
  {
    "lng": -74.3148279,
    "lat": 40.6233995
  },
  {
    "lng": -1.0618718,
    "lat": 53.057309
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -77.3464516,
    "lat": 38.953282
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -3.1885456,
    "lat": 55.6517553
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -110.974847,
    "lat": 32.2228765
  },
  {
    "lng": -117.9962165,
    "lat": 33.870413
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -123.057938,
    "lat": 49.0846258
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.9587873,
    "lat": 42.1157038
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -76.5483724,
    "lat": 42.4374175
  },
  {
    "lng": -74.0076276,
    "lat": 41.0556645
  },
  {
    "lng": -118.2252073,
    "lat": 33.9805731
  },
  {
    "lng": -0.5564726,
    "lat": 51.3201891
  },
  {
    "lng": -0.5879629,
    "lat": 44.8088438
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": 12.8760923,
    "lat": 47.7222676
  },
  {
    "lng": -80.9450759,
    "lat": 35.0073697
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -76.1279841,
    "lat": 43.4112973
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.3859839,
    "lat": 38.0094235
  },
  {
    "lng": 14.2840858,
    "lat": 53.0586366
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.9640834,
    "lat": 54.6236326
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -114.9822486,
    "lat": 36.0319843
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -82.9780695,
    "lat": 42.2858536
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -86.3921096,
    "lat": 35.8460396
  },
  {
    "lng": 23.7615346,
    "lat": 37.8454602
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -0.5239863,
    "lat": 44.8552882
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 0.2673446,
    "lat": 51.1371483
  },
  {
    "lng": 2.2071267,
    "lat": 48.8924273
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -81.8778582,
    "lat": 28.810823
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -86.2483921,
    "lat": 43.2341813
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -9.4170802,
    "lat": 38.9632411
  },
  {
    "lng": 0.877989,
    "lat": 43.730545
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": 100.2249797,
    "lat": 26.8595868
  },
  {
    "lng": 4.2578662,
    "lat": 45.6456225
  },
  {
    "lng": -70.934205,
    "lat": 41.6362152
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -91.4984941,
    "lat": 44.811349
  },
  {
    "lng": -119.702667,
    "lat": 34.4221319
  },
  {
    "lng": 24.0168024,
    "lat": 35.5158141
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -73.9395687,
    "lat": 42.8142432
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -118.5016166,
    "lat": 34.1591324
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": 1.9350788,
    "lat": 48.572604
  },
  {
    "lng": -5.1034063,
    "lat": 50.1685457
  },
  {
    "lng": -116.200886,
    "lat": 43.6166163
  },
  {
    "lng": -71.1533859,
    "lat": 42.3491615
  },
  {
    "lng": 2.1868998,
    "lat": 48.9229416
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -1.7888672,
    "lat": 52.4146286
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.1361888,
    "lat": 42.1539141
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 6.8827786,
    "lat": 49.287307
  },
  {
    "lng": -111.841185,
    "lat": 33.3062031
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -84.020224,
    "lat": 42.3180163
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -99.6825332,
    "lat": 18.941407
  },
  {
    "lng": -122.5449763,
    "lat": 37.9060368
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 106.6811524,
    "lat": 10.8237546
  },
  {
    "lng": 100.5386136,
    "lat": 13.7784702
  },
  {
    "lng": -88.1479278,
    "lat": 41.7728699
  },
  {
    "lng": -70.2586618,
    "lat": 43.6573605
  },
  {
    "lng": 37.074632,
    "lat": 0.01403
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -71.29303,
    "lat": 43.334168
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 2.3227967,
    "lat": 48.7546687
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 4.3527807,
    "lat": 50.8469765
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.2215869,
    "lat": 33.9701009
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 2.316085,
    "lat": 48.7795178
  },
  {
    "lng": -149.5659964,
    "lat": -17.5373835
  },
  {
    "lng": -82.2797719,
    "lat": 33.8795325
  },
  {
    "lng": -121.971335,
    "lat": 47.8552259
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -74.4439254,
    "lat": 40.4951365
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.3855058,
    "lat": 41.436589
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -1.4736657,
    "lat": 43.4945144
  },
  {
    "lng": -117.8617337,
    "lat": 33.8714814
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -76.4626118,
    "lat": 40.375713
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -1.6676238,
    "lat": 43.3844003
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.1533859,
    "lat": 42.3491615
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -81.6182086,
    "lat": 33.5723191
  },
  {
    "lng": 13.39272,
    "lat": 51.5158115
  },
  {
    "lng": -86.6722192,
    "lat": 36.0600602
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -122.1598465,
    "lat": 37.4443293
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -96.9253004,
    "lat": 35.3272928
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": -9.228879,
    "lat": 38.705235
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -117.2919818,
    "lat": 33.0369867
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -84.1457505,
    "lat": 33.8062166
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": 0.526559,
    "lat": 51.3819167
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -98.7319703,
    "lat": 29.7946641
  },
  {
    "lng": -1.4663202,
    "lat": 52.4792826
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -121.0739897,
    "lat": 38.8945939
  },
  {
    "lng": -111.834914,
    "lat": 41.7313063
  },
  {
    "lng": -70.650549,
    "lat": -33.4625225
  },
  {
    "lng": -91.8482064,
    "lat": 37.2731038
  },
  {
    "lng": -71.0119948,
    "lat": 42.4084302
  },
  {
    "lng": -92.4453558,
    "lat": 31.3119463
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -71.9107903,
    "lat": 42.5449024
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -75.9424217,
    "lat": 39.5992989
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 5.986163,
    "lat": 49.4947826
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -103.228023,
    "lat": 44.0806041
  },
  {
    "lng": -87.9751964,
    "lat": 41.7950525
  },
  {
    "lng": 8.8278266,
    "lat": 49.4810598
  },
  {
    "lng": 4.7707325,
    "lat": 44.3475554
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 4.2754772,
    "lat": 43.6924382
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -118.3965758,
    "lat": 34.1637147
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -82.5594293,
    "lat": 36.550238
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -111.873193,
    "lat": 33.1364413
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -86.9300023,
    "lat": 35.751179
  },
  {
    "lng": -2.8062224,
    "lat": 47.6980235
  },
  {
    "lng": -0.0786839,
    "lat": 51.6517156
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -75.0148931,
    "lat": 40.0115009
  },
  {
    "lng": -76.9832568,
    "lat": 39.8005316
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -120.7678602,
    "lat": 37.1641544
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -1.1236065,
    "lat": 52.6321088
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -88.6116855,
    "lat": 30.385755
  },
  {
    "lng": -74.0243916,
    "lat": 41.503557
  },
  {
    "lng": 6.1834097,
    "lat": 48.6937223
  },
  {
    "lng": -118.8061794,
    "lat": 34.1460234
  },
  {
    "lng": -2.9350039,
    "lat": 43.2630018
  },
  {
    "lng": 7.7701468,
    "lat": 47.239082
  },
  {
    "lng": 10.1857757,
    "lat": 36.8002068
  },
  {
    "lng": -42.8815888,
    "lat": -20.7538586
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 11.3297921,
    "lat": 50.9793301
  },
  {
    "lng": -73.7001187,
    "lat": 42.7742446
  },
  {
    "lng": -117.7258122,
    "lat": 33.5761376
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -76.4626118,
    "lat": 40.375713
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -81.4075838,
    "lat": 28.2918995
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -122.80378,
    "lat": 45.4871723
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -96.6154471,
    "lat": 33.1976496
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -1.4621381,
    "lat": 53.3783713
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": -74.0844894,
    "lat": 41.7464972
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -70.650549,
    "lat": -33.4625225
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 1.1527865,
    "lat": 51.7883997
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": 8.4673098,
    "lat": 49.4892913
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": -79.5341802,
    "lat": 8.9714493
  },
  {
    "lng": -91.6704053,
    "lat": 41.9758872
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": -75.4904323,
    "lat": 39.919698
  },
  {
    "lng": -77.4605399,
    "lat": 38.3031837
  },
  {
    "lng": -93.161159,
    "lat": 44.4582041
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": -0.3775015,
    "lat": 51.5060205
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.6158764,
    "lat": 50.4479733
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -106.0433023,
    "lat": 39.6302657
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -119.3003779,
    "lat": 46.287645
  },
  {
    "lng": 6.9963543,
    "lat": 43.6008898
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.756367,
    "lat": 28.1470965
  },
  {
    "lng": 14.1566859,
    "lat": 56.0293778
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 13.0464806,
    "lat": 47.7981346
  },
  {
    "lng": -49.0658025,
    "lat": -26.9195567
  },
  {
    "lng": -121.899142,
    "lat": 37.6090291
  },
  {
    "lng": 5.5512698,
    "lat": 45.0706211
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -122.1238767,
    "lat": 47.6694141
  },
  {
    "lng": -75.7166345,
    "lat": 39.4497639
  },
  {
    "lng": -1.361178,
    "lat": 43.6334222
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 12.0974869,
    "lat": 49.0195333
  },
  {
    "lng": -118.4489739,
    "lat": 35.1321878
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -0.1908861,
    "lat": 51.3596769
  },
  {
    "lng": -1.7616499,
    "lat": 43.3641518
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 6.0128532,
    "lat": 43.1249185
  },
  {
    "lng": 4.6309653,
    "lat": 43.6776223
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -123.2620435,
    "lat": 44.5645659
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": -106.831735,
    "lat": 40.4848003
  },
  {
    "lng": -0.520823,
    "lat": 44.8327
  },
  {
    "lng": 9.8132829,
    "lat": 52.3077423
  },
  {
    "lng": 7.903787,
    "lat": 47.3496571
  },
  {
    "lng": -104.7612638,
    "lat": 39.5184514
  },
  {
    "lng": 23.7603118,
    "lat": 61.4980214
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -115.5720773,
    "lat": 51.175076
  },
  {
    "lng": -83.2259222,
    "lat": 35.3737293
  },
  {
    "lng": -71.3322798,
    "lat": 41.9841334
  },
  {
    "lng": -111.8953815,
    "lat": 40.5710454
  },
  {
    "lng": 5.3078261,
    "lat": 43.8236124
  },
  {
    "lng": -118.12706,
    "lat": 34.093042
  },
  {
    "lng": -1.0861976,
    "lat": 51.262826
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -75.9760751,
    "lat": 36.8496579
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -73.6165288,
    "lat": 41.3972985
  },
  {
    "lng": -80.2781057,
    "lat": 25.8575963
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -93.7477839,
    "lat": 32.5135356
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": 3.6959771,
    "lat": 43.4014434
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -0.3970796,
    "lat": 48.5279194
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -83.7484616,
    "lat": 42.2813722
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -102.938238,
    "lat": 48.397244
  },
  {
    "lng": -84.2472117,
    "lat": 43.6155825
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -1.3532834,
    "lat": 53.4179463
  },
  {
    "lng": -77.2676335,
    "lat": 38.636447
  },
  {
    "lng": -155.996933,
    "lat": 19.641941
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -88.5987119,
    "lat": 43.0694499
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -74.0237512,
    "lat": 40.7795455
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -118.036849,
    "lat": 34.0751571
  },
  {
    "lng": -121.173921,
    "lat": 44.2726203
  },
  {
    "lng": -122.0335624,
    "lat": 37.9768525
  },
  {
    "lng": -117.173895,
    "lat": 46.7304268
  },
  {
    "lng": -71.4677032,
    "lat": 42.7656251
  },
  {
    "lng": -77.246933,
    "lat": 44.031827
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -80.5800049,
    "lat": 35.4094178
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": 16.5804218,
    "lat": 51.8436068
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -71.0183787,
    "lat": 42.0834335
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.0660616,
    "lat": 51.5856184
  },
  {
    "lng": -82.4605068,
    "lat": 28.5710156
  },
  {
    "lng": -4.1433925,
    "lat": 50.3780967
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -86.3097278,
    "lat": 41.3436555
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": 174.9057626,
    "lat": -41.2125751
  },
  {
    "lng": -88.0016263,
    "lat": 41.6737149
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -82.0906448,
    "lat": 26.9761707
  },
  {
    "lng": -74.0643065,
    "lat": 40.3470543
  },
  {
    "lng": -81.5856742,
    "lat": 28.5656649
  },
  {
    "lng": -96.9442177,
    "lat": 32.8295183
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": -98.0866781,
    "lat": 30.1902067
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": -117.084195,
    "lat": 32.6400541
  },
  {
    "lng": -0.6502981,
    "lat": 35.7044415
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -71.0119948,
    "lat": 42.4084302
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -0.2796034,
    "lat": 51.5560695
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -98.2330927,
    "lat": 29.5707831
  },
  {
    "lng": -111.9395211,
    "lat": 40.6061337
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -106.6329806,
    "lat": 35.2702448
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -121.696026,
    "lat": 37.9317766
  },
  {
    "lng": -114.163761,
    "lat": 47.6905295
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -86.9838165,
    "lat": 34.6060203
  },
  {
    "lng": -86.4436018,
    "lat": 36.9903199
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -122.2301808,
    "lat": 47.3075369
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.5149128,
    "lat": 40.1303822
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -75.9760751,
    "lat": 36.8496579
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -118.0879763,
    "lat": 34.0676169
  },
  {
    "lng": 11.1174874,
    "lat": 51.1618258
  },
  {
    "lng": -90.1281824,
    "lat": 43.5822002
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -85.6678639,
    "lat": 42.9632425
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 1.6770956,
    "lat": 46.8203785
  },
  {
    "lng": -16.9086783,
    "lat": 32.6496497
  },
  {
    "lng": -75.5235149,
    "lat": 42.5311809
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 9.612468,
    "lat": 47.7811014
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -1.7970987,
    "lat": 47.9659271
  },
  {
    "lng": -90.5136642,
    "lat": 41.5058344
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 119.4124282,
    "lat": -5.1342962
  },
  {
    "lng": -77.3464516,
    "lat": 38.953282
  },
  {
    "lng": -119.0167679,
    "lat": 36.06523
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 11.6804033,
    "lat": 60.2538602
  },
  {
    "lng": -123.763124,
    "lat": 49.4721147
  },
  {
    "lng": 2.2453842,
    "lat": 48.7144587
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": -122.972545,
    "lat": 49.2433804
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.3311238,
    "lat": 51.5714876
  },
  {
    "lng": -93.7380243,
    "lat": 41.6274511
  },
  {
    "lng": -71.6422408,
    "lat": 42.3196015
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -109.92006,
    "lat": 22.8938884
  },
  {
    "lng": -84.9702475,
    "lat": 34.7691867
  },
  {
    "lng": -100.1417946,
    "lat": 25.6653356
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -124.311739,
    "lat": 49.3179514
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -88.4069744,
    "lat": 44.2613967
  },
  {
    "lng": -116.2188054,
    "lat": 33.7192808
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -121.899142,
    "lat": 37.6090291
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -100.783739,
    "lat": 46.808327
  },
  {
    "lng": -85.9213796,
    "lat": 39.2014405
  },
  {
    "lng": -118.12706,
    "lat": 34.093042
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -99.157701,
    "lat": 19.3718796
  },
  {
    "lng": -76.3056707,
    "lat": 40.0379958
  },
  {
    "lng": -83.2696509,
    "lat": 42.240872
  },
  {
    "lng": -120.2659105,
    "lat": 34.7379311
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.8591333,
    "lat": 40.5130953
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -71.0369301,
    "lat": 42.3912241
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -122.478836,
    "lat": 48.7544012
  },
  {
    "lng": -118.39524,
    "lat": 37.363679
  },
  {
    "lng": 7.1930989,
    "lat": 50.6739719
  },
  {
    "lng": -77.185843,
    "lat": 38.9366852
  },
  {
    "lng": -0.3345171,
    "lat": 51.5907595
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.5316686,
    "lat": 37.9747795
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -122.0066891,
    "lat": 37.8551351
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 5.1580574,
    "lat": 45.614003
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -16.3407638,
    "lat": 28.5232609
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 7.1024635,
    "lat": 50.7352621
  },
  {
    "lng": -7.9891608,
    "lat": 31.6258257
  },
  {
    "lng": -121.29318,
    "lat": 38.8915741
  },
  {
    "lng": -87.9802164,
    "lat": 42.0811563
  },
  {
    "lng": -118.0879763,
    "lat": 34.0676169
  },
  {
    "lng": -84.4721678,
    "lat": 42.7320307
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 3.570579,
    "lat": 47.7961287
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -83.0062746,
    "lat": 42.4932575
  },
  {
    "lng": -99.2327986,
    "lat": 19.4788356
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": -155.1003754,
    "lat": 19.6854458
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.2032767,
    "lat": 40.0394982
  },
  {
    "lng": -121.290779,
    "lat": 37.9577016
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": 5.4185663,
    "lat": 43.3000002
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": 150.5714724,
    "lat": -34.2039562
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -74.0243916,
    "lat": 41.503557
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -107.3246941,
    "lat": 39.5466381
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 17.6440484,
    "lat": 48.2052983
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -77.9076627,
    "lat": 38.0098412
  },
  {
    "lng": 28.1879101,
    "lat": -25.7459277
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": 2.2881683,
    "lat": 48.892956
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 106.6811524,
    "lat": 10.8237546
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 6.2341093,
    "lat": 46.1934005
  },
  {
    "lng": -88.0125794,
    "lat": 44.5126379
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 15.4382786,
    "lat": 47.0708678
  },
  {
    "lng": -121.7304882,
    "lat": 48.0074736
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.1161892,
    "lat": 46.791321
  },
  {
    "lng": 17.1314203,
    "lat": 48.1557669
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 19.9971534,
    "lat": 50.0469432
  },
  {
    "lng": 9.7241329,
    "lat": 47.5806323
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -79.7966835,
    "lat": 43.3248924
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.4442629,
    "lat": 27.1192213
  },
  {
    "lng": -1.3242212,
    "lat": 51.4020243
  },
  {
    "lng": -111.9738429,
    "lat": 41.2230048
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -80.4927815,
    "lat": 43.451291
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -79.1422464,
    "lat": 37.4137536
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 11.3297921,
    "lat": 50.9793301
  },
  {
    "lng": -25.6689503,
    "lat": 37.7393398
  },
  {
    "lng": -121.7529071,
    "lat": 36.9092773
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -87.8212263,
    "lat": 42.5846773
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": 2.4396714,
    "lat": 48.8474508
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -97.0618324,
    "lat": 27.8332175
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 6.3546345,
    "lat": 46.9040348
  },
  {
    "lng": -2.1208614,
    "lat": 53.5435569
  },
  {
    "lng": -0.3735636,
    "lat": 44.5973806
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -71.3085329,
    "lat": 42.6414437
  },
  {
    "lng": -117.374238,
    "lat": 33.9824949
  },
  {
    "lng": 2.2695658,
    "lat": 48.884683
  },
  {
    "lng": 1.0080556,
    "lat": 43.5138889
  },
  {
    "lng": -63.5859487,
    "lat": 44.648618
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -119.9843482,
    "lat": 38.9332411
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 6.9839073,
    "lat": 51.8957136
  },
  {
    "lng": -155.787398,
    "lat": 19.9469278
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -92.9174074,
    "lat": 41.4073138
  },
  {
    "lng": 14.8094385,
    "lat": 56.8787183
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -7.6200284,
    "lat": 33.5945144
  },
  {
    "lng": -156.4549898,
    "lat": 20.7476261
  },
  {
    "lng": -71.8864609,
    "lat": 41.8459316
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 11.0287364,
    "lat": 50.9777974
  },
  {
    "lng": 7.3106175,
    "lat": 51.5646195
  },
  {
    "lng": -92.3337366,
    "lat": 38.951883
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -74.2390353,
    "lat": 40.7987113
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -72.8948036,
    "lat": 41.5031239
  },
  {
    "lng": -77.43428,
    "lat": 37.5385087
  },
  {
    "lng": -73.9395687,
    "lat": 42.8142432
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -72.8611283,
    "lat": 41.6156735
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.3635615,
    "lat": 49.1813403
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -3.3738533,
    "lat": 51.5171616
  },
  {
    "lng": 6.9557118,
    "lat": 43.5810901
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -87.9296885,
    "lat": 42.3839618
  },
  {
    "lng": -0.0927317,
    "lat": 51.3758448
  },
  {
    "lng": -111.044047,
    "lat": 45.6794293
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -70.650549,
    "lat": -33.4625225
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": 2.1585037,
    "lat": 48.9409016
  },
  {
    "lng": 20.4777531,
    "lat": 53.776644
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.4464337,
    "lat": 47.5505154
  },
  {
    "lng": -119.242889,
    "lat": 34.4480495
  },
  {
    "lng": -87.5085821,
    "lat": 38.6907902
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -9.3901368,
    "lat": 38.7095707
  },
  {
    "lng": 2.0839562,
    "lat": 48.724051
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -118.191604,
    "lat": 33.7690164
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 17.9500556,
    "lat": 59.4293164
  },
  {
    "lng": 1.3009485,
    "lat": 38.9830568
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.4585418,
    "lat": 29.048099
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -82.4112377,
    "lat": 33.0015407
  },
  {
    "lng": 77.1201239,
    "lat": 43.0860537
  },
  {
    "lng": -71.4802694,
    "lat": 41.7198453
  },
  {
    "lng": -87.9020186,
    "lat": 42.3702996
  },
  {
    "lng": -73.6376527,
    "lat": 40.6335905
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": -79.7038708,
    "lat": 44.5014007
  },
  {
    "lng": -92.2896267,
    "lat": 34.7465071
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -81.7669488,
    "lat": 28.5551912
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 10.0660066,
    "lat": 52.2576212
  },
  {
    "lng": -2.2458192,
    "lat": 51.8653705
  },
  {
    "lng": -74.4660408,
    "lat": 40.5462553
  },
  {
    "lng": 6.5317943,
    "lat": 46.724144
  },
  {
    "lng": -95.2441009,
    "lat": 29.4238472
  },
  {
    "lng": -87.7090543,
    "lat": 41.4845996
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -116.9719684,
    "lat": 33.7475203
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -96.6388833,
    "lat": 32.912624
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -99.5069922,
    "lat": 27.5075005
  },
  {
    "lng": -70.7055941,
    "lat": 42.091769
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -76.7958641,
    "lat": 39.36907
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -74.951279,
    "lat": 40.1045549
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": -84.5822632,
    "lat": 33.8188333
  },
  {
    "lng": -121.971335,
    "lat": 47.8552259
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -4.129694,
    "lat": 52.9256029
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": -71.2804301,
    "lat": 41.9439695
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -1.1491319,
    "lat": 44.6316943
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -95.5507771,
    "lat": 30.7235263
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -107.9822884,
    "lat": 38.6049854
  },
  {
    "lng": -70.4132249,
    "lat": 41.653384
  },
  {
    "lng": -116.392326,
    "lat": 43.6086295
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -70.6038026,
    "lat": 41.4542914
  },
  {
    "lng": -111.8486019,
    "lat": 40.3881114
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 16.9197326,
    "lat": 52.4006632
  },
  {
    "lng": -122.1560768,
    "lat": 37.7249296
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -71.0119948,
    "lat": 42.4084302
  },
  {
    "lng": 6.1096409,
    "lat": 46.2567057
  },
  {
    "lng": -84.5740953,
    "lat": 30.8736613
  },
  {
    "lng": 2.1008067,
    "lat": 49.0508845
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -87.682932,
    "lat": 42.0693991
  },
  {
    "lng": -44.7610795,
    "lat": -23.1415413
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -76.8815207,
    "lat": 38.8622077
  },
  {
    "lng": 0.2781546,
    "lat": 50.7664372
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -104.901361,
    "lat": 40.4774818
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 9.6770448,
    "lat": 50.5542328
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -122.036349,
    "lat": 37.3688301
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -80.3123023,
    "lat": 43.3600536
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": -89.5187664,
    "lat": 34.3663773
  },
  {
    "lng": 2.3633048,
    "lat": 48.7921098
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.3503555,
    "lat": 60.5110194
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": 7.1780374,
    "lat": 51.264018
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -72.8684337,
    "lat": 41.2762081
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -71.4366813,
    "lat": 41.779588
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 8.2736253,
    "lat": 49.9995205
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -80.5222961,
    "lat": 43.4652699
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -75.0254256,
    "lat": 39.4862777
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -84.4721678,
    "lat": 42.7320307
  },
  {
    "lng": 2.2674892,
    "lat": 48.9148269
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.0946169,
    "lat": 40.5687128
  },
  {
    "lng": 7.2439029,
    "lat": 47.1402077
  },
  {
    "lng": -82.0609557,
    "lat": 39.3575616
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": -51.2303767,
    "lat": -30.0324999
  },
  {
    "lng": 6.394641,
    "lat": 58.983132
  },
  {
    "lng": -123.529828,
    "lat": 38.7674439
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -81.3656419,
    "lat": 28.6275253
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": -73.0151084,
    "lat": 40.7656539
  },
  {
    "lng": 136.8998438,
    "lat": 35.1851045
  },
  {
    "lng": -70.6554648,
    "lat": -33.422295
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -46.3286399,
    "lat": -23.9335988
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 0.5604805,
    "lat": 44.1749808
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -71.7614891,
    "lat": 42.5267443
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.7017858,
    "lat": 42.5909135
  },
  {
    "lng": -122.6744557,
    "lat": 45.6306954
  },
  {
    "lng": -90.7045297,
    "lat": 35.8348088
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.232523,
    "lat": 37.4863239
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -80.0691435,
    "lat": 26.615891
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.4046994,
    "lat": 48.856303
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -2.2327511,
    "lat": 53.3261292
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.427027,
    "lat": 34.2625025
  },
  {
    "lng": -84.1555267,
    "lat": 40.284241
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 5.5783856,
    "lat": 46.1825453
  },
  {
    "lng": 8.8071646,
    "lat": 53.0758196
  },
  {
    "lng": 71.4306682,
    "lat": 51.1282205
  },
  {
    "lng": -86.6722192,
    "lat": 36.0600602
  },
  {
    "lng": -70.4429592,
    "lat": 43.6797334
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": -47.059564,
    "lat": -22.9056391
  },
  {
    "lng": -118.374752,
    "lat": 34.1649502
  },
  {
    "lng": -3.2751174,
    "lat": 47.8058026
  },
  {
    "lng": -80.1433786,
    "lat": 26.1223084
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.4034182,
    "lat": 50.8720096
  },
  {
    "lng": -88.4605713,
    "lat": 42.3294391
  },
  {
    "lng": -104.901361,
    "lat": 40.4774818
  },
  {
    "lng": -80.2440518,
    "lat": 36.0998131
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.0135253,
    "lat": 51.5911967
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -74.3415394,
    "lat": 41.0037087
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": -79.1822594,
    "lat": 40.8270091
  },
  {
    "lng": -122.116578,
    "lat": 37.3790629
  },
  {
    "lng": -84.8407732,
    "lat": 33.9237141
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 4.7449605,
    "lat": 52.4681109
  },
  {
    "lng": -86.5859011,
    "lat": 34.729847
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -78.7812081,
    "lat": 35.7882893
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -98.1981486,
    "lat": 19.0437196
  },
  {
    "lng": -81.0921335,
    "lat": 32.0790074
  },
  {
    "lng": 139.556512,
    "lat": 35.636327
  },
  {
    "lng": 74.2405329,
    "lat": 16.7028412
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -117.3505966,
    "lat": 33.1580933
  },
  {
    "lng": -106.4870404,
    "lat": 31.7601164
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": 1.2644847,
    "lat": 45.8354243
  },
  {
    "lng": 11.4250395,
    "lat": 48.7630165
  },
  {
    "lng": 1.3819699,
    "lat": 51.3878174
  },
  {
    "lng": -5.5627852,
    "lat": 54.6489642
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": 10.2358999,
    "lat": 53.6736529
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": -84.6696549,
    "lat": 33.5178907
  },
  {
    "lng": -77.3115564,
    "lat": 37.5107225
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -88.0079271,
    "lat": 43.0494122
  },
  {
    "lng": -99.7475905,
    "lat": 32.44645
  },
  {
    "lng": -120.9968892,
    "lat": 37.6393419
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": -71.0993581,
    "lat": 42.4802635
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -2.7599079,
    "lat": 47.6586772
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -76.5483724,
    "lat": 42.4374175
  },
  {
    "lng": -86.1336351,
    "lat": 40.4864444
  },
  {
    "lng": -82.3984882,
    "lat": 34.851354
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -52.7066964,
    "lat": 47.5646794
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -38.4812772,
    "lat": -12.9822499
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -116.2188054,
    "lat": 33.7192808
  },
  {
    "lng": -122.587967,
    "lat": 37.9872935
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -93.9993505,
    "lat": 44.1634663
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -76.610759,
    "lat": 39.2908816
  },
  {
    "lng": -71.8046023,
    "lat": 42.5854371
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -0.4675041,
    "lat": 52.1363806
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -2.8042467,
    "lat": 53.4275807
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -90.0539604,
    "lat": 29.9146493
  },
  {
    "lng": -97.1413417,
    "lat": 33.1838787
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": 9.1895147,
    "lat": 48.8953937
  },
  {
    "lng": -77.0893094,
    "lat": 38.8769326
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -76.8646092,
    "lat": 39.1938429
  },
  {
    "lng": -75.3173407,
    "lat": 40.0238245
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 72.5800568,
    "lat": 23.0215374
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -42.507633,
    "lat": -22.9257974
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -74.0218037,
    "lat": 40.1784471
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -105.101928,
    "lat": 40.1672117
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -83.1338214,
    "lat": 42.680588
  },
  {
    "lng": -81.4548392,
    "lat": 39.4167742
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -80.2440518,
    "lat": 36.0998131
  },
  {
    "lng": 0.0689113,
    "lat": 51.5589375
  },
  {
    "lng": -1.3824404,
    "lat": 54.9061115
  },
  {
    "lng": -85.4997057,
    "lat": 36.1623886
  },
  {
    "lng": 73.7902364,
    "lat": 20.0112475
  },
  {
    "lng": -0.8324037,
    "lat": 51.4120318
  },
  {
    "lng": 121.0338973,
    "lat": 14.5774392
  },
  {
    "lng": -99.1952423,
    "lat": 19.3906515
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -117.7999026,
    "lat": 49.0784756
  },
  {
    "lng": -149.894852,
    "lat": 61.2163129
  },
  {
    "lng": -85.7602087,
    "lat": 38.2967791
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -72.6077753,
    "lat": 41.7148499
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.3865271,
    "lat": 40.1936892
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -122.5352539,
    "lat": 37.9340915
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -99.1955083,
    "lat": 19.5370001
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 12.3425797,
    "lat": 45.5035386
  },
  {
    "lng": -1.7854322,
    "lat": 51.5615327
  },
  {
    "lng": 1.1528095,
    "lat": 52.0579324
  },
  {
    "lng": -73.1846098,
    "lat": 44.534084
  },
  {
    "lng": -1.5149935,
    "lat": 43.4813927
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": 6.282178,
    "lat": 46.7745324
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -72.7296262,
    "lat": 42.2294201
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -77.710254,
    "lat": 39.5893502
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 125.4515852,
    "lat": 6.878324
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -121.99059,
    "lat": 37.050096
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -96.9034244,
    "lat": 32.9515472
  },
  {
    "lng": -75.2590721,
    "lat": 39.9184461
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 13.08824,
    "lat": 52.5606426
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -97.1384584,
    "lat": 49.8955367
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": 2.3197111,
    "lat": 48.9891693
  },
  {
    "lng": 127.4554285,
    "lat": 36.3120051
  },
  {
    "lng": -74.0323752,
    "lat": 40.7433066
  },
  {
    "lng": 18.4368451,
    "lat": 49.7801136
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.5341802,
    "lat": 8.9714493
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -83.6554159,
    "lat": 36.5798289
  },
  {
    "lng": -74.0410865,
    "lat": 40.8871438
  },
  {
    "lng": 6.7360182,
    "lat": 43.4330308
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -87.8536288,
    "lat": 41.630663
  },
  {
    "lng": -71.1564428,
    "lat": 42.4153739
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -74.0254577,
    "lat": 45.3971509
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 0.2781546,
    "lat": 50.7664372
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.1867391,
    "lat": 41.1779095
  },
  {
    "lng": -123.0737925,
    "lat": 49.3206294
  },
  {
    "lng": -66.9146008,
    "lat": 10.5060934
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -84.2332718,
    "lat": 39.5522815
  },
  {
    "lng": -87.2550353,
    "lat": 41.5322592
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.2471089,
    "lat": 42.3479005
  },
  {
    "lng": -82.4333742,
    "lat": 42.9760854
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -94.626497,
    "lat": 39.1134562
  },
  {
    "lng": 22.0291149,
    "lat": 60.4688687
  },
  {
    "lng": 0.1481142,
    "lat": 51.5413271
  },
  {
    "lng": -103.3913671,
    "lat": 20.7211203
  },
  {
    "lng": 6.9478263,
    "lat": 46.252844
  },
  {
    "lng": 2.2766735,
    "lat": 48.730158
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -118.307201,
    "lat": 34.1812089
  },
  {
    "lng": 14.286198,
    "lat": 48.3059078
  },
  {
    "lng": -43.9450948,
    "lat": -19.9227318
  },
  {
    "lng": -74.6607144,
    "lat": 40.4667713
  },
  {
    "lng": -1.5391039,
    "lat": 53.9921491
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": 18.1820897,
    "lat": 59.3669445
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -83.4754913,
    "lat": 42.48059
  },
  {
    "lng": -80.0131374,
    "lat": 33.1960027
  },
  {
    "lng": -75.2215651,
    "lat": 40.1545535
  },
  {
    "lng": 139.7280058,
    "lat": 35.744206
  },
  {
    "lng": -121.971335,
    "lat": 47.8552259
  },
  {
    "lng": -76.5528831,
    "lat": 39.155816
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -121.899142,
    "lat": 37.6090291
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -122.0618702,
    "lat": 37.9020731
  },
  {
    "lng": -122.9543022,
    "lat": 50.1171903
  },
  {
    "lng": -1.4761491,
    "lat": 52.9212617
  },
  {
    "lng": -73.9081901,
    "lat": 42.0128695
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -3.7824148,
    "lat": 51.5952353
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": -94.626497,
    "lat": 39.1134562
  },
  {
    "lng": 5.4474738,
    "lat": 43.5298424
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -65.2038133,
    "lat": -26.8303703
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -120.310349,
    "lat": 47.4234599
  },
  {
    "lng": -97.7870525,
    "lat": 32.4426759
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": -83.1446485,
    "lat": 42.4894801
  },
  {
    "lng": -46.7916801,
    "lat": -23.5324859
  },
  {
    "lng": -9.2365233,
    "lat": 38.758959
  },
  {
    "lng": -0.902805,
    "lat": 52.2343297
  },
  {
    "lng": -122.2127011,
    "lat": 47.9793437
  },
  {
    "lng": -116.559631,
    "lat": 43.5737361
  },
  {
    "lng": -79.5692407,
    "lat": 44.9955309
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 4.7201986,
    "lat": 46.3472473
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -87.7115555,
    "lat": 42.076066
  },
  {
    "lng": -82.255371,
    "lat": 34.7373045
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -0.0786839,
    "lat": 51.6517156
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -3.5269209,
    "lat": 50.7256138
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": 4.93296,
    "lat": 44.8534
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.1562551,
    "lat": 40.7464901
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -90.5132836,
    "lat": 14.6416142
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -122.6925983,
    "lat": 45.2629088
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.3433705,
    "lat": 40.1148787
  },
  {
    "lng": -92.9645794,
    "lat": 44.985624
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -16.2507843,
    "lat": 28.467178
  },
  {
    "lng": 5.2146275,
    "lat": 43.4162729
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -97.6114237,
    "lat": 38.8402805
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -73.425676,
    "lat": 40.868154
  },
  {
    "lng": 5.2176582,
    "lat": 52.3722582
  },
  {
    "lng": -123.6229791,
    "lat": 48.6538128
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -86.5245906,
    "lat": 35.9670985
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 1.204956,
    "lat": 49.2551454
  },
  {
    "lng": -17.447938,
    "lat": 14.693425
  },
  {
    "lng": -94.4137923,
    "lat": 39.0924792
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": -71.5147839,
    "lat": 42.0028761
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": -77.1516844,
    "lat": 39.0817985
  },
  {
    "lng": -73.2504911,
    "lat": 42.3073477
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": -75.0629531,
    "lat": 42.453492
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -110.3158532,
    "lat": 24.1619948
  },
  {
    "lng": 2.4455201,
    "lat": 48.9229803
  },
  {
    "lng": -0.0472059,
    "lat": 38.6028245
  },
  {
    "lng": -76.5600957,
    "lat": 38.3380008
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 30.7030242,
    "lat": 36.8865728
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.4993421,
    "lat": 42.6411975
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -3.1791934,
    "lat": 51.4816546
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": 14.0381357,
    "lat": 50.6603327
  },
  {
    "lng": -82.6359078,
    "lat": 27.7700475
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": -82.9741393,
    "lat": 42.5438148
  },
  {
    "lng": -87.9299841,
    "lat": 41.8024604
  },
  {
    "lng": 23.7603118,
    "lat": 61.4980214
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -109.2194544,
    "lat": 41.5860557
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -94.9774274,
    "lat": 29.7355047
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.2775316,
    "lat": 48.7670404
  },
  {
    "lng": -117.3272615,
    "lat": 33.6680772
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -9.1072662,
    "lat": 38.6422246
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -115.474899,
    "lat": 32.6405247
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -3.0087671,
    "lat": 43.3479409
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -77.185843,
    "lat": 38.9366852
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -80.7325345,
    "lat": 28.3556635
  },
  {
    "lng": 2.2766735,
    "lat": 48.730158
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -1.5959177,
    "lat": 48.8376296
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 10.3694118,
    "lat": 52.2608949
  },
  {
    "lng": 7.3579641,
    "lat": 48.0777517
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -2.5943178,
    "lat": 53.3899497
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 2.6045838,
    "lat": 49.3012483
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -71.1786655,
    "lat": 42.3959296
  },
  {
    "lng": -80.0666026,
    "lat": 26.5256179
  },
  {
    "lng": 5.9304919,
    "lat": 43.1257311
  },
  {
    "lng": -86.5342881,
    "lat": 39.1670396
  },
  {
    "lng": -77.3191454,
    "lat": 42.850682
  },
  {
    "lng": -123.315869,
    "lat": 44.9189206
  },
  {
    "lng": -77.57539,
    "lat": 44.1019126
  },
  {
    "lng": -0.7242791,
    "lat": 45.0924569
  },
  {
    "lng": -80.5495112,
    "lat": 34.9854275
  },
  {
    "lng": -118.8375937,
    "lat": 34.1705609
  },
  {
    "lng": 10.4510906,
    "lat": 54.0341582
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 8.5345821,
    "lat": 52.0267233
  },
  {
    "lng": 3.8969928,
    "lat": 7.3786064
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -84.2138789,
    "lat": 10.0165183
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -121.802173,
    "lat": 36.6844029
  },
  {
    "lng": -95.6971686,
    "lat": 29.9691116
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -99.243949,
    "lat": 19.5733975
  },
  {
    "lng": 2.3210103,
    "lat": 48.8667225
  },
  {
    "lng": 11.3426327,
    "lat": 44.4938203
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -71.010051,
    "lat": 42.4648183
  },
  {
    "lng": -122.2054035,
    "lat": 47.7623204
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.0832101,
    "lat": 37.3893889
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -119.019463,
    "lat": 35.3738712
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -121.503636,
    "lat": 43.6703995
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.1400561,
    "lat": 50.8214626
  },
  {
    "lng": -75.4179623,
    "lat": 41.1770316
  },
  {
    "lng": 73.8545071,
    "lat": 18.5213738
  },
  {
    "lng": -99.157701,
    "lat": 19.3718796
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 2.2630238,
    "lat": 48.8003835
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -77.1549078,
    "lat": 39.3765918
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -88.3161965,
    "lat": 42.2411344
  },
  {
    "lng": -97.1503865,
    "lat": 27.909666
  },
  {
    "lng": -122.3218414,
    "lat": 38.4898675
  },
  {
    "lng": 24.7453688,
    "lat": 59.4372155
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -93.847129,
    "lat": 33.9456692
  },
  {
    "lng": 7.5004774,
    "lat": 47.0168481
  },
  {
    "lng": -83.2910468,
    "lat": 42.6389216
  },
  {
    "lng": -83.1052028,
    "lat": 42.4858692
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -0.1332853,
    "lat": 50.9575365
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -80.154904,
    "lat": -3.4145538
  },
  {
    "lng": 2.590549,
    "lat": 48.8783804
  },
  {
    "lng": -117.379483,
    "lat": 33.1958696
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": 6.4353792,
    "lat": 51.1947131
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 8.9520281,
    "lat": 46.0050102
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -87.8122348,
    "lat": 42.0289319
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -85.8480354,
    "lat": 39.9322625
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -71.4165905,
    "lat": 42.2773177
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -95.2864299,
    "lat": 29.5639758
  },
  {
    "lng": 5.112215,
    "lat": 43.8441157
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 6.6816355,
    "lat": 46.6012433
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -96.9977846,
    "lat": 32.7459645
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -123.0950506,
    "lat": 44.0505054
  },
  {
    "lng": -117.000165,
    "lat": 46.7323875
  },
  {
    "lng": 0.2446652,
    "lat": 50.8276836
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 10.8815262,
    "lat": 49.5710376
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": -73.1307708,
    "lat": 41.1947276
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 77.1709729,
    "lat": 31.1041526
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -8.6192306,
    "lat": 41.5314496
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 17.916667,
    "lat": 59.516667
  },
  {
    "lng": -8.6103497,
    "lat": 41.1502195
  },
  {
    "lng": -72.1934184,
    "lat": 41.3212481
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 4.8868454,
    "lat": 45.7733573
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 15.25,
    "lat": 59.05
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -122.47267,
    "lat": 37.6904826
  },
  {
    "lng": 15.094215,
    "lat": 37.5774071
  },
  {
    "lng": 12.087733,
    "lat": 49.05151
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -90.6956872,
    "lat": 37.154497
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -74.0237512,
    "lat": 40.7795455
  },
  {
    "lng": -96.789821,
    "lat": 46.877229
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.438329,
    "lat": 47.2455013
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.6171001,
    "lat": 54.9751321
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -86.0887296,
    "lat": 35.4832001
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -74.171811,
    "lat": 40.9167654
  },
  {
    "lng": -77.1710914,
    "lat": 38.882334
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -73.5835826,
    "lat": 40.6576071
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -0.74043,
    "lat": 50.9841854
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -91.2514355,
    "lat": 43.8122836
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": -4.4216366,
    "lat": 36.7213028
  },
  {
    "lng": 8.2416556,
    "lat": 50.0820384
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -97.1071186,
    "lat": 32.7355816
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -85.8590603,
    "lat": 41.6012796
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -114.568298,
    "lat": 35.1477774
  },
  {
    "lng": 16.6957954,
    "lat": 47.913427
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 12.5700724,
    "lat": 55.6867243
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 10.5385882,
    "lat": 52.9840679
  },
  {
    "lng": 7.2196635,
    "lat": 51.4818111
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 8.7610698,
    "lat": 50.1055002
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -76.7455478,
    "lat": 39.2609921
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -123.0950506,
    "lat": 44.0505054
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": 7.8400336,
    "lat": 52.0362198
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -88.0437509,
    "lat": 30.6913462
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -99.5069922,
    "lat": 27.5075005
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -80.4927815,
    "lat": 43.451291
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -114.9822486,
    "lat": 36.0319843
  },
  {
    "lng": 11.9670171,
    "lat": 57.7072326
  },
  {
    "lng": -80.1792299,
    "lat": 39.8964641
  },
  {
    "lng": -71.3725464,
    "lat": -33.0441903
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -80.8429304,
    "lat": 35.4108278
  },
  {
    "lng": 7.0845893,
    "lat": 51.1721629
  },
  {
    "lng": -114.568298,
    "lat": 35.1477774
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -112.185994,
    "lat": 33.5386858
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.4726215,
    "lat": 38.3235441
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 7.802508,
    "lat": 48.7182493
  },
  {
    "lng": -75.1268413,
    "lat": 40.0770553
  },
  {
    "lng": -74.9999754,
    "lat": 40.0166151
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -74.3592296,
    "lat": 40.7182356
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.9695409,
    "lat": 41.5048402
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -83.2396612,
    "lat": 42.7844752
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -2.4396676,
    "lat": 42.4661196
  },
  {
    "lng": -89.6501621,
    "lat": 40.5687911
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -98.2695702,
    "lat": 29.5641617
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -70.7548621,
    "lat": 43.0702223
  },
  {
    "lng": -74.2289491,
    "lat": 40.7264091
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -93.3501222,
    "lat": 44.8897027
  },
  {
    "lng": -93.6249494,
    "lat": 41.5868654
  },
  {
    "lng": -80.0830984,
    "lat": 26.3586885
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -94.8907869,
    "lat": 47.4785418
  },
  {
    "lng": -95.8243956,
    "lat": 29.7857853
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -71.1818781,
    "lat": 44.1105541
  },
  {
    "lng": 75.8189817,
    "lat": 26.9154576
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 7.7391678,
    "lat": 52.1363237
  },
  {
    "lng": 110.4229104,
    "lat": -6.9903988
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -117.3505966,
    "lat": 33.1580933
  },
  {
    "lng": -80.4934035,
    "lat": 41.2331116
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -121.8106925,
    "lat": 38.0093296
  },
  {
    "lng": 141.3542924,
    "lat": 43.061936
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -60.9677445,
    "lat": -34.5796344
  },
  {
    "lng": -76.9832568,
    "lat": 39.8005316
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.080796,
    "lat": 37.6688205
  },
  {
    "lng": -117.1743395,
    "lat": 33.1352995
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -121.290779,
    "lat": 37.9577016
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -75.1198911,
    "lat": 39.9448402
  },
  {
    "lng": -118.6058382,
    "lat": 34.1684364
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -122.7453699,
    "lat": 53.9128645
  },
  {
    "lng": 3.9452194,
    "lat": 50.4431879
  },
  {
    "lng": -58.7157491,
    "lat": -34.540349
  },
  {
    "lng": -96.789821,
    "lat": 46.877229
  },
  {
    "lng": -117.7197785,
    "lat": 34.0966764
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -73.7145746,
    "lat": 41.0409305
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -88.5061721,
    "lat": 40.211422
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -118.7885967,
    "lat": 45.672075
  },
  {
    "lng": 47.9734174,
    "lat": 29.3796532
  },
  {
    "lng": -70.9494939,
    "lat": 42.466763
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": -117.9962165,
    "lat": 33.870413
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -74.4113926,
    "lat": 40.518157
  },
  {
    "lng": -73.8381351,
    "lat": 42.6251239
  },
  {
    "lng": 8.8791526,
    "lat": 51.936284
  },
  {
    "lng": -74.9426677,
    "lat": 39.9670569
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 80.9346001,
    "lat": 26.8381
  },
  {
    "lng": -77.4083096,
    "lat": 39.003685
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -70.7618592,
    "lat": 41.9426657
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -79.05578,
    "lat": 35.9131542
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 71.4306682,
    "lat": 51.1282205
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -97.0819541,
    "lat": 32.8370727
  },
  {
    "lng": -92.4630182,
    "lat": 44.0234387
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 44.8005558,
    "lat": 41.6953103
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.4173658,
    "lat": 48.8688199
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": -48.5496098,
    "lat": -27.5973002
  },
  {
    "lng": -79.0287742,
    "lat": -8.1116778
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 13.4153952,
    "lat": 52.3384429
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -72.9250518,
    "lat": 41.3082138
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -81.4222408,
    "lat": 26.42016
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 55.7452211,
    "lat": 24.2248697
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": -3.2299102,
    "lat": 51.6489468
  },
  {
    "lng": -0.3394758,
    "lat": 53.7435722
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -83.1499322,
    "lat": 42.6583661
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -112.081648,
    "lat": 40.7031629
  },
  {
    "lng": -82.5817053,
    "lat": 34.8269276
  },
  {
    "lng": 8.3266114,
    "lat": 47.465839
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 73.8545071,
    "lat": 18.5213738
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": 98.3891503,
    "lat": 7.8847901
  },
  {
    "lng": -76.4229094,
    "lat": 40.8724037
  },
  {
    "lng": 76.7797143,
    "lat": 30.7334421
  },
  {
    "lng": -79.5341802,
    "lat": 8.9714493
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 7.0581152,
    "lat": 46.6190969
  },
  {
    "lng": 149.1012676,
    "lat": -35.2975906
  },
  {
    "lng": -116.9739167,
    "lat": 32.8383828
  },
  {
    "lng": 121.451,
    "lat": 25.0615
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": 27.4962548,
    "lat": 38.4549686
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -92.9438218,
    "lat": 44.8277446
  },
  {
    "lng": -1.4761491,
    "lat": 52.9212617
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 23.683814,
    "lat": 38.0425567
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.9813349,
    "lat": 44.6697996
  },
  {
    "lng": 3.2131307,
    "lat": 43.3426562
  },
  {
    "lng": -73.6788272,
    "lat": 41.4266361
  },
  {
    "lng": 0.0769545,
    "lat": 51.4115718
  },
  {
    "lng": -92.2896267,
    "lat": 34.7465071
  },
  {
    "lng": 11.3297921,
    "lat": 50.9793301
  },
  {
    "lng": -1.1210853,
    "lat": 50.7952074
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -149.894852,
    "lat": 61.2163129
  },
  {
    "lng": 2.4412184,
    "lat": 48.8623357
  },
  {
    "lng": -96.7297206,
    "lat": 32.9481789
  },
  {
    "lng": -1.9417444,
    "lat": 52.3057655
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 77.7679671,
    "lat": 29.0018557
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 9.4048406,
    "lat": 51.0117227
  },
  {
    "lng": -1.6302142,
    "lat": 53.6909103
  },
  {
    "lng": -68.672791,
    "lat": 44.883607
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 8.9420101,
    "lat": 45.9838461
  },
  {
    "lng": -8.7247205,
    "lat": 42.2376602
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -75.2890745,
    "lat": 39.9001126
  },
  {
    "lng": -71.0744952,
    "lat": 42.2973205
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -111.9866954,
    "lat": 40.6967891
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": -117.953097,
    "lat": 34.0280619
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -95.858694,
    "lat": 40.676526
  },
  {
    "lng": -0.591276,
    "lat": 51.512103
  },
  {
    "lng": -74.4222416,
    "lat": 40.6201412
  },
  {
    "lng": -87.607616,
    "lat": 45.415251
  },
  {
    "lng": 50.1039991,
    "lat": 26.4367824
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -87.7115555,
    "lat": 42.076066
  },
  {
    "lng": -71.1061639,
    "lat": 42.4184296
  },
  {
    "lng": -88.0434304,
    "lat": 42.1105502
  },
  {
    "lng": -88.083406,
    "lat": 42.0333608
  },
  {
    "lng": 7.1262071,
    "lat": 43.5812868
  },
  {
    "lng": 7.3389937,
    "lat": 47.7467233
  },
  {
    "lng": -122.5316686,
    "lat": 37.9747795
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -72.789313,
    "lat": 41.9538298
  },
  {
    "lng": -73.642509,
    "lat": 41.2041304
  },
  {
    "lng": -0.6450841,
    "lat": 53.5922488
  },
  {
    "lng": -0.3250175,
    "lat": 45.6931647
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -87.8122348,
    "lat": 42.0289319
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -76.307162,
    "lat": 40.1571324
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 4.8920811,
    "lat": 44.9332277
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -122.271356,
    "lat": 37.8044557
  },
  {
    "lng": 139.5400411,
    "lat": 35.7287951
  },
  {
    "lng": -74.4222416,
    "lat": 40.6201412
  },
  {
    "lng": -84.0795782,
    "lat": 9.9325427
  },
  {
    "lng": -75.3490769,
    "lat": 40.0373323
  },
  {
    "lng": 124.7243618,
    "lat": 8.4993515
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -122.8950075,
    "lat": 47.0451022
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -8.6103497,
    "lat": 41.1502195
  },
  {
    "lng": -1.0582645,
    "lat": 52.566854
  },
  {
    "lng": 5.6969882,
    "lat": 50.8579855
  },
  {
    "lng": -71.2503157,
    "lat": 41.6024068
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -75.2216048,
    "lat": 38.4606407
  },
  {
    "lng": -0.3957425,
    "lat": 51.6553875
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.4736657,
    "lat": 43.4945144
  },
  {
    "lng": -49.2712724,
    "lat": -25.4295963
  },
  {
    "lng": -123.137414,
    "lat": 49.163168
  },
  {
    "lng": 5.1580574,
    "lat": 45.614003
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -71.2213228,
    "lat": 43.4563663
  },
  {
    "lng": -80.794252,
    "lat": 34.1709826
  },
  {
    "lng": 8.7291498,
    "lat": 47.4991723
  },
  {
    "lng": 5.862294,
    "lat": 43.4522053
  },
  {
    "lng": -81.6695739,
    "lat": 39.3753521
  },
  {
    "lng": 91.8825282,
    "lat": 25.5760446
  },
  {
    "lng": 5.9815066,
    "lat": 50.8775239
  },
  {
    "lng": -85.4807825,
    "lat": 32.6098566
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": 75.851601,
    "lat": 30.9090157
  },
  {
    "lng": 2.4159739,
    "lat": 48.8432434
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 26.1190178,
    "lat": 44.3819025
  },
  {
    "lng": 76.7176885,
    "lat": 30.7041168
  },
  {
    "lng": 26.1772794,
    "lat": 44.4902779
  },
  {
    "lng": 33.0332657,
    "lat": 34.6852901
  },
  {
    "lng": 2.4806112,
    "lat": 48.8412317
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -87.850367,
    "lat": 43.4997212
  },
  {
    "lng": -82.2880508,
    "lat": 27.928464
  },
  {
    "lng": -71.0119948,
    "lat": 42.4084302
  },
  {
    "lng": 12.4985492,
    "lat": 55.704111
  },
  {
    "lng": -105.0811573,
    "lat": 39.8005505
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -61.4764728,
    "lat": -31.2492442
  },
  {
    "lng": 6.9129921,
    "lat": 46.4310831
  },
  {
    "lng": -72.8684337,
    "lat": 41.2762081
  },
  {
    "lng": -105.089705,
    "lat": 39.9935959
  },
  {
    "lng": 0.2175739,
    "lat": 44.460778
  },
  {
    "lng": 19.4784857,
    "lat": 51.7728245
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": 7.0845893,
    "lat": 51.1721629
  },
  {
    "lng": -122.870138,
    "lat": 38.6106812
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -83.3771553,
    "lat": 42.4853125
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -1.4722242,
    "lat": 47.1685211
  },
  {
    "lng": 2.2257833,
    "lat": 48.7423961
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 26.1650992,
    "lat": 44.4182836
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 24.6559808,
    "lat": 60.2049651
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": 23.7089143,
    "lat": 38.0620067
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.3111645,
    "lat": 39.2025604
  },
  {
    "lng": -5.9953403,
    "lat": 37.3886303
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": 12.2455414,
    "lat": 45.6658505
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -155.9564366,
    "lat": 19.663401
  },
  {
    "lng": 5.1215634,
    "lat": 52.0907006
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -75.5149128,
    "lat": 40.1303822
  },
  {
    "lng": -34.8848193,
    "lat": -8.0584933
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -79.7567616,
    "lat": 43.2167526
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 7.7430022,
    "lat": 46.3153507
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": 78.4740613,
    "lat": 17.360589
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 26.2513165,
    "lat": 50.6196175
  },
  {
    "lng": -122.2054035,
    "lat": 47.7623204
  },
  {
    "lng": 7.0086255,
    "lat": 43.641141
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 5.4768915,
    "lat": 52.5150949
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 78.4740613,
    "lat": 17.360589
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 8.4673098,
    "lat": 49.4892913
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 9.0804584,
    "lat": 52.1873798
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -92.1052679,
    "lat": 46.7838287
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": 85.3205817,
    "lat": 27.708317
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 6.6760958,
    "lat": 51.2652237
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -94.282265,
    "lat": 39.017316
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -106.660767,
    "lat": 52.131802
  },
  {
    "lng": -117.000165,
    "lat": 46.7323875
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -77.3063733,
    "lat": 38.8462236
  },
  {
    "lng": 91.8825282,
    "lat": 25.5760446
  },
  {
    "lng": -2.3596963,
    "lat": 51.3813864
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -8.6103497,
    "lat": 41.1502195
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -83.6277255,
    "lat": 42.7919727
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -105.270545,
    "lat": 40.0149856
  },
  {
    "lng": -3.7824148,
    "lat": 51.5952353
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": 0.3233131,
    "lat": 51.4780898
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -80.0830984,
    "lat": 26.3586885
  },
  {
    "lng": -118.4486675,
    "lat": 34.1866193
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -2.3596963,
    "lat": 51.3813864
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -0.902805,
    "lat": 52.2343297
  },
  {
    "lng": -5.5627852,
    "lat": 54.6489642
  },
  {
    "lng": 2.0153689,
    "lat": 48.5288442
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": -79.1462866,
    "lat": 42.060185
  },
  {
    "lng": 7.089351,
    "lat": 49.4305056
  },
  {
    "lng": -105.0770113,
    "lat": 40.5871782
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -114.334624,
    "lat": 48.4108018
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": -72.0362956,
    "lat": 43.3213132
  },
  {
    "lng": -8.6103497,
    "lat": 41.1502195
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -123.033121,
    "lat": 44.9391565
  },
  {
    "lng": -83.3527097,
    "lat": 42.36837
  },
  {
    "lng": -1.1399149,
    "lat": 53.5219538
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.173895,
    "lat": 46.7304268
  },
  {
    "lng": -3.9804785,
    "lat": 55.8661181
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 7.3389937,
    "lat": 47.7467233
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": 0.0295469,
    "lat": 51.5217707
  },
  {
    "lng": -9.3354702,
    "lat": 38.6921092
  },
  {
    "lng": -1.5815742,
    "lat": 52.2814519
  },
  {
    "lng": -2.2458192,
    "lat": 51.8653705
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 4.8994366,
    "lat": 45.823514
  },
  {
    "lng": -157.855676,
    "lat": 21.304547
  },
  {
    "lng": -80.0532942,
    "lat": 26.715364
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": 15.9622315,
    "lat": 45.8426414
  },
  {
    "lng": 139.766706,
    "lat": 35.6812546
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 19.9971534,
    "lat": 50.0469432
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -82.9651045,
    "lat": 40.2317686
  },
  {
    "lng": 7.063054,
    "lat": 50.3181149
  },
  {
    "lng": -74.4809868,
    "lat": 40.7970382
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 2.4530731,
    "lat": 48.7771486
  },
  {
    "lng": -74.0970865,
    "lat": 40.833989
  },
  {
    "lng": -74.4660408,
    "lat": 40.5462553
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -81.8802713,
    "lat": 42.9480988
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -79.5443274,
    "lat": 40.3024514
  },
  {
    "lng": -71.3739532,
    "lat": 42.8650869
  },
  {
    "lng": -76.492786,
    "lat": 38.9786401
  },
  {
    "lng": 0.1079732,
    "lat": 49.4938975
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -76.1474244,
    "lat": 43.0481221
  },
  {
    "lng": -5.71649,
    "lat": 54.3279335
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 9.8444774,
    "lat": 55.8611696
  },
  {
    "lng": -123.364953,
    "lat": 48.4283182
  },
  {
    "lng": 13.2591116,
    "lat": 54.4566445
  },
  {
    "lng": 0.0689113,
    "lat": 51.5589375
  },
  {
    "lng": 75.8189817,
    "lat": 26.9154576
  },
  {
    "lng": 4.6696185,
    "lat": 52.5496739
  },
  {
    "lng": -71.3876472,
    "lat": 41.8873726
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -73.3762307,
    "lat": 41.5139837
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -1.4149834,
    "lat": 43.4694806
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -82.7873244,
    "lat": 27.9094665
  },
  {
    "lng": -87.9090751,
    "lat": 43.0386475
  },
  {
    "lng": -71.2360624,
    "lat": 42.2802645
  },
  {
    "lng": -70.6694015,
    "lat": 41.5238752
  },
  {
    "lng": -77.8616386,
    "lat": 40.7944504
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -99.5069922,
    "lat": 27.5075005
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -1.1305431,
    "lat": 37.9923795
  },
  {
    "lng": -84.1916069,
    "lat": 39.7589478
  },
  {
    "lng": -70.8781883,
    "lat": 42.5489744
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -75.710976,
    "lat": 45.4277659
  },
  {
    "lng": 115.3351,
    "lat": -33.65214
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -74.6597376,
    "lat": 40.3496953
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 7.6944741,
    "lat": 47.5192013
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 9.2794469,
    "lat": 41.5911382
  },
  {
    "lng": 13.08824,
    "lat": 52.5606426
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": 9.1896346,
    "lat": 45.4641943
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -71.9952737,
    "lat": 42.5763523
  },
  {
    "lng": -8.3959425,
    "lat": 43.3709703
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 2.1748233,
    "lat": 48.8051045
  },
  {
    "lng": -79.7966835,
    "lat": 43.3248924
  },
  {
    "lng": 3.8855537,
    "lat": 45.0459739
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -88.1479278,
    "lat": 41.7728699
  },
  {
    "lng": 100.5386136,
    "lat": 13.7784702
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -85.3094883,
    "lat": 35.0457219
  },
  {
    "lng": -97.856109,
    "lat": 27.5158689
  },
  {
    "lng": -77.4347283,
    "lat": 38.837613
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -82.2946444,
    "lat": 28.058051
  },
  {
    "lng": -84.2809332,
    "lat": 30.4380832
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": -123.0950506,
    "lat": 44.0505054
  },
  {
    "lng": -76.8738048,
    "lat": 17.9717917
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -97.3404854,
    "lat": 32.9616819
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -89.5426165,
    "lat": 43.1715386
  },
  {
    "lng": -87.3297254,
    "lat": 20.8227773
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -94.4265011,
    "lat": 35.3880338
  },
  {
    "lng": 6.996379,
    "lat": 49.234362
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -96.0422378,
    "lat": 41.1544433
  },
  {
    "lng": -0.4181471,
    "lat": 51.5077154
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -81.4075838,
    "lat": 28.2918995
  },
  {
    "lng": -81.3055188,
    "lat": 28.6987317
  },
  {
    "lng": 75.851601,
    "lat": 30.9090157
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.9081901,
    "lat": 42.0128695
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -112.450627,
    "lat": 42.8620287
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 101.6454202,
    "lat": 3.0988792
  },
  {
    "lng": -71.3495035,
    "lat": 42.5292605
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 5.0414701,
    "lat": 47.3215806
  },
  {
    "lng": -111.551448,
    "lat": 45.892606
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -96.3198013,
    "lat": 15.8313373
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -86.1283681,
    "lat": 39.9784186
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -79.5655129,
    "lat": 43.7213619
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -75.546589,
    "lat": 39.7459468
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -75.0376707,
    "lat": 39.8915022
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -0.6680194,
    "lat": 51.4101286
  },
  {
    "lng": -2.9779978,
    "lat": 53.4102276
  },
  {
    "lng": -92.2896267,
    "lat": 34.7465071
  },
  {
    "lng": -120.832348,
    "lat": 35.3107214
  },
  {
    "lng": 4.3600687,
    "lat": 43.8374249
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -118.5538088,
    "lat": 34.4127963
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.5293246,
    "lat": 40.7695303
  },
  {
    "lng": -159.3191601,
    "lat": 22.0747334
  },
  {
    "lng": -74.9338911,
    "lat": 39.9005585
  },
  {
    "lng": 7.0158171,
    "lat": 51.4582235
  },
  {
    "lng": -95.2296553,
    "lat": 30.1024397
  },
  {
    "lng": -80.0983887,
    "lat": -2.2895167
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -93.2827625,
    "lat": 45.2710195
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -159.465733,
    "lat": 21.9042279
  },
  {
    "lng": 7.2439029,
    "lat": 47.1402077
  },
  {
    "lng": -81.5856742,
    "lat": 28.5656649
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -90.0034862,
    "lat": 34.9873822
  },
  {
    "lng": -92.4630182,
    "lat": 44.0234387
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 123.8559809,
    "lat": 9.6402611
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.0542002,
    "lat": 42.4085897
  },
  {
    "lng": -70.2506847,
    "lat": 43.7977006
  },
  {
    "lng": 2.136145,
    "lat": 48.8478753
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -73.6343052,
    "lat": 40.7266477
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -79.4428157,
    "lat": 37.7840208
  },
  {
    "lng": 6.8236481,
    "lat": 52.035862
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -1.0582645,
    "lat": 52.566854
  },
  {
    "lng": -73.9876388,
    "lat": 40.8214894
  },
  {
    "lng": 5.3259192,
    "lat": 60.3943055
  },
  {
    "lng": 8.8459949,
    "lat": 41.8353888
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -83.2696509,
    "lat": 42.240872
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -122.824222,
    "lat": 38.4021038
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -0.5668831,
    "lat": 53.7296397
  },
  {
    "lng": -92.447758,
    "lat": 42.5361805
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -74.2724241,
    "lat": 40.5133218
  },
  {
    "lng": 5.5836164,
    "lat": 43.6465639
  },
  {
    "lng": 4.6552471,
    "lat": 52.0441134
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -82.5508407,
    "lat": 35.595363
  },
  {
    "lng": -105.22058,
    "lat": 39.7546349
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -74.171811,
    "lat": 40.9167654
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -2.632996,
    "lat": 53.5433996
  },
  {
    "lng": -1.3908774,
    "lat": 50.9058615
  },
  {
    "lng": -73.4105803,
    "lat": 41.5770993
  },
  {
    "lng": -87.7962812,
    "lat": 41.6681632
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -88.1761521,
    "lat": 39.4961458
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": -8.0952772,
    "lat": 53.9441461
  },
  {
    "lng": 121.0486254,
    "lat": 14.6510546
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -0.7024738,
    "lat": 49.2764624
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": 10.7518463,
    "lat": 59.7756124
  },
  {
    "lng": 1.3819699,
    "lat": 51.3878174
  },
  {
    "lng": -81.8020722,
    "lat": 24.5548262
  },
  {
    "lng": -76.9408647,
    "lat": 38.9529442
  },
  {
    "lng": 115.0975839,
    "lat": -8.5959846
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -74.6241189,
    "lat": 40.3159898
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -118.3426122,
    "lat": 33.9128272
  },
  {
    "lng": -86.2500066,
    "lat": 41.6833813
  },
  {
    "lng": -77.3724593,
    "lat": 35.613224
  },
  {
    "lng": -79.2576479,
    "lat": 43.7729744
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.5076181,
    "lat": 48.881886
  },
  {
    "lng": 5.0980225,
    "lat": 43.6405237
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -122.1180201,
    "lat": 37.8857582
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -122.1244088,
    "lat": 37.6810422
  },
  {
    "lng": -87.9296885,
    "lat": 42.3839618
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 77.3272147,
    "lat": 28.5706333
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 100.5386136,
    "lat": 13.7784702
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 72.5800568,
    "lat": 23.0215374
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 9.0988968,
    "lat": 50.1591912
  },
  {
    "lng": -77.3465081,
    "lat": 37.5131191
  },
  {
    "lng": -1.7003017,
    "lat": 43.3624715
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 12.6484621,
    "lat": 47.8695272
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": 57.4927352,
    "lat": -20.2988986
  },
  {
    "lng": -79.9047583,
    "lat": 36.2087468
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 12.4483489,
    "lat": 55.6898267
  },
  {
    "lng": -80.9968286,
    "lat": 29.1386874
  },
  {
    "lng": 9.1800132,
    "lat": 48.7784485
  },
  {
    "lng": 74.8580917,
    "lat": 32.7185614
  },
  {
    "lng": -64.1834193,
    "lat": -31.4166867
  },
  {
    "lng": 74.8430082,
    "lat": 12.8698101
  },
  {
    "lng": 88.3638953,
    "lat": 22.5726459
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -73.1715669,
    "lat": 44.4671635
  },
  {
    "lng": 6.1376008,
    "lat": 51.7895571
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 7.71667,
    "lat": 50.15
  },
  {
    "lng": -66.0585188,
    "lat": 45.2787992
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.5463018,
    "lat": 34.8999056
  },
  {
    "lng": -1.1019893,
    "lat": 46.2051404
  },
  {
    "lng": -2.2478582,
    "lat": 52.3880787
  },
  {
    "lng": 139.6742379,
    "lat": 35.6959247
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.6311006,
    "lat": 42.3178989
  },
  {
    "lng": -74.1723667,
    "lat": 40.735657
  },
  {
    "lng": 8.6895121,
    "lat": 47.4330901
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -122.972545,
    "lat": 49.2433804
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.824222,
    "lat": 38.4021038
  },
  {
    "lng": -73.1774881,
    "lat": 42.1894315
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 8.4673098,
    "lat": 49.4892913
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": 12.0495271,
    "lat": 57.7970147
  },
  {
    "lng": 12.0495271,
    "lat": 57.7970147
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 6.083862,
    "lat": 50.776351
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": 7.0960124,
    "lat": 51.5110321
  },
  {
    "lng": -58.3953235,
    "lat": -34.7033363
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 8.041135,
    "lat": 51.7555148
  },
  {
    "lng": 11.9178807,
    "lat": 50.3219015
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 3.2106461,
    "lat": 39.5696458
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": 15.9622315,
    "lat": 45.8426414
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 8.7025509,
    "lat": 48.890934
  },
  {
    "lng": 27.5107799,
    "lat": 40.9781214
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 17.1314203,
    "lat": 48.1557669
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 5.1630646,
    "lat": 52.2773656
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 4.3600687,
    "lat": 43.8374249
  },
  {
    "lng": -87.682932,
    "lat": 42.0693991
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -88.3147539,
    "lat": 41.7571701
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 11.1647964,
    "lat": 61.0014937
  },
  {
    "lng": -78.828717,
    "lat": 42.716293
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": 2.3516139,
    "lat": 48.8475163
  },
  {
    "lng": 2.9610284,
    "lat": 48.3868056
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -71.8018877,
    "lat": 42.2625621
  },
  {
    "lng": -1.2779715,
    "lat": 51.6714842
  },
  {
    "lng": -85.1646726,
    "lat": 34.257038
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -81.3399769,
    "lat": 41.6664781
  },
  {
    "lng": 0.0880189,
    "lat": 52.5505996
  },
  {
    "lng": -2.7151735,
    "lat": 52.0553813
  },
  {
    "lng": -0.0139562,
    "lat": 51.4656437
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -7.9351771,
    "lat": 37.0162727
  },
  {
    "lng": -88.9524151,
    "lat": 39.8454163
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -79.9900861,
    "lat": 40.4416941
  },
  {
    "lng": -0.6308396,
    "lat": 44.805615
  },
  {
    "lng": -17.447938,
    "lat": 14.693425
  },
  {
    "lng": -84.9702475,
    "lat": 34.7691867
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": 4.4344787,
    "lat": 52.2484451
  },
  {
    "lng": -88.3123889,
    "lat": 43.0622536
  },
  {
    "lng": -72.7489158,
    "lat": 42.1205411
  },
  {
    "lng": 1.5485088,
    "lat": 49.0613978
  },
  {
    "lng": -82.005019,
    "lat": 39.9401426
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -71.0183787,
    "lat": 42.0834335
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": 29.7828009,
    "lat": 70.2267198
  },
  {
    "lng": 20.4568974,
    "lat": 44.8178131
  },
  {
    "lng": -0.4503027,
    "lat": 51.7135573
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": -85.1288435,
    "lat": 36.5745104
  },
  {
    "lng": -74.7659,
    "lat": 40.2203074
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -89.953157,
    "lat": 38.8114364
  },
  {
    "lng": -82.3490533,
    "lat": 31.7773202
  },
  {
    "lng": -73.6788272,
    "lat": 41.4266361
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -70.5129682,
    "lat": 41.3894198
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -88.0102281,
    "lat": 41.7936822
  },
  {
    "lng": -82.403533,
    "lat": 42.9743821
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 35.5025585,
    "lat": 33.8892265
  },
  {
    "lng": -84.2747329,
    "lat": 34.0709576
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": -77.0240371,
    "lat": 38.9997621
  },
  {
    "lng": -98.7075744,
    "lat": 35.5261633
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -77.061362,
    "lat": 43.237843
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": -97.827833,
    "lat": 30.5217116
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -88.0437509,
    "lat": 30.6913462
  },
  {
    "lng": -97.3327459,
    "lat": 32.753177
  },
  {
    "lng": -75.4712794,
    "lat": 40.6022059
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -99.1517322,
    "lat": 19.4414715
  },
  {
    "lng": -117.825981,
    "lat": 33.6856969
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -71.1061639,
    "lat": 42.4184296
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 104.9224426,
    "lat": 11.568271
  },
  {
    "lng": -117.659405,
    "lat": 33.5965685
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 1.3011264,
    "lat": 51.1291363
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -122.47267,
    "lat": 37.6904826
  },
  {
    "lng": -6.5922806,
    "lat": 53.3830239
  },
  {
    "lng": 10.8171691,
    "lat": 52.2499307
  },
  {
    "lng": 0.0793235,
    "lat": 51.5402677
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": 2.2543631,
    "lat": 48.9227298
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -86.3091683,
    "lat": 32.37742
  },
  {
    "lng": -96.8238183,
    "lat": 33.1505998
  },
  {
    "lng": 147.3281233,
    "lat": -42.8825088
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.9459248,
    "lat": 51.6195955
  },
  {
    "lng": -83.8979573,
    "lat": 33.9887165
  },
  {
    "lng": 6.7763137,
    "lat": 51.2254018
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -111.29189,
    "lat": 47.5048851
  },
  {
    "lng": -87.5519629,
    "lat": 35.5478514
  },
  {
    "lng": -111.651822,
    "lat": 35.1987522
  },
  {
    "lng": -2.1757665,
    "lat": 48.3491768
  },
  {
    "lng": 2.4879753,
    "lat": 48.716811
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -117.0244313,
    "lat": 34.8986215
  },
  {
    "lng": -123.1059324,
    "lat": 44.6365071
  },
  {
    "lng": -83.2501548,
    "lat": 31.2074197
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": 3.3941795,
    "lat": 6.4550575
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.374752,
    "lat": 34.1649502
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -87.9589621,
    "lat": 42.1544205
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -80.4927815,
    "lat": 43.451291
  },
  {
    "lng": -9.2719186,
    "lat": 38.788679
  },
  {
    "lng": -38.4812772,
    "lat": -12.9822499
  },
  {
    "lng": 50.1014927,
    "lat": 53.1956255
  },
  {
    "lng": -81.3749508,
    "lat": 40.7985464
  },
  {
    "lng": -117.2860371,
    "lat": 34.2475493
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": 4.5310837,
    "lat": 52.0109579
  },
  {
    "lng": 76.7797143,
    "lat": 30.7334421
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -38.4812772,
    "lat": -12.9822499
  },
  {
    "lng": -0.0154152,
    "lat": 51.4781086
  },
  {
    "lng": -83.9704593,
    "lat": 35.7564719
  },
  {
    "lng": -95.8519484,
    "lat": 41.258841
  },
  {
    "lng": -2.3783676,
    "lat": 52.7688594
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 6.8812387,
    "lat": 51.0909476
  },
  {
    "lng": -122.478836,
    "lat": 48.7544012
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 5.3905714,
    "lat": 45.6134459
  },
  {
    "lng": 33.8307062,
    "lat": 27.222556
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -124.311739,
    "lat": 49.3179514
  },
  {
    "lng": -122.1702293,
    "lat": 47.1870191
  },
  {
    "lng": 7.4373615,
    "lat": 52.2797707
  },
  {
    "lng": -82.5508407,
    "lat": 35.595363
  },
  {
    "lng": 7.0976053,
    "lat": 43.6857041
  },
  {
    "lng": 9.4978479,
    "lat": 51.3157833
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -156.3103925,
    "lat": 20.8539162
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -0.3763353,
    "lat": 39.4697065
  },
  {
    "lng": 12.1400211,
    "lat": 54.0886707
  },
  {
    "lng": -1.3900241,
    "lat": 53.0972537
  },
  {
    "lng": -73.9923596,
    "lat": 40.3042778
  },
  {
    "lng": -119.7029194,
    "lat": 36.8252277
  },
  {
    "lng": 4.3296526,
    "lat": 50.8390983
  },
  {
    "lng": -111.789037,
    "lat": 33.3527632
  },
  {
    "lng": 7.7507127,
    "lat": 48.584614
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -119.0779359,
    "lat": 34.4458248
  },
  {
    "lng": -0.1880608,
    "lat": 51.4143912
  },
  {
    "lng": -0.2796034,
    "lat": 51.5560695
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.510611,
    "lat": 48.8137847
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 8.2786906,
    "lat": 47.3504945
  },
  {
    "lng": -85.559604,
    "lat": 43.119721
  },
  {
    "lng": -97.555905,
    "lat": 30.3420882
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -123.7080446,
    "lat": 48.7786872
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": 14.2487679,
    "lat": 40.8358846
  },
  {
    "lng": -68.529968,
    "lat": 48.450155
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 10.2134046,
    "lat": 56.1496278
  },
  {
    "lng": 7.1780374,
    "lat": 51.264018
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 4.3627245,
    "lat": 51.9994572
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -1.4471035,
    "lat": 55.0087655
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -2.2138905,
    "lat": 47.2733517
  },
  {
    "lng": -73.9312445,
    "lat": 43.7714532
  },
  {
    "lng": -76.5719676,
    "lat": 39.0826193
  },
  {
    "lng": -79.7599366,
    "lat": 43.685832
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -80.5800049,
    "lat": 35.4094178
  },
  {
    "lng": -71.0183787,
    "lat": 42.0834335
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -81.243372,
    "lat": 42.9832406
  },
  {
    "lng": -77.2676335,
    "lat": 38.636447
  },
  {
    "lng": -79.9399309,
    "lat": 32.7884363
  },
  {
    "lng": -0.6469022,
    "lat": 44.842168
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -3.2666925,
    "lat": 51.4065052
  },
  {
    "lng": -122.8072257,
    "lat": 47.0263876
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -78.5123274,
    "lat": -0.2201641
  },
  {
    "lng": -121.78167,
    "lat": 42.224867
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -0.6308396,
    "lat": 44.805615
  },
  {
    "lng": -1.6171001,
    "lat": 54.9751321
  },
  {
    "lng": -1.1236065,
    "lat": 52.6321088
  },
  {
    "lng": -111.8486019,
    "lat": 40.3881114
  },
  {
    "lng": 6.4086189,
    "lat": 46.0775797
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -75.1340604,
    "lat": 40.2492741
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -118.4720281,
    "lat": 34.4233293
  },
  {
    "lng": -84.5160916,
    "lat": 35.8713147
  },
  {
    "lng": -111.854317,
    "lat": 34.5636358
  },
  {
    "lng": 0.025585,
    "lat": 51.5898978
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -4.7050443,
    "lat": 51.6726128
  },
  {
    "lng": -2.7151735,
    "lat": 52.0553813
  },
  {
    "lng": -0.1801094,
    "lat": 51.1103444
  },
  {
    "lng": 80.9346001,
    "lat": 26.8381
  },
  {
    "lng": -80.4706078,
    "lat": 27.816415
  },
  {
    "lng": -111.831455,
    "lat": 33.4151005
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -93.0012525,
    "lat": 34.665341
  },
  {
    "lng": 77.4831922,
    "lat": 19.0940088
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 27.4721276,
    "lat": 42.4936616
  },
  {
    "lng": -93.326521,
    "lat": 45.5693224
  },
  {
    "lng": -108.56448,
    "lat": 39.0672568
  },
  {
    "lng": -122.3330573,
    "lat": 37.496904
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 101.6455587,
    "lat": 2.9338908
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -77.8603829,
    "lat": 39.2952821
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -73.7629097,
    "lat": 41.0339862
  },
  {
    "lng": -1.6285858,
    "lat": 49.634413
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -4.0600467,
    "lat": 51.0804057
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.0215737,
    "lat": 37.5872576
  },
  {
    "lng": -97.3375448,
    "lat": 37.6922361
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -83.2965971,
    "lat": 42.3833698
  },
  {
    "lng": 25.1332843,
    "lat": 35.33908
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -78.6177611,
    "lat": 42.7689141
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -81.9438802,
    "lat": 26.5625742
  },
  {
    "lng": -103.228023,
    "lat": 44.0806041
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -92.3877837,
    "lat": 35.2339274
  },
  {
    "lng": 8.7348747,
    "lat": 47.2413349
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": -92.4630182,
    "lat": 44.0234387
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": 1.9086066,
    "lat": 47.9027336
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -0.6487899,
    "lat": 47.2982437
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.7097768,
    "lat": 51.0876062
  },
  {
    "lng": 75.8681996,
    "lat": 22.7203616
  },
  {
    "lng": -74.1637553,
    "lat": 40.8584328
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -71.0183787,
    "lat": 42.0834335
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -71.5676895,
    "lat": 42.3913503
  },
  {
    "lng": -88.2810994,
    "lat": 42.03726
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.3137707,
    "lat": 41.4899827
  },
  {
    "lng": -58.268868,
    "lat": -34.7303025
  },
  {
    "lng": -80.2781057,
    "lat": 25.8575963
  },
  {
    "lng": -73.75815,
    "lat": 42.8208245
  },
  {
    "lng": -71.0994968,
    "lat": 42.3875968
  },
  {
    "lng": 6.996379,
    "lat": 49.234362
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 5.6221058,
    "lat": 6.3330586
  },
  {
    "lng": -112.0273739,
    "lat": 41.1715361
  },
  {
    "lng": -82.0609557,
    "lat": 39.3575616
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -121.917794,
    "lat": 36.6211149
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -91.2190416,
    "lat": 38.6083822
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -77.615214,
    "lat": 43.157285
  },
  {
    "lng": 120.9694534,
    "lat": 14.6916903
  },
  {
    "lng": 10.8979522,
    "lat": 48.3690341
  },
  {
    "lng": -122.3053932,
    "lat": 47.8278656
  },
  {
    "lng": -73.2541069,
    "lat": 42.4484778
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -97.4394816,
    "lat": 35.2225717
  },
  {
    "lng": -1.4621381,
    "lat": 53.3783713
  },
  {
    "lng": -58.6351056,
    "lat": -34.4537215
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 14.4212535,
    "lat": 50.0874654
  },
  {
    "lng": -93.161159,
    "lat": 44.4582041
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -91.2256224,
    "lat": 43.5750997
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 135.3413128,
    "lat": 34.7377745
  },
  {
    "lng": -81.1764865,
    "lat": 35.3160401
  },
  {
    "lng": 153.0933668,
    "lat": -26.6544338
  },
  {
    "lng": -97.4033191,
    "lat": 27.7635302
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -73.7078294,
    "lat": 40.7053335
  },
  {
    "lng": -1.4968,
    "lat": 53.6830458
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 5.6969882,
    "lat": 50.8579855
  },
  {
    "lng": -92.7554671,
    "lat": 44.9750953
  },
  {
    "lng": -96.9034244,
    "lat": 32.9515472
  },
  {
    "lng": -79.1262839,
    "lat": 40.6424116
  },
  {
    "lng": -77.8837984,
    "lat": 37.7204342
  },
  {
    "lng": 98.3891503,
    "lat": 7.8847901
  },
  {
    "lng": 5.0044767,
    "lat": 45.7764637
  },
  {
    "lng": -2.6294313,
    "lat": 53.6531915
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -96.7297206,
    "lat": 32.9481789
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 9.2045813,
    "lat": 48.9596036
  },
  {
    "lng": -94.70496,
    "lat": 37.4108841
  },
  {
    "lng": -4.4860088,
    "lat": 48.3905283
  },
  {
    "lng": -100.0170787,
    "lat": 37.7527982
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 5.2253042,
    "lat": 51.9573504
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -0.1947552,
    "lat": 51.4027615
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -123.0950506,
    "lat": 44.0505054
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 6.8514435,
    "lat": 51.4696137
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -2.2458192,
    "lat": 51.8653705
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -96.9977846,
    "lat": 32.7459645
  },
  {
    "lng": -89.2903392,
    "lat": 31.3271189
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -94.2008288,
    "lat": 46.3580221
  },
  {
    "lng": 6.6916476,
    "lat": 51.1981778
  },
  {
    "lng": -4.2412484,
    "lat": 50.8309593
  },
  {
    "lng": -0.0135253,
    "lat": 51.5911967
  },
  {
    "lng": -1.6117595,
    "lat": 54.9751136
  },
  {
    "lng": -91.403171,
    "lat": 31.5604076
  },
  {
    "lng": -0.333653,
    "lat": 51.4277844
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 25.0407809,
    "lat": 60.2933337
  },
  {
    "lng": -93.46651,
    "lat": 45.0065149
  },
  {
    "lng": -73.9395687,
    "lat": 42.8142432
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -85.759407,
    "lat": 38.2542376
  },
  {
    "lng": -96.6736063,
    "lat": 29.4938849
  },
  {
    "lng": 11.9670171,
    "lat": 57.7072326
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -0.5473085,
    "lat": 51.4312585
  },
  {
    "lng": -88.0934145,
    "lat": 42.353355
  },
  {
    "lng": -101.1992336,
    "lat": 26.8792399
  },
  {
    "lng": -122.0322895,
    "lat": 37.3228934
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -100.783739,
    "lat": 46.808327
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -73.7753539,
    "lat": 41.270178
  },
  {
    "lng": -70.650549,
    "lat": -33.4625225
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -1.6800198,
    "lat": 48.1113387
  },
  {
    "lng": -73.9373912,
    "lat": 41.7841956
  },
  {
    "lng": -96.6154471,
    "lat": 33.1976496
  },
  {
    "lng": -81.5856742,
    "lat": 28.5656649
  },
  {
    "lng": -123.815722,
    "lat": 46.975371
  },
  {
    "lng": 7.4521749,
    "lat": 46.9484742
  },
  {
    "lng": -73.9523976,
    "lat": 45.4038563
  },
  {
    "lng": 34.7818064,
    "lat": 32.0852997
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 8.6736295,
    "lat": 49.8851869
  },
  {
    "lng": -119.495902,
    "lat": 49.8879177
  },
  {
    "lng": -1.623206,
    "lat": 47.2711217
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": -1.3129164,
    "lat": 54.564094
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": -79.9559437,
    "lat": 39.6296809
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 106.8822289,
    "lat": -6.2628908
  },
  {
    "lng": -157.9336111,
    "lat": 21.3822222
  },
  {
    "lng": 2.2890454,
    "lat": 48.9105948
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -1.4736657,
    "lat": 43.4945144
  },
  {
    "lng": -71.0994968,
    "lat": 42.3875968
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 2.4749347,
    "lat": 48.8490721
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": -3.1974329,
    "lat": 51.6663189
  },
  {
    "lng": -121.8106925,
    "lat": 38.0093296
  },
  {
    "lng": -80.3503283,
    "lat": 27.2939333
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 8.7291498,
    "lat": 47.4991723
  },
  {
    "lng": 2.3027323,
    "lat": 48.795056
  },
  {
    "lng": -1.4921233,
    "lat": 47.2971979
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": -2.9990745,
    "lat": 53.7485046
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 1.2923954,
    "lat": 52.6285576
  },
  {
    "lng": 17.6387436,
    "lat": 59.8586126
  },
  {
    "lng": -117.873221,
    "lat": 33.7494951
  },
  {
    "lng": -0.1200826,
    "lat": 51.4955481
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -112.185994,
    "lat": 33.5386858
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 2.5524906,
    "lat": 48.8492238
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -93.2922715,
    "lat": 37.2081729
  },
  {
    "lng": 4.6435597,
    "lat": 52.3837058
  },
  {
    "lng": -1.1700018,
    "lat": 44.6616428
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -21.9409445,
    "lat": 64.129393
  },
  {
    "lng": -0.3699697,
    "lat": 50.8115402
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -122.2566367,
    "lat": 38.1040864
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.1779083,
    "lat": 48.9134112
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -114.057541,
    "lat": 51.0456064
  },
  {
    "lng": -97.4169964,
    "lat": 42.0283379
  },
  {
    "lng": -93.6376741,
    "lat": 43.2626747
  },
  {
    "lng": -86.5675095,
    "lat": 34.7736807
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": 84.1528515,
    "lat": 21.5570606
  },
  {
    "lng": -1.257412,
    "lat": 51.4024177
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -81.4406258,
    "lat": 41.1596261
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -99.0000012,
    "lat": 28.4656903
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -117.865339,
    "lat": 34.1361187
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -71.2841163,
    "lat": -29.9452193
  },
  {
    "lng": -83.9210261,
    "lat": 35.9603948
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 10.4486418,
    "lat": 54.0354576
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 174.7631803,
    "lat": -36.852095
  },
  {
    "lng": -45.083415,
    "lat": -23.433162
  },
  {
    "lng": -58.947319,
    "lat": -34.9268133
  },
  {
    "lng": -117.3505966,
    "lat": 33.1580933
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": -116.0833144,
    "lat": 34.8253019
  },
  {
    "lng": -79.3321008,
    "lat": 42.4423544
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": 19.0402383,
    "lat": 47.4978789
  },
  {
    "lng": -95.9383758,
    "lat": 41.2587459
  },
  {
    "lng": -91.2514355,
    "lat": 43.8122836
  },
  {
    "lng": -82.458444,
    "lat": 27.9477595
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 9.7385532,
    "lat": 52.3744779
  },
  {
    "lng": 6.759562,
    "lat": 51.434999
  },
  {
    "lng": -2.6318629,
    "lat": 50.9420451
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -84.5740953,
    "lat": 30.8736613
  },
  {
    "lng": -75.5149128,
    "lat": 40.1303822
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -73.2820608,
    "lat": 41.4200956
  },
  {
    "lng": -83.9478911,
    "lat": 42.0554875
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -86.5949279,
    "lat": 36.2082431
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -79.9321566,
    "lat": 46.3653409
  },
  {
    "lng": -61.4635055,
    "lat": 10.2805193
  },
  {
    "lng": -0.325966,
    "lat": 51.4685202
  },
  {
    "lng": -92.2670941,
    "lat": 34.769536
  },
  {
    "lng": -73.754968,
    "lat": 42.6511674
  },
  {
    "lng": -94.2670404,
    "lat": 36.3456186
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -123.137414,
    "lat": 49.163168
  },
  {
    "lng": -90.1505426,
    "lat": 29.9899926
  },
  {
    "lng": -111.787022,
    "lat": 43.8235163
  },
  {
    "lng": 5.303116,
    "lat": 51.6889387
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": 2.4733771,
    "lat": 49.2607914
  },
  {
    "lng": -61.4635055,
    "lat": 10.2805193
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": -96.5764834,
    "lat": 33.4220266
  },
  {
    "lng": -77.1968941,
    "lat": 39.2694715
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 83.0076292,
    "lat": 25.3356491
  },
  {
    "lng": -81.71573,
    "lat": 25.9372513
  },
  {
    "lng": -104.825348,
    "lat": 38.8339578
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": -75.6059638,
    "lat": 39.9597213
  },
  {
    "lng": -88.7306517,
    "lat": 42.8339562
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": -91.4984941,
    "lat": 44.811349
  },
  {
    "lng": 73.1942567,
    "lat": 22.2973142
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 103.7649059,
    "lat": 1.4581986
  },
  {
    "lng": -72.2737216,
    "lat": -50.3387375
  },
  {
    "lng": -118.3878945,
    "lat": 34.2204227
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": -81.655651,
    "lat": 30.3321838
  },
  {
    "lng": 8.05,
    "lat": 52.2
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 0.0781021,
    "lat": 43.232858
  },
  {
    "lng": 4.2074197,
    "lat": 51.9930016
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 18.869167,
    "lat": -33.934444
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 75.5678878,
    "lat": 31.2922311
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": 2.3211651,
    "lat": 48.8564006
  },
  {
    "lng": -58.6217416,
    "lat": -34.6510527
  },
  {
    "lng": 7.9429235,
    "lat": 48.4695984
  },
  {
    "lng": -83.1821445,
    "lat": 42.4595317
  },
  {
    "lng": -72.6311006,
    "lat": 42.3178989
  },
  {
    "lng": 6.759562,
    "lat": 51.434999
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -75.3085201,
    "lat": 39.9809452
  },
  {
    "lng": 88.4309916,
    "lat": 26.7164127
  },
  {
    "lng": -59.6437728,
    "lat": -29.1443478
  },
  {
    "lng": -88.2578582,
    "lat": 42.1211364
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -118.3878945,
    "lat": 34.2204227
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -117.929416,
    "lat": 33.8708215
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -84.9790087,
    "lat": 32.9955364
  },
  {
    "lng": -81.4625919,
    "lat": 30.6696818
  },
  {
    "lng": -122.2034496,
    "lat": 47.4799078
  },
  {
    "lng": 16.9197326,
    "lat": 52.4006632
  },
  {
    "lng": -121.3222422,
    "lat": 38.6270984
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": 11.4676387,
    "lat": 48.2266316
  },
  {
    "lng": -84.5501874,
    "lat": 39.2085354
  },
  {
    "lng": -3.1791934,
    "lat": 51.4816546
  },
  {
    "lng": -76.8485094,
    "lat": 39.0984317
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -86.3921096,
    "lat": 35.8460396
  },
  {
    "lng": 2.273457,
    "lat": 48.8250508
  },
  {
    "lng": -75.9279495,
    "lat": 40.335345
  },
  {
    "lng": -77.3538176,
    "lat": 37.627722
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -117.42351,
    "lat": 47.6571934
  },
  {
    "lng": -74.2210643,
    "lat": 40.8164458
  },
  {
    "lng": 8.446357,
    "lat": 49.9819502
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -59.1488389,
    "lat": -37.2919426
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -74.012084,
    "lat": 40.8042674
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.4105803,
    "lat": 41.5770993
  },
  {
    "lng": 88.3638953,
    "lat": 22.5726459
  },
  {
    "lng": 7.3000295,
    "lat": 50.3240804
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 7.4815213,
    "lat": 46.9790726
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -111.9367107,
    "lat": 40.5584882
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -112.0244841,
    "lat": 41.1135837
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -85.8465279,
    "lat": 39.9389855
  },
  {
    "lng": -81.4075838,
    "lat": 28.2918995
  },
  {
    "lng": -88.0409574,
    "lat": 45.3834983
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 8.6986809,
    "lat": 51.5169114
  },
  {
    "lng": -105.0846694,
    "lat": 39.7085736
  },
  {
    "lng": -88.3123889,
    "lat": 43.0622536
  },
  {
    "lng": -2.9184744,
    "lat": 47.6199988
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": -41.8875267,
    "lat": -22.7597805
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": 2.3821895,
    "lat": 48.9146078
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.8331972,
    "lat": 48.5824932
  },
  {
    "lng": 6.5726698,
    "lat": 46.5285212
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -49.2712724,
    "lat": -25.4295963
  },
  {
    "lng": -2.9937869,
    "lat": 53.0465084
  },
  {
    "lng": 1.4175744,
    "lat": 50.0491699
  },
  {
    "lng": 5.7235287,
    "lat": 51.1932084
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -77.9487284,
    "lat": 34.2352853
  },
  {
    "lng": -97.0647322,
    "lat": 33.1540091
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -79.9356589,
    "lat": 35.9941053
  },
  {
    "lng": -4.2501687,
    "lat": 55.861155
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": -117.162772,
    "lat": 32.7174202
  },
  {
    "lng": -75.4278733,
    "lat": 38.9130453
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": 2.248254,
    "lat": 41.4493539
  },
  {
    "lng": -84.1468616,
    "lat": 33.4473361
  },
  {
    "lng": -98.4951405,
    "lat": 29.4246002
  },
  {
    "lng": 139.766706,
    "lat": 35.6812546
  },
  {
    "lng": -78.5103731,
    "lat": 35.9803138
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -70.650549,
    "lat": -33.4625225
  },
  {
    "lng": -81.4145468,
    "lat": 29.9032284
  },
  {
    "lng": -95.7343117,
    "lat": 33.1189413
  },
  {
    "lng": -96.9756323,
    "lat": 33.3142085
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": 23.7348324,
    "lat": 37.9755648
  },
  {
    "lng": -78.9018053,
    "lat": 35.996653
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -95.7909473,
    "lat": 43.3112893
  },
  {
    "lng": -74.7695394,
    "lat": 46.0412856
  },
  {
    "lng": -74.047455,
    "lat": 40.7215682
  },
  {
    "lng": 6.8304613,
    "lat": 46.5550197
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": 22.5546776,
    "lat": 51.2181945
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.1791934,
    "lat": 51.4816546
  },
  {
    "lng": -84.2396434,
    "lat": 33.8095487
  },
  {
    "lng": -111.940016,
    "lat": 33.4255117
  },
  {
    "lng": 14.5105343,
    "lat": 46.0582538
  },
  {
    "lng": -123.0950506,
    "lat": 44.0505054
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 10.0176952,
    "lat": 53.3965903
  },
  {
    "lng": -80.1386547,
    "lat": 26.8233946
  },
  {
    "lng": -74.171811,
    "lat": 40.9167654
  },
  {
    "lng": -74.3618499,
    "lat": 40.4635362
  },
  {
    "lng": -1.486516,
    "lat": 48.899151
  },
  {
    "lng": -82.366121,
    "lat": 28.1866014
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -9.3036149,
    "lat": 38.7293967
  },
  {
    "lng": -65.5927221,
    "lat": -27.3459249
  },
  {
    "lng": -85.3436973,
    "lat": 35.1223478
  },
  {
    "lng": 0.1186637,
    "lat": 52.2055314
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 1.7969781,
    "lat": 48.8658569
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -88.0670118,
    "lat": 41.8775293
  },
  {
    "lng": 2.39164,
    "lat": 48.7876
  },
  {
    "lng": 35.5025585,
    "lat": 33.8892265
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 8.4286614,
    "lat": 51.8074106
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": 23.7603118,
    "lat": 61.4980214
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 147.3281233,
    "lat": -42.8825088
  },
  {
    "lng": 18.0710935,
    "lat": 59.3251172
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": -92.4412674,
    "lat": 34.6295373
  },
  {
    "lng": 8.6820917,
    "lat": 50.1106444
  },
  {
    "lng": -87.6305899,
    "lat": 46.4481521
  },
  {
    "lng": 7.8193394,
    "lat": 49.1419455
  },
  {
    "lng": -118.7538071,
    "lat": 34.2677404
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": 0.2673446,
    "lat": 51.1371483
  },
  {
    "lng": -49.4858389,
    "lat": -28.9348832
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": 0.2517025,
    "lat": 50.9717443
  },
  {
    "lng": 10.1596948,
    "lat": 56.1220185
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -84.5124602,
    "lat": 39.1014537
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -88.207301,
    "lat": 40.1117174
  },
  {
    "lng": 55.1885387,
    "lat": 25.0742823
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -83.6324022,
    "lat": 32.8406946
  },
  {
    "lng": -0.5404819,
    "lat": 53.2293545
  },
  {
    "lng": -84.6165164,
    "lat": 44.3326932
  },
  {
    "lng": 79.0820556,
    "lat": 21.1498134
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -91.4171209,
    "lat": 41.9222443
  },
  {
    "lng": 3.2881194,
    "lat": 45.7703602
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -87.6244212,
    "lat": 41.8755616
  },
  {
    "lng": -83.0007065,
    "lat": 39.9622601
  },
  {
    "lng": 11.3927685,
    "lat": 47.2654296
  },
  {
    "lng": -71.2503157,
    "lat": 41.6024068
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -94.5280474,
    "lat": 45.1271847
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -82.2359254,
    "lat": 27.044224
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.636681,
    "lat": 47.4763
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": 2.5524906,
    "lat": 48.8492238
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -121.9357918,
    "lat": 37.7021521
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": 174.7772114,
    "lat": -41.2887953
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 2.7005289,
    "lat": 48.4881157
  },
  {
    "lng": -71.1187829,
    "lat": 42.332918
  },
  {
    "lng": -4.0816846,
    "lat": 52.4143113
  },
  {
    "lng": 1.215829,
    "lat": 6.130419
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 3.9452194,
    "lat": 50.4431879
  },
  {
    "lng": 5.9304919,
    "lat": 43.1257311
  },
  {
    "lng": -71.060511,
    "lat": 42.3554334
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -104.6158764,
    "lat": 50.4479733
  },
  {
    "lng": -0.5702444,
    "lat": 45.3723689
  },
  {
    "lng": 5.0363571,
    "lat": 52.0811781
  },
  {
    "lng": 2.2385432,
    "lat": 48.8126688
  },
  {
    "lng": -106.82356,
    "lat": 39.1911128
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": -88.0934108,
    "lat": 42.1969689
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": 4.6309653,
    "lat": 43.6776223
  },
  {
    "lng": -84.4970393,
    "lat": 38.0464066
  },
  {
    "lng": 11.1441047,
    "lat": 49.3559425
  },
  {
    "lng": -99.1332716,
    "lat": 19.4933046
  },
  {
    "lng": -77.9112655,
    "lat": 37.5531622
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -0.3685668,
    "lat": 43.2957547
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": -75.071284,
    "lat": 39.9181686
  },
  {
    "lng": 1.9737186,
    "lat": 47.9200018
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": -90.0782127,
    "lat": 29.9759983
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 101.6454202,
    "lat": 3.0988792
  },
  {
    "lng": 4.6435597,
    "lat": 52.3837058
  },
  {
    "lng": -1.9298486,
    "lat": 52.4672508
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -74.5517146,
    "lat": 40.5598127
  },
  {
    "lng": -118.000016,
    "lat": 33.6783336
  },
  {
    "lng": 25.3923149,
    "lat": 37.4513936
  },
  {
    "lng": -87.9084039,
    "lat": 42.1900249
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -73.212906,
    "lat": 44.4761601
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 80.3217588,
    "lat": 26.4609135
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -72.1847598,
    "lat": 40.9633868
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -80.1353006,
    "lat": 25.7929198
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -84.5740953,
    "lat": 30.8736613
  },
  {
    "lng": 88.3638953,
    "lat": 22.5726459
  },
  {
    "lng": -83.5378173,
    "lat": 41.6529143
  },
  {
    "lng": -106.660767,
    "lat": 52.131802
  },
  {
    "lng": -3.1791934,
    "lat": 51.4816546
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 25.2829111,
    "lat": 54.6870458
  },
  {
    "lng": 2.4077003,
    "lat": 48.7350308
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": 0.4252037,
    "lat": 51.5138172
  },
  {
    "lng": 5.4270482,
    "lat": 43.8287799
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -86.8997385,
    "lat": 40.0408627
  },
  {
    "lng": -86.7742984,
    "lat": 36.1622767
  },
  {
    "lng": 2.3580232,
    "lat": 48.935773
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 80.3217588,
    "lat": 26.4609135
  },
  {
    "lng": 7.5905713,
    "lat": 48.3971559
  },
  {
    "lng": 6.1288847,
    "lat": 45.8992348
  },
  {
    "lng": -122.2301808,
    "lat": 47.3075369
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": -122.1560768,
    "lat": 37.7249296
  },
  {
    "lng": -104.830994,
    "lat": 39.7405111
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -86.4477416,
    "lat": 43.9555406
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": 7.8494005,
    "lat": 47.9960901
  },
  {
    "lng": -97.6788056,
    "lat": 30.5085915
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": 8.050948,
    "lat": 49.5945916
  },
  {
    "lng": -1.1236065,
    "lat": 52.6321088
  },
  {
    "lng": -0.0927317,
    "lat": 51.3758448
  },
  {
    "lng": 7.5878261,
    "lat": 47.5581077
  },
  {
    "lng": 0.1561947,
    "lat": 45.6484505
  },
  {
    "lng": 1.0939658,
    "lat": 49.4404591
  },
  {
    "lng": -0.0843244,
    "lat": 51.4418786
  },
  {
    "lng": 2.0426301,
    "lat": 48.9274192
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -122.2270272,
    "lat": 47.3826903
  },
  {
    "lng": 6.6436313,
    "lat": 44.8984037
  },
  {
    "lng": -118.4720281,
    "lat": 34.4233293
  },
  {
    "lng": -75.6025597,
    "lat": 6.2697324
  },
  {
    "lng": -117.929416,
    "lat": 33.8708215
  },
  {
    "lng": -74.0254577,
    "lat": 45.3971509
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -1.67584,
    "lat": 52.6088967
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -110.3158532,
    "lat": 24.1619948
  },
  {
    "lng": -34.8848193,
    "lat": -8.0584933
  },
  {
    "lng": -121.2810611,
    "lat": 38.7071247
  },
  {
    "lng": -122.4614566,
    "lat": 37.8770247
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": 73.7902364,
    "lat": 20.0112475
  },
  {
    "lng": -1.7342725,
    "lat": 53.0173327
  },
  {
    "lng": -84.1557496,
    "lat": 33.0545709
  },
  {
    "lng": -93.0931028,
    "lat": 44.9497487
  },
  {
    "lng": -43.2093727,
    "lat": -22.9110137
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 0.1481142,
    "lat": 51.5413271
  },
  {
    "lng": 30.2368381,
    "lat": 1.5642298
  },
  {
    "lng": 77.0299194,
    "lat": 28.4646148
  },
  {
    "lng": -78.6390989,
    "lat": 35.7803977
  },
  {
    "lng": -74.2107006,
    "lat": 40.6639916
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 120.2570297,
    "lat": 23.0263249
  },
  {
    "lng": 7.2791655,
    "lat": 49.8123205
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": -106.82356,
    "lat": 39.1911128
  },
  {
    "lng": -119.5856465,
    "lat": 49.4901506
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -58.415498,
    "lat": -35.0405873
  },
  {
    "lng": -8.5187849,
    "lat": 41.4064621
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": 2.4230925,
    "lat": 42.6181232
  },
  {
    "lng": -1.9020456,
    "lat": 53.8684021
  },
  {
    "lng": 10.8979522,
    "lat": 48.3690341
  },
  {
    "lng": 1.3337639,
    "lat": 47.5876861
  },
  {
    "lng": 5.240333,
    "lat": 51.8236456
  },
  {
    "lng": 12.4483489,
    "lat": 55.6898267
  },
  {
    "lng": 77.3105561,
    "lat": 28.4031478
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -99.157701,
    "lat": 19.3718796
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": 26.1009263,
    "lat": 44.4356444
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": 3.3331703,
    "lat": 46.5660526
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": -88.0792782,
    "lat": 42.0427256
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 4.3113461,
    "lat": 52.0799838
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": -4.0600467,
    "lat": 51.0804057
  },
  {
    "lng": -97.5170536,
    "lat": 35.4729886
  },
  {
    "lng": -0.1618183,
    "lat": 51.5223681
  },
  {
    "lng": -3.175096,
    "lat": 51.4357312
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -57.6190998,
    "lat": -25.3172629
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": 27.9186111,
    "lat": -27.8813889
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 12.5326186,
    "lat": 55.678016
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -118.7538071,
    "lat": 34.2677404
  },
  {
    "lng": 0.5231646,
    "lat": 51.2748258
  },
  {
    "lng": -79.666672,
    "lat": 43.447436
  },
  {
    "lng": 2.4046994,
    "lat": 48.856303
  },
  {
    "lng": 77.0299194,
    "lat": 28.4646148
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 1.3549991,
    "lat": 44.0175835
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 135.5451809,
    "lat": 34.6856252
  },
  {
    "lng": -118.401813,
    "lat": 33.7872386
  },
  {
    "lng": -0.5879629,
    "lat": 44.8088438
  },
  {
    "lng": -70.7261966,
    "lat": 42.1924492
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -99.1332716,
    "lat": 19.4933046
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -72.6071119,
    "lat": 42.1487691
  },
  {
    "lng": -0.0996181,
    "lat": 51.582382
  },
  {
    "lng": 35.4873214,
    "lat": 38.7219011
  },
  {
    "lng": 12.466667,
    "lat": 58.716667
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": -95.3676974,
    "lat": 29.7589382
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": -99.1331785,
    "lat": 19.4326296
  },
  {
    "lng": 4.3873058,
    "lat": 45.4401467
  },
  {
    "lng": -111.9738429,
    "lat": 41.2230048
  },
  {
    "lng": -79.5443274,
    "lat": 40.3024514
  },
  {
    "lng": -82.8868636,
    "lat": 39.8522449
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -105.938456,
    "lat": 35.6876096
  },
  {
    "lng": -105.573284,
    "lat": 36.4072377
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 85.1235252,
    "lat": 25.6093239
  },
  {
    "lng": -83.0466403,
    "lat": 42.3315509
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -78.4766781,
    "lat": 38.029306
  },
  {
    "lng": -48.5496098,
    "lat": -27.5973002
  },
  {
    "lng": -66.9146008,
    "lat": 10.5060934
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -0.3957425,
    "lat": 51.6553875
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": -85.0766113,
    "lat": 33.5801103
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": 6.6327025,
    "lat": 46.5218269
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 2.240206,
    "lat": 48.8356649
  },
  {
    "lng": -4.7565615,
    "lat": 36.6600506
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": -77.2688875,
    "lat": 38.7812445
  },
  {
    "lng": 3.5225691,
    "lat": 47.9647312
  },
  {
    "lng": -122.674194,
    "lat": 45.5202471
  },
  {
    "lng": -0.3770142,
    "lat": 51.5968712
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -0.3770142,
    "lat": 51.5968712
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -72.6816365,
    "lat": 41.2827593
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 75.8189817,
    "lat": 26.9154576
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -111.886797,
    "lat": 40.7596198
  },
  {
    "lng": 150.89385,
    "lat": -34.4243941
  },
  {
    "lng": -99.7475905,
    "lat": 32.44645
  },
  {
    "lng": 77.7679671,
    "lat": 29.0018557
  },
  {
    "lng": 2.219344,
    "lat": 48.8437412
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -8.4294632,
    "lat": 40.2111931
  },
  {
    "lng": 2.3013348,
    "lat": 48.839743
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -106.650985,
    "lat": 35.0841034
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 28.049722,
    "lat": -26.205
  },
  {
    "lng": -77.0365256,
    "lat": -12.0621065
  },
  {
    "lng": -74.2401466,
    "lat": 40.829822
  },
  {
    "lng": 2.3763968,
    "lat": 48.9379294
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": 17.0326689,
    "lat": 51.1089776
  },
  {
    "lng": -0.1440551,
    "lat": 51.4893335
  },
  {
    "lng": -76.533788,
    "lat": 38.6941057
  },
  {
    "lng": -83.5378173,
    "lat": 41.6529143
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 74.8787496,
    "lat": 31.6356659
  },
  {
    "lng": -120.3835349,
    "lat": 37.985304
  },
  {
    "lng": -90.1505426,
    "lat": 29.9899926
  },
  {
    "lng": 79.0820556,
    "lat": 21.1498134
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -73.5582912,
    "lat": 40.721775
  },
  {
    "lng": -112.074141,
    "lat": 33.4484367
  },
  {
    "lng": -121.7529071,
    "lat": 36.9092773
  },
  {
    "lng": 5.240582,
    "lat": 52.2964844
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.3426122,
    "lat": 33.9128272
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": 77.2192671,
    "lat": 28.6430858
  },
  {
    "lng": -89.8973084,
    "lat": 35.3414745
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -70.0327996,
    "lat": 41.9376051
  },
  {
    "lng": 75.851601,
    "lat": 30.9090157
  },
  {
    "lng": 73.0351433,
    "lat": 26.2967719
  },
  {
    "lng": -2.4396676,
    "lat": 42.4661196
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.8298607,
    "lat": 52.4424926
  },
  {
    "lng": -122.636465,
    "lat": 38.2325829
  },
  {
    "lng": -73.8785937,
    "lat": 40.8466508
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": 172.6078498,
    "lat": -43.5399227
  },
  {
    "lng": -95.3097807,
    "lat": 34.9187023
  },
  {
    "lng": 28.1220546,
    "lat": -26.2669894
  },
  {
    "lng": -93.2654692,
    "lat": 44.9772995
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -80.9174262,
    "lat": 35.1518062
  },
  {
    "lng": -79.666672,
    "lat": 43.447436
  },
  {
    "lng": -86.1583502,
    "lat": 39.7683331
  },
  {
    "lng": -73.5698065,
    "lat": 45.5031824
  },
  {
    "lng": -73.8987469,
    "lat": 40.9312099
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": -90.1505426,
    "lat": 29.9899926
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -74.0836547,
    "lat": 4.6534109
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 31.2118063,
    "lat": 29.9870753
  },
  {
    "lng": 135.5014539,
    "lat": 34.6937569
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -118.5356869,
    "lat": 34.200768
  },
  {
    "lng": 0.2031905,
    "lat": 49.7074621
  },
  {
    "lng": 76.7797143,
    "lat": 30.7334421
  },
  {
    "lng": -99.1619751,
    "lat": 19.3498606
  },
  {
    "lng": 85.3250387,
    "lat": 23.3700501
  },
  {
    "lng": -16.7787271,
    "lat": 28.2101368
  },
  {
    "lng": -79.5443274,
    "lat": 40.3024514
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": 76.3196717,
    "lat": 32.2143039
  },
  {
    "lng": 0.6383746,
    "lat": 51.8019608
  },
  {
    "lng": -122.347748,
    "lat": 37.9357576
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 29.2696961,
    "lat": 37.752386
  },
  {
    "lng": -117.43433,
    "lat": 34.0922947
  },
  {
    "lng": 75.851601,
    "lat": 30.9090157
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": 1.7766633,
    "lat": 48.9717033
  },
  {
    "lng": -119.8126581,
    "lat": 39.5261206
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": 85.1235252,
    "lat": 25.6093239
  },
  {
    "lng": 5.7496879,
    "lat": 43.1378654
  },
  {
    "lng": -0.0927317,
    "lat": 51.3758448
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -75.2326641,
    "lat": 43.1009031
  },
  {
    "lng": -1.1236065,
    "lat": 52.6321088
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -117.826166,
    "lat": 33.7458511
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": -84.6433146,
    "lat": 42.7269261
  },
  {
    "lng": -118.491227,
    "lat": 34.0194704
  },
  {
    "lng": -111.457294,
    "lat": 36.9148305
  },
  {
    "lng": 1.09163,
    "lat": 49.3831
  },
  {
    "lng": 139.766706,
    "lat": 35.6812546
  },
  {
    "lng": -1.3900241,
    "lat": 53.0972537
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": -72.251587,
    "lat": 43.643032
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 2.3366502,
    "lat": 48.8064996
  },
  {
    "lng": 73.8545071,
    "lat": 18.5213738
  },
  {
    "lng": -66.9146008,
    "lat": 10.5060934
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -49.2712724,
    "lat": -25.4295963
  },
  {
    "lng": 2.3748001,
    "lat": 48.8443818
  },
  {
    "lng": 7.2683912,
    "lat": 43.7009358
  },
  {
    "lng": 36.8172449,
    "lat": -1.2832533
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": -93.326521,
    "lat": 45.5693224
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -121.890591,
    "lat": 37.3361663
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -73.8929714,
    "lat": 45.5646052
  },
  {
    "lng": 7.459464,
    "lat": 53.2050927
  },
  {
    "lng": 22.9352716,
    "lat": 40.6403167
  },
  {
    "lng": -86.8024326,
    "lat": 33.5206824
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.3860488,
    "lat": 48.655886
  },
  {
    "lng": 2.2481797,
    "lat": 48.9479069
  },
  {
    "lng": 2.2956951,
    "lat": 49.8941708
  },
  {
    "lng": 7.459464,
    "lat": 53.2050927
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": 11.7713656,
    "lat": 51.6706514
  },
  {
    "lng": -2.600511,
    "lat": 51.450363
  },
  {
    "lng": 5.7357819,
    "lat": 45.1875602
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": -71.3085329,
    "lat": 42.6414437
  },
  {
    "lng": 13.7381437,
    "lat": 51.0493286
  },
  {
    "lng": -97.7436995,
    "lat": 30.2711286
  },
  {
    "lng": -2.7540658,
    "lat": 52.707755
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": -77.0365427,
    "lat": 38.8950368
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -77.0470229,
    "lat": 38.8051095
  },
  {
    "lng": 30.061507,
    "lat": -1.950851
  },
  {
    "lng": 115.251951,
    "lat": -8.685213
  },
  {
    "lng": -75.4757444,
    "lat": 39.0715528
  },
  {
    "lng": 2.6183971,
    "lat": 48.9839674
  },
  {
    "lng": 7.6808525,
    "lat": 48.8873911
  },
  {
    "lng": -84.3898151,
    "lat": 33.7544657
  },
  {
    "lng": -81.4145468,
    "lat": 29.9032284
  },
  {
    "lng": 25.1332843,
    "lat": 35.33908
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 16.3691936,
    "lat": 48.2032863
  },
  {
    "lng": 101.6942371,
    "lat": 3.1516964
  },
  {
    "lng": -4.4216366,
    "lat": 36.7213028
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": -0.1011379,
    "lat": 51.5061349
  },
  {
    "lng": -119.78483,
    "lat": 36.7394421
  },
  {
    "lng": -157.9129733,
    "lat": 21.34045
  },
  {
    "lng": 10.135555,
    "lat": 54.3227085
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": -88.0437509,
    "lat": 30.6913462
  },
  {
    "lng": 90.3890144,
    "lat": 23.7643863
  },
  {
    "lng": -1.7767859,
    "lat": 46.4990505
  },
  {
    "lng": 126.99,
    "lat": 37.5323
  },
  {
    "lng": 5.986163,
    "lat": 49.4947826
  },
  {
    "lng": -5.9336562,
    "lat": 54.5842881
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": 91.753943,
    "lat": 26.1805978
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 5.2828123,
    "lat": 45.5872259
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": -1.5527266,
    "lat": 43.4711437
  },
  {
    "lng": 5.8882101,
    "lat": 45.2384678
  },
  {
    "lng": -117.911732,
    "lat": 33.8347516
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": 3.8767337,
    "lat": 43.6112422
  },
  {
    "lng": 121.451,
    "lat": 25.0615
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 5.9146362,
    "lat": 45.6886292
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -0.7734022,
    "lat": 48.0706687
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": -1.6084351,
    "lat": 46.7391797
  },
  {
    "lng": -122.972751,
    "lat": 45.300347
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 6.6916476,
    "lat": 51.1981778
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": 5.9203636,
    "lat": 45.5662672
  },
  {
    "lng": 24.9427473,
    "lat": 60.1674881
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": 2.4631476,
    "lat": 48.9385489
  },
  {
    "lng": 15.7844221,
    "lat": 67.2367153
  },
  {
    "lng": 6.5912615,
    "lat": 48.0158951
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": 1.3044842,
    "lat": 51.1296508
  },
  {
    "lng": -73.8283132,
    "lat": 40.7135078
  },
  {
    "lng": 7.7661798,
    "lat": 51.3854116
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -74.0237512,
    "lat": 40.7795455
  },
  {
    "lng": -0.1932607,
    "lat": 51.4570271
  },
  {
    "lng": -90.1910154,
    "lat": 38.6280278
  },
  {
    "lng": -3.1904199,
    "lat": 55.9519018
  },
  {
    "lng": -76.6932818,
    "lat": 42.8397906
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -73.9283672,
    "lat": 41.7065539
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -99.097453,
    "lat": 19.3957447
  },
  {
    "lng": 32.8540497,
    "lat": 39.9207759
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -8.4280045,
    "lat": 41.5510583
  },
  {
    "lng": 21.0067249,
    "lat": 52.2319581
  },
  {
    "lng": 5.2276307,
    "lat": 52.0892832
  },
  {
    "lng": -1.548621,
    "lat": 53.794414
  },
  {
    "lng": -78.8783922,
    "lat": 42.8867166
  },
  {
    "lng": 73.8545071,
    "lat": 18.5213738
  },
  {
    "lng": -84.544109,
    "lat": 38.9431183
  },
  {
    "lng": 5.9108573,
    "lat": 51.984257
  },
  {
    "lng": 5.5873582,
    "lat": 50.6429913
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 12.4829321,
    "lat": 41.8933203
  },
  {
    "lng": 7.5894588,
    "lat": 48.5281292
  },
  {
    "lng": 27.4338897,
    "lat": -11.6357362
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -117.3703235,
    "lat": 34.1064001
  },
  {
    "lng": 10.2134046,
    "lat": 56.1496278
  },
  {
    "lng": 77.3272147,
    "lat": 28.5706333
  },
  {
    "lng": 34.7818064,
    "lat": 32.0852997
  },
  {
    "lng": 6.1342493,
    "lat": 49.5999681
  },
  {
    "lng": 2.4197113,
    "lat": 48.8051624
  },
  {
    "lng": 74.1822147,
    "lat": 17.2852127
  },
  {
    "lng": 33.0332657,
    "lat": 34.6852901
  },
  {
    "lng": -80.0666026,
    "lat": 26.5256179
  },
  {
    "lng": 0.1826107,
    "lat": 51.5747271
  },
  {
    "lng": 80.9346001,
    "lat": 26.8381
  },
  {
    "lng": -49.5511221,
    "lat": -14.9522349
  },
  {
    "lng": -79.090576,
    "lat": 43.835765
  },
  {
    "lng": 26.1009263,
    "lat": 44.4356444
  },
  {
    "lng": -99.1135482,
    "lat": 19.4191658
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -94.5781416,
    "lat": 39.100105
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": 75.5678878,
    "lat": 31.2922311
  },
  {
    "lng": 5.7318101,
    "lat": 58.9699675
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 2.2561602,
    "lat": 48.8953328
  },
  {
    "lng": 13.7381437,
    "lat": 51.0493286
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 13.0001566,
    "lat": 55.6052931
  },
  {
    "lng": -1.1246168,
    "lat": 53.3042362
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -3.9904173,
    "lat": 55.7893512
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -4.4216366,
    "lat": 36.7213028
  },
  {
    "lng": -79.4491057,
    "lat": 43.7543217
  },
  {
    "lng": 100.7485803,
    "lat": 13.6818766
  },
  {
    "lng": -79.4377991,
    "lat": 36.0956918
  },
  {
    "lng": 98.3891503,
    "lat": 7.8847901
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -73.5107732,
    "lat": 42.7091389
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 13.7757809,
    "lat": 54.0536473
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -81.3790304,
    "lat": 28.5421109
  },
  {
    "lng": -47.6493269,
    "lat": -22.725165
  },
  {
    "lng": 77.7679671,
    "lat": 29.0018557
  },
  {
    "lng": -119.0779359,
    "lat": 34.4458248
  },
  {
    "lng": -0.0567767,
    "lat": 51.5471373
  },
  {
    "lng": -0.0786839,
    "lat": 51.6517156
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 6.1466014,
    "lat": 46.2017559
  },
  {
    "lng": 115.2191175,
    "lat": -8.6524973
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -8.5187849,
    "lat": 41.4064621
  },
  {
    "lng": -119.495902,
    "lat": 49.8879177
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": 4.8924534,
    "lat": 52.3730796
  },
  {
    "lng": 151.2082848,
    "lat": -33.8698439
  },
  {
    "lng": -117.084195,
    "lat": 32.6400541
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 72.8692035,
    "lat": 19.054999
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -2.1001142,
    "lat": 53.712125
  },
  {
    "lng": 4.2133313,
    "lat": 51.1253635
  },
  {
    "lng": -121.493895,
    "lat": 38.5810606
  },
  {
    "lng": -74.924321,
    "lat": 42.7006303
  },
  {
    "lng": -80.8430827,
    "lat": 35.2272086
  },
  {
    "lng": 6.9292641,
    "lat": 46.9895828
  },
  {
    "lng": 77.590082,
    "lat": 12.9767936
  },
  {
    "lng": -90.9562125,
    "lat": 30.4868564
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 2.3483915,
    "lat": 48.8534951
  },
  {
    "lng": 31.2357257,
    "lat": 30.0443879
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": -118.3426122,
    "lat": 33.9128272
  },
  {
    "lng": -123.113952,
    "lat": 49.2608724
  },
  {
    "lng": 2.4077003,
    "lat": 48.7350308
  },
  {
    "lng": -4.2660965,
    "lat": 55.4540605
  },
  {
    "lng": -77.4759588,
    "lat": 43.1301133
  },
  {
    "lng": 12.3652209,
    "lat": 55.7303911
  },
  {
    "lng": -86.6722192,
    "lat": 36.0600602
  },
  {
    "lng": 138.5999312,
    "lat": -34.9281805
  },
  {
    "lng": 74.8580917,
    "lat": 32.7185614
  },
  {
    "lng": -77.4744148,
    "lat": 39.029784
  },
  {
    "lng": 9.9753758,
    "lat": 53.5909051
  },
  {
    "lng": 15.9622315,
    "lat": 45.8426414
  },
  {
    "lng": -120.375716,
    "lat": 35.3540209
  },
  {
    "lng": 5.9146362,
    "lat": 45.6886292
  },
  {
    "lng": -2.2451148,
    "lat": 53.4794892
  },
  {
    "lng": 71.5787458,
    "lat": 34.0123846
  },
  {
    "lng": -1.2578499,
    "lat": 51.7520131
  },
  {
    "lng": -0.0786839,
    "lat": 51.6517156
  },
  {
    "lng": -0.1426957,
    "lat": 51.5394397
  },
  {
    "lng": -94.626497,
    "lat": 39.1134562
  },
  {
    "lng": -75.3321363,
    "lat": 42.6239023
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": 77.1709729,
    "lat": 31.1041526
  },
  {
    "lng": -79.8728583,
    "lat": 43.2560802
  },
  {
    "lng": -59.1488389,
    "lat": -37.2919426
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -79.882817,
    "lat": 43.513671
  },
  {
    "lng": -103.3913671,
    "lat": 20.7211203
  },
  {
    "lng": 15.9622315,
    "lat": 45.8426414
  },
  {
    "lng": 71.7337464,
    "lat": 34.1461506
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": -122.036349,
    "lat": 37.3688301
  },
  {
    "lng": 77.2219388,
    "lat": 28.6517178
  },
  {
    "lng": 76.7797143,
    "lat": 30.7334421
  },
  {
    "lng": -93.7594059,
    "lat": 41.5644476
  },
  {
    "lng": 2.320041,
    "lat": 48.8588897
  },
  {
    "lng": 6.4271457,
    "lat": 45.9418675
  },
  {
    "lng": -8.5458608,
    "lat": 42.8804219
  },
  {
    "lng": -86.7491214,
    "lat": 34.8558725
  },
  {
    "lng": 2.4252507,
    "lat": 6.3676953
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": -60.3404356,
    "lat": -33.2246717
  },
  {
    "lng": 14.4464593,
    "lat": 50.0596288
  },
  {
    "lng": -88.2430932,
    "lat": 40.1164841
  },
  {
    "lng": 74.8204443,
    "lat": 34.0747444
  },
  {
    "lng": 4.8320114,
    "lat": 45.7578137
  },
  {
    "lng": -1.1449555,
    "lat": 52.9473037
  },
  {
    "lng": 9.9215263,
    "lat": 57.0462626
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -47.059564,
    "lat": -22.9056391
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -0.5800364,
    "lat": 44.841225
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": -81.0352313,
    "lat": 34.000754
  },
  {
    "lng": 6.959974,
    "lat": 50.938361
  },
  {
    "lng": -43.9450948,
    "lat": -19.9227318
  },
  {
    "lng": -1.0714014,
    "lat": 44.6360982
  },
  {
    "lng": -81.6936772,
    "lat": 41.4996574
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -97.4719662,
    "lat": 33.0534563
  },
  {
    "lng": -124.053442,
    "lat": 44.636755
  },
  {
    "lng": 5.3699525,
    "lat": 43.2961743
  },
  {
    "lng": -2.99168,
    "lat": 53.4071991
  },
  {
    "lng": -122.5449763,
    "lat": 37.9060368
  },
  {
    "lng": 7.8191185,
    "lat": 51.681281
  },
  {
    "lng": 35.2257856,
    "lat": 31.7788472
  },
  {
    "lng": -45.8854538,
    "lat": -23.1867782
  },
  {
    "lng": 11.5753822,
    "lat": 48.1371079
  },
  {
    "lng": 153.0235009,
    "lat": -27.4689623
  },
  {
    "lng": -115.146357,
    "lat": 36.1716997
  },
  {
    "lng": 6.77037,
    "lat": 46.5419511
  },
  {
    "lng": -122.599707,
    "lat": 49.2197345
  },
  {
    "lng": 3.0819427,
    "lat": 45.7774551
  },
  {
    "lng": 115.8605784,
    "lat": -31.9558967
  },
  {
    "lng": -89.3837613,
    "lat": 43.074761
  },
  {
    "lng": 18.4172197,
    "lat": -33.9288301
  },
  {
    "lng": -3.7035825,
    "lat": 40.4167047
  },
  {
    "lng": -77.8616386,
    "lat": 40.7944504
  },
  {
    "lng": 26.1009263,
    "lat": 44.4356444
  },
  {
    "lng": -74.0060152,
    "lat": 40.7127281
  },
  {
    "lng": -80.19362,
    "lat": 25.7741728
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -123.3272489,
    "lat": 42.4393707
  },
  {
    "lng": 15.6946065,
    "lat": 48.2843295
  },
  {
    "lng": 5.478633,
    "lat": 51.4392648
  },
  {
    "lng": -117.2298477,
    "lat": 33.7818729
  },
  {
    "lng": -83.2107671,
    "lat": 42.2595071
  },
  {
    "lng": -118.242766,
    "lat": 34.0536909
  },
  {
    "lng": 2.177073,
    "lat": 41.3825802
  },
  {
    "lng": -96.7968559,
    "lat": 32.7762719
  },
  {
    "lng": -82.3249846,
    "lat": 29.6519684
  },
  {
    "lng": -122.4193286,
    "lat": 37.7792588
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 144.9631732,
    "lat": -37.8142454
  },
  {
    "lng": -88.3525714,
    "lat": 41.6834778
  },
  {
    "lng": -9.1365919,
    "lat": 38.7077507
  },
  {
    "lng": -122.849143,
    "lat": 49.1913033
  },
  {
    "lng": -0.206809,
    "lat": 51.474408
  },
  {
    "lng": -117.826166,
    "lat": 33.7458511
  },
  {
    "lng": 13.7757809,
    "lat": 54.0536473
  },
  {
    "lng": -122.330062,
    "lat": 47.6038321
  },
  {
    "lng": -46.6333824,
    "lat": -23.5506507
  },
  {
    "lng": -1.9739174,
    "lat": 52.4968157
  },
  {
    "lng": -75.710976,
    "lat": 45.4277659
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 4.351697,
    "lat": 50.8465573
  },
  {
    "lng": 75.8533326,
    "lat": 30.135717
  },
  {
    "lng": -104.984862,
    "lat": 39.7392364
  },
  {
    "lng": 11.077298,
    "lat": 49.453872
  },
  {
    "lng": 8.531007,
    "lat": 52.0191005
  },
  {
    "lng": -83.0335384,
    "lat": 42.6261446
  },
  {
    "lng": -72.0997804,
    "lat": 41.3556187
  },
  {
    "lng": -72.9250518,
    "lat": 41.3082138
  },
  {
    "lng": -75.6901106,
    "lat": 45.4208777
  },
  {
    "lng": -6.2605593,
    "lat": 53.3493795
  },
  {
    "lng": -1.5541362,
    "lat": 47.2186371
  },
  {
    "lng": -79.3839347,
    "lat": 43.6534817
  },
  {
    "lng": -86.9300023,
    "lat": 35.751179
  },
  {
    "lng": -4.0278869,
    "lat": 57.8796955
  },
  {
    "lng": -71.8046023,
    "lat": 42.5854371
  },
  {
    "lng": -72.9020069,
    "lat": 41.3836233
  },
  {
    "lng": -75.1635262,
    "lat": 39.9527237
  },
  {
    "lng": -79.0993958,
    "lat": 36.075382
  },
  {
    "lng": -90.4611995,
    "lat": 30.5043583
  },
  {
    "lng": 10.3549776,
    "lat": 53.4022952
  },
  {
    "lng": 8.5410422,
    "lat": 47.3744489
  },
  {
    "lng": 67.0207055,
    "lat": 24.8546842
  },
  {
    "lng": -83.0302033,
    "lat": 42.5803122
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  },
  {
    "lng": 4.47775,
    "lat": 51.9244424
  },
  {
    "lng": -117.903317,
    "lat": 33.6633386
  },
  {
    "lng": -73.9497211,
    "lat": 40.6526006
  }
]
